import { store } from './../index';
import $ from 'jquery';
import api from './../service/apiService'
import {
    offerText,
    Service,
    Contract,
    BuildProduct,
    ContractConstants,
    FutureNotification,
    DOFlow,
    Save,
    Pages,
    CheckLQ,
    EquipmentDiscounts,
    OfferTypes,
} from './../constants/actionType';
import { apiUrl } from './../constants/apiUrl'
import { logKafka, checktime, logOtherInfo, detailsInfo, catchJSException } from './../service/logService'
import { getCartHeader, getCartData, getSelectedInternet, getCartProducts, getSelectedChannels, getSelectedIntrnlChannels } from './../util/cartUtility'
import { ModalWindow, CartServices, ProductType, PAGEACTIVITY, CheckOut } from './../constants/actionType';
import * as modalAction from './../action/modalWindow';
import * as prefetchAction from './../action/prefetch';
import * as checkoutAction from './../action/checkout';
import { redirectTo } from './../action/redirection';
import { errorAction } from './error';
import { loaderActive } from './loder';
import { updateNonProduct } from './../util/commonUtil';
import { updateSCTags, updateSCcustomEvent, tempSCData, addToCartSCEvent, scClickEventProduct } from './../service/dtmTag';
import { updateVzdlSCCustomEvent, vzdlErrorUpdate, addToCartVzdlSCEvent, tempVzdlSCData, updateSubFlowValue, updateDetailValue, updateSandboxIdValue, updateMessageValue, setProductsCurrent } from './../service/vzdl';
import { InHomeUtils } from './../util/inhomeUtils';
import { logNRTime } from './../util/commonUtil';
import { getNRCurrentTime } from './../util/commonUtil';
import { quickCheckout, setVzwMtn } from './loopQual';
import { checkTokenValidity, genarateToken} from './../containers/buildProduct/mnhSignin';
import { updateTNInfo } from './personalInfo';
import { logToKibanna } from '../service/logService';
import { batchActions } from 'redux-batched-actions';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
let statevalue = "";
let suppSelectedProds = [];
let includeDisneyAsSpecialOffer = false;
let ignoreUniqueSplOffer = false;
let showMarvel = false;
let hasMarvelProfile = false;
let smartCartFlow = false;
let isNC = false;
let addonProducts = "";
let vcloud;
let isAmazonWithDisney = false;
let isJointDeviceOffer = false;
let isTagGspeed = false;
let acpGetDetailsFlag = true;
let vzfGetDetailsFlag = true;
let fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
const getRequest = (visitId, contract, serviceType, flowType, couponFlowType = null) => {
    let isPromo = true;
    if (serviceType === Service.voice) {
        isPromo = false
    }

    let intents = [];
    if (couponFlowType !== null) {
        if (couponFlowType === "Employee" || couponFlowType === "Retiree") {
            intents.push({ "key": "Employee", "value": "Y" })
        }
        else if (couponFlowType === "Affinity") {
            intents.push({ "key": "Affinity", "value": "Y" })
        }
    }

    let request = {

        uid: visitId,
        idType: 'visit',
        contract: contract === 'MTM' ? 'MTM' : 'TWOYEAR',
        isPromoInclude: isPromo,
        serviceType: serviceType,
        "intents": intents
    }

    if (flowType === 'MV') {
        request.orderType = flowType;
    }
    if (flowType === 'NC') {
        isNC = true;
    }
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'getRequest', JSON.stringify(request)));
    return JSON.stringify(request);
}

const getPremiumChannelRequest = (visitId, contract, serviceType, selectedProductId, flowType) => {
    let lstProductId = [];
    if (InHomeUtils.isNotNull(selectedProductId) && selectedProductId !== "")
        lstProductId.push(selectedProductId);
    let request = {
        uid: visitId,
        idType: 'visit',
        contract: contract,
        isPromoInclude: true,
        serviceType: serviceType,
        selectedProduct: lstProductId,
        orderType: flowType
    }
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPremiumChannelRequest', JSON.stringify(request)));
    return JSON.stringify(request);
}

const getRequestChannel = (visitid, zipcode, tarcode) => {
    let request = {
        zipcode: zipcode,
        tarcode: tarcode,
        visitid: visitid
    }
    // if (serviceType === 'battery') {
    //     request = {
    //         uid: visitId,
    //         contract: contract
    //     }
    // }
    logOtherInfo(detailsInfo('BuildProduct', visitid, 'getRequestChannel', JSON.stringify(request)));
    return JSON.stringify(request);
}

const getRequestMultiUseoffer = (coupon) => {
    var someDate = new Date();
    var numberOfDaysToAdd = 7;
    someDate.setDate(someDate.getDate() + numberOfDaysToAdd)
    var dd = someDate.getDate();
    var mm = someDate.getMonth() + 1;
    var y = someDate.getFullYear();
    var someFormattedDate = dd + '/' + mm + '/' + y;

    let request = {
        "code": coupon,
        "expirationDate": someFormattedDate,
        "leadListId": '',
        "type": "MUC"
    }
    return JSON.stringify(request);
};

const getRequestChatoffer = (product, specialOffer, contract,isMnHAuthenticated) => {
    let request = {
        productId: specialOffer.Target,
        offerId: specialOffer.OfferId, //'36272';
        promoId: specialOffer.USOCIOSC, //'Q4645';
        productType: "OFFER",
        serviceType: specialOffer.BsOfferAttr === 'EQUIPMENT' ? "VIDEO" : "DATA",
        quantity: '1',
        contract: contract === 'TWOYEAR' ? 'TWOYEAR' : 'MTM',
        status: 'add',
        bundleId: product.bundleId, //'B0014';
        offerCombinationId: product.offerTileId, //'24#7603:,32369,7196,36104,36272,7199,32272,32588,36056,3435,4616,36076,36077';
        bundleKey: product.bundleKey,//'FTTP_1000M_1000M:Q2493:FVPRIMARY'; 
        isMnHAuthenticated:isMnHAuthenticated
    }
    return JSON.stringify(request);
};

const getRequestSpecialoffer = (specialOffer, contract, isChecked, offertype, isMnHAuthenticated, buildProductState) => {
    //console.log('***** spl offer req ', specialOffer);
    let offerid = specialOffer.OfferId;
    let isoc = specialOffer.USOCIOSC;
    let productId = specialOffer?.Target;

    /* Below if to append offer id and isoc for the bundle promos enabled for Holiday and Gaming offer in 2024
    Though the offers would be coming as different products from CRMM, they should be given as a bundle offer in UI
    */
    if(specialOffer?.USOCIOSC === 'R4049') {
        const xboxGiftCard = buildProductState?.splPromoOffersList?.find(offer => offer?.offerFor == 'Data' && offer?.OfferText?.toLowerCase()?.includes('xbox egift card'));
        if(xboxGiftCard) {
            offerid += `,${xboxGiftCard?.OfferId}`;
            isoc += `,${xboxGiftCard?.USOCIOSC}`;
        }
    }

    if(specialOffer?.USOCIOSC === 'R4140') {
        const xboxseries = buildProductState?.splPromoOffersList?.find(offer => offer?.offerFor == 'Data' && offer?.OfferText?.toLowerCase()?.includes('xbox series'));
        const xboxGiftCard = buildProductState?.splPromoOffersList?.find(offer => offer?.offerFor == 'Data' && offer?.OfferText?.toLowerCase()?.includes('xbox egift card'));
        console.log(xboxseries,'xboxseries');
        if(xboxseries) {
            offerid += `,${xboxseries?.OfferId},${xboxGiftCard?.OfferId}`;
            isoc += `,${xboxseries?.USOCIOSC},${xboxGiftCard?.USOCIOSC}`;
        }
    }
    if (specialOffer?.USOCIOSC === "R4142") {
        offerid = "39768,39757";
        isoc = "R4143,R4139";
    }
    
    if(specialOffer?.USOCIOSC === 'R4047') {
        offerid = "39741"; 
        isoc = "R4048"; 
    }

    if (((specialOffer?.BsOfferAttrValue === OfferTypes.vintageOffer) || specialOffer?.USOCIOSC === 'R4047' || specialOffer?.USOCIOSC === "R4142")) {
        productId = "";
    }

    let request = {
        productId: productId,
        offerId: offerid, //'36272';
        promoId: isoc, //'Q4645';
        productType: "OFFER",
        serviceType: 'OFFER',
        quantity: '1',
        contract: (contract === 'TWOYEAR' || contract === '2YR') ? 'TWOYEAR' : 'MTM',
        status: 'add',
        isMnHAuthenticated:isMnHAuthenticated
        //bundleId: product.bundleId, //'B0014';
        //offerCombinationId: product.offerTileId, //'24#7603:,32369,7196,36104,36272,7199,32272,32588,36056,3435,4616,36076,36077';
        //bundleKey: product.bundleKey,//'FTTP_1000M_1000M:Q2493:FVPRIMARY'; 
    }
    return JSON.stringify(request);
};

const getRequestfuturenotification = (visitId, telNbr, addrId, firstName, lastName, businessName, addressLine1, addressLine2, city, state, zipCode, emailAddress,
    contactPhone, vzPhone, notifyFios, notifyFiosTv, appId, nsiInd) => {
    let request = {
        "telNbr": telNbr,
        "addrId": addrId,
        "firstName": firstName,
        "lastName": lastName,
        "businessName": businessName,
        "addressLine1": addressLine1,
        "addressLine2": addressLine2,
        "city": city,
        "state": state,
        "zipCode": zipCode,
        "emailAddress": emailAddress,
        "contactPhone": contactPhone,
        "vzPhone": vzPhone,
        "notifyFios": notifyFios,
        "notifyFiosTv": notifyFiosTv,
        "appId": appId,
        "nsiInd": nsiInd
    }
    return JSON.stringify(request);
};

const validateReferralCode = (visitId, coupon) => {
    let request = {
        "visitId": visitId,
        "refCode": coupon,
        "refMode": "",
        "client": "VZCOM"
    }
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'validateReferralCode', JSON.stringify(request)));
    return JSON.stringify(request);
};

const referralCouponRequest = (visitId, visitorId, coupon) => {
    let request = {
        "visitId": visitId,
        "refCode": coupon,
        "refMode": "",
        "client": "VZCOM",
        "visitorId": visitorId
    }
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'referralCouponRequest', JSON.stringify(request)));
    return JSON.stringify(request);
}

const getContractRequest = (contract) => {
    let request = {
        key: ContractConstants.contractChange,
        value: contract === ContractConstants.twoYear ? ContractConstants.twoYearInWords : ContractConstants.monthToMonth,
        action: "add"
    }
    return JSON.stringify(request)
}

export const spanishTab = (dispatch, status,index) => {
    dispatch({ type: 'SPANISH_TV', value: status});
}

const getStdRequest = (contract, prod, productType, isChecked, selectedCoreServices, voiceTn, flowType,buildProductState) => {
    let mnhSignupIndicator = ""
    if(buildProductState?.internet?.mnhSignupIndicator !== "" && buildProductState?.internet?.mnhSignupIndicator !== null && buildProductState?.internet?.mnhSignupIndicator !== undefined){
        mnhSignupIndicator = buildProductState?.internet?.mnhSignupIndicator
    }
    if(window && window.sessionStorage && window.sessionStorage.getItem("intermediaryWithoutMNH") && window.sessionStorage.getItem("intermediaryWithoutMNH") === "true"){
        mnhSignupIndicator = "N";
    }
    let serviceType = "";
    if (productType === Service.internet)
        serviceType = Service.data
    if (productType === Service.tv || productType === Service.customTV || productType === Service.vRoom || productType === Service.recording || productType === Service.channel || productType === Service.intrnlChnl || productType === Service.dct || productType === Service.ceAppsParity || productType === Service.ceAppsBundle || productType === Service.dummyvRoom)
        serviceType = Service.video
    if (productType === Service.voice || productType === Service.intlPlans || productType === Service.listing || productType === Service.battery || productType === Service.batteryshipment)
        serviceType = Service.voice
    if (productType === 'ROUTER' || productType === Service.router) {
        if (InHomeUtils.isNotNull(selectedCoreServices) && selectedCoreServices !== '' && selectedCoreServices.indexOf(Service.data) > -1)
            serviceType = Service.data
        else
            serviceType = Service.video
    }

    if (productType === Service.streamServ || productType === Service.streamDev || productType === Service.streamDevCount)
        serviceType = Service.data;
    let productId = prod.id;
    let prodType = prod.prodType;
    let qty = (prodType === Service.streamDevCount || productType === Service.ceAppsParity) ? prod.unitCount : "1";
    if (prodType === Service.streamDevCount) {
        prodType = Service.streamDev;
    }
    // if (routerProduct !== null) {
    //     productId += "," + routerProduct.id;
    //     productType += "," + routerProduct.prodType;
    // }
    if (prod.prodType === Service.streamServ) {
        serviceType = Service.data
        contract = ContractConstants.monthToMonth;
    }
    let request = {
        contract: contract,
        productId: productId,
        productType: prodType,
        quantity: qty,
        serviceType: serviceType ? serviceType : productType,
        status: isChecked ? "remove" : "add",
        orderType: flowType,
        isMnHAuthenticated : mnhSignupIndicator
    }
    if (productType === Service.voice) {
        request.tn = voiceTn
    }
    if (prod.fiosFiveSelectedChannels && prod.fiosFiveSelectedChannels.length > 0) {
        updateFiosFiveCartReqObj(request, prod);
    }
    if (productType === Service.intrnlChnl) {
        updateIntlPackageCartReqObj(request, prod);
    }


    return JSON.stringify(request)
}

const getBundleRequest = (contract, prod, serviceType, isChecked, voiceTn, selectedCoreServices, isLocalTVInCart, isFCPflow, flowType,lqState,buildProductState) => {
    let mnhSignupIndicator = ""
    if(buildProductState?.internet?.mnhSignupIndicator !== "" && buildProductState?.internet?.mnhSignupIndicator !== null && buildProductState?.internet?.mnhSignupIndicator !== undefined){
        mnhSignupIndicator = buildProductState?.internet?.mnhSignupIndicator
    }
    if (serviceType === Service.internet)
        serviceType = Service.data
    if (serviceType === Service.tv || serviceType === Service.customTV || serviceType === Service.vRoom || serviceType === Service.recording || serviceType === Service.channel || serviceType === Service.intrnlChnl || serviceType === Service.dct || serviceType === Service.ceAppsParity || serviceType === Service.ceAppsBundle || serviceType === Service.dummyvRoom)
        serviceType = Service.video
    if (serviceType === Service.voice || serviceType === Service.listing || serviceType === Service.battery)
        serviceType = Service.voice
    if (serviceType === Service.router) {
        if (InHomeUtils.isNotNull(selectedCoreServices) && selectedCoreServices !== '' && selectedCoreServices.indexOf(Service.data) > -1)
            serviceType = Service.data
        else
            serviceType = Service.video
    }
    if (isFCPflow) {
        contract = ContractConstants.monthToMonth;
    }
    else if (isLocalTVInCart && !isChecked && prod.prodType === "BASIC" && prod.prodTypeValue !== "LOCLDGTL") {
        contract = ContractConstants.twoYearInWords;
    }
    else if (isLocalTVInCart) {
        contract = ContractConstants.monthToMonth;
    }
    if (prod.prodType === Service.streamServ) {
        serviceType = Service.data
        contract = ContractConstants.monthToMonth;
    }
    if (lqState && lqState.showMarvel) {
        showMarvel = true;
    }
    // if(!lqState.showMarvel && !smartCartFlow && isNC){
    //     if(prod.offerTileId.includes('37627')){
    //         prod.offerTileId = prod.offerTileId.replace("37627","");
    //     }
    //     if(prod.offerTileId.includes('37628')){
    //         prod.offerTileId = prod.offerTileId.replace("37628","");
    //     }
    // }
    let request = {
        bundleId: prod.bundleId,
        bundleKey: prod.bundleKey,
        contract: contract,
        offerCombinationId: prod.offerTileId,
        productId: prod.id,
        productType: prod.prodType,
        quantity: "1",
        serviceType: serviceType,
        status: isChecked ? "remove" : "add",
        orderType: flowType,
        isMnHAuthenticated: mnhSignupIndicator
    }
    if (lqState.isQAMLessFlow) {
        request.QAMLessFlow = lqState.isQAMLessFlow;
    }
    if (serviceType === Service.voice) {
        request.tn = voiceTn
    }
    if (prod.prodTypeValue === "ULTIMATETESTDRIVE") {
        request.selectedCustomPlan = "basicdiff";
    }
    if(serviceType === "MM3")
    {
        request.serviceType = "DATA"
    }
    if (prod?.fiosFiveSelectedChannels && prod?.fiosFiveSelectedChannels?.length > 0) {
        updateFiosFiveCartReqObj(request, prod);
    }
    return JSON.stringify(request)
}

const getClearCartRequest = (serviceType, selectedCoreServices) => {
    let servType = selectedCoreServices === '' ? 'ALL' : serviceType === Service.internet ? Service.data : serviceType === Service.tv ? Service.video : serviceType === Service.streamServ ? Service.streamServ : 'FIOS_VOICE';

    let request = {
        serviceType: servType,
        productType: 'All'
    }
    return JSON.stringify(request)
}

export const customRouterSetName = (name, dispatch) => {
    dispatch({ type: "SETCUSTOMROUTERNAME", value: name })
};

export const buildprodLoaded = (status, dispatch) => {
    dispatch({ type: BuildProduct.buildprodLoaded, value: status });
};

/*const customTV = [{
    prodType: "CUSTOM",
    keyWord: "",
    onProfile: null,
    originalPrice: "",
    diffPrice: null,
    displayPrice: "$64.99",
    netPrice: 0,
    includedPromos: null,
    priceType: null,
    productTypeValue: "CUSTV",
    billingType: null,
    forDisplay: null,
    bundleId: null,
    offerTileId: null,
    bundleKey: null,
    specialOffer: null,
    speedCode: null,
    speedName: null,
    upSpeed: null,
    downSpeed: null,
    includedWithPlan: false,
    tosRequired: null,
    bundleItems: null,
    rank: null,
    isAlaCarte: false,
    priceWithPromo: null,
    productInSmartCart: false,
    id: "CUST",
    name: {
        description: "<p>7 plans to choose from",
        name: "Custom TV",
        websimpledesc: "155+ channels"
    }

}]*/

const setHtmlSymbols = (prodObj) => {
    if (prodObj.name) {
        prodObj.name = prodObj.name.replace(/&trade;/, String.fromCharCode(0x2122));
    }
    if (prodObj.description) {
        prodObj.description = prodObj.description.replace(/&trade;/, String.fromCharCode(0x2122));
    }
};

export const setAccordionStatus = (service, dispatch, isAccordionOpen) => {
    dispatch({ type: service.toUpperCase(), value: '' });
    if (service === 'toggle_phone_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,tv,contract,sploffer,flashoffer,streamserv" })
    }
    if (service === 'toggle_tv_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,voice,contract,sploffer,flashoffer,streamingdev" })
    }
    if (service === 'toggle_internet_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,contract,sploffer,flashoffer,streamserv" })
    }
    if (service === 'toggle_contract_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,sploffer,flashoffer,streamserv" })
    }
    if (service === 'toggle_splOffer_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,contract,flashoffer,streamserv" })
    }
    // if (service === 'toggle_flashoffer_accor') {
    //     dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,contract,sploffer,streamserv" })
    // }
    if (service === 'toggle_streamingserv_accor') {
        // Commenting for temporarily fixing the swinging issue btw accordion
        // dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,contract,sploffer,flashoffer" })
    }
    if (isAccordionOpen === false) {
        dispatch({ type: "TOGGLE_FOCUS_ACCORDION", value: true });
    }
}

export const focusAccordion = (service, dispatch) => {
    dispatch({ type: service.toUpperCase(), value: "Open" });
    if (service.indexOf('toggle_phone') > -1) {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,tv,perks,contract,sploffer,flashoffer,streamserv" })
    }
    if (service.indexOf('toggle_tv') > -1) {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,voice,perks,contract,sploffer,flashoffer,streamserv" })
    }
    if (service.indexOf('toggle_internet') > -1) {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,perks,contract,sploffer,flashoffer,streamserv" })
    }
    if (service === 'toggle_internet_perks_accor') { // toggle_perks_accor
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,contract,sploffer,flashoffer,streamserv" })
    }
    if (service === 'toggle_contract_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,perks,internet,sploffer,flashoffer,streamserv" })
    }
    if (service === 'toggle_splOffer_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,perks,internet,contract,flashoffer,streamserv" })
    }
    if (service === 'toggle_flashoffer_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,perks,internet,contract,sploffer,streamserv" })
    }
    if (service === 'toggle_streamingserv_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,perks,internet,contract,sploffer,flashoffer" })
    }
}

export const accordionFocusAnimate = (dispatch) => {
    dispatch({ type: 'TOGGLE_FOCUS_ACCORDION' });
}

export const parentAccordionFocusAnimate = (dispatch) => {
    dispatch({ type: 'TOGGLE_FOCUS_PARENT_ACCORDION' });
}

export const focusAnimation = (offset) => {
    $('body').animate({
        scrollTop: offset
    }, 750);
    // commented since scrollTo not supported by IE
    // document.getElementsByTagName('body')[0].scrollTo({
    //     top: offset - 12,
    //     left: 0,
    //     behavior: 'smooth'
    //   });
}

export const focusAnimationPerks = () => {
    setTimeout(() => {
    $('body').animate({
        scrollTop : $('#toggle_internet_perks_accor').offset()
    })
    },500);
}
export function getFocusAccordion(accordionType, flowType, buildProduct, cart, loopQual, supp) {
  if (!buildProduct?.isMNEnabled) {
    return "";
  }
  if (accordionType === "internet") {
    const selectedInternet = buildProduct?.internet?.selectedProduct;
    const WifiRouterInCart = cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName?.toLowerCase() ===  "promotions"))?.subSections?.subSection?.[0]?.promos?.some(a => a?.promoId === "R1910");
    const selectedRouter = buildProduct?.router?.selectedProduct || WifiRouterInCart;
    const hasRouterAccordion = selectedInternet && Array.isArray(buildProduct?.router?.equipments) && buildProduct?.router?.equipments?.length > 0;
    const selectedSplOffer = buildProduct?.sploffer?.selectedProduct || buildProduct?.sploffer?.data?.selectedProduct;
    let isSony3Mons = Array.isArray(buildProduct?.sploffer?.data?.offerplansMTM) && buildProduct?.sploffer?.data?.offerplansMTM?.length === 1 && buildProduct?.sploffer?.data?.offerplansMTM?.findIndex(p => p?.BsOfferAttrValue === "SONY_PLAYSTATION_3MONTH") > -1;
    const hasSplOfferAccordion = selectedInternet && loopQual?.isFCPflow && (buildProduct?.sploffer?.isDataOffer || isSony3Mons)
      && (
        (Array.isArray(buildProduct?.sploffer?.data?.offerplans2YR) && buildProduct?.sploffer?.data?.offerplans2YR?.length > 1 && buildProduct?.contract?.contractType === "2YR")
        || (Array.isArray(buildProduct?.sploffer?.data?.offerplansMTM) && (buildProduct?.sploffer?.data?.offerplansMTM?.length > 1 || (isSony3Mons && (buildProduct?.internet?.selectedProduct?.downSpeed === "200M" || buildProduct?.internet?.selectedProduct?.downSpeed === "300M" || buildProduct?.internet?.selectedProduct?.downSpeed === "100M"))) && buildProduct?.contract?.contractType === "MTM")
      )
      && !loopQual?.showStadia && !loopQual?.showMarvel;
    const selectedFlashOffer = buildProduct?.flashoffer?.selectedProduct;
    let suppCart = cart?.cartResponse?.tierContent?.[0]?.sections?.section?.[3]?.subSections?.subSection?.[1]?.promos?.findIndex(a => a?.offerAttr === "ACQBLACKFRIDAY2022")?.length > -1;
    let supphasPreholidayGC = supp?.baseOrderDetail?.vzOrder?.hasPreholidayGC;
    let supphashasBlackFriday = supp?.baseOrderDetail?.vzOrder?.hasBlackfriday;
    const hasFlashOfferAccordion = selectedInternet && (suppCart || buildProduct?.isbfpromo)
      && (
        (
          supphasPreholidayGC !== "Y" && supphashasBlackFriday !== "Y"
          && (
            (Array.isArray(buildProduct?.flashoffer?.offerplans2YR) && buildProduct?.flashoffer?.offerplans2YR?.length > 1 && buildProduct?.contract?.contractType === "2YR")
            || (Array.isArray(buildProduct?.flashoffer?.offerplansMTM) && buildProduct?.flashoffer?.offerplansMTM?.length > 1 && buildProduct?.contract?.contractType === "MTM")
          )
        ) || (
          loopQual?.runtimeKey?.EnableBlackFridayOffers === "Y"
          && (Array.isArray(buildProduct?.flashoffer?.offerplans2YR) || Array.isArray(buildProduct?.flashoffer?.offerplansMTM))
          && buildProduct?.internet?.selectedProduct.downSpeed !== "400M" && buildProduct?.internet?.selectedProduct?.downSpeed !== "200M"
        )
      );
    const selectedPerks = buildProduct?.perks?.selectedProduct;
    const hasPerksAccordion = selectedInternet && !(loopQual?.hoaFlowDetails?.isHoaFlow && buildProduct?.hoabundle?.hoaresponse?.defaultMap);
    if (!selectedInternet) {
      return "toggle_internet_plan_accor";
    } else if (!selectedRouter && hasRouterAccordion) {
      return "toggle_internet_router_accor";
    } else if (selectedRouter && !selectedSplOffer && hasSplOfferAccordion) {
      return "toggle_data_splOffer_accor";
    } else if (selectedRouter && ((selectedSplOffer && hasSplOfferAccordion) || !hasSplOfferAccordion) && !selectedFlashOffer && hasFlashOfferAccordion) {
      return "toggle_internet_flashoffer_accor";
    } else if (selectedRouter && ((selectedSplOffer && hasSplOfferAccordion) || !hasSplOfferAccordion) && ((selectedFlashOffer && hasFlashOfferAccordion) || !hasFlashOfferAccordion) && !selectedPerks && hasPerksAccordion) {
      return "toggle_internet_perks_accor";
    }
  } else if (accordionType === "tv") {
    const selectedTv = buildProduct?.tv?.selectedProduct;
    const selectedCustomTv = buildProduct?.tv?.customTV?.selectedProduct;
    const hasCustomTvAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ && selectedTv?.prodTypeValue === Service.customGeneric || selectedTv?.prodTypeVal === Service.customGeneric;
    const selectedRouter = buildProduct?.router?.selectedProduct;
    const selectedInternet = buildProduct?.internet?.selectedProduct;
    const hasRouterAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ && !selectedInternet;
    const selectedDct = buildProduct?.dct?.selectedProduct
    const hasDctAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ && buildProduct?.dct?.isDCTEligible === true;
    const selectedVRoom = buildProduct?.vRoom?.selectedProduct;
    const hasVRoomAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ;
    const selectedTvConnections = buildProduct?.tvConnections?.selectedProduct;
    let selectedvRoomProd = (selectedVRoom?.prodId || selectedVRoom?.id) && buildProduct?.vRoom?.equipments?.filter(p => p && (p?.id === selectedVRoom?.prodId || p?.id === selectedVRoom?.id));
    let selecteddummyvRoomProd = (selectedTvConnections?.prodId || selectedTvConnections?.id) && buildProduct?.tvConnections?.equipments?.filter(p => p && (p?.id === selectedTvConnections?.prodId || p?.id === selectedTvConnections?.id));
    let vRoomCount = selectedvRoomProd?.[0]?.unitCount ? parseInt(selectedvRoomProd?.[0]?.unitCount) : 0;
    let dummyvRoomCount = selecteddummyvRoomProd?.[0]?.unitCount ? parseInt(selecteddummyvRoomProd?.[0]?.unitCount) : 0;
    const hasTvConnectionsAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ && buildProduct?.showConnectedApps && Array.isArray(buildProduct?.ceApps?.equipments) && buildProduct?.ceApps?.equipments?.length > 0
      && selectedInternet && vRoomCount > 0;
    const selectedCeApps = buildProduct?.ceApps?.selectedProduct;
    const hasCeAppsAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ && buildProduct?.showConnectedApps && Array.isArray(buildProduct?.ceApps?.equipments) && buildProduct?.ceApps?.equipments?.length > 0
      && selectedInternet && vRoomCount > 0 && ((!dummyvRoomCount && vRoomCount === 1) || (dummyvRoomCount && vRoomCount === dummyvRoomCount));
    const selectedRecording = buildProduct?.recording?.selectedProduct;
    const hasRecordingAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ;
    const selectedSplOffer = buildProduct?.sploffer?.selectedProduct || buildProduct?.sploffer?.tv?.selectedProduct;
    const hasSplOfferAccordion = loopQual?.isFCPflow && buildProduct?.sploffer?.isTVOffer
      && (
        (Array.isArray(buildProduct?.sploffer?.tv?.offerplans2YR) && buildProduct?.sploffer?.tv?.offerplans2YR?.length > 1 && buildProduct?.contract?.contractType === "2YR")
        || (Array.isArray(buildProduct?.sploffer?.tv?.offerplansMTM) && buildProduct?.sploffer?.tv?.offerplansMTM?.length > 1 && buildProduct?.contract?.contractType === "MTM")
      );
    const selectedChannel = buildProduct?.channel?.selectedProduct;
    const hasChannelAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ;
    // const selectedInternationalChannel = buildProduct?.internationalChannel?.selectedProduct;
    // const hasInternationalChannelAccordion = selectedTv && selectedTv?.prodType !== Service.streamServ && buildProduct?.internationalChannel?.equipments?.spanish;
    // const selectedStreamDev = buildProduct?.streamDev?.selectedProduct;
    // const hasStreamDevAccordion = Array.isArray(buildProduct?.streamDev?.streamDevProd) && buildProduct?.streamDev?.streamDevProd?.length > 0;
    if (!selectedTv) {
      return "toggle_tv_plan_accor";
    } else if (!selectedCustomTv && hasCustomTvAccordion) {
      return "toggle_tv_CustomTV_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && !selectedRouter && hasRouterAccordion) {
      return "toggle_tv_router_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && ((selectedRouter && hasRouterAccordion) || !hasRouterAccordion) && !selectedDct && hasDctAccordion) {
      return "toggle_tv_dct_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && ((selectedRouter && hasRouterAccordion) || !hasRouterAccordion) && ((selectedDct && hasDctAccordion) || !hasDctAccordion) && !selectedVRoom && hasVRoomAccordion) {
      return "toggle_tv_settopbox_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && ((selectedRouter && hasRouterAccordion) || !hasRouterAccordion) && ((selectedDct && hasDctAccordion) || !hasDctAccordion) && selectedVRoom && !selectedTvConnections && hasTvConnectionsAccordion) {
      return "toggle_tv_connections_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && ((selectedRouter && hasRouterAccordion) || !hasRouterAccordion) && ((selectedDct && hasDctAccordion) || !hasDctAccordion) && selectedVRoom && ((selectedTvConnections && hasTvConnectionsAccordion) || !hasTvConnectionsAccordion) && !selectedCeApps && hasCeAppsAccordion) {
      return "toggle_tv_ceapps_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && ((selectedRouter && hasRouterAccordion) || !hasRouterAccordion) && ((selectedDct && hasDctAccordion) || !hasDctAccordion) && selectedVRoom && ((selectedTvConnections && hasTvConnectionsAccordion) || !hasTvConnectionsAccordion) && ((selectedCeApps && hasCeAppsAccordion) || !hasCeAppsAccordion) && !selectedRecording && hasRecordingAccordion) {
      return "toggle_tv_recording_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && ((selectedRouter && hasRouterAccordion) || !hasRouterAccordion) && ((selectedDct && hasDctAccordion) || !hasDctAccordion) && selectedVRoom && ((selectedTvConnections && hasTvConnectionsAccordion) || !hasTvConnectionsAccordion) && ((selectedCeApps && hasCeAppsAccordion) || !hasCeAppsAccordion) && selectedRecording && !selectedSplOffer && hasSplOfferAccordion) {
      return "toggle_tv_sploffer_accor";
    } else if (((selectedCustomTv && hasCustomTvAccordion) || !hasCustomTvAccordion) && ((selectedRouter && hasRouterAccordion) || !hasRouterAccordion) && ((selectedDct && hasDctAccordion) || !hasDctAccordion) && selectedVRoom && ((selectedTvConnections && hasTvConnectionsAccordion) || !hasTvConnectionsAccordion) && ((selectedCeApps && hasCeAppsAccordion) || !hasCeAppsAccordion) && selectedRecording && ((selectedSplOffer && hasSplOfferAccordion) || !hasSplOfferAccordion) && !selectedChannel && hasChannelAccordion) {
      return "toggle_tv_channel_accor";
    }
  } else if (accordionType === "phone") {
    const selectedVoice = buildProduct?.voice?.selectedProduct;
    const selectedIntlCalling = buildProduct?.intlCalling?.selectedProduct;
    const hasIntlCallingAccordion = selectedVoice && loopQual?.isFCPflow === true;
    // const selectedIntlPlans = buildProduct?.intlPlans?.selectedProduct;
    // const hasIntlPlansAccordion = selectedVoice && loopQual?.isFCPflow === true && Array.isArray(buildProduct?.intlPlans?.intlPlansProducts) && buildProduct?.intlPlans?.intlPlansProducts?.length > 0;
    const selectedWinback = buildProduct?.winback?.selectedProduct;
    const hasWinbackAccordion = selectedVoice && flowType !== "MV";
    const selectedListing = buildProduct?.listing?.selectedProduct;
    const hasListingAccordion = selectedVoice;
    const selectedBackup = buildProduct?.backup?.selectedProduct;
    const hasBackupAccordion = selectedVoice && Array.isArray(buildProduct?.backup?.backupProducts) && buildProduct?.backup?.backupProducts?.length > 0;
    const selectedEmergencyServices = buildProduct?.emergencyServices?.selectedProduct;
    const hasEmergencyServicesAccordion = selectedVoice && loopQual?.runtimeKey?.isAllowFireAlarm === "Y";
    // const selectedTechsure = buildProduct?.techsure?.selectedProduct;
    // const hasTechsureAccordion = selectedVoice && loopQual?.runtimeKey?.isAllowFireAlarm === "Y";
    if (!selectedVoice) {
      return "toggle_phone_plan_accor";
    } else if (selectedVoice && !selectedIntlCalling && hasIntlCallingAccordion) {
      return "toggle_phone_intlcalling_accor";
    // } else if (selectedVoice && ((selectedIntlCalling && hasIntlCallingAccordion) || !hasIntlCallingAccordion) && !selectedIntlPlans && hasIntlPlansAccordion) {
    //   return "toggle_phone_intlplans_accor";
    } else if (selectedVoice && ((selectedIntlCalling && hasIntlCallingAccordion) || !hasIntlCallingAccordion) && !selectedWinback && hasWinbackAccordion) {
      return "toggle_phone_winbackcheck_accor";
    } else if (selectedVoice && ((selectedIntlCalling && hasIntlCallingAccordion) || !hasIntlCallingAccordion) && ((selectedWinback && hasWinbackAccordion) || !hasWinbackAccordion) && !selectedListing && hasListingAccordion) {
      return "toggle_phone_listing_accor";
    } else if (selectedVoice && ((selectedIntlCalling && hasIntlCallingAccordion) || !hasIntlCallingAccordion) && ((selectedWinback && hasWinbackAccordion) || !hasWinbackAccordion) && selectedListing && !selectedBackup && hasBackupAccordion) {
      return "toggle_phone_backup_accor";
    } else if (selectedVoice && ((selectedIntlCalling && hasIntlCallingAccordion) || !hasIntlCallingAccordion) && ((selectedWinback && hasWinbackAccordion) || !hasWinbackAccordion) && selectedListing && ((selectedBackup && hasBackupAccordion) || !hasBackupAccordion) && !selectedEmergencyServices && hasEmergencyServicesAccordion) {
      return "toggle_emergency_services_accor";
    // } else if (selectedVoice && ((selectedIntlCalling && hasIntlCallingAccordion) || !hasIntlCallingAccordion) && ((selectedWinback && hasWinbackAccordion) || !hasWinbackAccordion) && selectedListing && ((selectedBackup && hasBackupAccordion) || !hasBackupAccordion) && ((selectedEmergencyServices && hasEmergencyServicesAccordion) || !hasEmergencyServicesAccordion) && !selectedTechsure && hasTechsureAccordion) {
    //   return "toggle_internet_techsure_accor";
    }
  }
  return "";
}

export const fetchDCT = (dispatch, visitId, flowType) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDCT', "Inside fetchDCT"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vcpestb', flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products)) {
                if (response?.data?.products?.length > 0) {
                    response?.data?.products?.forEach((prod) => setHtmlSymbols(prod));
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDCT', "Products Found"));
                    response?.data?.products.push({ id: 'NODCT', prodType: 'VCPESTB', name: "No Thanks, not right now" });
                    dispatch({ type: 'FETCH_DCT', value: response?.data?.products?.map(p => p) });
                    if (InHomeUtils.isNotNull(response?.data?.products?.map(p => p)) && response?.data?.products?.map(p => p)?.length > 0) {
                        dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { DCT: true } });
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDCT', "DCT " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                    dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
                }
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDCT', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchDCT,errorMessage:Api Response is not success`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDCT', "Exception is: " + error.message));
                //    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchDCT,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchDCT', ex);
        dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
    }
};

export const fetchCeapps = (dispatch, visitId, selectedProductId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchceapps', "Inside fetchceapps"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'ceapps', flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response?.meta) && InHomeUtils.getIndexOf(response?.meta?.code, '200') && InHomeUtils.isNotNull(response?.data) && InHomeUtils.isNotNull(response?.data?.products) && response?.data?.products?.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchceapps', "Connected TV Apps"));

                // response.data.products.forEach((prod) => setHtmlSymboSls(prod));
                if (response?.data?.products?.length) {
                    dispatch({
                        type: 'FETCH_CEAPPS',
                        value: response.data.products
                    })
                }
                if (InHomeUtils.isNotNull(response?.data?.products?.map(p => p)) && response?.data?.products?.map(p => p)?.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Ceapps: true } });
                }
            }

        })
            .catch(error => {
                //     loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchceapps,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchceapps', ex);
    }
};

export const fetchContractConfig = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchContractConfig', "Inside fetchContractConfig"));
        let url = apiUrl().contractConfigUrl;
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && response !== "") {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchContractConfig', "Response is Success"));
                dispatch({ type: 'FETCH_CONTRACTCONFIG', value: response });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchContractConfig', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchContractConfig', "Exception is: " + error.message));
                let errorMsg = `MethodName:fetchContractConfig,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchContractConfig', ex);
    }
};

export const fetchEligibleOffers = async(dispatch, visitId, offertype, reAttemptCount = 0) => {
    try {
        let offersEligible = '';
        let url = apiUrl().getProduct + '/checkoffers/' + offertype;
        api(url, 'GET').then(async response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cacheValue) && response.data.cacheValue !== "") {
                offersEligible = response.data.cacheValue;
                await dispatch({ type: 'FETCH_ELIGIBLE_OFFERS', value: offersEligible });
                if(offersEligible && ((offersEligible.indexOf('BEATS_STUDIO') > -1) || (offersEligible.indexOf('10_ongoing_Discount') > -1) || (offersEligible.indexOf('NEST_HUBMAX_DATA') > -1) || (offersEligible.indexOf('NEST_AUDIO_DATA') > -1))){
                dispatch({ type: "IONT_ELIGIBLE_AMAZON", value: true })
                }
                if (response && response.data && response.data.cacheKey && response.data.cacheKey === 'ELIGIBLE_IONTORVZW') {
                    dispatch({ type: "IONT_ELIGIBLE", value: true })
                    //IONTOccupanyCheck(dispatch)
                    dispatch({ type: "IONT_STATUS", value: true })
                }
            }
            else if (response && !response.data && reAttemptCount < 3){
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchEligibleOffers', "fetchEligibleOffers " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "fetchEligibleOffers " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                setTimeout(() => {
                    fetchEligibleOffers(dispatch, visitId, offertype, (reAttemptCount + 1))
                }, 3000);
            } 
            else {
                dispatch({ type: 'FETCH_ELIGIBLE_OFFERS', value: 'NONE' });
            }
            
            isJointDeviceOffer = InHomeUtils.isNotNull(offersEligible) ? offersEligible.indexOf(OfferTypes.jointDevice) !== -1 ? true : false : false;
            return offersEligible;
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchEligibleOffers,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                return offersEligible;
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchEligibleOffers', ex);
    }
};

export const fetchWinbackProducts = (dispatch, flowType) => {
    let product = [];
    product.push({ id: 'WINBACKYES', prodType: 'WINBACK', name: 'Yes, check my number', displayPrice: '$4.99 One-Time fee may apply' });
    product.push({ id: 'WINBACKNO', prodType: 'WINBACK', name: 'No, I would like a new number', displayPrice: '$0.00' });
    dispatch({ type: 'FETCH_WINBACKPRODUCT', value: product });
    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Winback: true } });
}

export const fetchHoaBundle = async (dispatch, visitId, zip, state, tarCode, DOIDValue, masterpackagesview, servicesQualified, buildProductState = null, saveState = null, isquickCheckout = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchHoaBundle', "Inside fetchHoaBundle"));
        let url = apiUrl().vecorder;
        let request = { doKey: DOIDValue, uid: visitId };
        let addlInfo = {
            zip: zip,
            state: state,
            tarCode: tarCode,
            masterpackageview: masterpackagesview,
            selectedProductId: "",
            couponFlowType: null,
            EquipmentState: null,
            isAlaCarte: false,
            servicesQualified: servicesQualified
        };
        return api(url, 'POST', JSON.stringify(request)).then(async response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '404')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchHoaBundle', PAGEACTIVITY.MSG.error_404, PAGEACTIVITY.UA));
                    errorAction("LBO", "BuildProduct", "HOA", "", visitId, dispatch, true, "Service-404");
                    vzdlErrorUpdate(response.meta.code, "Service-404");
                    dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: false } });
                }
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchHoaBundle', "Response is Success"));
                    let logmessage = `DoFlow-STATE:${statevalue}|CONTRACT:${response.data.contract}`

                    //DOKEY is : ${DOIDValue} || Contract is : ${response.data.contract}
                    if (InHomeUtils.isNotNull(response.data.productMap)) {

                        if (InHomeUtils.isNotNull(response?.data?.productMap?.Data) && response?.data?.productMap?.Data?.length > 0) {
                            let prdString = ""
                            response?.data?.productMap?.Data?.forEach(p => {
                                prdString += p?.downSpeed + ",";
                            })
                            logmessage = logmessage + "|" + "DATA:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response?.data?.productMap?.Video) && response?.data?.productMap?.Video?.length > 0) {
                            let prdString = ""
                            response?.data?.productMap?.Video?.forEach(p => {
                                prdString += p?.prodTypeValue + ",";
                            })
                            logmessage = logmessage + "|" + "VIDEO:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response?.data?.productMap?.Fios_Voice) && response?.data?.productMap?.Fios_Voice?.length > 0) {
                            let prdString = ""
                            response?.data?.productMap?.Fios_Voice?.forEach(p => {
                                prdString += p?.name + ",";
                            })
                            logmessage = logmessage + "|" + "VOICE:" + prdString;
                        }
                    }
                    logmessage = logmessage + "|" + "DOKEY:" + DOIDValue;
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchHoaBundle', logmessage, PAGEACTIVITY.UA));
                    dispatch({ type: 'FETCH_HOABUNDLE', value: response?.data });
                    /*if(response?.data && response.data.defaultMap && response.data.defaultMap.internet && (typeof response.data.defaultMap.internet === 'string')){
                        setTimeout(()=>{
                            let notificationMssg =  `As a Verizon Enhanced Communities Value Program customer, your offer includes ${response.data.defaultMap.internet}`;
                            updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "name,detail,notification", false, "", false, notificationMssg);
                        },1000)
                    }*/
                    BindAllProductsDOFlow(response, visitId, zip, tarCode, dispatch, masterpackagesview, addlInfo.servicesQualified, true);
                    await BindCartProductsDOFlow(visitId, dispatch, response, null, state, addlInfo.servicesQualified, buildProductState, saveState, true);
                    dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: false } });
                    if (isquickCheckout && InHomeUtils.isNotNull(response?.data?.gigInCart) && !response?.data?.gigInCart) {
                        quickCheckout(dispatch, false);
                        redirectTo(Pages.BuildProduct + "?gignotqualified", dispatch);
                    }
                }
                if ((InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500'))) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchHoaBundle', "HoaFlow-DOKEY:" + DOIDValue + "|" + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:fetchHoaBundle,errorMessage:API response error`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: false } });
                    dispatch({ type: 'FETCH_HOABUNDLE', value: "NO_USOCS" });
                    errorAction("LBO", "BuildProduct", "HOA", "", visitId, dispatch, true, "hoa");
                }
            }
            else {
                doPrefetch("INIT", dispatch, visitId, addlInfo, 'MTM', '', false, '', '', '', '', '', buildProductState)
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: false } });
                if (isquickCheckout) {
                    quickCheckout(dispatch, false);
                    redirectTo(Pages.BuildProduct + "?hoaResponsenotvalid", dispatch);
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchHoaBundle', "Exception is: " + error.message));
                let errorMsg = `MethodName:fetchHoaBundle,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: false } });
                if (isquickCheckout) {
                    quickCheckout(dispatch, false);
                    redirectTo(Pages.BuildProduct + "?hoaResponsenotvalid", dispatch);
                }
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchHoaBundle', ex);
        dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: false } });
        if (isquickCheckout) {
            quickCheckout(dispatch, false);
            redirectTo(Pages.BuildProduct + "?hoaResponsenotvalid", dispatch);
        }
    }
};

export const fetchDOBundle = async (dispatch, visitId, zip, state, tarCode, DOIDValue, masterpackagesview, servicesQualified, buildProductState = null, saveState = null, isquickCheckout = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDOBundle', "Inside fetchDOBundle"));
        let url = apiUrl().dobundle;
        let request = { doKey: DOIDValue, uid: visitId };
        let addlInfo = {
            zip: zip,
            state: state,
            tarCode: tarCode,
            masterpackageview: masterpackagesview,
            selectedProductId: "",
            couponFlowType: null,
            EquipmentState: null,
            isAlaCarte: false,
            servicesQualified: servicesQualified
        };
        return api(url, 'POST', JSON.stringify(request)).then(async response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '404')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDOBundle', PAGEACTIVITY.MSG.error_404, PAGEACTIVITY.UA));
                    errorAction("LBO", "BuildProduct", "DOBundle", "", visitId, dispatch, true, "Service-404");
                    vzdlErrorUpdate(response.meta.code, "Service-404");
                }
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDOBundle', "Response is Success"));
                    let logmessage = `DoFlow-STATE:${statevalue}|CONTRACT:${response.data.contract}`

                    //DOKEY is : ${DOIDValue} || Contract is : ${response.data.contract}
                    if (InHomeUtils.isNotNull(response.data.productMap)) {

                        if (InHomeUtils.isNotNull(response.data.productMap.Data) && response?.data?.productMap?.Data?.length > 0) {
                            let prdString = ""
                            response.data.productMap.Data.forEach(p => {
                                prdString += p.downSpeed + ",";
                            })
                            logmessage = logmessage + "|" + "DATA:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response.data.productMap.Video) && response?.data?.productMap?.Video?.length > 0) {
                            let prdString = ""
                            response.data.productMap.Video.forEach(p => {
                                prdString += p.prodTypeValue + ",";
                            })
                            logmessage = logmessage + "|" + "VIDEO:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response.data.productMap.Fios_Voice) && response?.data?.productMap?.Fios_Voice?.length > 0) {
                            let prdString = ""
                            response.data.productMap.Fios_Voice.forEach(p => {
                                prdString += p.name + ",";
                            })
                            logmessage = logmessage + "|" + "VOICE:" + prdString;
                        }
                    }
                    logmessage = logmessage + "|" + "DOKEY:" + DOIDValue;
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDOBundle', logmessage, PAGEACTIVITY.UA));
                    dispatch({ type: 'FETCH_DOBUNDLE', value: response });
                    BindAllProductsDOFlow(response, visitId, zip, tarCode, dispatch, masterpackagesview, addlInfo.servicesQualified);
                    await BindCartProductsDOFlow(visitId, dispatch, response, null, state, addlInfo.servicesQualified, buildProductState, saveState);
                    if (isquickCheckout && InHomeUtils.isNotNull(response.data.gigInCart) && !response.data.gigInCart) {
                        quickCheckout(dispatch, false);
                        redirectTo(Pages.BuildProduct + "?gignotqualified", dispatch);
                    }
                }
                if ((InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500')) || (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))) { //If Getting DOBundle Response is Exception or null we will call default
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDOBundle', "DoFlow-DOKEY:" + DOIDValue + "|" + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:fetchDOBundle,errorMessage:API response error`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    doPrefetch("INIT", dispatch, visitId, addlInfo, 'MTM', '', false, '', '', '', '', '', buildProductState)
                    dispatch({ type: DOFlow.onDOError, value: true });//Capturing DO Error for default prefetch hide the video section...  
                    if (isquickCheckout) {
                        quickCheckout(dispatch, false);
                        redirectTo(Pages.BuildProduct + "?doResponsenotvalid", dispatch);
                    }
                }
            }
            else {
                doPrefetch("INIT", dispatch, visitId, addlInfo, 'MTM', '', false, '', '', '', '', '', buildProductState)
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                if (isquickCheckout) {
                    quickCheckout(dispatch, false);
                    redirectTo(Pages.BuildProduct + "?doResponsenotvalid", dispatch);
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDOBundle', "Exception is: " + error.message));
                let errorMsg = `MethodName:fetchDOBundle,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                if (isquickCheckout) {
                    quickCheckout(dispatch, false);
                    redirectTo(Pages.BuildProduct + "?doResponsenotvalid", dispatch);
                }
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchDOBundle', ex);
        if (isquickCheckout) {
            quickCheckout(dispatch, false);
            redirectTo(Pages.BuildProduct + "?doResponsenotvalid", dispatch);
        }
    }
};

export const fetchCareFlowBundle = (dispatch, visitId, zip, state, tarCode, masterpackagesview, couponFlowType, servicesQualified, buildProductState) => {
    try {
        let url = apiUrl().dobundle;
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCareFlowBundle', "Inside fetchCareFlowBundle"));
        let intents = [];
        if (InHomeUtils.isNotNull(couponFlowType)) {
            if (couponFlowType === "Employee" || couponFlowType === "Retiree") {
                intents.push({ "key": "Employee", "value": "Y" })
            }
            else if (couponFlowType === "Affinity") {
                intents.push({ "key": "Affinity", "value": "Y" })
            }
        }
        let request = {
            "doKey": "",
            "uid": visitId,
            "intents": intents
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '404')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCareFlowBundle', PAGEACTIVITY.MSG.error_404, PAGEACTIVITY.UA));
                    errorAction("LBO", "BuildProduct", "careFlowBundle", "", visitId, dispatch, true, "Service-404");
                    vzdlErrorUpdate(response.meta.code, "Service-404");
                }
                if (InHomeUtils.isNotNull(response?.meta) && InHomeUtils.getIndexOf(response?.meta?.code, '200') && InHomeUtils.isNotNull(response?.data)) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCareFlowBundle', "Response is success"));
                    let logmessage = `DoFlow-STATE:${statevalue}|CONTRACT:${response?.data?.contract}`
                    //couponFlowType is : ${couponFlowType} || Contract is : ${response.data.contract}`
                    if (InHomeUtils.isNotNull(response?.data?.productMap)) {

                        if (InHomeUtils.isNotNull(response?.data?.productMap?.Data) && response?.data?.productMap?.Data?.length > 0) {
                            let prdString = ""
                            response?.data?.productMap?.Data?.forEach(p => {
                                prdString += p?.downSpeed + ",";
                            })
                            logmessage = logmessage + "|" + "DATA:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response?.data?.productMap?.Video) && response?.data?.productMap?.Video?.length > 0) {
                            let prdString = ""
                            response?.data?.productMap?.Video?.forEach(p => {
                                prdString += p?.prodTypeValue + ",";
                            })
                            logmessage = logmessage + "|" + "VIDEO:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response?.data?.productMap?.Fios_Voice) && response?.data?.productMap?.Fios_Voice?.length > 0) {
                            let prdString = ""
                            response?.data?.productMap?.Fios_Voice?.forEach(p => {
                                prdString += p?.name + ",";
                            })
                            logmessage = logmessage + "|" + "VOICE:" + prdString;
                        }
                    }
                    logmessage = logmessage + "|" + "COUPONFLOWTYPE:" + couponFlowType
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCareFlowBundle', logmessage, PAGEACTIVITY.UA));

                    dispatch({ type: 'FETCH_DOBUNDLE', value: response });
                    BindAllProductsDOFlow(response, visitId, zip, tarCode, dispatch, masterpackagesview, servicesQualified);
                    BindCartProductsDOFlow(visitId, dispatch, response, couponFlowType, state, servicesQualified);
                }
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500')) { //If Getting DOBundle Response is Exception or null we will call default
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCareFlowBundle', "DoFlow : couponFlowType is : " + couponFlowType + " || " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:fetchCareFlowBundle,errorMessage:API response error`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    let addlInfo = {
                        zip: zip,
                        state: state,
                        tarCode: tarCode,
                        masterpackageview: masterpackagesview,
                        selectedProductId: "",
                        couponFlowType: couponFlowType,
                        EquipmentState: null,
                        isAlaCarte: false,
                        servicesQualified: servicesQualified
                    };
                    doPrefetch("INIT", dispatch, visitId, addlInfo, 'MTM', '', false, '', '', '', '', '', buildProductState);
                    dispatch({ type: DOFlow.onDOError, value: true });//Capturing DO Error for default prefetch hide the video section...
                    //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCareFlowBundle', "Exception is: " + error.message));
                let errorMsg = `MethodName:fetchCareFlowBundle,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchCareFlowBundle', ex);
    }
};

export const DispatchBundles = (response, visitId, zip, tarCode, dispatch, masterpackagesviewRows) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchBundles', "Inside DispatchBundles"));
        if (InHomeUtils.isNotNull(response)) {
            if (InHomeUtils.isNotNull(response?.data?.productMap?.Data) && response?.data?.productMap?.Data?.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchBundles', "Dispatch DATA 2YR"));
                dispatch({ type: 'FETCH_DATA2Y', value: response?.data?.productMap?.Data?.map(p => p) });
                //For Getting Help me choose content with speed code 
                let speedCode = "";
                response?.data?.productMap?.Data?.forEach(p => {
                    speedCode += p?.speedCode + ",";
                })
                dispatch({ type: 'SPEED_CODE', value: speedCode });
                if (response?.data?.productMap?.Data?.length == 1) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'DataTiles', response?.data?.productMap?.Data[0]?.downSpeed + " only available"));
                }
            }
            if (InHomeUtils.isNotNull(response?.data?.productMap?.Video) && response?.data?.productMap?.Video?.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchBundles', "Dispatching Video products"));
                let tvPlans = response?.data?.productMap?.Video?.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC' || p.prodTypeValue.indexOf('CUSTOM') === -1)
                let customTvPlans = response?.data?.productMap?.Video?.filter(p => p.prodTypeValue.indexOf('CUSTOM') > -1 && p.prodTypeValue !== 'CUSTOM_GENERIC')
                let testdriveTvPlans = response?.data?.productMap?.Video?.filter(p => p.prodTypeValue === 'ULTIMATETESTDRIVE');
                let ultimateTv = response?.data?.productMap?.Video?.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');

                if (InHomeUtils.isNotNull(tvPlans) && tvPlans?.length > 0) {
                    for (let i = 0; i < tvPlans?.length; i++) {
                        if (tvPlans[i]?.prodTypeValue === "CUSTOM_GENERIC") {
                            tvPlans[i].description = "155+ channels  (7 plans to choose from)";
                            continue;
                        }
                        if (InHomeUtils.isNotNull(masterpackagesviewRows)) {
                            let tvPackage = fetchrowMasterTvList(masterpackagesviewRows, tvPlans[i].id);
                            if (InHomeUtils.isNotNull(tvPackage)) {
                                tvPlans[i].description = tvPackage.totalchannelcount + "+ channels (" + tvPackage.hdchannelcount + "+ in HD)";
                            }
                        }
                    }
                }

                if (InHomeUtils.isNotNull(testdriveTvPlans) && testdriveTvPlans?.length > 0) {
                    dispatch({ type: 'ULTIMATE_DRIVE_AVL', value: true });
                }
                if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv?.length > 0) {
                    dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id });
                }
                if (InHomeUtils.isNotNull(tvPlans)) {
                    dispatch({ type: 'FETCH_TV2Y', value: tvPlans.map(p => p) });
                }
                if (InHomeUtils.isNotNull(customTvPlans)) {
                    dispatch({
                        type: 'FETCH_CUSTOMTV',
                        value: customTvPlans.map(p => p)
                    });
                }
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'DispatchBundles', ex);
    }
}

export const DispatchStandalone = (response, visitId, zip, tarCode, dispatch, masterpackageview, servicesQualified) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Inside DispatchStandalone"));
        if (InHomeUtils.isNotNull(response)) {
            //Dispatch Data Response
            if (InHomeUtils.isNotNull(response?.data?.productMap?.Data) && response?.data?.productMap?.Data?.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Dispatching Data M2M"));
                dispatch({ type: 'FETCH_DATAM2M', value: response?.data?.productMap?.Data?.map(p => p) });
                //For Getting Help me choose content with speed code 
                let speedCode = "";
                response?.data?.productMap?.Data?.forEach(p => {
                    speedCode += p?.speedCode + ",";
                })
                dispatch({ type: 'SPEED_CODE', value: speedCode });
                if (response?.data?.productMap?.Data?.length == 1) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'DataTiles', response?.data?.productMap?.Data[0]?.downSpeed + " only available"));
                }
                //servicesQualified.isVideoQualified ? fetchData2Y(dispatch, visitId) : {};
                 store.getState() && store.getState().loopQual && store.getState().loopQual.lqResponse && store.getState().loopQual.lqResponse.isFCP ? fetchDataMTM(dispatch, visitId) :  fetchData2Y(dispatch, visitId);

            }
            else {
                //If the DObundle response returns the Null value for Video we will make the default prefetch call
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Fetching Data M2M"));
                servicesQualified.isDataQualified ? fetchDataMTM(dispatch, visitId) : {};
                dispatch({ type: 'UPDATE_DATA_CONTRACT', value: '2YR' });
            }
            //Dispatch TV Response 
            if (InHomeUtils.isNotNull(response?.data?.productMap?.Video) && response?.data?.productMap?.Video?.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Dispatching TV products"));
                let tvPlans = response?.data?.productMap?.Video?.filter(p => p?.prodTypeValue === 'CUSTOM_GENERIC' || p?.prodTypeValue.indexOf('CUSTOM') === -1)
                let testdriveTvPlans = response?.data?.productMap?.Video?.filter(p => p?.prodTypeValue === 'ULTIMATETESTDRIVE');
                let ultimateTv = response?.data?.productMap?.Video?.filter(p => p?.prodType === 'BASIC' && p?.prodTypeValue === 'ULTIMATE');
                if (InHomeUtils.isNotNull(testdriveTvPlans) && testdriveTvPlans?.length > 0) {
                    dispatch({ type: 'ULTIMATE_DRIVE_AVL', value: true });
                }
                if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv?.length > 0) {
                    dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id });
                }
                dispatch({ type: 'FETCH_TVM2M', value: tvPlans?.map(p => p) });

                store.getState() && store.getState().loopQual && store.getState().loopQual.lqResponse && store.getState().loopQual.lqResponse.isFCP ? fetchTVMTM(dispatch, visitId, zip, tarCode, masterpackageview, true) :  fetchTV2Y(dispatch, visitId, zip, tarCode, masterpackageview, true);

                //servicesQualified.isVideoQualified ? fetchTV2Y(dispatch, visitId, zip, tarCode, masterpackageview, true) : {};
            }
            else {
                //If the DObundle response returns the Null value for Video we will make the default prefetch call           
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "fetching TV M2M"));
                servicesQualified.isVideoQualified ? fetchTVMTM(dispatch, visitId, zip, tarCode, masterpackageview, true) : {};
                dispatch({ type: 'UPDATE_VIDEO_CONTRACT', value: 'MTM' });
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'DispatchStandalone', ex);
    }
}

export const BindAllProductsDOFlow = (response, visitId, zip, tarCode, dispatch, masterpackagesview, servicesQualified, hoaFlow = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'BindAllProductsDOFlow', "Inside BindAllProductsDOFlow"));
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)) {
            if (response.data.contract === "TWOYEAR") {
                DispatchBundles(response, visitId, zip, tarCode, dispatch, masterpackagesview)
            }
            else {
                DispatchStandalone(response, visitId, zip, tarCode, dispatch, masterpackagesview, servicesQualified)
            }
            if (InHomeUtils.isNotNull(response?.data?.productMap?.Fios_Voice) && response?.data?.productMap?.Fios_Voice?.length !== 0) {
                dispatch({ type: 'FETCH_VOICE', value: response?.data?.productMap?.Fios_Voice?.map(p => p) });
                let sortedResponse = InHomeUtils.isNotNull(response?.data?.voiceUsageRatesList) && response?.data?.voiceUsageRatesList?.sort(function (a, b) { return (a.countryName < b.countryName) ? -1 : (a.countryName > b.countryName) ? 1 : 0; });
                InHomeUtils.isNotNull(sortedResponse) && dispatch({
                    type: 'FETCH_INTLCALLING',
                    value: sortedResponse
                });
            }
            else {
                servicesQualified.isVoiceQualified ? fetchVoiceMTM(dispatch, visitId) : {};
            }
            // Fix added for Restrict Duplicate LoadTn calling when already has requestTN or loadTNForSCResume
            let isTNUpdated = false;
            if (store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.issmartcartflow
                && store.getState().buildProduct.requestTN && InHomeUtils.isNotEmpty(store.getState().buildProduct.requestTN)
                && store.getState().save && store.getState().save.loadTNForSCResume && InHomeUtils.isNotEmpty(store.getState().save.loadTNForSCResume)
                && store.getState().buildProduct.requestTN === store.getState().save.loadTNForSCResume && store.getState().save.isTNUpdatedForResumeSmartCart) {
                isTNUpdated = true;
            }
            if (!isTNUpdated) {
                console.log("buildProduct: loadTN1 TN not updated");
                loadTN(visitId, dispatch, hoaFlow ? response.data : null);
            }
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'BindAllProductsDOFlow', PAGEACTIVITY.MSG.responseEmpty, PAGEACTIVITY.UA));
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'BindAllProductsDOFlow', ex);
    }
};

export const fetchFreeRouter = (dispatch, visitId, flowType, hoaFlow = false, serType = "",buildProduct) => { //For DoFlow Only
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchFreeRouter', "Inside fetchFreeRouter"));
        let routerPlans = "";
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
            apiType = 'ACCESSPOINTBILLER';
        }
        let mm3Qualified = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.mm3Qualified;
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, 'MTM', 'router', flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products)) {                   
                    response.data.products.forEach((prod) => setHtmlSymbols(prod));
                    dispatch({
                        type: 'FETCH_ROUTER',
                        value: response.data.products.map(p => p)
                    });
                    routerPlans = response.data.products.filter(p => p.prodTypeValue !== 'CUSTOMER_PROVIDED_ROUTER').sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                    response.data.products.filter(p => p.prodTypeValue === 'CUSTOMER_PROVIDED_ROUTER').map(p => routerPlans.push(p));
                   /* dispatch({
                        type: 'FETCH_ROUTER',
                        value: routerPlans.map(p => p)
                    });
                    */
                    if (hoaFlow) {
                        dispatch({
                            type: 'UPDATE_HOADETAILS_ROUTER',
                            value: routerPlans?.filter(p => (p.keyword.indexOf('VVPROUTER') > -1 && p.prodTypeValue === "VZROUTER_NOT_CHARGED_CONSUMER"))
                        });
                    }
                    if (InHomeUtils.isNotNull(routerPlans)) {
                        if( mm3Qualified !== true) { 
                        updateSubProductCartonLoad(visitId, routerPlans[0], dispatch, 'MTM', serType, buildProduct)
                        }
                        if (routerPlans?.length > 0) {
                            dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Router: true } });
                        }
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchFreeRouter', "FREE Router " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:fetchFreeRouter,errorMessage:Router Plans null`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
            }
        })
            .catch(error => {
                //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchFreeRouter,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchFreeRouter', ex);
    }
};

export const BindCartProductsDOFlow = async (visitId, dispatch, doresponse, couponFlowType, state, servicesQualified, buildProductState = null, saveState = null, hoaFlow = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'BindCartProductsDOFlow', "Inside BindCartProductsDOFlow"));
        let cartResult = false;
        let LqHOAFlow = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqResponse.hoaFlag;
        let url = apiUrl().getCartAcc + '/' + visitId;
        return api(url, 'GET', "").then(response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    if (InHomeUtils.isNotNull(response.data)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent)
                        && response?.data?.cartTierPricing?.tierContent?.length > 0) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'BindCartProductsDOFlow', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));

                        try {
                            if (InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections)
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0])
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections)
                                && response?.data?.cartTierPricing?.tierContent[0]?.sections?.section[0]?.subSections?.length > 0) {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'BindCartProductsDOFlow', "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, PAGEACTIVITY.UA));
                            }
                        }
                        catch (ex) {
                            catchJSException(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'BindCartProductsDOFlow', ex);
                        }
                    }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'BindCartProductsDOFlow', "CART TIER CONTENT EMPTY", PAGEACTIVITY.UA));
                    }

                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail,
                            cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                        }
                    });
                    cartResult = true;
                }
                if (cartResult) {
                    let cartProducts = getCartProducts(response.data.cartTierPricing, visitId)
                    let cartResponse = InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing;
                    let contract = '';
                    if (InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.contract)) {
                        contract = response.data.orderDetail.contract;
                    }
                    let flowTypeVal = store && store?.getState && store?.getState().app && store?.getState()?.app?.flowType;
                    if(response.data && response.data.orderDetail && response.data.cartTierPricing){
                        setProductsCurrent(response.data.orderDetail, response.data.cartTierPricing, flowTypeVal ,"scAdd,scOpen");
                    }
                    let additionalInfo = { flowType: 'DoFlow', isUpsell: false, couponFlowType: couponFlowType, orderType: '', vcpestbQty: '' };
                    PreselectCartProducts(cartProducts, dispatch, visitId, additionalInfo, doresponse, buildProductState, '', response.data, servicesQualified, hoaFlow)
                    fetchOfferInCart(visitId, cartProducts, dispatch, contract, true, response);
                    getSpecialOffers(visitId, contract, dispatch, '', true, null, cartProducts, false, cartResponse);
                    BindContractForDOFlow(response.data, dispatch, couponFlowType, servicesQualified)
                    DispatchCollapsedView(dispatch)
                    DispatchSelectedCoreService(response.data.orderDetail, dispatch)
                    if (InHomeUtils.isNull(couponFlowType) && LqHOAFlow !== "Y") {
                        DispatchDoStatus(true, dispatch, doresponse?.data?.productMap?.Video?.length === 0)//Fix For DoFlow Page Refresh case
                    }

                    if (InHomeUtils.isNotNull(couponFlowType) && (couponFlowType === "Employee" || couponFlowType === "Retiree")) {
                        //If emp flow diable contract accordion section --here
                        updateContractAccordionStatus(dispatch, true);
                    }
                    //To trigger the save as  autgen on Do flow
                    if (InHomeUtils.isNotNull(saveState) && (InHomeUtils.isNotEmpty(saveState.saveLqMtnInput) || InHomeUtils.isNotEmpty(saveState.saveLqEmailInput)) && InHomeUtils.isNotNull(buildProductState) && !buildProductState.doSmartCart) {
                        doSmartCartSave(dispatch, visitId, saveState.saveLqMtnInput, saveState.saveLqEmailInput);
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'BindCartProductsDOFlow', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'BindCartProductsDOFlow', "Exception is: " + error.message));
                let errorMsg = `MethodName:BindCartProductsDOFlow,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                const page = {
                    page: 'BuildProduct',
                    mount: '',
                    unmount: '',
                    apiFetched: Date.now()
                }
                checktime(page);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'BindCartProductsDOFlow', ex);
    }
};

export const isGPONIONTEligible = (status, dispatch) => {
    dispatch({ type: BuildProduct.isGPONIONTEligible, value: status })
};
export const isBannerChecked = (status, dispatch) => {
    dispatch({ type: BuildProduct.isBannerChecked, value: status })
};
export const setSmartCartFlow = (status, dispatch) => {
    smartCartFlow = status;
    dispatch({ type: BuildProduct.isSmartCartFlow, value: status })
};
export const isMarvelOfferInCart = (status, dispatch) => {
    dispatch({ type: BuildProduct.isMarvelOfferInCart, value: status })
};
export const isIdleTimeCheckout = (status, dispatch) => {
    dispatch({ type: BuildProduct.isIdleTimeCheckout, value: status })
};
export const previousSelectedSpeed = (status, dispatch) => {
    dispatch({ type: BuildProduct.previousSelectedSpeed, value: status })
};
export const isMarvelInPreviousSelSpd = (status, dispatch) => {
    dispatch({ type: BuildProduct.isMarvelInPreviousSelSpd, value: status })
};
export const isBostonDMA = (status, dispatch) => {
    dispatch({ type: BuildProduct.isBostonDMA, value: status })
};
export const setIONTContractAccor = (status, dispatch) => {
    dispatch({ type: 'TOGGLE_CONTRACT_ACCOR_IONT', value: status })
};
export const setIONTContractAccorStatus = (status, dispatch) => {
    dispatch({ type: 'TOGGLE_CONTRACT_ACCOR_IONT_STATUS', value: status })
};
export const updateSetBrowerInfoInvoked = (value, dispatch) => {
    dispatch({ type: 'SET_BROWSERINFO_INVOKED', value: value })
};
export const DispatchCollapsedView = (dispatch) => {
    //dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
    dispatch({ type: 'TOGGLE_TV_ACCOR', value: 'DOFlow' });
};

export const ResumeCollapsedView = (dispatch) => {
    dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: 'ResumeFlow' });
};

export const DispatchDoStatus = (dostatus, dispatch, fetchtvres) => {
    dispatch({ type: DOFlow.onDOStatus, value: dostatus });
    if (!fetchtvres) {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const DispatchSelectedCoreService = (response, dispatch) => {
    let selectedCoreService = InHomeUtils.isNotNull(response) && response.servicesOrdered;
    if (InHomeUtils.isNotNull(selectedCoreService)) {
        //"DATA","VIDEO","DATA,VIDEO","DATA,FIOS_VOICE","VIDEO,FIOS_VOICE"
        dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService } });
    }
}

export const smartCartSelectedCoreService = (selectedCoreService, dispatch) => {
    if (InHomeUtils.isNotNull(selectedCoreService)) {
        dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService } });
    }
}

export const BindContractForDOFlow = (response, dispatch, couponFlowType) => {
    if (InHomeUtils.isNotNull(response.orderDetail)) {
        if (response.orderDetail.contract === "TWOYEAR") {
            updatecontractforSC("2YR", response.orderDetail.bundle, dispatch, couponFlowType)
        } else {
            updatecontractforSC("MTM", response.orderDetail.bundle, dispatch, couponFlowType)
        }
    } else if (InHomeUtils.isNotNull(response.cartOrderDetail)) {
        if (response.cartOrderDetail.contract === "TWOYEAR") {
            updatecontractforSC("2YR", response.cartOrderDetail.bundle, dispatch, couponFlowType)
        } else {
            updatecontractforSC("MTM", response.cartOrderDetail.bundle, dispatch, couponFlowType)
        }
    }
};

export const updateSubProductCartonLoad = (visitId, product, dispatch, contract, serType,buildProduct) => {
    let isMnHAuthenticated = ""
    if(buildProduct?.internet?.mnhSignupIndicator !== "" && buildProduct?.internet?.mnhSignupIndicator !== null && buildProduct?.internet?.mnhSignupIndicator !== undefined){
        isMnHAuthenticated = buildProduct?.internet?.mnhSignupIndicator
      }
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSubProductCartonLoad', "Inside updateSubProductCartonLoad"));
        let url = apiUrl().updateCartAcc + '/' + visitId;
        let request = {
            contract: contract,
            productId: product.id,
            productType: product.prodType,
            quantity: "1",
            serviceType: InHomeUtils.isNotNull(serType) && InHomeUtils.isNotEmpty(serType) ? serType : "DATA",
            status: "add",
            isMnHAuthenticated:isMnHAuthenticated
        }

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSubProductCartonLoad', "Response Success"));
                    if (InHomeUtils.isNotNull(response.data)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent)
                        && response?.data?.cartTierPricing?.tierContent?.length > 0) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateSubProductCartonLoad', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));
                    }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateSubProductCartonLoad', "CART EMPTY", PAGEACTIVITY.UA));
                    }
                    // console.log('***** perks cart 2');
                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                            cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail,
                            cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                        }
                    });
                    DispatchRouterFreeProduct(product, dispatch);
                }
                else { //error while updating cart
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateSubProductCartonLoad', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:updateSubProductCartonLoad,errorMessage:API Error while updating cart`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSubProductCartonLoad', "Exception is: " + error.message));
                let errorMsg = `MethodName:updateSubProductCartonLoad,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateSubProductCartonLoad', ex);
    }
}

export const DispatchRouterFreeProduct = (product, dispatch) => {
    let isChecked = true;
    dispatch({ type: 'SELECTROUTER_SELECTEDPROD', value: isChecked ? product : null });
}
export const SuppSplOfferPYP = (sploffPYP, dispatch) => {
    dispatch({ type: 'SPL_OFFER_PYP', value: sploffPYP });
}

export const fetchOfferInCart = (visitId, cartProducts, dispatch, contract, isDoFlow, cartResponse, isFromUpdateCart, stadiaMLPFlow = false, lqState = null, flowType = null, isUpdateSpecialOffer = true, specialOfferpromo) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchOfferInCart', "Inside fetchOfferInCart"));
        if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
            logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchOfferInCart', "cart products available"));
            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.rewardoffers)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchOfferInCart', "cart Promotions Available"));
                let data;
                let speed400Data;
                let eventAction = "";
                if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd) && cartResponse && InHomeUtils.isNotNull(cartResponse.data) && cartResponse.data.orderDetail && cartResponse.data.orderDetail.contract && cartResponse.data.orderDetail.contract === 'MTM') {
                    data = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.speedCode) && e.speedCode === 944);
                    speed400Data = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.speedCode) && e.speedCode === 945);

                }
                let promotions = cartProducts.CartSubProduct.SpecialOffers.rewardoffers;
                let isDisney = promotions.filter(e => e.offerAttrValue === 'DISNEYPLUS_12MO');
                let isAmazonshow5 = promotions.filter(e => e.offerAttrValue === 'AMAZON_SHOW5');
                if (InHomeUtils.isNotNull(isAmazonshow5) && isAmazonshow5?.length > 0) {
                    isAmazonWithDisney = true;
                }
                let isHulufor400M = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'HULUSVOD_12MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'HULUSVOD_12MO')));

                if (InHomeUtils.isNotNull(speed400Data) && speed400Data?.length > 0 && InHomeUtils.isNotNull(isDisney) && isDisney?.length > 0 && isAmazonWithDisney) {
                    if (InHomeUtils.isNotNull(isHulufor400M) && isHulufor400M?.length > 0) {
                        includeDisneyAsSpecialOffer = false;

                    }
                    else {
                        includeDisneyAsSpecialOffer = true;
                    }
                }
                else {
                    includeDisneyAsSpecialOffer = false;
                }
                if (InHomeUtils.isNotNull(data) && data?.length > 0 && InHomeUtils.isNotNull(isDisney) && isDisney?.length > 0) {
                    includeDisneyAsSpecialOffer = true;
                }
                else {
                    includeDisneyAsSpecialOffer = false;
                }
                if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                    data = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.speedCode) && e.speedCode === 944);
                }
                let isfcpFlow = InHomeUtils.isFcpFlow();
                let isHulufor200M = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'HULUSVOD_6MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'HULUSVOD_6MO')));
                if (InHomeUtils.isNotNull(data) && data?.length > 0 && InHomeUtils.isNotNull(isDisney) && isDisney?.length > 0 && InHomeUtils.isNotNull(isfcpFlow) && isfcpFlow && !showMarvel && isHulufor200M && isHulufor200M.length === 0) {
                    includeDisneyAsSpecialOffer = true;
                }
                else {
                    includeDisneyAsSpecialOffer = false;
                }
    
                dispatch({ type: 'CONTRACTOFFER_SELECTEDPRODID', value: promotions.length > 0 ? processOfferSection(promotions) : null })
                dispatch({ type: 'CONTRACTOFFER_UPDATE_CONTRACT', value: contract })
                //let specialOffers = promotions.filter(offer => ((offer.offerAttr === 'JMPADD' && offer.offerAttrValue.indexOf('FIOS200') > -1) || (offer.offerAttr === 'VZREWARD' && (offer.offerAttrValue.indexOf('HOLIDAY_VISACARD') > -1))));
                //let dataOffers = promotions.filter(offer => getOffersFilter(offer, Service.data));
                //For 200 Mbps case added condition
                //let dataOffers = (InHomeUtils.isNotNull(promotions) && promotions.length === 1 && promotions[0].offerFor.toUpperCase() === "DATA") ? promotions : promotions.filter(offer => getOffersFilter(offer, Service.data));
                // let leadListPromiseData = fetchDataMTM(dispatch, visitId,'NC'); 
        let isLeadList = false;
        // if(!isResumecartFlow){   // to avoid multiple plan call in resumeCart flow
        let vecFlow = store?.getState()?.loopQual && store?.getState()?.loopQual.lqResponse && (store?.getState()?.loopQual.lqResponse.hoaFlag === "V" || store?.getState()?.loopQual.lqResponse.hoaFlag === "Y");
        if(!vecFlow){
            let leadListPromiseData = fetchDataMTM(dispatch, visitId,flowType)      
        Promise.all([leadListPromiseData]).then(function (values) {
            isLeadList = values?.[0]?.leadListAddress;
            if(isLeadList && specialOfferpromo!= undefined && (specialOfferpromo?.id == "R4010" || specialOfferpromo?.id == "R4017")){
                specialOfferpromo.offerAttr = specialOfferpromo?.BsOfferAttr;
                specialOfferpromo.offerId = specialOfferpromo?.bsOfferId;
                specialOfferpromo.promoId = specialOfferpromo?.id;
                specialOfferpromo.promoText = specialOfferpromo?.OfferText;
                specialOfferpromo.promotionId = specialOfferpromo?.bsPromoId;
                promotions = [];
                promotions.push(specialOfferpromo);
            }
            if(specialOfferpromo == undefined){
                let spclOffer20InCart = cartProducts?.CartSubProduct?.Promotions?.promotions?.filter(offer => offer.offerAttrValue == "Special_$20_Discount");
                promotions.push(spclOffer20InCart?.[0]);
            }
            let dataOffers = InHomeUtils.isNotNull(promotions) && promotions?.length > 0 ? promotions.filter(offer =>  getOffersFilter(offer, Service.data) ) : promotions;
            if (dataOffers?.length === 0) {
                dataOffers = InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions.filter(o => (o.offerAttrValue === "SPR_VIN_PH_BO_DMA") || (o.offerAttrValue === "SPR_VIN_NOT_NYDMA") || (o.offerAttrValue === "SPR_VIN_NYDMA") || (o.offerAttrValue === "Special_Ongoing_$5_Discount") || (o.offerAttrValue === "Special_Ongoing_$20_Discount") )) ? [...dataOffers,...cartProducts.CartSubProduct.Promotions.promotions.filter(o => (o.offerAttrValue === "SPR_VIN_PH_BO_DMA") || (o.offerAttrValue === "SPR_VIN_NOT_NYDMA") || (o.offerAttrValue === "SPR_VIN_NYDMA")  || (o.offerAttrValue === "Special_Ongoing_$5_Discount") || (o.offerAttrValue === "Special_Ongoing_$20_Discount")) ]: null;
            }
            let removeCyberMondayXbox = dataOffers?.filter(offer=>offer?.id !== "R4139") || [];
            dataOffers = [...removeCyberMondayXbox]
            if (Array.isArray(dataOffers) && dataOffers?.length > 0) {
                dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: dataOffers?.length > 0 ? processOfferSection(dataOffers?.[0]) : null })
                isUpdateSpecialOffer && dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: dataOffers?.length > 0 ? processOfferSection(dataOffers?.[0]) : null })
            }
        });
    }
    // }                
                let dataOffers = InHomeUtils.isNotNull(promotions) && promotions?.length > 0 ? promotions.filter(offer =>  getOffersFilter(offer, Service.data) ) : promotions;
                if (dataOffers?.length === 0) {
                    dataOffers = InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions.filter(o => (o.offerAttrValue === "SPR_VIN_PH_BO_DMA") || (o.offerAttrValue === "SPR_VIN_NOT_NYDMA") || (o.offerAttrValue === "SPR_VIN_NYDMA") || (o.offerAttrValue === "Special_Ongoing_$5_Discount") || (o.offerAttrValue === "Special_Ongoing_$20_Discount") )) ? [...dataOffers,...cartProducts.CartSubProduct.Promotions.promotions.filter(o => (o.offerAttrValue === "SPR_VIN_PH_BO_DMA") || (o.offerAttrValue === "SPR_VIN_NOT_NYDMA") || (o.offerAttrValue === "SPR_VIN_NYDMA")  || (o.offerAttrValue === "Special_Ongoing_$5_Discount") || (o.offerAttrValue === "Special_Ongoing_$20_Discount")) ]: null;
                }
                let tvOffers = promotions.filter(offer => getOffersFilter(offer, Service.video));
                let combinedOffers = [...dataOffers, ...tvOffers];
                let specialOffers = promotions.filter(x => !combinedOffers.includes(x));
                let StadiaInCart = [];
                if ((Array.isArray(dataOffers) && dataOffers?.length > 0) || (Array.isArray(tvOffers) && tvOffers?.length > 0)) {
                    dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: dataOffers?.length > 0 ? processOfferSection(dataOffers[0]) : null })
                    isUpdateSpecialOffer && dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: dataOffers?.length > 0 ? processOfferSection(dataOffers[0]) : null })
                    
                    dispatch({ type: 'SPLOFFER_SELECTEDPRODID_TV', value: tvOffers?.length > 0? processOfferSection(tvOffers[0]) : null })
                    StadiaInCart = promotions.filter(x => combinedOffers.includes(x));
                }

                let Mergescevent  = (InHomeUtils.isNotNull(lqState) && lqState.runtimeKey && lqState.runtimeKey.Mergescevent  && lqState.runtimeKey.Mergescevent  === "Y") ? "Y" : "N";
                if ((isDoFlow || isFromUpdateCart) && StadiaInCart[0]) {
                    addToCartSCEvent(visitId, StadiaInCart[0], Service.splOffer, cartResponse, isDoFlow, true, null, isfcpFlow);
                    // setTimeout(() => {
                    //     addToCartVzdlSCEvent(visitId, StadiaInCart[0], Service.splOffer, cartResponse, isDoFlow, true, null, flowType, isfcpFlow,'AddtoCart', null, null, isTagGspeed, "Y");
                    // }, 1000);
                }
                let flashOffers = promotions.filter(offer => (offer.offerAttr === 'ACQBLACKFRIDAY2021'))
                    // dispatch({ type: 'FLASHOFFER_SELECTEDPRODID', value: flashOffers.length > 0 ? processOfferSection(flashOffers[0]) : null })
                if (isFromUpdateCart && dataOffers?.length > 0 && InHomeUtils.isNotNull(lqState)) {
                    let echoOfferInCart = dataOffers[0]?.OfferText?.toLowerCase().indexOf("echo 4th gen") > -1;
                    echoOfferInCart ? fetchTVMTM(dispatch, visitId, lqState.selectedAdr.zip, lqState.selectedState.tarCode, '', false, null, flowType) : "";
                }
                /* CETC-145933 Perks shouldn't auto expand for classic customers*/
                const buildProductSplOffer = store?.getState()?.buildProduct?.sploffer;
                const internetSplOffers = buildProductSplOffer?.data?.offerplansMTM;
                if ((!Array.isArray(internetSplOffers) || internetSplOffers?.length === 0) || (internetSplOffers?.length > 0 && buildProductSplOffer?.data?.selectedProduct)) {
                    const isMM4 = store?.getState()?.buildProduct?.internet?.m2mPlans?.[0]?.productKeyword?.includes("MM4");
                    if (isMM4) {
                        const isEmberMnHAuthenticated = store?.getState()?.buildProduct && store.getState().buildProduct?.internet?.mnhSignupIndicator === "Y" && store.getState().buildProduct?.emberInfo?.isEmberFlow;
                        if(isEmberMnHAuthenticated){
                            let perksElement = document.getElementById("toggle_internet_perks_accor");
                            if(perksElement){
                                perksElement.click();
                            }
                        }
                        dispatch({ type: "TOGGLE_PERKS_ACCOR", value: true });                            
                    }
                }
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchOfferInCart', "CART PROMOTIONS" + PAGEACTIVITY.MSG.notAvailable, PAGEACTIVITY.UA));
            }
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchOfferInCart', "CART PRODUCTS " + PAGEACTIVITY.MSG.notAvailable, PAGEACTIVITY.UA));
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchOfferInCart', ex);
    }
}

export const PreselectCartProducts = (cartProducts, dispatch, visitId, additionalInfo, doresponse, buildProduct, lqState, cart, servicesQualified, hoaFlow = false, hasDVR = false, cartresp = null) => {
    //(cartProducts, dispatch, visitId, flowType, doresponse, buildProduct, lqState, cart, servicesQualified, isUpsell = false, couponFlowType = null,orderType = "")
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Inside PreselectCartProducts"));
        let isChecked = true;
        let isFCPResumeFlow = (additionalInfo.flowType === 'FCPResume') ? true : false;
        let isDoFlow = (additionalInfo.flowType === 'DoFlow') ? true : false;
        let isSuppFlow = (additionalInfo.flowType === 'SUPP') ? true : false;
        let is15gFlow = (additionalInfo.flowType === '15G') ? true : false;
        vcloud = (lqState && lqState.runtimeKey && lqState.runtimeKey.vcloud && lqState.runtimeKey.vcloud === "Y") ? "Y" : "N";
        if (InHomeUtils.isNotNull(cartProducts)) {            
            if (InHomeUtils.isNotNull(cartProducts.Bundle)) {                
                for (let preselcount = 0; preselcount < cartProducts?.Bundle?.bundleProd?.length; preselcount++) {                    
                    if (cartProducts.Bundle.bundleProd[preselcount].editLink === CartServices.dataPlans && servicesQualified.isDataQualified) {                        
                        if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap.Data)) {
                            for (let datacount = 0; datacount < doresponse?.data?.productMap?.Data?.length; datacount++) {
                                if (doresponse.data.productMap.Data[datacount].id === cartProducts.Bundle.bundleProd[preselcount].prodId) {
                                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Data Id's -Bundle"));
                                    dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? processOfferSection(doresponse.data.productMap.Data[datacount]) : null });
                                    if (isChecked && isSuppFlow) {
                                        suppSelectedProds.push(doresponse.data.productMap.Data[datacount].prodId)
                                    }
                                    fetchRouter(dispatch, visitId, additionalInfo.orderType, 0, false, null, "", null, additionalInfo.flowType);
                                    //fetchRouter(dispatch, visitId, additionalInfo.orderType)
                                    fetchInternetSubProducts(dispatch, visitId, additionalInfo.orderType);
                                    fetchStreamingServices(visitId, dispatch, additionalInfo.orderType, additionalInfo.couponFlowType);
                                }
                            }
                        }
                        else {                           
                            //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB,visitId,'PreselectCartProducts',"DATANOTFOUND-DORESPONSE-BUNDLE",PAGEACTIVITY.UA));
                            dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? cartProducts.Bundle.bundleProd[preselcount] : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(cartProducts.Bundle.bundleProd[preselcount].prodId)
                            }
                        }
                    }
                    else if (cartProducts.Bundle.bundleProd[preselcount].editLink === CartServices.tvPlans && servicesQualified.isVideoQualified) {
                        if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Video)) {
                            for (let videocount = 0; videocount < doresponse?.data?.productMap?.Video?.length; videocount++) {
                                if (doresponse.data.productMap.Video[videocount].id === cartProducts.Bundle.bundleProd[preselcount].prodId) {
                                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Video Id's -Bundle"));
                                    dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Video[videocount] : null });
                                    if (isChecked && isSuppFlow) {
                                        suppSelectedProds.push(doresponse.data.productMap.Video[videocount].prodId)
                                    }
                                    // fetchTVSubProducts(dispatch, visitId,couponFlowType,doresponse.data.productMap.Video[videocount].id);
                                    let ultimateAvaiInBundleRes = '';

                                    let testdriveTvPlans = doresponse.data.productMap.Video[videocount].prodTypeValue === "ULTIMATETESTDRIVE"
                                    if (testdriveTvPlans) {
                                        let ultimateTv = doresponse.data.productMap.Video.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                                        if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv?.length > 0) {
                                            ultimateAvaiInBundleRes = ultimateTv[0].id;
                                        }
                                    }
                                    if (ultimateAvaiInBundleRes !== '') {
                                        fetchTVSubProducts(dispatch, visitId, additionalInfo.couponFlowType, ultimateAvaiInBundleRes, additionalInfo.orderType);
                                    }
                                    else {
                                        fetchTVSubProducts(dispatch, visitId, additionalInfo.couponFlowType, doresponse.data.productMap.Video[videocount].id, additionalInfo.orderType);
                                    }
                                    fetchRouter(dispatch, visitId, additionalInfo.orderType)
                                }
                            }
                        }
                        else {
                            //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB,visitId,'PreselectCartProducts',"VIDEONOTFOUND-DORESPONSE-BUNDLE",PAGEACTIVITY.UA));
                            if (InHomeUtils.isNotNull(cartProducts.Bundle.bundleProd[preselcount].prodTypeVal) && cartProducts.Bundle.bundleProd[preselcount].prodTypeVal.startsWith("CUSTOM_") && cartProducts.Bundle.bundleProd[preselcount].prodTypeVal !== Service.customGeneric) {
                                const customTvProd = getProductsFromPlans(buildProduct.tv.customTV.plans, 'prodTypeValue', null, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal);
                                dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? customTvProd : null });
                                if (isChecked && isSuppFlow && InHomeUtils.isNotNull(customTvProd)) {
                                    suppSelectedProds.push(customTvProd.id)
                                }
                                if (buildProduct?.tv?.customTV?.plans?.length === 0) {
                                    let tvPromise = cart.cartOrderDetail.contract === 'MTM' ? fetchTVMTM(dispatch, visitId, lqState.selectedState.zip, lqState.selectedState.tarCode, buildProduct.masterpackageview, false, null, additionalInfo.orderType) : fetchTV2Y(dispatch, visitId, lqState.selectedState.zip, lqState.selectedState.tarCode, buildProduct.masterpackageview, additionalInfo.orderType);
                                    Promise.all([tvPromise]).then(function (values) {
                                        let tvFromPlans = getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, Service.customGeneric);
                                        let customTVFromPlans = getProductsFromPlans(values[0].products, 'prodTypeValue', null, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal)

                                        dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvFromPlans : null });
                                        dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? customTVFromPlans : null });
                                        dispatch({ type: 'COLLAPSE_ALL_ACCORDION' });
                                        if (isChecked && isSuppFlow) {
                                            if (InHomeUtils.isNotNull(tvFromPlans)) {
                                                suppSelectedProds.push(tvFromPlans.id);
                                            }
                                            if (InHomeUtils.isNotNull(customTVFromPlans)) {
                                                suppSelectedProds.push(customTVFromPlans.id);
                                            }

                                        }
                                    });
                                } else {
                                    let tvFromPlans = getProductsFromPlans(buildProduct.tv, 'prodTypeValue', cart.cartOrderDetail.contract, Service.customGeneric);
                                    let customTVFromPlans = getProductsFromPlans(buildProduct.tv.customTV.plans, 'prodTypeValue', null, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal);

                                    dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvFromPlans : null });
                                    dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? customTVFromPlans : null });
                                    if (isChecked && isSuppFlow) {
                                        if (InHomeUtils.isNotNull(tvFromPlans)) {
                                            suppSelectedProds.push(tvFromPlans.id);
                                        }
                                        if (InHomeUtils.isNotNull(customTVFromPlans)) {
                                            suppSelectedProds.push(customTVFromPlans.id);
                                        }
                                    }
                                }
                            } else if (InHomeUtils.isNotNull(cartProducts.Bundle.bundleProd[preselcount].prodTypeVal) && (cartProducts.Bundle.bundleProd[preselcount].prodTypeVal === BuildProduct.utdProductTypeValue || cartProducts.Bundle.bundleProd[preselcount].prodTypeVal === BuildProduct.ultimateProductTypeValue)) {
                                //Only if Ultimate Test Drive available in Cart, to trigger channel with Ultimate TV usoc
                                let tvPromise = cart.cartOrderDetail.contract === 'MTM' ? fetchTVMTM(dispatch, visitId, lqState.selectedState.zip, lqState.selectedState.tarCode, buildProduct.masterpackageview, false, null, additionalInfo.orderType) : fetchTV2Y(dispatch, visitId, lqState.selectedState.zip, lqState.selectedState.tarCode, buildProduct.masterpackageview, additionalInfo.orderType);
                                Promise.all([tvPromise]).then(function (values) {
                                    let ultimateTvProduct = getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, BuildProduct.ultimateProductTypeValue);
                                    let tvProductInCart = getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal);
                                    if (InHomeUtils.isNotNull(ultimateTvProduct)) {
                                        dispatch({ type: 'ULTIMATE_USOC', value: ultimateTvProduct.id });
                                    }
                                    dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvProductInCart : null });
                                    if (isChecked && isSuppFlow) {
                                        if (InHomeUtils.isNotNull(ultimateTvProduct)) {
                                            suppSelectedProds.push(ultimateTvProduct.id);
                                        }
                                        if (InHomeUtils.isNotNull(tvProductInCart)) {
                                            suppSelectedProds.push(tvProductInCart.id);
                                        }
                                    }
                                    fetchChannel(dispatch, visitId, ultimateTvProduct.id, additionalInfo.orderType);
                                    dispatch({ type: 'COLLAPSE_ALL_ACCORDION' });
                                }
                                );
                            } else {
                                //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB,visitId,'PreselectCartProducts',"VIDEONOTFOUND-DORESPONSE-BUNDLE",PAGEACTIVITY.UA));
                                dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? cartProducts.Bundle.bundleProd[preselcount] : null });
                                if (isChecked && isSuppFlow) {
                                    suppSelectedProds.push(cartProducts.Bundle.bundleProd[preselcount].prodId);
                                }
                            }

                            // for no free dct case
                            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState) && lqState.selectedState.state && lqState.selectedState.state === "MD") {
                                let noFreeDctProd = getNoDCT(cartProducts, visitId);
                                if (InHomeUtils.isNotNull(noFreeDctProd)) {
                                    dispatch({ type: Service.dct + '_SELECTEDPROD', value: isChecked ? noFreeDctProd : null });
                                    if (isChecked && isSuppFlow) {
                                        suppSelectedProds.push(noFreeDctProd.id);
                                    }
                                }
                            }
                        }
                    }
                    else if (cartProducts.Bundle.bundleProd[preselcount].editLink === CartServices.voicePlans && servicesQualified.isVoiceQualified) {
                        if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Fios_Voice)) {
                            for (let voicecount = 0; voicecount < doresponse?.data?.productMap?.Fios_Voice?.length; voicecount++) {
                                if (doresponse.data.productMap.Fios_Voice[voicecount].id === cartProducts.Bundle.bundleProd[preselcount].prodId) {
                                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Voice Id's - Bundle"));
                                    dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Fios_Voice[voicecount] : null });
                                    fetchVoiceSubProducts(dispatch, visitId, additionalInfo.orderType);
                                    if (isChecked && isSuppFlow) {
                                        suppSelectedProds.push(doresponse.data.productMap.Fios_Voice[voicecount].prodId);
                                    }
                                }
                            }
                        }
                        else {
                            //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB,visitId,'PreselectCartProducts',"VOICENOTFOUND-DORESPONSE-BUNDLE",PAGEACTIVITY.UA));
                            dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? cartProducts.Bundle.bundleProd[preselcount] : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(cartProducts.Bundle.bundleProd[preselcount].prodId);
                            }
                        }
                    }
                }
            }
            else if ((isFCPResumeFlow || isDoFlow) && (InHomeUtils.isNotNull(cartProducts.DataProduct) || InHomeUtils.isNotNull(cartProducts.TvProduct) || InHomeUtils.isNotNull(cartProducts.VoiceProduct))) {
                if (isDoFlow) {
                    if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap.Data) && (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd[0]))) {
                        for (let datacount = 0; datacount < doresponse?.data?.productMap?.Data?.length; datacount++) {
                            if (doresponse.data.productMap.Data[datacount].id === cartProducts.DataProduct.dataProd[0].prodId) {
                                dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? processOfferSection(doresponse.data.productMap.Data[datacount]) : null });
                                if ((InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd[0].prodName) && cartProducts.DataProduct.dataProd[0].prodName.indexOf('Gigabit') > -1) || hoaFlow) {
                                    fetchFreeRouter(dispatch, visitId, additionalInfo.orderType, hoaFlow, "DATA",buildProduct);
                                }
                                else {
                                    fetchRouter(dispatch, visitId, additionalInfo.orderType);
                                }
                                fetchInternetSubProducts(dispatch, visitId, additionalInfo.orderType);
                                fetchStreamingServices(visitId, dispatch, additionalInfo.orderType, additionalInfo.couponFlowType);
                            }
                        }
                    }
                    if (InHomeUtils.isNotNull(cartProducts.TvProduct)) {
                        //Triggers video preselection
                        preselectVideoForSC(dispatch, visitId, cartProducts, buildProduct, lqState, cart, isChecked, additionalInfo);
                        // for no free dct case
                        if (lqState && lqState.selectedState && lqState.selectedState.state && lqState.selectedState.state === "MD") {
                            let noFreeDctProd = getNoDCT(cartProducts, visitId);
                            if (InHomeUtils.isNotNull(noFreeDctProd)) {
                                dispatch({ type: Service.dct + '_SELECTEDPROD', value: isChecked ? noFreeDctProd : null });
                            }
                        }
                        let routerInCart = false;
                        if (store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.router && store.getState().buildProduct.router.selectedProduct && InHomeUtils.isNotNull(store.getState().buildProduct.router.selectedProduct)) {
                            routerInCart = true;
                        }
                        if (!routerInCart) {
                            if (hoaFlow) {
                                fetchFreeRouter(dispatch, visitId, additionalInfo.orderType, hoaFlow, "VIDEO",buildProduct);
                            } else {
                                fetchRouter(dispatch, visitId, additionalInfo.orderType)
                            }
                        }
                    }
                    if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap.Fios_Voice) && InHomeUtils.isNotNull(cartProducts.VoiceProduct) && InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0])) {
                        for (let datacount = 0; datacount < doresponse?.data?.productMap?.Fios_Voice?.length; datacount++) {
                            if (doresponse.data.productMap.Fios_Voice[datacount].id === cartProducts.VoiceProduct.voiceProd[0].prodId) {
                                dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Fios_Voice[datacount] : null });
                                fetchVoiceSubProducts(dispatch, visitId, additionalInfo.orderType);
                            }
                        }
                    }
                    if (InHomeUtils.isNotNull(cartProducts.Channels)) { //Getting the Standalone TV //tvProd serviceType.intrnlChnl
                        dispatch({ type: Service.channel + '_SELECTEDPROD', value: isChecked ? cartProducts.Channels.channelProd : null });
                    }
                }
                else {
                    if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd[0])) {
                        dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? cartProducts.DataProduct.dataProd[0] : null });
                        if (isChecked && isSuppFlow) {
                            suppSelectedProds.push(cartProducts.DataProduct.dataProd[0].prodId);
                        }
                        if (InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd[0].prodName)) {
                            let profileRouter = null;
                            try {
                                if (isFCPResumeFlow) {
                                    if (InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment.equipment)) {
                                        profileRouter = cartProducts.CartSubProduct.Equipment.equipment.filter(p => p.prodType === 'ROUTERBILLER' || p.prodType === 'ACCESSPOINTBILLER');
                                    }
                                    if (!InHomeUtils.isNotNull(profileRouter) && InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.OneTimeCharges) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge)) {
                                        profileRouter = cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge.filter(p => p.prodType === 'ROUTERNRCBILLER' || p.prodType === 'ACCESSPOINTNRCBILLER');
                                    }
                                }


                            }
                            catch (ex) {
                                catchJSException('BuildProduct', visitId, 'action-PreselectCartProducts', ex);
                            }

                            if (cartProducts.DataProduct.dataProd[0].prodName.indexOf('Gigabit') > -1 && !InHomeUtils.isNotNull(profileRouter)) {
                                fetchFreeRouter(dispatch, visitId, additionalInfo.orderType, "DATA",buildProduct);
                            }
                            else if(!buildProduct?.isResumecartFlow) {   // to avoid multiple router call in resumeCart flow
                                fetchRouter(dispatch, visitId, additionalInfo.orderType);
                            }
                            fetchInternetSubProducts(dispatch, visitId, additionalInfo.orderType);
                            fetchStreamingServices(visitId, dispatch, additionalInfo.orderType, additionalInfo.couponFlowType);
                        }
                    }
                    if (InHomeUtils.isNotNull(cartProducts.TvProduct)) {
                        //Triggers video preselection
                        preselectVideoForSC(dispatch, visitId, cartProducts, buildProduct, lqState, cart, isChecked, additionalInfo);
                        // for no free dct case
                        if (lqState && lqState.selectedState && lqState.selectedState.state && lqState.selectedState.state === "MD") {
                            let noFreeDctProd = getNoDCT(cartProducts, visitId);
                            if (InHomeUtils.isNotNull(noFreeDctProd)) {
                                dispatch({ type: Service.dct + '_SELECTEDPROD', value: isChecked ? noFreeDctProd : null });
                                if (isChecked && isSuppFlow) {
                                    suppSelectedProds.push(noFreeDctProd.id);
                                }
                            }
                        }
                        fetchRouter(dispatch, visitId, additionalInfo.orderType)
                    }
                    if (InHomeUtils.isNotNull(cartProducts.VoiceProduct) && InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0])) {
                        dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? cartProducts.VoiceProduct.voiceProd[0] : null });
                        if (isChecked && isSuppFlow) {
                            suppSelectedProds.push(cartProducts.VoiceProduct.voiceProd[0].prodId);
                        }
                        fetchVoiceSubProducts(dispatch, visitId, additionalInfo.orderType);
                    }
                }
            }
            else if (InHomeUtils.isNotNull(cartProducts.DataProduct) && servicesQualified.isDataQualified) { //Getting the Standalone Data //dataProd                
                if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Data)) {
                    for (let datacounts = 0; datacounts < doresponse?.data?.productMap?.Data?.length; datacounts++) {
                        if (doresponse.data.productMap.Data[datacounts].id === cartProducts.DataProduct.dataProd[0].prodId) {
                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Data Id's -Standalone"));
                            dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? processOfferSection(doresponse.data.productMap.Data[datacounts]) : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(doresponse.data.productMap.Data[datacounts].prodId);
                            }
                            fetchStreamingServices(visitId, dispatch, additionalInfo.orderType, additionalInfo.couponFlowType);
                        }
                    }
                }
                else {                    
                    //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'PreselectCartProducts', "DATANOTFOUND-DORESPONSE-STANDALONE", PAGEACTIVITY.UA));
                    //if (cartProducts.DataProduct.dataProd[0].prodName !== undefined && cartProducts.DataProduct.dataProd[0].prodName !== null && cartProducts.DataProduct.dataProd[0].prodName.indexOf('300') > -1) {
                    if (buildProduct?.internet?.m2mPlans?.length === 0 ) {   
                        let dataPromise = fetchDataMTM(dispatch, visitId, additionalInfo.flowType)
                        Promise.all([dataPromise]).then(function (values) {                            
                            if ((isSuppFlow || buildProduct.isSmartCartFlow) && store.getState().buildProduct.isDataPerksSetForSCFlow) {                                
                            }
                            else {
                                const internetProd = getProductsFromPlans(values[0].products, 'id', cart.cartOrderDetail.contract, cartProducts.DataProduct.dataProd[0].prodId);
                                dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? internetProd : null });
                                // smartcart changes saved internet without planperk
                                if(internetProd && internetProd.planPerks && internetProd?.planPerks?.length >=1 ){
                                    dispatch({ type: 'MM3INTERNETSUBPROD', value: internetProd.planPerks });
                                    dispatch({ type: 'FETCH_DATASUBPROD', value: internetProd.planPerks })
                                    dispatch({ type: "MM3_SELECTEDPROD", value: null })
                                    }
                                setTimeout(() => {
                                    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: 'internetSubAccOpen' });
                                    if(is15gFlow){
                                        dispatch({ type: 'TOGGLE_ACCORDION_15G', value: '' });
                                    }
                                }, 5000);    
                                if (isChecked && isSuppFlow && InHomeUtils.isNotNull(internetProd)) {
                                suppSelectedProds.push(internetProd.id);
                                }
                            }                            
                        });
                    } else {
                        let internetProdm2mPlans = getProductsFromPlans(buildProduct.internet.m2mPlans, 'id', cart.cartOrderDetail.contract, cartProducts.DataProduct.dataProd[0].prodId);
                        if(internetProdm2mPlans==null && buildProduct.internet.mm3internetsubprod !=null){
                            internetProdm2mPlans = getProductsFromPlans(buildProduct.internet.mm3internetsubprod, 'id', cart.cartOrderDetail.contract, cartProducts.DataProduct.dataProd[0].prodId);
                        }
                        dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? internetProdm2mPlans : null });
                        if (isChecked && isSuppFlow && InHomeUtils.isNotNull(internetProdm2mPlans)) {
                            suppSelectedProds.push(internetProdm2mPlans.id);
                        }
                        dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: 'ResumeFlow' });
                    }
                    if (is15gFlow) {
                        try {
                            let product;
                            if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                                product = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.prodType) && e.prodType === 'FTTPD');
                                if (InHomeUtils.isNotNull(product)) {
                                    setTimeout(() => {
                                        addToCartVzdlSCEvent(visitId, product[0], Service.internet, cartresp, false, true, null, additionalInfo.flowType, additionalInfo.isFCPflow, 'AddtoCart', '', addonProducts)
                                    }, 3000);
                                }
                            }
                        }
                        catch (err) {
                            catchJSException('BuildProduct', visitId, 'PreselectCartProducts', ex);
                        }     
                        
                        // fetchRouter(dispatch, visitId, additionalInfo.orderType, 0, false, lqState, "", buildProduct);
                        fetchRouter(dispatch, visitId, additionalInfo.orderType, 0, false, lqState, "", buildProduct, additionalInfo.flowType);
                        //fetchInternetSubProducts(dispatch, visitId, additionalInfo.orderType);
                        fetchTechSure(dispatch, visitId, additionalInfo.flowType, 0, false, lqState, "", buildProduct)
                        fetchStreamingServices(visitId, dispatch, additionalInfo.flowType, additionalInfo.couponFlowType);
                    }
                    // }else{
                    //     dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? cartProducts.DataProduct.dataProd[0] : null });
                    // }
                }
                if (InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd[0].prodName) && isDoFlow) {
                    if (cartProducts.DataProduct.dataProd[0].prodName.indexOf('Gigabit') > -1) {
                        //let is1GinCart = true;
                        //BindAllSubProductsDOFLOW(dispatch, visitId, is1GinCart);
                        fetchFreeRouter(dispatch, visitId, additionalInfo.orderType, "DATA",buildProduct);
                    }
                    else {
                        fetchRouter(dispatch, visitId, additionalInfo.orderType);
                    }
                    fetchInternetSubProducts(dispatch, visitId, additionalInfo.orderType);
                }

                //For DATA + Video (Local TV) AlaCarte case
                if (InHomeUtils.isNotNull(cartProducts.TvProduct)) {
                    preselectVideoForSC(dispatch, visitId, cartProducts, buildProduct, lqState, cart, isChecked, additionalInfo);
                }

                if (InHomeUtils.isNotNull(cartProducts.VoiceProduct) && InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0])) {
                    dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? cartProducts.VoiceProduct.voiceProd[0] : null });
                    if (isChecked && isSuppFlow) {
                        suppSelectedProds.push(cartProducts.VoiceProduct.voiceProd[0].prodId);
                    }
                    fetchVoiceSubProducts(dispatch, visitId, additionalInfo.orderType);
                }
            }
            else if (InHomeUtils.isNotNull(cartProducts.TvProduct) && servicesQualified.isVideoQualified) { //Getting the Standalone TV //tvProd
                if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Video)) {
                    for (let videocounts = 0; videocounts < doresponse?.data?.productMap?.Video?.length; videocounts++) {
                        if (doresponse.data.productMap.Video[videocounts].id === cartProducts.TvProduct.tvProd[0].prodId) {
                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Video Id's -Standalone"));
                            dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Video[videocounts] : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(doresponse.data.productMap.Video[videocounts].prodId);
                            }
                            // fetchTVSubProducts(dispatch, visitId,couponFlowType,doresponse.data.productMap.Video[videocounts].id);
                            let ultimateAvaiInBundleRes = '';
                            let testdriveTvPlans = doresponse.data.productMap.Video[videocounts].prodTypeValue === "ULTIMATETESTDRIVE"
                            if (testdriveTvPlans) {
                                let ultimateTv = doresponse.data.productMap.Video.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                                if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv?.length > 0) {
                                    dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id });
                                    ultimateAvaiInBundleRes = ultimateTv[0].id;
                                }
                            }
                            if (ultimateAvaiInBundleRes !== '') {
                                fetchTVSubProducts(dispatch, visitId, additionalInfo.couponFlowType, ultimateAvaiInBundleRes, additionalInfo.orderType);
                            }
                            else {
                                fetchTVSubProducts(dispatch, visitId, additionalInfo.couponFlowType, doresponse.data.productMap.Video[videocounts].id, additionalInfo.orderType);
                            }
                        }
                    }
                }
                else {
                    //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'PreselectCartProducts', "VIDEONOTFOUND-DORESPONSE-STANDALONE", PAGEACTIVITY.UA));
                    //Triggers video preselection
                    preselectVideoForSC(dispatch, visitId, cartProducts, buildProduct, lqState, cart, isChecked, additionalInfo);
                    // for no free dct case
                    if (lqState.selectedState && lqState.selectedState.state && lqState.selectedState.state === "MD") {
                        let noFreeDctProd = getNoDCT(cartProducts, visitId);
                        if (InHomeUtils.isNotNull(noFreeDctProd)) {
                            dispatch({ type: Service.dct + '_SELECTEDPROD', value: isChecked ? noFreeDctProd : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(noFreeDctProd.id);
                            }
                        }
                    }
                }
            }
            if (!isDoFlow) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Non Do Flow - Fetch Listing,channel and techsure"));
                if (InHomeUtils.isNotNull(cartProducts.Listing) && InHomeUtils.isNotNull(cartProducts.Listing.listingProd)) {
                    cartProducts.Listing.listingProd.forEach(function (prod) {
                        if (prod.prodType === "FVLISTMAIN" || prod.prodType === "FVNONPUB") {
                            dispatch({ type: Service.listing + '_SELECTEDPROD', value: isChecked ? prod : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(prod.prodId);
                            }
                        }
                        else if (prod.prodType === "FVINTLPLAN" && prod.prodId !== "FVINTLPLAN" && prod.prodTypeVal !== "DUMMY" && prod.prodTypeVal !== "STANDARD") {
                            dispatch({ type: Service.intlPlans + '_SELECTEDPROD', value: isChecked ? prod : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(prod.prodId);
                            }
                        }
                    });
                }
                else if (!additionalInfo.isUpsell && additionalInfo.orderType && additionalInfo.orderType != "MV") {
                    let listingProd = {
                        displayPrice: "$0",
                        id: "FVLIST",
                        name: "List my number",
                        prodType: "FVLISTMAIN"
                    }
                    dispatch({ type: Service.listing + '_SELECTEDPROD', value: isChecked ? listingProd : null });
                    if (isChecked && isSuppFlow) {
                        suppSelectedProds.push(listingProd.id);
                    }
                }
                if (InHomeUtils.isNotNull(cartProducts.Channels)) { //Getting the Standalone TV //tvProd serviceType.intrnlChnl
                    dispatch({ type: Service.channel + '_SELECTEDPROD', value: isChecked ? cartProducts.Channels.channelProd : null });
                    if (isChecked && isSuppFlow) {
                        let channelProds = cartProducts.Channels.channelProd.map((val, i) => {
                            return val.prodId;
                        });
                        suppSelectedProds.push(...channelProds);
                    }
                }
                if (InHomeUtils.isNotNull(cartProducts.intrnlChannels)) { //Getting the Standalone TV //tvProd serviceType.intrnlChnl
                    dispatch({ type: Service.intrnlChnl + '_SELECTEDPROD', value: isChecked ? cartProducts.intrnlChannels.intrnlChannelProd : null });
                    if (isChecked && isSuppFlow) {
                        let intrlchannelProds = cartProducts.intrnlChannels.intrnlChannelProd.map((val, i) => {
                            return val.prodId;
                        });
                        suppSelectedProds.push(...intrlchannelProds);
                    }
                }
                if (InHomeUtils.isNotNull(cartProducts.VoiceProduct)) { //Getting the Standalone Voice //tvProd
                    dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? cartProducts.VoiceProduct.voiceProd[0] : null });
                    if (isChecked && isSuppFlow) {
                        suppSelectedProds.push(cartProducts.VoiceProduct.voiceProd[0].prodId);
                    }
                }

                if (InHomeUtils.isNotNull(cartProducts.Techsure) && cartProducts?.Techsure?.VasProduct?.length > 0) {
                    if (InHomeUtils.isNotEmpty(cartProducts.Techsure.VasProduct[0].isProductSupported) && cartProducts.Techsure.VasProduct[0].isProductSupported === 'No') {
                        dispatch({ type: Service.techSure + "_SELECTEDPROD", value: null });
                    } else {
                        //dispatch({ type: Service.techSure + "_SELECTEDPROD", value: isChecked ? cartProducts.Techsure.VasProduct[0] : null });
                        if (vcloud === "Y") {
                            let vasProd = cartProducts.Techsure.VasProduct.filter(p => InHomeUtils.isNull(p.isVCloudProd));
                            vasProd = vasProd?.length > 0 ? vasProd : null;
                            dispatch({ type: Service.techSure + "_SELECTEDPROD", value: isChecked ? vasProd : null });

                            let vcloudProd = cartProducts.Techsure.VasProduct.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes');
                            vcloudProd = vcloudProd?.length > 0 ? vcloudProd : null;
                            dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: isChecked ? vcloudProd : null });
                        }
                        else {
                            let vcloudProd = cartProducts.Techsure.VasProduct.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes');
                            vcloudProd = vcloudProd?.length > 0 ? vcloudProd : null;
                            if(vcloudProd){

                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: isChecked ? vcloudProd : null });
                            }
                            else{

                                dispatch({ type: Service.techSure + "_SELECTEDPROD", value: isChecked ? cartProducts.Techsure.VasProduct : null });
                            }
                        }

                        dispatch({ type: 'ENABLE_VASCHILD_LIST', value: true });
                        if (isChecked && isSuppFlow) {
                            let vasProds = cartProducts.Techsure.VasProduct.map((val, i) => {
                                return val.prodId;
                            });
                            suppSelectedProds.push(...vasProds);
                        }
                    }
                }
                else {
                    dispatch({ type: Service.techSure + "_SELECTEDPROD", value: null });
                }
            }
            else {
                if (InHomeUtils.isNotNull(cartProducts.Techsure) && InHomeUtils.isNotNull(cartProducts.Techsure.VasProduct) && cartProducts?.Techsure?.VasProduct?.length > 0) {
                    if (InHomeUtils.isNotEmpty(cartProducts.Techsure.VasProduct[0].isProductSupported) && cartProducts.Techsure.VasProduct[0].isProductSupported === 'No') {
                        dispatch({ type: Service.techSure + "_SELECTEDPROD", value: null });
                    } else {
                        //dispatch({ type: Service.techSure + "_SELECTEDPROD", value: isChecked ? cartProducts.Techsure.VasProduct[0] : null });
                        if (vcloud === "Y") {
                            let vasProd = cartProducts.Techsure.VasProduct.filter(p => InHomeUtils.isNull(p.isVCloudProd));
                            vasProd = vasProd?.length > 0 ? vasProd : null;
                            dispatch({ type: Service.techSure + "_SELECTEDPROD", value: isChecked ? vasProd : null });

                            let vcloudProd = cartProducts.Techsure.VasProduct.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes');
                            vcloudProd = vcloudProd?.length > 0 ? vcloudProd : null;
                            dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: isChecked ? vcloudProd : null });
                        }
                        else {
                            let vasProd = cartProducts.Techsure.VasProduct.filter(p => InHomeUtils.isNull(p.isVCloudProd));
                            vasProd = vasProd?.length > 0 ? vasProd : null;
                            dispatch({ type: Service.techSure + "_SELECTEDPROD", value: isChecked ? vasProd : null });

                            let vcloudProd = cartProducts.Techsure.VasProduct.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes');
                            vcloudProd = vcloudProd?.length > 0 ? vcloudProd : null;
                            dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: isChecked ? vcloudProd : null });
                         }
                        if (isChecked && isSuppFlow) {
                            suppSelectedProds.push(cartProducts.Techsure.VasProduct.prodId);
                        }
                        dispatch({ type: 'ENABLE_VASCHILD_LIST', value: true });
                    }
                }
            }
            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment)) {//Getting the Equipments 
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Cart has Equipments"));
                    cartProducts.CartSubProduct.Equipment.equipment.forEach(function (prod) {
                        let productType = prod.editLink !== null ? prod.editLink.toUpperCase() : "";
                        dispatch({ type: productType + "_SELECTEDPROD", value: isChecked ? prod : null });
                        if (isChecked && isSuppFlow) {
                            suppSelectedProds.push(prod.prodId);
                        }
                    });
                }
                if (isSuppFlow && !hasDVR) {
                    let product = [{ id: 'NORECORD', prodType: 'VFEATURE', name: "I don't want to record on any TV's" }];
                    dispatch({ type: 'RECORDING_SELECTEDPROD', value: product[0] })
                }
                if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.OneTimeCharges)) {//Getting the Equipments 
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Cart has OneTime Charges"));
                    cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge.forEach(function (prod) {
                        let prType = prod.editLink !== null ? prod.editLink.toUpperCase() : "";
                        let prdtype = prod.prodType;
                        let price = prod.price;
                        if (prType === "BATTERY") {
                            prod["keyword"] = price.indexOf("0.0") === -1 ? "CHARGED" : "";
                        }
                        else if (prdtype === "SLABATTERYSHIPMENT" || prdtype === "DCELLTRAYSHIPMENT") {
                            prType = "BBUSHIPMENT";
                        }
                        else if (prdtype === "OTTEQUIPNRC") {
                            dispatch({ type: Service.streamDev + '_SELECTEDPROD', value: isChecked ? prod : null });
                            dispatch({ type: Service.streamDevCountResume + '_SELECTEDPROD', value: isChecked ? prod.quantity : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(prod.prodId, prod.quantity.prodId);
                            }
                        }
                        if (prType !== "") {
                            dispatch({ type: prType + "_SELECTEDPROD", value: isChecked ? prod : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(prod.prodId);
                            }
                        }
                    });
                }
                if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers)) {
                    if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.specialoffers) && cartProducts?.CartSubProduct?.SpecialOffers?.specialoffers?.length > 0) {
                        cartProducts.CartSubProduct.SpecialOffers.specialoffers.forEach(function (prod) {
                            dispatch({ type: Service.streamServ + '_SELECTEDPROD', value: isChecked ? prod : null });
                            if (isChecked && isSuppFlow) {
                                suppSelectedProds.push(prod.prodId);
                            }
                        });
                    }
                }
                if (InHomeUtils.isNotNull(cartProducts.StreamingService)) {
                    cartProducts.StreamingService.StreamingService.forEach(function (prod) {
                        if (prod.prodType === "OTTBASIC" && prod.prodTypeVal === Service.slingtv) {
                            dispatch({ type: 'OTTBASIC_SELECTEDPROD', value: prod });
                            if (isSuppFlow) {
                                dispatch({ type: 'FETCH_TVM2M_SLING', value: "" });
                            }
                        }
                        else {
                            dispatch({ type: Service.tv + '_SELECTEDPROD', value: prod });
                        }
                        if (isChecked && isSuppFlow) {
                            suppSelectedProds.push(prod.prodId);
                        }
                    });
                    fetchStreamingServices(visitId, dispatch, additionalInfo.orderType, additionalInfo.couponFlowType);
                }
            }
            if (!isSuppFlow && InHomeUtils.isNotNull(cart) && InHomeUtils.isNotNull(cart.cartData) && cart?.cartData?.length > 0) {
                if (InHomeUtils.isNotNull(cart.cartData[0].streamService) && InHomeUtils.isNotNull(cart.cartData[0].streamService.streamServiceProds)) {
                    cart.cartData[0].streamService.streamServiceProds.forEach(function (prod) {
                        if (prod.prodType === "OTTBASIC" && prod.prodTypeVal === Service.slingtv) {
                            dispatch({ type: 'OTTBASIC_SELECTEDPROD', value: prod });
                            suppSelectedProds.push(cart.cartData[0].streamService.streamServiceProds[0].prodId);
                        }
                        else {
                            dispatch({ type: Service.tv + '_SELECTEDPROD', value: prod });
                        }
                        if (isChecked && isSuppFlow) {
                            suppSelectedProds.push(cart.cartData[0].streamService.streamServiceProds[0].prodId);
                        }
                    });
                    // dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? cart.cartData[0].streamService.streamServiceProds[0] : null });
                }
            }
            dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,tv,voice,contract,sploffer,flashoffer,streamserv" })
        }
        if (isSuppFlow) {
            dispatch({ type: 'SUPP_SELECTED_PRODS', value: suppSelectedProds });
        }
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'PreselectCartProducts', ex);
    }
};

const getNoDCT = (cartProducts, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getNoDCT', "Inside getNoDCT"));
        let noFreeDctProd = {
            id: "NODCT",
            name: "No Thanks, not right now",
            prodType: "VCPESTB"
        }
        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment)) {//Getting the Equipments 
                for (let spCount = 0; spCount < cartProducts?.CartSubProduct?.Equipment?.equipment?.length; spCount++) {
                    let productType = InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink) ? cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink.toUpperCase() : "";
                    if (productType === "DIGITALADAPTER") {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getNoDCT', "NODCT " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                        return null;
                    }
                }
            }
        }
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getNoDCT', "return DCT Product"));
        return noFreeDctProd;
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getNoDCT', ex);
    }
}

const preselectVideoForSC = (dispatch, visitId, cartProducts, buildProduct, lqState, cart, isChecked, additionalInfo) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'preselectVideoForSC', "Inside preselectVideoForSC"));
        let isLocalTVInCart = false;
        let isDCTinCart = false;
        let isSuppFlow = (additionalInfo.flowType === 'SUPP') ? true : false;
        let zipCode = lqState && lqState.selectedState && lqState.selectedState.zip ? lqState.selectedState.zip : '';
        let tarCode = lqState && lqState.selectedState && lqState.selectedState.tarCode ? lqState.selectedState.tarCode : '';
        let contract = cart.cartOrderDetail && cart.cartOrderDetail.contract ? cart.cartOrderDetail.contract : cart.orderDetail && cart.orderDetail.contract ? cart.orderDetail.contract : 'MTM';
        if (InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal.startsWith("CUSTOM_") && cartProducts.TvProduct.tvProd[0].prodTypeVal !== Service.customGeneric) {
            if (buildProduct?.tv?.customTV?.plans?.length === 0) {
                let tvPromise = fetchTVMTM(dispatch, visitId, zipCode, tarCode, buildProduct.masterpackageview, false, null,additionalInfo.flowType)
                Promise.all([tvPromise]).then(function (values) {
                    let tvFromPlans = getProductsFromPlans(values[0].products, 'prodTypeValue', contract, Service.customGeneric);
                    let customTVFromPlans = getProductsFromPlans(values[0].products, 'prodTypeValue', null, cartProducts.TvProduct.tvProd[0].prodTypeVal);

                    dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvFromPlans : null });
                    dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? customTVFromPlans : null });
                    if (isChecked && isSuppFlow) {
                        if (InHomeUtils.isNotNull(tvFromPlans)) {
                            suppSelectedProds.push(tvFromPlans.id);
                        }
                        if (InHomeUtils.isNotNull(customTVFromPlans)) {
                            suppSelectedProds.push(customTVFromPlans.id);
                        }
                    }
                }
                );
            } else {
                let tvFromPlans = getProductsFromPlans(buildProduct.tv, 'prodTypeValue', contract, Service.customGeneric);
                let customTVFromPlans = getProductsFromPlans(buildProduct.tv.customTV.plans, 'prodTypeValue', null, cartProducts.TvProduct.tvProd[0].prodTypeVal);

                dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvFromPlans : null });
                dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? customTVFromPlans : null });
                if (isChecked && isSuppFlow) {
                    if (InHomeUtils.isNotNull(tvFromPlans)) {
                        suppSelectedProds.push(tvFromPlans.id);
                    }
                    if (InHomeUtils.isNotNull(customTVFromPlans)) {
                        suppSelectedProds.push(customTVFromPlans.id);
                    }
                }
            }

        } else if (InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && (cartProducts.TvProduct.tvProd[0].prodTypeVal === BuildProduct.utdProductTypeValue || cartProducts.TvProduct.tvProd[0].prodTypeVal === BuildProduct.ultimateProductTypeValue)) {
            //Only if Ultimate Test Drive available in Cart, to trigger channel with Ultimate TV usoc
            let tvPromise = fetchTVMTM(dispatch, visitId, zipCode, tarCode, buildProduct.masterpackageview, false, null,additionalInfo.flowType)
            Promise.all([tvPromise]).then(function (values) {
                let tvProductInCart = getProductsFromPlans(values[0].products, 'prodTypeValue', contract, cartProducts.TvProduct.tvProd[0].prodTypeVal);
                dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvProductInCart : null });

                let ultimateTvProduct = getProductsFromPlans(values[0].products, 'prodTypeValue', contract, BuildProduct.ultimateProductTypeValue);
                if (InHomeUtils.isNotNull(ultimateTvProduct)) {
                    dispatch({ type: 'ULTIMATE_USOC', value: ultimateTvProduct.id });
                }
                if (isChecked && isSuppFlow) {
                    if (InHomeUtils.isNotNull(tvProductInCart)) {
                        suppSelectedProds.push(tvProductInCart.prodId || tvProductInCart.id)
                    }
                    if (InHomeUtils.isNotNull(ultimateTvProduct)) {
                        suppSelectedProds.push(ultimateTvProduct.id)
                    }
                }
                fetchChannel(dispatch, visitId, ultimateTvProduct.id);
            }
            );
        } else {
            dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? cartProducts.TvProduct.tvProd[0] : null });
            if (isChecked && isSuppFlow) {
                suppSelectedProds.push(cartProducts.TvProduct.tvProd[0].prodId)
            }
        }
        fetchTVSubProducts(dispatch, visitId, null, cartProducts.TvProduct.tvProd[0].prodId, additionalInfo.orderType);
        if (isSuppFlow) {
            dispatch({ type: 'SUPP_SELECTED_PRODS', value: suppSelectedProds });
        }
        // Check for Digital adapter in saved Smart cart- to render Vroom-None  option tile
        if (InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") {
            isLocalTVInCart = true;
        }
        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment.equipment)) {
                for (let spCount = 0; spCount < cartProducts?.CartSubProduct?.Equipment?.equipment?.length; spCount++) {
                    let productType = InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink) ? cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink.toUpperCase() : "";
                    if (productType === "DIGITALADAPTER") {
                        isDCTinCart = true;
                    }
                }
            }
        }
        if (isLocalTVInCart || isDCTinCart) {
            fetchVRoom(dispatch, visitId, isLocalTVInCart, isDCTinCart);
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'preselectVideoForSC', ex);
    }
}

const processOfferSection = product => {
    if (InHomeUtils.isNotNull(product?.specialOffers) && product?.specialOffers?.length > 0) {
        product.specialOffers.map(o => {
            o['id'] = o.USOCIOSC;
            o['prodType'] = 'SPLOFFER';
            o['prodTypeVal'] = o['prodTypeValue'] = '';
            o['OfferText'] = o.OfferText;
        })
    }
    else if (InHomeUtils.isNotNull(product.promoId)) {
        product['id'] = product.promoId;
        product['prodType'] = product.offerAttr === 'ACQBLACKFRIDAY2020' ? 'FLASHOFFER' : 'SPLOFFER';
        product['prodTypeVal'] = product['prodTypeValue'] = '';
        product['OfferText'] = product.promoText;
    }
    else if (InHomeUtils.isNotNull(product) && product?.length > 0 && InHomeUtils.isNotNull(product[0].promoId)) {
        product.map(o => {
            o['id'] = o.promoId;
            o['prodType'] = o.offerAttr === 'ACQBLACKFRIDAY2020' ? 'FLASHOFFER' : 'SPLOFFER';
            o['prodTypeVal'] = o['prodTypeValue'] = '';
            o['OfferText'] = o.promoText;
        })
    }
    else {
        if (InHomeUtils.isNotNull(product.offer2YR) && product?.offer2YR?.length > 0) {
            product.offer2YR.map(o => {
                o['id'] = o.USOCIOSC;
                o['prodType'] = 'SPLOFFER';
                o['prodTypeVal'] = o['prodTypeValue'] = '';
                o['OfferText'] = o.OfferText;
            })
        }
        if (InHomeUtils.isNotNull(product.offersMTM) && product?.offersMTM?.length > 0) {
            product.offersMTM.map(o => {
                o['id'] = o.USOCIOSC;
                o['prodType'] = 'SPLOFFER';
                o['prodTypeVal'] = o['prodTypeValue'] = '';
                o['OfferText'] = o.OfferText;
            })
        }
        if (InHomeUtils.isNotNull(product.flashoffer2YR) && product?.flashoffer2YR?.length > 0) {
            product.flashoffer2YR.map(o => {
                o['id'] = o.USOCIOSC;
                o['prodType'] = 'FLASHOFFER';
                o['prodTypeVal'] = o['prodTypeValue'] = '';
                o['OfferText'] = o.OfferText;
            })
        }
        if (InHomeUtils.isNotNull(product.flashoffersMTM) && product?.flashoffersMTM?.length > 0) {
            product.flashoffersMTM.map(o => {
                o['id'] = o.USOCIOSC;
                o['prodType'] = 'FLASHOFFER';
                o['prodTypeVal'] = o['prodTypeValue'] = '';
                o['OfferText'] = o.OfferText;
            })
        }
    }
    return product;
}

export const setMobileAndHomeEligibility = (products, dispatch, visitId) => {
    const mnhOffers = OfferTypes.allMNHOffers.split(',');
    try {
        const ismnhEligible = products && products?.filter?.(plan => plan?.specialOffers).map(plan => plan?.specialOffers).flat().some(offer => mnhOffers.includes(offer?.BsOfferAttrValue));
        if (ismnhEligible) {
            dispatch({ type: 'MOBILE_AND_HOME_ELIGIBLE', value: true })
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setMobileAndHomeEligibility', ex);
    }
}



export const fetchDataMTM = (dispatch, visitId, flowType, couponFlowType = null, action = null, reAttemptCount = 0, isPrefetch = false, addlInfo=null, servicesInfo=null) => {
    try {
        let mlpDetailsFromLq = JSON.parse(window.sessionStorage.getItem('MLP_Plan_Details'));
        let lqData = store && store.getState() && store.getState().loopQual;
        let buildProductState = store && store.getState() && store.getState().buildProduct;
        let mlpDataSelected = store && store.getState() && store.getState().buildProduct?.internet?.selectedProduct ? true : false;
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDataMTM', "Inside fetchDataMTM"));
        let url = apiUrl().getProduct + '/plans';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        const queryString = window.location.search;
        performance.mark('Triggered Plan Call')
        return new Promise((resolve, reject) => {
            //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'Data', flowType, couponFlowType)).then(response => {
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                performance.mark('Triggered Plan Call end')
                let isStreamline =  store?.getState()?.loopQual?.streamlineLQ  || false;
                const SuppressPopularPlanCalls = store?.getState()?.loopQual?.runtimeKey?.SuppressPopularPlanCalls === 'Y';
                const isPopularPlanPage = SuppressPopularPlanCalls && window?.location?.href?.includes('inhome/popularPlans');
                if(isPrefetch && !isStreamline && !isPopularPlanPage) {
                    prefetchAction.fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                    prefetchAction.fetchFiosVoiceMTM(dispatch, visitId, servicesInfo,flowType, addlInfo)
                }
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                    InHomeUtils.isNotNull(response?.data) && InHomeUtils.isNotNull(response?.data?.products) && response?.data?.products?.length > 0) {
                    dispatch({ type: "SET_IWM_ELIGIBLE", value: response?.data?.isiwmEligible });
                    setMobileAndHomeEligibility(response.data.products, dispatch, visitId);
                    // response.data = Object.assign({}, response.data, {
                    //     additionalInfo: {
                    //         selfInstallMessage: "Q7704,Q7706,Q7707,Q7708,Q7710,Q7711"
                    //     }});
                    if(response.data && response.data.mnhSignupIndicator)
                    {
                        if(response.data.mnhSignupIndicator !== '' && response.data.mnhSignupIndicator !== 'N')
                            updateSubFlowValue(' | M+H', 'm+h');
                        dispatch({type : 'MNHSIGNUPINDICATOR',value : response.data.mnhSignupIndicator});
                    }
                    if(response.data && response.data.strikePrice)
                    {
                        dispatch({type : 'STRIKE_PRICE_INDICATOR',value : response.data.strikePrice});
                   
                    }
                    if(response.data && response.data.leadListAddress){
                        dispatch({type : 'LEAD_LIST_ADDRESS_VALIDATION',value : response.data.leadListAddress});
                    }
                    if(response.data && InHomeUtils.isNotNull(mlpDetailsFromLq) && !mlpDataSelected){
                        let mlpDetail = mlpDetailsFromLq;
                            let mlp_selectedProduct = response?.data?.products?.filter(item => item?.id === mlpDetail?.planId);
                            updateCart(visitId,lqData,mlp_selectedProduct[0],"INTERNET",false,dispatch,null,null,null,"MTM","DATA",false,false,null,buildProductState,null,flowType,"",false,false,false,false)
							
						window.sessionStorage.removeItem('MLP_Plan_Details');
                    }
                    if(response?.data){
                        let offersFor500 = response?.data?.products?.filter(item => item?.id=="R3585" || item?.id=="R3584" || item?.id=="R2809");
                        let offersFor300 = response?.data?.products?.filter(item => item?.id=="R3587" || item?.id=="R3586" || item?.id=="R2806");
                        let offersFor100 = response?.data?.products?.filter(item => item?.id=="R3588");
                        let is500FeeWaived = offersFor500?.[0]?.specialOffers?.findIndex(item => ["R4342","R4341","R4446","R4560"]?.includes(item?.USOCIOSC)) > -1 ? true : false;
                        let is300FeeWaived = offersFor300?.[0]?.specialOffers?.findIndex(item => ["R4342","R4341","R4446","R4560"]?.includes(item?.USOCIOSC)) > -1 ? true : false;
                        let is100FeeWaived = offersFor100?.[0]?.specialOffers?.findIndex(item => ["R4342","R4341","R4446","R4560"]?.includes(item?.USOCIOSC)) > -1 ? true : false;
                        let isFeeWaivedForAll = is500FeeWaived || is300FeeWaived || is100FeeWaived;
                        dispatch({type : 'IS_FEE_WAIVED_FOR_ALL',value : isFeeWaivedForAll});
                    }
                    if(response.data && response.data.legSTBLeadLstCust){
                        dispatch({type : 'LEGACY_STB_LEAD_LIST_CUSTOMERS',value : response.data.legSTBLeadLstCust});
                    }
                    if((response.data && response.data.typeofDiscount && response.data.typeOfDiscountScenario))
                    {
                        
                        dispatch({type : 'STRIKE_PRICE_INDICATOR1',value : response.data.typeofDiscount});
                        dispatch({type : 'STRIKE_PRICE_INDICATOR2',value : response.data.typeOfDiscountScenario});
                    
                    }
                    if(response.data && response.data.check2GNotAllowed && response.data.check2GNotAllowed!=""){
                        dispatch({type : 'SET_2Gig_NOT_ALLOWED_MESSAGE',value : response.data.check2GNotAllowed});
                    }
                    if(response.data && response.data.mm3Qualified && response.data.mm3Qualified == true)
                    {
                        dispatch({type : 'MM3QUALIFIED',value : true});
                        window.sessionStorage.setItem('mm3Qualified', true);
      	            }
                      if(response?.data && response?.data?.vzEmployee && response?.data?.vzEmployee === true )
                        {
                            dispatch({type : 'VZEMPLOYEE',value : true});
                          }
                        else{
                            dispatch({type : 'VZEMPLOYEE',value : false});
                        }
                    
                    
                    if (InHomeUtils.isNotNull(response.data.isOCOFlow) && response.data.isOCOFlow === "Y") {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'HOA', PAGEACTIVITY.MSG.HOA, PAGEACTIVITY.UA));
                        errorAction("LBO", "CheckLQ", "HOA", "", visitId, dispatch, true, "HOA");
                    }
                    let prdString = "";

                    if (response.data.additionalInfo && response.data.additionalInfo.selfInstallMessage) {
                        dispatch({ type: 'SELF_INSTALL_MESSAGE', message: response.data.additionalInfo.selfInstallMessage })
                        let isGponMochaEligibleProducts = response.data.products.filter(product => response.data.additionalInfo.selfInstallMessage.includes(product.id));
                        isGponMochaEligibleProducts && isGponMochaEligibleProducts?.length === 1 && (isGponMochaEligibleProducts[0].speedCode === '937' || isGponMochaEligibleProducts[0].speedCode === '936') && dispatch({ type: 'EMERGENCY_GPON_MOCHA_ELIGIBLE', value: true });
                    }
                    else {
                        dispatch({ type: 'SELF_INSTALL_MESSAGE', message: '' });
                    }

                    if(response.data && response.data.products && response?.data?.products?.length > 0) {
                        const prod = response.data.products[0];
                        if(!response.data.mm3Qualified && prod?.productKeyword?.includes('MM4')) {
                            dispatch({ type: 'UPDATE_MN_API', value: true });
                            window.sessionStorage.setItem('mm3Qualified', true);
                            
                        } else {
                            dispatch({ type: 'SET_MIDNIGHT', value: false });
                            dispatch({ type: 'UPDATE_MN_API', value: false });
                        }
                    }

                    let isInstallFeeWaived = true;
                    let disneyPromoEligible = false;
                    let netmaxEligible = false;
                    response?.data?.products?.forEach(p => {
                        prdString += p.downSpeed + ",";
                        // logic to check install fee waiver is present for all product
                        if (isInstallFeeWaived) {
                            let isInDiscountOffer = p?.discountOffers?.filter(offer => offer?.USOCIOSC === 'R3777' || offer?.USOCIOSC === 'R3881');
                            let isInSpecialOffer = p?.specialOffers?.filter(offer => offer?.USOCIOSC === 'R3777' || offer?.USOCIOSC === 'R3881');
                            isInstallFeeWaived = isInDiscountOffer?.length > 0 || isInSpecialOffer?.length > 0
                        }

                        // CETC-146562 as per the ticket we are displaying the Disney details view in supp flow
                        
                        if(p?.specialOffers && p?.specialOffers?.length > 0) {
                            if(window && (window?.location?.href?.includes('supp'))) {
                                const disney = p.specialOffers?.find(offer => offer?.BsOfferAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT');
                                if(disney) {
                                    disneyPromoEligible = true;
                                }
                            }
                            dispatch({ type: 'DISNEY_PROMO_PRESENT', value: disneyPromoEligible });
                        }
                        const netmax = store?.getState()?.buildProduct?.internet?.selectedProduct?.specialOffers?.find(offer => offer?.BsOfferAttrValue === 'NETMAX_PERK_DISCOUNT');
                            if(netmax) {
                                netmaxEligible = true;
                            }
                            dispatch({ type: 'NETMAX_PROMO_PRESENT', value: netmaxEligible });
                    })
                    if (isInstallFeeWaived) {
                        dispatch({type : 'UPDATE_INSTALLFEEWAIVED_ALLPLANS',value : true});
                    }
                    if(response.data.acpqualified){
                        dispatch({ type: 'SET_ACP_STATUS', value: true });
                        if(acpGetDetailsFlag){
                            acpGetDetailsFlag = false;
                            checkoutAction.getACPDetails(dispatch, '?isAcpFlow=Y');
                        }
                    }
                    else if(response.data.vfwdqualified){

                        let  isInDiscountOffer = response.data?.products[0]?.discountOffers;
                        let checkDiscount= isInDiscountOffer?.filter(p=>
                          p.BsOfferAttrValue === "VZP_NEWFIOSFORWARDSTANDALONE_DISCOUNT" || p.BsOfferAttrValue === "VZ_FORWARDBILLCREDIT_DISCOUNT"
                        )
                          if((checkDiscount=== undefined || checkDiscount==="" || checkDiscount?.length<=0  || isInDiscountOffer?.length <=0)  && reAttemptCount<=0){
                              fetchDataMTM(dispatch, visitId, flowType, couponFlowType, action, (reAttemptCount + 1))
                          }

                        if(isInDiscountOffer?.find(off => off.BsOfferAttrValue === "VZ_FORWARDBILLCREDIT_DISCOUNT")) {
                            dispatch({ type: 'SET_VZF_CREDIT_STATUS', value: true });
                        }
                        const specialOffers = response?.data?.products?.[0]?.specialOffers;
                        if(specialOffers?.length > 0 && specialOffers?.find(offer => offer?.BsOfferAttrValue === "VZFORWARD_NY_BROADBAND_DISCOUNT")) {
                            dispatch({ type: "SET_VZF_NY_DISCOUNT", value: true });
                        }
    
                        dispatch({ type: 'SET_VZF_STATUS', value: true });
                        if(vzfGetDetailsFlag){
                            vzfGetDetailsFlag = false;
                            checkoutAction.getACPDetails(dispatch, '?isVfFlow=Y');
                        }
                    }
                    if(response.data.mnhSignupIndicator == 'Y'){
                        checkoutAction.getMnhsignininfodetails(dispatch);
                    }
                    if(window && window.sessionStorage && window.sessionStorage.getItem("comboResponseObj")){
                    checkoutAction.getcustomerdetailsresponse(dispatch);
                    }
                   // checkoutAction.getcustomerdetailsresponse(dispatch);


                    
                    let msg = `DATA ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|DATA:${prdString}`
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', msg, PAGEACTIVITY.UA));
                    let offerIndicators = store && store.getState() && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.offerIndicator ? store.getState().loopQual.runtimeKey.offerIndicator : '';
                    let showFccLabelkey = store && store.getState() && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey?.ShowFccLabelInfo == 'Y' ? true : false;

                    let offerIndicatorsArray = [];
                    let offerIndicatorResultArray = ['iONT','New_Occupant_iONT','New_OFS','PBPD']
                    let offerIndicatorResult = 'allOtherMarkets'
                    if(offerIndicators){
                        offerIndicatorsArray = offerIndicators.split(",");
                        if(offerIndicatorsArray){
                            for(let i = 0; i < offerIndicatorsArray?.length; i++){
                                if(response.data.products && response.data.products[0] && response.data.products[0].specialOffers){
                                    let temp = false;
                                    response.data.products[0].specialOffers.map(product =>{
                                        if(offerIndicatorsArray[i].includes(product.BsOfferAttrValue)){
                                            temp = true;
                                        }
                                    });
                                    if(temp && i<offerIndicatorResultArray?.length){
                                        offerIndicatorResult = offerIndicatorResultArray[i];
                                    }
                                }
                            }
                            if(response.data.products && response.data.products[0] && response.data.products[0].discountOffers){
                                let temp = false;
                                response.data.products[0].discountOffers.map(product =>{
                                    if(offerIndicatorsArray[1].includes(product.BsOfferAttrValue)){
                                        temp = true;
                                    }
                                });
                                if(temp){
                                    offerIndicatorResult = offerIndicatorResultArray[1];
                                }
                            }
                        }
                    }
                    dispatch({
                        type: 'UPDATE_OFFER_INDICATOR', value: offerIndicatorResult
                    });
                    window.addressQualificationType = offerIndicatorResult;
                    dispatch({
                        type: 'FETCH_DATAM2M', value: response?.data?.products?.map(p => {
                            return processOfferSection(p);
                        })
                    });

                    /**Save the sale offers */
                    if(response.data.products && response.data.products[0] && response.data.products[0].specialOffers){
                        if(response.data.products[0].specialOffers.find(save => ['R3883', 'R3884','R3885'].includes(save?.USOCIOSC)))
                        {
                            if(window.sessionStorage.getItem('saveSaleOffer')){
                               updateSandboxIdValue(window.sessionStorage.getItem('saveSaleOffer'));
                            }
                        }
                    }

                    if (response?.data?.products?.length == 1) {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'DataTiles', response.data.products[0].downSpeed + " only available"));
                    }

                    if(response.data && response.data.skipFDVWithNGPON2 == true){
                        dispatch({type : 'DISABLE_VOICE_ACCOR_NGPON2',value : true});
                    }
                    else{
                        dispatch({type : 'DISABLE_VOICE_ACCOR_NGPON2',value : false});
                    }
                    
                    let speedCode = "";
                    let totalSpeeds = [];
                    let isocInfo = [];  
                    response.data.products.forEach(p => {
                        speedCode += p.speedCode + ",";
                        totalSpeeds.push(p.speedCode);
                    })
                    response.data.products.map((item)=>item.planPerks.map((it)=>{
                        if(it.id!==null){
                            isocInfo.push(it.id)
                        }
                    }))
                    response.data.products.map((item)=> {
                        if(item.id!=null){
                            isocInfo.push(item.id)
                        }
                    })
                    dispatch({ type: 'ISOC_INFO', value: isocInfo });
                    if(showFccLabelkey){
                        FCCLabelData(dispatch, isocInfo)
                    }
                    dispatch({ type: 'SPEED_CODE', value: speedCode });
                    dispatch({ type: 'ALL_SPEED_CODES', value: totalSpeeds  });
                    let internetInCart = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.internet?.selectedProduct;
                    let newProduct = [];
                    if(internetInCart && internetInCart.planPerks && response.data.mm3Qualified){
                        response.data.products.map((item) => {
                            if(item.speedCode == internetInCart.speedCode && item.planPerks && item?.planPerks?.length > 0){
                               newProduct.push(item);  
                            }
                       })
                    }
                    
                    if(newProduct && newProduct?.length > 0){
                        dispatch({ type: 'FETCH_DATASUBPROD', value: newProduct[0].planPerks })
                    }
                    // if(!speedCode.includes('941')) {
                    //     dispatch({ type: CheckLQ.updateBannerType, value: BannerTypes.HolidayOfferNon1G })
                    // }
                    // if (InHomeUtils.isNotNull(action) && (action === 'INIT' || action === 'SMART_CART' || action === DOFlow.onDoFlowInit)) {
                    //     let validatePromise = getFcpEligibility(visitId);
                    //     Promise.all([validatePromise])
                    //         .then(response => {
                    //             let FCPFlow = response[0];
                    //             dispatch({
                    //                 type: CheckLQ.isFCPflow,
                    //                 value: FCPFlow
                    //             });
                    //         })
                    // }
                    resolve(response.data);
                }
                else if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    fetchDataMTM(dispatch, visitId, flowType, couponFlowType, action, (reAttemptCount + 1))
                }
                else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                    InHomeUtils.clearMemory();
                    InHomeUtils.redirectToHomePage("LQ=N");
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', "DATA " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-DataMTM", "", visitId, dispatch, true, "ProductNotReturned-DataMTM");
                        window.localStorage.setItem('isLboTriggered', true);    
                    }
                    let errorMsg = `MethodName:fetchDataMTM,errorMessage:ProductNotReturned`;
                    const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response?.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta?.code, '200') ? `meta code is not 200, value - ${response.meta?.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                    vzdlErrorUpdate(response?.meta?.code, "ProductNotReturned-DataMTM");
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "INFO");
                }
            }).catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDataMTM', "Exception is: " + error.message));
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchDataMTM,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchDataMTM', ex);
    }
};

export const fetchData2Y = (dispatch, visitId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDataMTM', "Inside fetchData2Y"));
        let url = apiUrl().getProduct + '/plans';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.twoYear, 'Data', flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response?.data?.products?.length > 0) {
                dispatch({ type: "SET_IWM_ELIGIBLE", value: response?.data?.isiwmEligible });
                let prdString = ""
                response.data.products.forEach(p => {
                    prdString += p.downSpeed + ",";
                })
                let vecFlow = store?.getState()?.loopQual && store?.getState()?.loopQual.lqResponse && (store?.getState()?.loopQual.lqResponse.hoaFlag === "V" || store?.getState()?.loopQual.lqResponse.hoaFlag === "Y");
                if(vecFlow){
                    dispatch({ type: 'UPDATE_DATA_CONTRACT', value: '2YR' });
                }
                //For Getting Help me choose content with speed code 
                let speedCode = "";
                response.data.products.forEach(p => {
                    speedCode += p.speedCode + ",";
                })
                dispatch({ type: 'SPEED_CODE', value: speedCode });
                if(response.data && response.data.mnhSignupIndicator)
                    {
                        if(response.data.mnhSignupIndicator !== '' && response.data.mnhSignupIndicator !== 'N')
                        updateSubFlowValue(' | M+H', 'm+h');
                        dispatch({type : 'MNHSIGNUPINDICATOR',value : response.data.mnhSignupIndicator});
                    }
                if(response.data && response.data.mm3Qualified && response.data.mm3Qualified == true)
                {
                    dispatch({type : 'MM3QUALIFIED',value : true});
                  }
                  if(response.data && response.data.strikePrice)
                    {
                        dispatch({type : 'STRIKE_PRICE_INDICATOR',value : response.data.strikePrice});
                   
                    }
               
                if (response.data.additionalInfo && response.data.additionalInfo.selfInstallMessage) {
                    dispatch({ type: 'SELF_INSTALL_MESSAGE', message: response.data.additionalInfo.selfInstallMessage })
                    let isGponMochaEligibleProducts = response.data.products.filter(product => response.data.additionalInfo.selfInstallMessage.includes(product.id));
                    isGponMochaEligibleProducts && isGponMochaEligibleProducts.length === 1 && (isGponMochaEligibleProducts[0].speedCode === '937' || isGponMochaEligibleProducts[0].speedCode === '936') && dispatch({ type: 'EMERGENCY_GPON_MOCHA_ELIGIBLE', value: true });
                }
                else {
                    dispatch({ type: 'SELF_INSTALL_MESSAGE', message: '' });
                }

                let msg = `DATA ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.twoyear}|DATA:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', msg, PAGEACTIVITY.UA));
                dispatch({
                    type: 'FETCH_DATA2Y', value: response.data.products.map(p => {
                        return processOfferSection(p);
                    })
                });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchData2Y(dispatch, visitId, flowType, (reAttemptCount += 1))
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', "DATA " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.twoyear, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Data2Y", "", visitId, dispatch, true, "ProductNotReturned-Data2Y");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-Data2Y");
                let errorMsg = `MethodName:fetchData2Y,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "INFO");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchData2Y', "Exception is: " + error.message));
                //     loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchData2Y,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchData2Y', ex);
    }
};

export const fetchRouter = (dispatch, visitId, flowType, reAttemptCount = 0, isFinalCall = false, lqState = null, voicetn = "", buildProductState = null, addlFlowType = null, setLoader = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Inside fetchRouter"));
        let url = apiUrl().getProduct + '/equipments';
        let apiType = 'router';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
            apiType = 'ACCESSPOINTBILLER';
        }
        let is15gFlow = addlFlowType === '15G' ? true : false
        if(setLoader) loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        let mm3Qualified = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.mm3Qualified;
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        performance.mark('Triggered Router call')
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, apiType, flowType)).then(response => {
            if(setLoader) loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            performance.mark('Triggered Router call end')
            if (window.nrTimeState && window.nrTimeState.fromTime) {
                logNRTime(window.nrTimeState, dispatch, 'BuildProducts');
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Router Products Found"));
                response.data.products.forEach((prod) => setHtmlSymbols(prod));
                //if(mm3Qualified){
                    dispatch({
                        type: 'FETCH_ROUTER',
                        value: response.data.products.map(p => p)
                    })
                  //  }    
                let WHWRouter = response.data.products.filter(p => InHomeUtils.isNotNull(p.keyword) && (p.keyword.indexOf('AutoAddExtender:R0642') > -1 || p.keyword.indexOf('AUTOADDEXTENDER:R0840') > -1));
                let routerPlans = response.data.products.filter(p => p.prodTypeValue !== 'CUSTOMER_PROVIDED_ROUTER' && p.name.indexOf('G3100') < 0 && InHomeUtils.isNotNull(p.keyword) && p.keyword.indexOf('AutoAddExtender:R0642') < 0 && p.keyword.indexOf('AUTOADDEXTENDER:R0840') < 0).sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                if (InHomeUtils.isNotNull(WHWRouter) && WHWRouter.length > 0) {
                    routerPlans.splice(0, 0, WHWRouter[0])
                }
               
                response.data.products.filter(p => p.prodTypeValue === 'CUSTOMER_PROVIDED_ROUTER').map(p => routerPlans.push(p));
               /* if(mm3Qualified && mm3Qualified == false){
                    dispatch({
                        type: 'FETCH_ROUTER',
                        value: routerPlans.map(p => p)
                    });  
                } */

                let WHWRouter1gig = response.data.products.filter(p => InHomeUtils.isNotNull(p.keyword) && ((p.keyword.indexOf('Display:ACQ:1G_500MAtNonGigAddr') > -1) || (p.keyword.indexOf('DISPLAY:ACQ:2G_1G_500MATNONGIGADDR') > -1)));
                let freeRouter = [];
                freeRouter =  response.data.products.filter(p => ( p.displayPrice.indexOf("$0") > -1 && p.prodTypeValue === "MRC_CHARGED_CONSUMER"));
               
              /*  if (InHomeUtils.isNotNull(buildProductState) && WHWRouter1gig && WHWRouter1gig.length > 0) {
                    if (!is15gFlow) {
                        updateCart(visitId, lqState, WHWRouter1gig[0], "ROUTER", false, dispatch, voicetn, null, null, "MTM", "DATA", false, false, null, buildProductState, null, flowType, null);
                    } 
                }
                else{
                    if( freeRouter &&  freeRouter.length > 0){
                    updateCart(visitId, lqState, freeRouter[0], "ROUTER", false, dispatch, voicetn, null, null, "MTM", "DATA", false, false, null, buildProductState, null, flowType, null);
                 } 
                } */
                if (InHomeUtils.isNotNull(routerPlans) && routerPlans.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Router: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM && !isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRouter', "Router " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchRouter(dispatch, visitId, flowType, (reAttemptCount + 1))
            } else if (isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRouter', "Router" + PAGEACTIVITY.MSG.productNotFound + "- ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Router", "", visitId, dispatch, true, "ProductNotReturned-Router");
                    window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchRouter,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-Router");
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Exception is: " + error.message));
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchRouter,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchRouter', ex);
    }
};

export const fetchQuipmentReps = (dispatch, visitId, flowType, reAttemptCount = 0, isFinalCall = false, lqState = null, voicetn = "", buildProductState = null, addlFlowType = null) => {
    try {
        return new Promise((resolve,reject)=> {
        
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Inside fetchRouter"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
            apiType = 'ACCESSPOINTBILLER';
        }
        let is15gFlow = addlFlowType === '15G' ? true : false
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        let mm3Qualified = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.mm3Qualified;
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'router', flowType)).then(response => {

            //loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (window.nrTimeState && window.nrTimeState.fromTime) {
                logNRTime(window.nrTimeState, dispatch, 'BuildProducts');
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Router Products Found"));
                response.data.products.forEach((prod) => setHtmlSymbols(prod));
                resolve(response.data.products.map(p => p))    
            }
            else if (reAttemptCount < retryCountFromAEM && !isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRouter', "Router " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchQuipmentReps(dispatch, visitId, flowType, (reAttemptCount + 1));
               } else if (isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRouter', "Router" + PAGEACTIVITY.MSG.productNotFound + "- ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Router", "", visitId, dispatch, true, "ProductNotReturned-Router");
                    window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchRouter,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-Router");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            } else {
                resolve(null)
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Exception is: " + error.message));
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchRouter,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });

        })
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchRouter', ex);
    }
};

export const doSmartCartSave = (dispatch, visitId, mtn, eMailID) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'doSmartCartSave', "Inside doSmartCartSave"));
        //Remove the unrequired junk characters in MTN Info
        if (InHomeUtils.isNotNull(mtn) && InHomeUtils.isNotEmpty(mtn)) {
            mtn = mtn.replace(/[^0-9]/g, '');
        }
        let url = apiUrl().smartSave;
        let prospectUpdate = false;
        if (InHomeUtils.isNotEmpty(eMailID)) {
            prospectUpdate = true;
        }
        let request = {
            email: eMailID,
            mtn: mtn,
            saveType: 'autogen',
            prospectUpdate: prospectUpdate ? "Y" : "",
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: 'DO_SMARTCART',
                    value: true
                });
            }
            else {
                let errorMsg = `MethodName:doSmartCartSave,errorMessage:API response error`;
                logKafka("ERROR", "doSmartCartSave", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:doSmartCartSave,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "doSmartCartSave", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'doSmartCartSave', ex);
    }
};
export const enableVasChildList = (dispatch, enableVasChildList = false) => {
    dispatch({
        type: 'ENABLE_VASCHILD_LIST',
        value: enableVasChildList
    });
}
export const fetchTechSure = (dispatch, visitId, flowType, lqState = null, voicetn = "", buildProductState = null, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTechSure', "Inside fetchTechSure"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        vcloud = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.vcloud;
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // console.log("vcloud: " + vcloud);
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vas', flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTechSure', "Vas Products Found"));
                var techsurePrd = response.data.products; //response.data.products.sort((a, b) => parseFloat(a.displayPrice.replace("$", "")) - parseFloat(b.displayPrice.replace("$", ""))); 
                // let vasprod = techsurePrd.filter(p => (p.childOf === null || p.childOf === "") && (InHomeUtils.isNull(p.isVCloudProd) || p.isVCloudProd === "" ) && p.name.indexOf("Home Device Advisor") < 0);
                let vasprod = techsurePrd?.filter(p => (InHomeUtils.isNull(p?.isVCloudProd) || p?.isVCloudProd === "" ) && p?.name?.indexOf("Home Device Advisor") < 0);
                let HDA = techsurePrd.filter(p => (p.childOf === null || p.childOf === "") && (InHomeUtils.isNull(p.isVCloudProd) || p.isVCloudProd === "" ) && p.name.indexOf("Home Device Advisor") > -1);
                if (InHomeUtils.isNotNull(HDA) && HDA.length > 0) {
                    vasprod.splice(1, 0, HDA[0])
                }
                if (vcloud === 'Y') {
                    dispatch({
                        type: 'FETCH_TECHSURE',
                        value: vasprod//techsurePrd.filter(p => p.childOf === null && InHomeUtils.isNull(p.isVCloudProd))
                    });
                    var techsurecloudPrd = techsurePrd.sort((a, b) => parseFloat(a.displayPrice.replace("$", "")) - parseFloat(b.displayPrice.replace("$", "")));
                    let techsurecloudPrdFiltered = techsurecloudPrd.filter(p => ( p.childOf === null || p.childOf === "")&& p.isVCloudProd && p.isVCloudProd === "Yes")
                    dispatch({
                        type: 'FETCH_TECHSURE_CLOUD',
                        value: techsurecloudPrdFiltered
                    });
                }
                else {
                    dispatch({
                        type: 'FETCH_TECHSURE',
                        value: techsurePrd.filter(p => p.childOf === null)
                    });
                }
                dispatch({
                    type: 'FETCH_VAS_CHILD',
                    value: techsurePrd.filter(p => (p.childOf !== null && p.childOf !== ""))
                });

                if (InHomeUtils.isNotNull(techsurePrd.map(p => p)) && techsurePrd.map(p => p).length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { TechSure: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTechSure', "VAS " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchTechSure(dispatch, visitId, flowType, lqState, "", buildProductState, reAttemptCount + 1)
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTechSure', "VAS " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchTechSure,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-VAS");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTechSure', "Exception is:" + error.message));
                //  loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchTechSure,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchTechSure', ex);
    }
};

const fetchrowMasterTvList = (masterpackagesviewRows, currentPackageid) => {
    for (let i = 0; i < masterpackagesviewRows.length; i++) {
        if (masterpackagesviewRows[i].packageusoc === currentPackageid) {
            return masterpackagesviewRows[i];
        }
    }
}

export const fetchTVMTM = (dispatch, visitId, zip, tarCode, channelLineUpTvPackages, isDoflow, couponFlowType = null, flowType, reAttemptCount = 0, isFinalCall = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "Inside fetchTVMTM"));
        let url = apiUrl().getProduct + '/plans';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        return new Promise((resolve, reject) => {
            //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'Video', flowType, couponFlowType)).then(response => {
                   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    let prdString = ""
                    response.data.products.forEach(p => {
                        prdString += p.prodTypeValue + ",";
                    })
                    let msg = `TV ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|VIDEO:${prdString}`
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', msg, PAGEACTIVITY.UA));

                    //let customGenericTV = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC')
                    response.data.products.map(p => {
                        return processOfferSection(p);
                    });
                    let tvPlans = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC' || p.prodTypeValue.indexOf('CUSTOM') === -1);
                    let customTvPlans = response.data.products.filter(p => p.prodTypeValue.indexOf('CUSTOM') > -1 && p.prodTypeValue !== 'CUSTOM_GENERIC');
                    let testdriveTvPlans = response.data.products.filter(p => p.prodTypeValue === 'ULTIMATETESTDRIVE');
                    let ultimateTv = response.data.products.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                    let masterpackagesviewRows = null;
                    if (InHomeUtils.isNotNull(testdriveTvPlans) && testdriveTvPlans.length > 0) {
                        dispatch({ type: 'ULTIMATE_DRIVE_AVL', value: true });
                    }
                    if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv.length > 0) {
                        dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id });
                    }
                    masterpackagesviewRows = channelLineUpTvPackages;
                    if (InHomeUtils.isNotNull(masterpackagesviewRows)) {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "TV M2M - Fetching TV Results"));
                        fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'N', testdriveTvPlans);
                    }
                    else {
                        let channelpackageUrl = apiUrl().channelLineupPackagesUrl;
                        api(channelpackageUrl, 'POST', getRequestChannel(visitId, zip, tarCode)).then(response => {
                            if (InHomeUtils.isNotNull(response)) {
                                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "TV M2M - ChannelLineup - Success"));
                                masterpackagesviewRows = response.masterpackagesview;
                                if (masterpackagesviewRows && masterpackagesviewRows.length > 0) {
                                    dispatch({
                                        type: 'CHANNEL_MASTERPACKAGEVIEW',
                                        value: masterpackagesviewRows
                                    });
                                }
                            }
                            fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'N', testdriveTvPlans);
                        })
                            .catch(error => {
                                let errorMsg = `MethodName:fetchTVMTM-Channelineup,errorMessage:${error.message}`;
                                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                            });
                    }
                    resolve(response.data);
                }
                else if (reAttemptCount < retryCountFromAEM && !isFinalCall) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    fetchTVMTM(dispatch, visitId, zip, tarCode, channelLineUpTvPackages, isDoflow, couponFlowType, flowType, (reAttemptCount + 1))
                }
                else if (isFinalCall) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', "TV " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-TVMTM", "", visitId, dispatch, true, "ProductNotReturned-TVMTM");
                        window.localStorage.setItem('isLboTriggered', true);
                    }
                    let errorMsg = `MethodName:fetchTVMTM,errorMessage:ProductNotReturned`;
                    const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                    vzdlErrorUpdate(response.meta.code, "ProductNotReturned-TVMTM");
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
                }
                if (isDoflow) {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            })
                .catch(error => {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "Exception is: " + error.message));
                    //    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                    let errorMsg = `MethodName:fetchTVMTM,errorMessage:${error.message}`;
                    //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchTVMTM', ex);
    }
};

const fetchTVResults = (dispatch, customTvPlans, tvPlans, masterpackagesviewRows, Tv2Year) => {
    for (let i = 0; i < tvPlans.length; i++) {
        if (tvPlans[i].prodTypeValue === "CUSTOM_GENERIC") {
            tvPlans[i].description = "155+ channels  (7 plans to choose from)";
            continue;
        }
        if (InHomeUtils.isNotNull(masterpackagesviewRows)) {
            let singlerowtv = fetchrowMasterTvList(masterpackagesviewRows, tvPlans[i].id);
            if (InHomeUtils.isNotNull(singlerowtv)) {
                tvPlans[i].description = singlerowtv.totalchannelcount + "+ channels (" + singlerowtv.hdchannelcount + "+ in HD)";
            }
        }
    }
    if (Tv2Year === 'N') {
        dispatch({ type: 'FETCH_TVM2M', value: tvPlans.map(p => p) });
    }
    else {
        dispatch({ type: 'FETCH_TV2Y', value: tvPlans.map(p => p) });
    }
    // else {
    //     doProcessBasicDiff(dispatch, tvPlansBasicDiff, tvPlans);
    // }
    dispatch({ type: 'FETCH_CUSTOMTV', value: customTvPlans.map(p => p) });
}

export const updateStateBuildPrdPage = (val) => {
    statevalue = val;
}

export const fetchTV2Y = (dispatch, visitId, zip, tarCode, channelLineUpTvPackages, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTV2Y', "Inside fetchTV2Y"));
        let url = apiUrl().getProduct + '/plans';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        return new Promise((resolve, reject) => {
            //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST', getRequest(visitId, Contract.twoYear, 'Video', flowType)).then(response => {
                //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    let prdString = ""
                    response.data.products.forEach(p => {
                        prdString += p.prodTypeValue + ",";
                    })
                    let msg = `TV ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.twoyear}|VIDEO:${prdString}`
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTV2Y', msg, PAGEACTIVITY.UA));

                    //let customGenericTV = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC')
                    response.data.products.map(p => {
                        return processOfferSection(p);
                    });
                    let tvPlans = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC' || p.prodTypeValue.indexOf('CUSTOM') === -1)
                    let customTvPlans = response.data.products.filter(p => p.prodTypeValue.indexOf('CUSTOM') > -1 && p.prodTypeValue !== 'CUSTOM_GENERIC')
                    let masterpackagesviewRows = null;
                    masterpackagesviewRows = channelLineUpTvPackages;
                    if (InHomeUtils.isNotEmpty(masterpackagesviewRows) && masterpackagesviewRows.length > 0) {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTV2Y', "TV 2YR - Fetching Tv Results"));
                        fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'Y');
                    }
                    else {
                        let channelpackageUrl = apiUrl().channelLineupPackagesUrl;
                        api(channelpackageUrl, 'POST', getRequestChannel(visitId, zip, tarCode)).then(response => {
                            if (InHomeUtils.isNotNull(response)) {
                                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTV2Y', "TV 2YR - channellineup Success"));
                                masterpackagesviewRows = response.masterpackagesview;
                                dispatch({
                                    type: 'CHANNEL_MASTERPACKAGEVIEW',
                                    value: masterpackagesviewRows
                                });
                                fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'Y');
                            }

                        })
                            .catch(error => {
                                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                                let errorMsg = `MethodName:fetchTV2Y-Channelineup,errorMessage:${error.message}`;
                                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                            });
                    }
                    resolve(response.data);
                }
                else if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTV2Y', "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    fetchTV2Y(dispatch, visitId, zip, tarCode, channelLineUpTvPackages, flowType, reAttemptCount + 1)
                }
                else {

                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTV2Y', "TV " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.twoyear, PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-TV2Y", "", visitId, dispatch, true, "ProductNotReturned-TV2Y");
                        window.localStorage.setItem('isLboTriggered', true);    
                    }
                    let errorMsg = `MethodName:fetchTV2Y,errorMessage:ProductNotReturned`;
                    const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                    vzdlErrorUpdate(response.meta.code, "ProductNotReturned-TV2Y");
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");

                }

            })
                .catch(error => {
                    //    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                    //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                    let errorMsg = `MethodName:fetchTV2Y,errorMessage:${error.message}`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchTV2Y', ex);
    }
};
// export const doProcessBasicDiff = (dispatch, tvPlansBasicDiff, tvPlans) => {
//     let newprodList=[];
//     for (let i = 0; i < tvPlans.length; i++) {
//         console.log("tvPlans length");
//         if (tvPlans[i].prodTypeValue === "ULTIMATE") {
//             console.log("ULTIMATE");
//             let tvplanUltimate = tvPlans[i];
//             let newprod = tvplanUltimate.constructor();
//             for (var attr in tvplanUltimate) {
//                 if (tvplanUltimate.hasOwnProperty(attr)) newprod[attr] = tvplanUltimate[attr];
//             }
//             //newprod = copy(tvplanUltimate);
//             newprod.displayPrice = tvPlansBasicDiff[0].displayPrice;
//             //tvplanUltimate.description = tvPlansBasicDiff.description;
//             newprod.id = tvPlansBasicDiff[0].id;
//             newprod.name = tvPlansBasicDiff[0].name;
//             newprod.originalPrice = tvPlansBasicDiff[0].originalPrice;
//             newprod.prodType = tvPlansBasicDiff[0].prodType;
//             newprod.prodTypeValue = tvPlansBasicDiff[0].prodTypeValue;
//             newprodList.push(newprod);//tvPlans.push(newprod);
//             console.log("After BasicDiff push");
//         }

//     }
//     tvPlans.map(p=>newprodList.push(p))
//     dispatch({
//         type: 'FETCH_TV2Y',
//         value: newprodList.map(p => p)
//     });

// };
export const fetchVoiceMTM = (dispatch, visitId, couponFlowType = null, flowType, reAttemptCount = 0, isFinalCall = false,) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVoiceMTM', "Inside fetchVoiceMTM"));
        let url = apiUrl().getProduct + '/plans';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'Fios_Voice', flowType, couponFlowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                let prdString = ""
                response.data.products.forEach(p => {
                    prdString += p.name + ",";
                })
                let msg = `VOICE ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|VOICE:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', msg, PAGEACTIVITY.UA));

                dispatch({
                    type: 'FETCH_VOICE',
                    value: response.data.products.map(p => {
                        return processOfferSection(p);
                    })
                });
                let sortedResponse = InHomeUtils.isNotNull(response.data.voiceUsageRatesList) && response.data.voiceUsageRatesList.sort(function (a, b) { return (a.countryName < b.countryName) ? -1 : (a.countryName > b.countryName) ? 1 : 0; });
                InHomeUtils.isNotNull(sortedResponse) && dispatch({
                    type: 'FETCH_INTLCALLING',
                    value: sortedResponse
                });
            }
            else if (reAttemptCount < retryCountFromAEM && !isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoiceMTM', "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchVoiceMTM(dispatch, visitId, couponFlowType, flowType, (reAttemptCount + 1));
            }
            else if (isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoiceMTM', "VOICE " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                  errorAction("LBO", "BuildProduct", "ProductNotReturned-VoiceMTM", "", visitId, dispatch, true, "ProductNotReturned-VoiceMTM");
                  window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchVoiceMTM,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-VoiceMTM");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                //    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchVoiceMTM,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchVoiceMTM', ex);
    }
};

export const fetchVoice2Y = (dispatch, visitId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVoice2Y', "Inside fetchVoice2Y"));
        let url = apiUrl().getProduct + '/plans';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.twoYear, 'Fios_Voice', flowType)).then(response => {
            //  loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                let prdString = ""
                response.data.products.forEach(p => {
                    prdString += p.downSpeed + ",";
                })
                let msg = `VOICE ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.twoyear}|VOICE:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoice2Y', msg, PAGEACTIVITY.UA));

                dispatch({
                    type: 'FETCH_VOICE',
                    value: response.data.products.map(p => {
                        return processOfferSection(p);
                    })
                });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoice2Y', "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchVoice2Y(dispatch, visitId, flowType, (reAttemptCount + 1));
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoice2Y', "VOICE " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.twoyear, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Voice2Y", "", visitId, dispatch, true, "ProductNotReturned-Voice2Y");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchVoice2Y,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-Voice2Y");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchVoice2Y,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchVoice2Y', ex);
    }
};

export const fetchPerksMTM = (dispatch, visitId, couponFlowType = null, flowType, reAttemptCount = 0, isFinalCall = false,) => {
    try {      
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPerksMTM', "Inside fetchPerksMTM"));
        let url = apiUrl().getProduct + '/perks';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, "MTM", 'perks', flowType, couponFlowType)).then(response => {  
            // perkStub.then(response=>{
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.product) && response.data.product.length > 0) {
                dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
                dispatch({ type: 'FETCH_PERKS_MESSAGES', value: response.perkMessageSet.map(p => p) });
                let prdString = ""
                response?.data?.product?.forEach(p => {
                    prdString += p?.name + ",";
                })
                let msg = `PERKS ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|PERKS:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerksMTM', msg, PAGEACTIVITY.UA));

                let perksPlans =  response?.data?.product;
                let isDisneyTrioInPlans =   perksPlans?.findIndex(p => p?.productId === "R4438") > -1;
                dispatch({ type: 'SET_DISNEY_TRIO', value: isDisneyTrioInPlans });

            }
            else if (reAttemptCount < retryCountFromAEM && !isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerksMTM', "PERKS " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchPerksMTM(dispatch, visitId, couponFlowType, flowType, (reAttemptCount + 1));
            }
            else if (isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerksMTM', "PERKS " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                  errorAction("LBO", "BuildProduct", "ProductNotReturned-PerksMTM", "", visitId, dispatch, true, "ProductNotReturned-PerksMTM");
                  window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchPerksMTM,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-PerksMTM");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                // perkStub.then(response=>{
                //     dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
                // })
                // dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
            
                //    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchPerksMTM,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        // perkStub.then(response=>{
        //     dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
        // })
        catchJSException('BuildProduct', visitId, 'fetchPerksMTM', ex);
    }
};

export const fetchVRoom = (dispatch, visitId, isLocalTVInCart, isDCTinCart, flowType, reAttemptCount = 0, isFinalCall = false, isUpdateVroom = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVRoom', "Inside fetchVRoom"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vroom', flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVRoom', "VRoom Products Found"));
                response.data.products.forEach((prod) => setHtmlSymbols(prod));
                if (response.data.products.length === 1) {
                    dispatch({
                        type: 'EMERGENCY_NOTIFICATION_VROOM',
                        value: true
                    })
                }
                /*if (isLocalTVInCart || isDCTinCart) {
                    response.data.products.push({ id: 'NOVROOM', prodType: 'vroom', unitCount: "none", name: "No TVs" });
                }*/
                response.data.products.sort((a, b) => (a.unitCount > b.unitCount) ? 1 : ((b.unitCount > a.unitCount) ? -1 : 0));
                let tvConnections = JSON.parse(JSON.stringify(response.data.products))
                tvConnections = tvConnections.map(p => { p['prodType'] = 'DUMMYVROOM'; return p; });
                dispatch({
                    type: 'FETCH_VROOM',
                    value: response.data.products.map(p => p)
                });
                dispatch({
                    type: 'FETCH_TVCONNECTIONS',
                    value: tvConnections
                });
                if (InHomeUtils.isNotNull(response.data.products.map(p => p)) && response.data.products.map(p => p).length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Vroom: true } });
                }
                if(isUpdateVroom){
                    dispatch({ type: 'UPDATE_VROOM', value: { product: null, isChecked : false } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM && !isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVRoom', "VRoom " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchVRoom(dispatch, visitId, isLocalTVInCart, isDCTinCart, flowType, (reAttemptCount + 1));
            } else if (isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVRoom', "VRoom " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-VRoom", "", visitId, dispatch, true, "ProductNotReturned-VRoom");
                    window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchVRoom,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-VRoom");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                //    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchVRoom,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchVRoom', ex);
    }
};

export const fetchRecording = (dispatch, visitId, couponFlowType, flowType, reAttemptCount = 0, isFinalCall = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRecording', "Inside fetchRecording"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vfeature', flowType, couponFlowType)).then(response => {            
            //  loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {                
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRecording', "Recording Products Found"));
                let product = [{ id: 'NORECORD', prodType: 'VFEATURE', name: "I don't want to record on any TV's" }];
                let recordingProduct = response.data.products.map(p => p);
                product.map(p => recordingProduct.push(p));
                let recordingSelectedProduct = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.recording && store.getState().buildProduct.recording.selectedProduct;
                if(recordingSelectedProduct && recordingSelectedProduct.id){
                    let productMatched = false;
                    for(let i=0;i < recordingProduct.length;i++){
                        if(recordingProduct[i].id === recordingSelectedProduct.id){
                            productMatched = true;
                            break;
                        }
                    }
                    if(!productMatched){
                        dispatch({
                            type: 'RECORDING_SELECTEDPROD',
                            value: null
                        });
                    }
                }
                dispatch({
                    type: 'FETCH_RECORDING',
                    value: recordingProduct
                });
                if (InHomeUtils.isNotNull(recordingProduct) && recordingProduct.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Recording: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM && !isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRecording', "Recording " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchRecording(dispatch, visitId, couponFlowType, flowType, (reAttemptCount + 1))
            } else if (isFinalCall) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRecording', "Recording " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Rcording", "", visitId, dispatch, true, "ProductNotReturned-Recording");
                    window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchRecording,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-Rcording");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                //  loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchRecording,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchRecording', ex);
    }
};

export const fetchChannel = (dispatch, visitId, selectedProductId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchChannel', "Inside fetchChannel"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getPremiumChannelRequest(visitId, Contract.monthToMonth, 'MOVIE', selectedProductId, flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchChannel', "Channel Products Found"));
                dispatch({
                    type: 'FETCH_CHANNEL',
                    value: response.data.products.filter(p => p.includedWithPlan === false)
                });
                if (InHomeUtils.isNotNull(response.data.products.filter(p => p.includedWithPlan === false)) && response.data.products.filter(p => p.includedWithPlan === false).length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Channel: true } });
                    // dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { InternationalChannel: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchChannel(dispatch, visitId, selectedProductId, flowType, (reAttemptCount + 1))
            }
            /* else {
                 if (!isLboOccurred) {
                     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt 1", PAGEACTIVITY.UA));
                     fetchChannel(dispatch, visitId, selectedProductId, true)
                 } else {
                     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                     errorAction("LBO", "BuildProduct", "ProductNotReturned-Channel", "", visitId, dispatch, true, "ProductNotReturned-Channel");
                     let errorMsg = `MethodName:fetchChannel,errorMessage:ProductNotReturned`;
                     logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                 }
             }*/
        })
            .catch(error => {
                //     loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchChannel,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchChannel', ex);
    }
};

export const fetchIntrChannel = (dispatch, visitId, selectedProductId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntrChannel', "Inside fetchIntrChannel"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getPremiumChannelRequest(visitId, Contract.monthToMonth, 'INTLPKG', '', flowType)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntrChannel', "International Channel Products Found"));
                let value = {}
                response.data.products.map(p => {
                    if (p.productKeyword && p.productKeyword.includes('|LANGUAGE:')) {
                        let language = p.productKeyword.split('|').filter(k => k.includes('LANGUAGE:'))[0].split(':')[1];
                        if (language) {
                            language = language?.toLowerCase();
                            if (Object.keys(value).length && Object.keys(value).includes(language)) {
                                value[language].push(p);
                            }
                            else {
                                value[language] = [];
                                value[language].push(p);
                            }
                        }
                    }
                })
                let sortedValue = value;
                if (typeof value === 'object' && Object.keys(value).length) {
                    sortedValue = Object.keys(value).sort().reduce(
                        (obj, key) => {
                            obj[key] = value[key];
                            return obj;
                        },
                        {}
                    );
                }

                dispatch({
                    type: 'FETCH_INTERNATIONAL_CHANNEL',
                    value: sortedValue
                });
                if (Object.keys(value).length) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { InternationalChannel: true } });
                    // dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { InternationalChannel: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchIntrChannel', "International Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchIntrChannel(dispatch, visitId, selectedProductId, flowType, (reAttemptCount + 1))
            }
            /* else {
                 if (!isLboOccurred) {
                     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt 1", PAGEACTIVITY.UA));
                     fetchChannel(dispatch, visitId, selectedProductId, true)
                 } else {
                     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                     errorAction("LBO", "BuildProduct", "ProductNotReturned-Channel", "", visitId, dispatch, true, "ProductNotReturned-Channel");
                     let errorMsg = `MethodName:fetchChannel,errorMessage:ProductNotReturned`;
                     logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                 }
             }*/
        })
            .catch(error => {
                //     loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:fetchIntrChannel,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchIntrChannel', ex);
    }
};
export const updateTN = (visitId, exTN, dispatch) => {
    try {
        dispatch({
            type: 'LOAD_TN',
            value: exTN
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateTN', ex);
    }
}
export const loadTN = (visitId, dispatch, hoaData = null) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'loadTN', "Inside loadTN"));
        let url = apiUrl().voicetn + '/requesttn?nooftns=1';
        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '201') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotEmpty(response.data.requestedTnsOnly) && response.data.requestedTnsOnly.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'loadTN', "loadTN Success"));
                dispatch({
                    type: 'LOAD_TN',
                    value: response.data.requestedTnsOnly[0]
                });

                if (InHomeUtils.isNotNull(hoaData) && InHomeUtils.isNotNull(hoaData.defaultMap) && InHomeUtils.isNotNull(hoaData.defaultMap['voice'])) {
                    updateRequestTNForFDV(visitId, response.data.requestedTnsOnly[0], dispatch);
                }

            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'loadTN', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                dispatch({
                    type: 'LOAD_TN',
                    value: "1000000001"
                });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:loadTN,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'loadTN', ex);
    }
};

export const fetchListing = (dispatch, visitId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchListing', "Inside fetchListing"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'listing', flowType)).then(response => {
            //      loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchListing', "Listing Products Found"));
                let listingProd = response.data.products.filter(p => p.prodType !== "FVPREMIUM").sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                dispatch({
                    type: 'FETCH_LISTING',
                    value: listingProd
                });
                if (InHomeUtils.isNotNull(listingProd) && listingProd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Listing: true } });
                }

                let PYOACProducts = response.data.products.filter(p => p.prodType === "FVPREMIUM" && (p.keyword !== null && p.keyword.indexOf("PYOAC") > -1))
                dispatch({
                    type: 'FETCH_PYOAC',
                    value: PYOACProducts
                })
                if (InHomeUtils.isNotNull(PYOACProducts) && PYOACProducts.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Pyoac: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchListing', "Listing " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchListing(dispatch, visitId, flowType, reAttemptCount + 1);
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchListing', "Listing " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Listing", "", visitId, dispatch, true, "ProductNotReturned-Listing");
                    window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchListing,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-Listing");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                //     loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchListing,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchListing', ex);
    }
};
export const fetchIntlPlans = (dispatch, visitId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntlPlans', "Inside fetchIntlPlans"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'INTL', flowType)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntlPlans', "International Plans Products Found"));
                var intlPlansPrd = response.data.products.sort((a, b) => parseFloat(a.displayPrice.replace("$", "")) - parseFloat(b.displayPrice.replace("$", "")));
                dispatch({
                    type: 'FETCH_INTERNATIONAL_PLANS',
                    value: intlPlansPrd
                });
                if (InHomeUtils.isNotNull(intlPlansPrd) && intlPlansPrd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { IntlPlans: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchIntlPlans', "International Plans " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchIntlPlans(dispatch, visitId, flowType, (reAttemptCount + 1));
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchIntlPlans', "International Plans " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                //errorAction("LBO", "BuildProduct", "ProductNotReturned-IntlPlans", "", visitId, dispatch, true, "ProductNotReturned-BatteryBackup");
                let errorMsg = `MethodName:IntlPlans,errorMessage:ProductNotReturned`;
                const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-IntlPlans");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:IntlPlans,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchIntlPlans', ex);
    }
};

export const fetchBackup = (dispatch, visitId, flowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchBackup', "Inside fetchBackup"));
        let url = apiUrl().getProduct + '/equipments';
        if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        let fttpAvailabilityDetailsAGR = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqQualdetails && store.getState().loopQual.lqQualdetails.getBroadbandAvailabilityResult && store.getState().loopQual.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR;
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'battery', flowType)).then(response => {
            //  loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchBackup', "BBU Products Found"));
                //let bbuPrds = response.data.service[0].packages[0].products.filter(p => (p.keyWord === "|FDV_BTRY_CHARGED|" || p.keyWord === "|FDV_DCELL_TRAY_CHARGED|" || p.keyWord === "|FDV_BTRY_ZRATED_DEC|" || p.keyWord === "|FDV_DCELL_TRAY_ZRATED_DEC|"))
                let bbProds = response.data.products.filter(p => p.prodType.indexOf('SHIPMENT') === -1)
                let bbShipProds = response.data.products.filter(p => p.prodType.indexOf('SHIPMENT') > -1).sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                dispatch({
                    type: 'FETCH_BATTERY',
                    //value: bbuPrds
                    value: bbProds
                });
                dispatch({
                    type: 'FETCH_BATTERY_SHIPMENT',
                    value: bbShipProds
                });
                if (InHomeUtils.isNotNull(bbProds) && bbProds.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Backup: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchBackup', "BBU " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchBackup(dispatch, visitId, flowType, (reAttemptCount + 1));
            }
            else {
                if(fttpAvailabilityDetailsAGR && fttpAvailabilityDetailsAGR.ontAGR && fttpAvailabilityDetailsAGR.ontAGR.length > 0 && fttpAvailabilityDetailsAGR.ontAGR[0].ontType !== 'SOHO'){
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchBackup', "BBU " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-BatteryBackup", "", visitId, dispatch, true, "ProductNotReturned-BatteryBackup");
                        window.localStorage.setItem('isLboTriggered', true);
                    }
                    let errorMsg = `MethodName:fetchBackup,errorMessage:ProductNotReturned`;
                    const kibanaErrorMssg = !InHomeUtils.isNotNull(response) ? "response object is null" : !InHomeUtils.isNotNull(response.meta) ? "response.meta is null" : !InHomeUtils.getIndexOf(response.meta.code, '200') ? `meta code is not 200, value - ${response.meta.code}` : !InHomeUtils.isNotNull(response?.data) ? "response.data is null" : !InHomeUtils.isNotNull(response.data?.products) ? 'response.data.products is null' : response.data.products?.length === 0 ? 'response.data.products array is empty' : 'No Root Cause identified';
                    vzdlErrorUpdate(response.meta.code, "ProductNotReturned-BatteryBackup");
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    logToKibanna(`BuildProductPage-${errorMsg} RootCause-${kibanaErrorMssg}`, "ERROR");
                }else{
                    dispatch({ type: 'UPDATE_BATTERY_ACCOR_STATUS', value: 'optional' });
                }
                
            }
        })
            .catch(error => {
                //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchBackup,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchBackup', ex);
    }
};

function getPropertyFromArray(arr, propertyName) {
    if (Array.isArray(arr) && arr.length > 0 && arr[0][propertyName] !== undefined) {
        return arr[0][propertyName];
    }
    
    return "";
}

export const updateCartTNPorted = (visitId, isDoFlow, product, dispatch, portedTN, wbProd, isChecked = false, flowType,buildProduct) => {
    let isMnHAuthenticated = ""
    if(buildProduct?.internet?.mnhSignupIndicator !== "" && buildProduct?.internet?.mnhSignupIndicator !== null && buildProduct?.internet?.mnhSignupIndicator !== undefined){
        isMnHAuthenticated = buildProduct?.internet?.mnhSignupIndicator
      }
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartTNPorted', "Inside updateCartTNPorted"));
        let url = apiUrl().updateCartAcc + '/' + visitId;
        let request = JSON.stringify({
          tn: portedTN,
          productId: getPropertyFromArray(product, 'id'),
          productType: getPropertyFromArray(product, 'prodType'),
          serviceType: Service.voice,
          status: isChecked ? "remove" : "add",
          quantity: "1",
          contract: Contract.monthToMonth,
          isMnHAuthenticated:isMnHAuthenticated
        });
        updateSCTags("add to cart")
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartTNPorted', `Winback TN ${!isChecked ? "Removed from" : "Added to"} cart`));
                let isfcpFlow = InHomeUtils.isFcpFlow();
                addToCartSCEvent(visitId, product, "WINBACKADDED", response, isDoFlow, !isChecked, flowType, isfcpFlow);
                setTimeout(() => {
                    addToCartVzdlSCEvent(visitId, product, "WINBACKADDED", response, isDoFlow, !isChecked, flowType, isfcpFlow);
                }, 1000)
                if (isChecked) {
                    updateRequestTNForFDV(visitId, portedTN, dispatch);
                }
                dispatch({ type: 'UPDATE_PORTEDTN', value: !isChecked ? portedTN : "" });
                dispatch({ type: ModalWindow.onModalWindowClose, value: 'WINBACKYES' })
                dispatch({ type: 'WINBACK_SELECTEDPROD', value: !isChecked || (InHomeUtils.isNotNull(wbProd) && wbProd.id === "WINBACKNO") ? wbProd : null });
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartTNPorted', `Winback - TN Not ${!isChecked ? "Removed from" : "Added to"} cart`, PAGEACTIVITY.UA));
            }

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartTNPorted', ex);
    }
}

export const updateFutureNotificationIntialStatus = (visitId, dispatch) => {
    dispatch({
        type: FutureNotification.intialstatusbackendcall,
        value: false
    });
}

export const updateFutureNotification = (visitId, telNbr, addrId, firstName, lastName, businessName, addressLine1, addressLine2, city, state, zipCode, emailAddress, contactPhone, vzPhone, notifyFios, notifyFiosTv, appId, nsiInd, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Inside updateFutureNotification"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Updating your details", isLoaderImg: "loader" }
        });
        let url = apiUrl().futurenotification;

        api(url, 'POST', getRequestfuturenotification(visitId, telNbr, addrId, firstName, lastName, businessName, addressLine1, addressLine2, city, state, zipCode, emailAddress, contactPhone, vzPhone, notifyFios, notifyFiosTv, appId, nsiInd)).then(response => {
            if (InHomeUtils.isNull(response)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Validation Failure"));
                dispatch({
                    type: FutureNotification.validationfailure,
                    value: true
                });
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Validation Success"));
                dispatch({
                    type: FutureNotification.validationsucess,
                    value: true
                });
                //dispatch({ type: ModalWindow.onModalWindowClose, value: ModalWindow.ids.notification })  
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '400') && response.meta.description === "Email validation failed") {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Email Validation Failed"));
                dispatch({ type: FutureNotification.emailErr, value: true })
                //lqAction.emailErr(true, this.props.dispatch)
                //dispatch({ type: ModalWindow.onModalWindowClose, value: ModalWindow.ids.notification })  
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Validation Failed"));
                dispatch({
                    type: FutureNotification.validationfailure,
                    value: true
                });
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:updateFutureNotification,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateFutureNotification', ex);
    }
}

export const referFrinedValidation = (visitId, isDoFlow, coupon, dispatch, flowType) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true ,  isLoaderText: "Adding promotions"} });
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'referFrinedValidation', "Inside referFrinedValidation"));
        dispatch({ type: 'REFERAFRIENDBACKENDCALSTART', value: true });

        let url = apiUrl().referFrinedValidation;

        api(url, 'POST', validateReferralCode(visitId, coupon)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.transactions) && response.transactions.length > 0 && response.transactions[0].code !== 999) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'referFrinedValidation', " transaction is success"));
                //dispatch({ type: ModalWindow.onModalWindowClose, value:  ModalWindow.ids.coupon }) 
                tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| raf code redeem success";
                tempVzdlSCData.detail = "raf code redeem success";
                if (flowType == "MV") {
                    tempSCData.customerCategory = "^Moves^";
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("rafRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,contentChannel");
                }
                else
                    updateSCcustomEvent(flowType !== "SUPP" ? "rafRedeemOrderSummaryLoad" :"rafRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                updateVzdlSCCustomEvent(flowType !== "SUPP" ? "rafRedeemOrderSummaryLoad" :"rafRedeemLoad", "pageViewOmni", "detail");
                dispatch({ type: 'COUPONSUCCESS', value: true })
                dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONSUCESS', value: true })

            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'referFrinedValidation', "TRANSACTION FAILED", PAGEACTIVITY.UA));
                tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| raf code redeem error";
                tempVzdlSCData.detail = "raf code redeem error";
                if (flowType == "MV") {
                    tempSCData.customerCategory = "^Moves^";
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("rafRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,contentChannel");
                }
                else
                    updateSCcustomEvent(flowType !== "SUPP" ? "rafRedeemOrderSummaryLoad" :"rafRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                updateVzdlSCCustomEvent(flowType !== "SUPP" ? "rafRedeemOrderSummaryLoad" :"rafRedeemLoad", "pageViewOmni", "detail");
                dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONFAILURE', value: true })
            }
            dispatch({ type: 'REFERAFRIENDBACKENDCALSTART', value: false });
        })
            .catch(error => {
                dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONRESULT', value: "couponValidation failures" });
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                let errorMsg = `MethodName:referFrinedValidation,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({
                    type: 'REFERAFRIENDBACKENDCALSTART', value: false
                }
                );
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'referFrinedValidation', ex);
    }
    finally{
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false} });
    }
}
export const ffCouponValidation = (visitId, isDoFlow, visitorId, buildProductState, dispatch) => {
    let flowType= store && store?.getState && store?.getState().app && store?.getState()?.app?.flowType;
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true ,  isLoaderText: "Adding promotions"} });
    try {
        let ffValidationErrorType = "";
        let coupon = buildProductState.couponInfo.coupon;
        
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'ffCouponValidation', "Inside ffCouponValidation"));
        dispatch({ type: 'FFBACKENDCALLSTART', value: true });
        let url = apiUrl().ffCouponValidation;
        api(url, 'POST', referralCouponRequest(visitId, visitorId, coupon)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.leadListId) && InHomeUtils.isNotEmpty(response.data.leadListId) && InHomeUtils.isNotNull(response.data.validInd) && InHomeUtils.isNotEmpty(response.data.validInd) && response.data.validInd === "Y") {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'ffCouponValidation', " transaction is success"));
                let qualifiedSpeedProducts = [];
                if (InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.m2mPlans) && InHomeUtils.isNotEmpty(buildProductState.internet) && InHomeUtils.isNotEmpty(buildProductState.internet.m2mPlans) && buildProductState.internet.m2mPlans.length !== 0) {
                    qualifiedSpeedProducts = buildProductState.internet.m2mPlans;
                }
                let isCompatibleFFPackageInCart = false;
                let maxSpeedCode = getMaxQualifiedSpeedProduct(qualifiedSpeedProducts);
                if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct.speedCode) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct.speedCode) && buildProductState.internet.selectedProduct.speedCode == maxSpeedCode) {
                    isCompatibleFFPackageInCart = true;
                }
                if (isCompatibleFFPackageInCart) {
                    tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                    tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem success| friends and family";
                    tempVzdlSCData.detail = "special offer code redeem success - friends and family";
                    updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                    updateVzdlSCCustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "pageViewOmni", "detail");
                }
                else {
                    tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                    tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem success| friends and family - product not applied";
                    tempVzdlSCData.detail = "special offer code redeem success - friends and family - product not applied";
                    updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                    updateVzdlSCCustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "pageViewOmni", "detail");
                }
                updatePromocodeRemove("add" ,visitId, dispatch, buildProductState)              
                let crmmRefreshResp = new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(updateCRMMRefresh(coupon, response.data.leadListId, visitId, dispatch, false, buildProductState));
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }, 4000);
                }) 
                // let crmmRefreshResp = updateCRMMRefresh(coupon, response.data.leadListId, visitId, dispatch, false, buildProductState);
            }
            else {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && !InHomeUtils.isNotNull(response.data.leadListId) && InHomeUtils.isNotNull(response.data.validInd) && InHomeUtils.isNotEmpty(response.data.validInd) && response.data.validInd === "N" && InHomeUtils.isNotNull(response.data.reasonInvalid) && InHomeUtils.isNotEmpty(response.data.reasonInvalid)) {
                    if (response.data.reasonInvalid.toUpperCase() === "INVALID") {
                        ffValidationErrorType = "INVALID";
                        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-invalid coupon";
                        tempSCData.events = "event5,event15,event20,event46,event21";
                        tempVzdlSCData.detail = "special offer code redeem error-invalid coupon";
                        updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                        // updateVzdlSCCustomEvent("ffRedeemLoad", "pageViewOmni", "detail");
                    }
                    else if (response.data.reasonInvalid.toUpperCase() === "MAX USED" || response.data.reasonInvalid.toUpperCase() === "EXPIRED") {
                        ffValidationErrorType = "MAXUSEDEXPIRED";
                        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-coupon already entered";
                        tempSCData.events = "event5,event15,event20,event46,event21";
                        tempVzdlSCData.detail = "special offer code redeem error-coupon already entered";
                        updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                        updateVzdlSCCustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "pageViewOmni", "detail");
                    }
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'ffCouponValidation', "TRANSACTION FAILED DUE TO COUPON " + response.data.reasonInvalid, PAGEACTIVITY.UA));
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'ffCouponValidation', "TRANSACTION FAILED", PAGEACTIVITY.UA));
                    ffValidationErrorType = "TRANSACTIONFAILED";

                }
                let ffValidationInfo = {
                    ffValidationFailure: true,
                    ffValidationErrorType: ffValidationErrorType
                }
                dispatch({ type: 'FFCOUPONVALIDATIONFAILURE', value: ffValidationInfo })
                dispatch({ type: 'FFBACKENDCALLSTART', value: false });
                tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-invalid coupon";
                tempSCData.events = "event5,event15,event20,event46,event21";
                tempVzdlSCData.detail = "special offer code redeem error-invalid coupon";
                updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                // updateVzdlSCCustomEvent("ffRedeemLoad", "pageViewOmni", "detail");
                // let couponValidationMsg = "We're sorry, the referral code entered is not recognized. Please check and enter again.";
                // //vzdlErrorUpdate("",couponValidationMsg,"event11,prodView");
            }
            //dispatch({ type: 'FFBACKENDCALLSTART', value: false });
        })
            .catch(error => {
                let errorMsg = `MethodName:ffCouponValidation,errorMessage:${error.message}`;
                let ffValidationInfo = {
                    ffValidationFailure: true,
                    ffValidationErrorType: ''
                }
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'FFBACKENDCALLSTART', value: false });
                dispatch({ type: 'FFCOUPONVALIDATIONFAILURE', value: ffValidationInfo });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'ffCouponValidation', ex);
        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-invalid coupon";
        tempVzdlSCData.detail = "special offer code redeem error-invalid coupon";
        tempSCData.events = "event5,event15,event20,event46,event21";
        updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "ffRedeemOrderSummaryLoad" :"ffRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
        // updateVzdlSCCustomEvent("ffRedeemLoad", "pageViewOmni", "detail");
    }
    finally{
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false} });
    }
}
export const VISPRPCouponValidation = (visitId, isDoFlow, visitorId, buildProductState, dispatch, isFCPflow,appState) => {
    let flowType= store && store?.getState && store?.getState().app && store?.getState()?.app?.flowType;
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true ,  isLoaderText: "Adding promotions"} });
    try {
        let coupon = buildProductState.couponInfo.coupon;
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'VISPRPCouponValidation', "Inside VISPRPCouponValidation"));
        dispatch({ type: 'VISPREBACKENDCALLSTART', value: true });
        let visPreValidationErrorType ='';
        let url = apiUrl().ffCouponValidation;
        api(url, 'POST', referralCouponRequest(visitId, visitorId, coupon)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) 
                 && InHomeUtils.isNotNull(response.data.validInd) && InHomeUtils.isNotEmpty(response.data.validInd) && response.data.validInd === "Y") {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'VISPRPCouponValidation', " transaction is success"));
                updatePromocodeRemove("add" ,visitId, dispatch, buildProductState)              
                let crmmRefreshResp = new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(updateCRMMRefreshForVisibleAndPrepaid(coupon, response.data.leadListId, visitId, dispatch, false, buildProductState,isFCPflow,appState,isDoFlow));
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }, 4000);
                }) 
                // let crmmRefreshResp = updateCRMMRefreshForVisibleAndPrepaid(coupon, response.data.leadListId, visitId, dispatch, false, buildProductState,isFCPflow,appState,isDoFlow);
            }
            else {
                if (response && response.data && response.data.reasonInvalid && 
                   (response.data.reasonInvalid.toUpperCase() === "MAX USED" || response.data.reasonInvalid.toUpperCase() === "EXPIRED" || response.data.reasonInvalid.toUpperCase() === "INVALID" )) {
                    visPreValidationErrorType = "MAXUSEDEXPIRED";
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'VISPRPCouponValidation', "TRANSACTION FAILED", PAGEACTIVITY.UA));
                    visPreValidationErrorType = "TRANSACTIONFAILED";
                }
                let visPreValidationInfo = {
                    visPreValidationFailure: true,
                    visPreValidationErrorType: visPreValidationErrorType
                }
                dispatch({ type: 'VISPRECOUPONVALIDATIONFAILURE', value: visPreValidationInfo })
                dispatch({ type: 'VISPREBACKENDCALLSTART', value: false });
            }
            
        })
            .catch(error => {
                let errorMsg = `MethodName:VISPRPCouponValidation,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'VISPRPCouponValidation', ex);
        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-invalid coupon";
        tempVzdlSCData.detail = "special offer code redeem error-invalid coupon";
        tempSCData.events = "event5,event15,event20,event46,event21";
        updateSCcustomEvent("VISPRPCouponValidation", "ddAddToCartEvent", "detailPageName,pageName,events");
        // updateVzdlSCCustomEvent("ffRedeemLoad", "pageViewOmni", "detail");
    }
    finally{
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false} });
    }
}
export const updateVZCCouponNotificationMsg = (msgInfo, timeout, dispatch) => {
    if (timeout) {
        setTimeout(() => dispatch({ type: 'VZCCOUPON_NOTIFCATION', value: msgInfo }), 7000);
    }
    else {
        dispatch({ type: 'VZCCOUPON_NOTIFCATION', value: msgInfo })
    }
}
export const updateVZCCouponNotification = (prodType, isChecked, cartProducts, buildProduct, visitId, dispatch) => {
    try {
        if (InHomeUtils.isNotNull(buildProduct.vzcCouponInfo) && InHomeUtils.isNotNull(buildProduct.vzcCouponInfo.vzcValidationSuccess) && buildProduct.vzcCouponInfo.vzcValidationSuccess == true) {
            let displayMsg = "";
            let vzcCouponInfo = {
                vzcValidationSuccess: true,
                isDiscountEligible: false,
                isDiscountApplied: false
            }
            if ((prodType.toUpperCase() === "INTERNET" || prodType.toUpperCase() === "FIOS_VOICE")) {
                if (isChecked == false) {
                    if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions)) {
                        let promotions = cartProducts.CartSubProduct.Promotions.promotions;
                        let vzOffers = null;
                        if (prodType.toUpperCase() === "INTERNET") {
                            vzOffers = promotions.filter(offer => (offer.offerAttrValue.toUpperCase() === 'FCP_CONNECTIONSDATA_DISCOUNT'));
                        }
                        else if (prodType.toUpperCase() === "FIOS_VOICE") {
                            vzOffers = promotions.filter(offer => (offer.offerAttrValue.toUpperCase() === 'FCP_CONNECTIONSVOICE_DISCOUNT'));
                        }
                        if (InHomeUtils.isNotNull(vzOffers) && vzOffers.length > 0) {
                            vzcCouponInfo.isDiscountEligible = true;
                            vzcCouponInfo.isDiscountApplied = true;
                            dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
                            displayMsg = 'Connection discount has been added to your cart.';
                        }
                    }
                }
                else if (isChecked == true) {
                    if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions)) {
                        let promos = cartProducts.CartSubProduct.Promotions.promotions;
                        let vzcOffers = null;
                        if (prodType.toUpperCase() === "INTERNET") {
                            vzcOffers = promos.filter(offer => (offer.offerAttrValue.toUpperCase() === 'FCP_CONNECTIONSDATA_DISCOUNT'));
                        }
                        else if (prodType.toUpperCase() === "FIOS_VOICE") {
                            vzcOffers = promos.filter(offer => (offer.offerAttrValue.toUpperCase() === 'FCP_CONNECTIONSVOICE_DISCOUNT'));
                        }
                        if (InHomeUtils.isNotNull(vzcOffers) && !vzcOffers.length > 0 && buildProduct.vzcCouponInfo.isDiscountEligible) {
                            vzcCouponInfo.isDiscountEligible = true;
                            vzcCouponInfo.isDiscountApplied = false;
                            dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
                            displayMsg = 'Connection discount has been removed from cart.';
                        }
                    }
                    else {
                        displayMsg = 'Connection discount has been removed from cart.';
                    }
                }
            }
            if (InHomeUtils.isNotEmpty(displayMsg)) {
                let msgInfo = {
                    currentMsg: displayMsg,
                    isDisplay: true
                }
                updateVZCCouponNotificationMsg(msgInfo, false, dispatch);
                msgInfo.currentMsg = '';
                msgInfo.isDisplay = false;
                updateVZCCouponNotificationMsg(msgInfo, true, dispatch);
            }

        }


    } catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateVZCCouponNotification', ex);

    }
}

export const vzCouponValidation = (visitId, isDoFlow, buildProductState, dispatch) => {
    let flowType= store && store?.getState && store?.getState().app && store?.getState()?.app?.flowType;
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true ,  isLoaderText: "Adding promotions"} });
    try {
        let url = apiUrl().validateCouponToken;
        let coupon = buildProductState.couponInfo.coupon;
        let jsonstr = JSON.stringify({ customertoken: coupon });
        let isValidationSuccess = false;
        let vzcCouponValidationErrorType = '';
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive:true,  isLoaderText: "Adding promotions" } });
        dispatch({ type: 'VZCCOUPONVALIDATIONSTART', value: true });
        api(url, 'POST', jsonstr).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.status) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')
                && InHomeUtils.isNotEmpty(response.data.result.status) && response.data.result.status === "Valid" && InHomeUtils.isNotNull(response.data.companyToken) && InHomeUtils.isNotNull(response.data.customerToken) && ( InHomeUtils.isNotNull(response.data.flowType) && InHomeUtils.isNotEmpty(response.data.flowType) && response.data.flowType === "Affinity" || InHomeUtils.isNotNull(response.data.flowType) && InHomeUtils.isNotEmpty(response.data.flowType) && response.data.flowType === "Employee")) {
                let isCompatibleVZPackageInCart = false;
                if (InHomeUtils.isNotNull(buildProductState) && ((InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct)) || ((InHomeUtils.isNotNull(buildProductState.voice) && InHomeUtils.isNotNull(buildProductState.voice.selectedProduct))))) {
                    isCompatibleVZPackageInCart = true;
                }
                if (isCompatibleVZPackageInCart) {
                    tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                    tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem success| vz connections";
                    tempVzdlSCData.detail = "special offer code redeem success - vz connections";
                    updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                    updateVzdlSCCustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "pageViewOmni", "detail");
                    
                }
                else {
                    tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                    tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem success| vz connections - product not applied";
                    tempVzdlSCData.detail = "special offer code redeem success - vz connections - product not applied";
                    updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                    updateVzdlSCCustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "pageViewOmni", "detail");
                }
                updatePromocodeRemove("add" ,visitId, dispatch, buildProductState)              
                let vzCrmmRefreshResp = new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(getCRMMRefresh(visitId, buildProductState, dispatch));
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }, 4000);
                }) 
                Promise.all([vzCrmmRefreshResp]).then(function (values) {
                    /*  if(InHomeUtils.isNotNull(buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(buildProductState.vzcCouponInfo.isDiscountEligible)&&InHomeUtils.isNotNull(buildProductState.vzcCouponInfo.isDiscountApplied) &&  buildProductState.vzcCouponInfo.isDiscountEligible==true && buildProductState.vzcCouponInfo.isDiscountApplied==true) {
                        let msgInfo = {
                            currentMsg: "VZ Connections discount has been added to your cart",
                            isDisplay: true
                        }
                        updateVZCCouponNotificationMsg(msgInfo, false, dispatch);
                        msgInfo.currentMsg = '';
                        msgInfo.isDisplay = false;
                        updateVZCCouponNotificationMsg(msgInfo, true, dispatch); } */
                });

            }
            else {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)
                    && InHomeUtils.isNotNull(response.data.result) &&
                    InHomeUtils.isNotNull(response.data.result.status)
                    && InHomeUtils.isNotEmpty(response.data.result.status)
                    && response.data.result.status === "InValid"
                    && !InHomeUtils.isNotNull(response.data.companyToken)
                    && !InHomeUtils.isNotNull(response.data.customerToken)) {
                    if (response.data.result.msg.indexOf("expired") > -1) {
                        vzcCouponValidationErrorType = 'EXPIRED';
                        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-coupon already entered";
                        tempSCData.events = "event5,event15,event20,event46,event21";
                        tempVzdlSCData.detail = "special offer code redeem error-coupon already entered";
                        updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                        updateVzdlSCCustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "pageViewOmni", "detail");
                    }
                    else if (response.data.result.msg.indexOf("pending") > -1) {
                        vzcCouponValidationErrorType = 'PENDING';
                    }
                    else {
                        vzcCouponValidationErrorType = 'INVALID';
                        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-invalid coupon";
                        tempVzdlSCData.detail = "special offer code redeem error-invalid coupon";
                        tempSCData.events = "event5,event15,event20,event46,event21";
                        updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                        // updateVzdlSCCustomEvent("vzcRedeemLoad","pageViewOmni","detail");
                    }
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'vzCouponValidation', "TRANSACTION FAILED DUE TO COUPON " + response.data.result.msg, PAGEACTIVITY.UA));
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'vzCouponValidation', "TRANSACTION FAILED", PAGEACTIVITY.UA));
                    vzcCouponValidationErrorType = "TRANSACTIONFAILED";
                }
                tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-invalid coupon";
                tempVzdlSCData.detail = "special offer code redeem error-invalid coupon";
                tempSCData.events = "event5,event15,event20,event46,event21";
                updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                // updateVzdlSCCustomEvent("vzcRedeemLoad","pageViewOmni","detail");
            }
            if (!isValidationSuccess && InHomeUtils.isNotEmpty(vzcCouponValidationErrorType)) {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                if((response.data.result.status == "vaild" || response.data.result.status == "Vaild") && response.data.result.msg.indexOf("already redeemed") > -1){
                    dispatch({ type: 'VZCOUPONREEDEMED', value: true });
                }else if((response.data.result.status == "InValid" || response.data.result.status.toLowerCase() == "invalid") && response.data.result.msg.indexOf("already in use") > -1){
                    dispatch({ type: 'VZCOUPONREEDEMED', value: true });
                }
                else {
                let vzcCouponInfo = {
                    vzcValidationFailure: true
                }
                dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
                dispatch({ type: 'VZCCOUPONVALIDATIONSTART', value: false });
            }
            }

        }).catch(error => {
            let vzcCouponInfo = {
                vzcValidationFailure: true
            }
            let errorMsg = `MethodName:vzCouponValidation,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
            dispatch({ type: 'VZCCOUPONVALIDATIONSTART', value: false });
        });
    }
    catch (ex) {
        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem error-invalid coupon";
        tempSCData.events = "event5,event15,event20,event46,event21";
        tempVzdlSCData.detail = "special offer code redeem error-invalid coupon";
        updateSCcustomEvent(flowType !=="MV" && flowType!=="SUPP"? "vzcRedeemOrderSummaryLoad" :"vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
        // updateVzdlSCCustomEvent("vzcRedeemLoad","pageViewOmni","detail");
        catchJSException('BuildProduct', visitId, 'vzCouponValidation', ex);
    }finally{
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

const getCRMMRefereshRequest = (coupon, leadListId) => {
    let request = {
        "code": coupon,
        "expirationDate": '',
        "leadListId": leadListId,
        "type": ''
    }
    return JSON.stringify(request);
}

const getCRMMRefereshRequestForVisPre = (coupon, leadListId) => {
    if(coupon.toLowerCase().indexOf("visbl") > -1){
        leadListId = 'LC10000773';
    }else if(coupon.toLowerCase().indexOf("visbh") > -1){
        leadListId = 'LC10000775';
    }else if(coupon.toLowerCase().indexOf("prpdl") > -1){
        leadListId = 'LC10000776';
    }else if(coupon.toLowerCase().indexOf("prpdh") > -1){
        leadListId = 'LC10000777';
    }
    let request = {
        "code": coupon,
        "expirationDate": '',
        "leadListId": leadListId,
        "type": ''
    }
    return JSON.stringify(request);
}

export const updateCRMMRefresh = (coupon, leadListId, visitId, dispatch, isMLPFlow, buildProductState) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCRMMRefresh', "Inside updateCRMMRefresh"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding promotions", isLoaderImg: "loader" }
        });
        let qualifiedSpeedProducts = [];
        if (InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.m2mPlans) && InHomeUtils.isNotEmpty(buildProductState.internet) && InHomeUtils.isNotEmpty(buildProductState.internet.m2mPlans) && buildProductState.internet.m2mPlans.length !== 0) {
            qualifiedSpeedProducts = buildProductState.internet.m2mPlans;
        }
        let isFFDiscountQualified = false;
        let ffCouponIsoc = "";
        let isCompatibleFFPackageInCart = false;
        let maxSpeedCode = getMaxQualifiedSpeedProduct(qualifiedSpeedProducts);
        if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct.speedCode) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct.speedCode) && buildProductState.internet.selectedProduct.speedCode == maxSpeedCode) {
            isCompatibleFFPackageInCart = true;
        }
        let url = apiUrl().refreshPromotionsUrl
        let ffValidationInfo = {
            ffCoupon: coupon,
            leadListID: leadListId,
            ffCouponError: false,
            ffValidationSucess: false,
            ffValidationFailure: false,
            ffValidationErrorType: '',
            isFFCheckoutValidation: false,
            profileDataSpeed: ''
        }
        let internetTargetId = "";
        if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct)) {
            internetTargetId = buildProductState.internet.selectedProduct.id;
            if (InHomeUtils.isNotNull(internetTargetId) && InHomeUtils.isNotEmpty(internetTargetId) && internetTargetId.length == 1 && InHomeUtils.isNotNull(internetTargetId[0])) {
                if (InHomeUtils.isNotNull(internetTargetId[0].prodId) && InHomeUtils.isNotEmpty(internetTargetId[0].prodId)) {
                    internetTargetId = internetTargetId[0].prodId;
                }
            }
            if(buildProductState.internet.selectedProduct.speedCode == '947' || buildProductState.internet.selectedProduct.speedCode == '941'){
                if(buildProductState.mm3internetsub.selectedProduct !== null){
                   internetTargetId = buildProductState.mm3internetsub.selectedProduct.id
                }
           }
        }
        return new Promise((resolve, reject) => {
            api(url, 'POST', getCRMMRefereshRequest(coupon, leadListId)).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.service) && response.service.length > 0) {
                    try {
                        response.service.map(function (serviceObj) {
                            if (InHomeUtils.isNotNull(serviceObj)) {
                                let packagesObj = (InHomeUtils.isNotNull(serviceObj.packages) && serviceObj.packages.length > 0) ? serviceObj.packages.map((packages) => packages) : null;
                                if (InHomeUtils.isNotNull(packagesObj) && packagesObj.length > 0) {
                                    packagesObj.map(function (pkg) {
                                        if (InHomeUtils.isNotNull(pkg)) {
                                            let productsObj = (InHomeUtils.isNotNull(pkg.products) && pkg.products.length > 0) ? pkg.products.map((products) => products) : null;
                                            if (InHomeUtils.isNotNull(productsObj) && productsObj.length > 0) {
                                                productsObj.map(function (product) {
                                                    if (InHomeUtils.isNotNull(product)) {
                                                        let couponOfferObj = (InHomeUtils.isNotNull(product.couponOffer) && product.couponOffer.length > 0) ? product.couponOffer.map((couponOffer) => couponOffer) : null;
                                                        if (InHomeUtils.isNotNull(couponOfferObj) && couponOfferObj.length > 0) {
                                                            couponOfferObj.map(function (coupon) {
                                                                if (InHomeUtils.isNotNull(coupon)) {
                                                                    if (InHomeUtils.isNotNull(coupon) && InHomeUtils.isNotEmpty(coupon?.BsOfferAttrValue) && coupon?.BsOfferAttrValue?.toLowerCase().indexOf("frndsfmly") > -1 && coupon.Target.indexOf(internetTargetId) > -1) {
                                                                        isFFDiscountQualified = true;
                                                                        ffCouponIsoc = coupon?.USOCIOSC
                                                                    }
                                                                }
                                                            });
                                                        }
                                                    }
                                                });
                                            }

                                        }
                                    });
                                }
                            }
                        });
                    }
                    catch (ex) {
                        catchJSException('BuildProduct', visitId, 'updateCRMMRefresh', ex);
                    }
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCRMMRefresh', "refresh Promos - Success"));
                    if (isCompatibleFFPackageInCart && isFFDiscountQualified && !isMLPFlow) {
                        //For high data speed in cart+ crmm refresh success                        
                        let updateIntentResp = updateRefreshIntent(visitId, dispatch);
                        Promise.all([updateIntentResp]).then(function (values) {
                            ffValidationInfo.ffValidationSucess = true;
                            dispatch({ type: 'FFBACKENDCALLSTART', value: false });
                            dispatch({ type: 'FFCOUPONVALIDATIONSUCCESS', value: ffValidationInfo });
                            dispatch({type: 'COUPONSUCCESS', value: true})
                            dispatch({type: 'COUPONISOC', value: ffCouponIsoc})
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            resolve(response);
                        });

                    }
                    else {
                        if (isMLPFlow) {
                            // For mlp Flow Highest  Data Speed  Product is added by default
                            ffValidationInfo.ffValidationSucess = true;
                            dispatch({type: 'COUPONSUCCESS', value: true})
                        }
                        else if (isCompatibleFFPackageInCart && !isFFDiscountQualified) {
                            //For high data speed+ crmm refresh fails
                            ffValidationInfo.ffValidationFailure = true;
                            ffValidationInfo.ffValidationErrorType = "INVALID";
                        }
                        else if (!isCompatibleFFPackageInCart && !isFFDiscountQualified) {
                            // For incompactible product and crmm doesnt return any promotion
                            ffValidationInfo.ffValidationSucess = true;
                            dispatch({type: 'COUPONSUCCESS', value: true})
                        }
                        dispatch({ type: 'FFBACKENDCALLSTART', value: false });
                        dispatch({ type: 'FFCOUPONVALIDATIONSUCCESS', value: ffValidationInfo });
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        resolve(false);
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCRMMRefresh', "refresh Promos - Fail", PAGEACTIVITY.UA));
                    dispatch({ type: 'FFBACKENDCALLSTART', value: false });
                    ffValidationInfo.ffValidationFailure = true;
                    ffValidationInfo.ffValidationErrorType = "INVALID";
                    dispatch({ type: 'FFCOUPONVALIDATIONSUCCESS', value: ffValidationInfo });
                    // dispatch({type: 'COUPONSUCCESS', value: true})
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    resolve(false);

                }
                //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                // resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:updateCRMMRefresh,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        });

    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCRMMRefresh', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}
export const updateCRMMRefreshForVisibleAndPrepaid = (coupon, leadListId, visitId, dispatch, isMLPFlow, buildProductState, isFCPflow,appState,isDoFlow) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCRMMRefresh', "Inside updateCRMMRefresh"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding promotions", isLoaderImg: "loader" }
        });
        let isTvInCart = false;
        if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && InHomeUtils.isNotEmpty(buildProductState.tv.selectedProduct) && buildProductState.tv.selectedProduct.id) {
            isTvInCart = true;
        }
        let isvisPreDiscountQualified = false;
        let visPreCouponIsoc ="";
        let isCompatibleVisPrePackageInCart = false;
        if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct.speedCode) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct)) {
            isCompatibleVisPrePackageInCart = true;
        }
        let url = apiUrl().refreshPromotionsUrl
        let visPreValidationInfo = {
            visPreCoupon: coupon,
            leadListID: 'LC10000773',
            visPreCouponError: false,
            visPreValidationSucess: false,
            visPreValidationFailure: false,
            visPreValidationErrorType: '',
            isVisPreCheckoutValidation: false,
            isDiscountEligible:false,
            isDiscountApplied:false

        }
        return new Promise((resolve, reject) => {
            api(url, 'POST', getCRMMRefereshRequestForVisPre(coupon, leadListId)).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.service) && response.service.length > 0) {
                    try {
                        response.service.map(function (serviceObj) {
                            if (InHomeUtils.isNotNull(serviceObj)) {
                                let packagesObj = (InHomeUtils.isNotNull(serviceObj.packages) && serviceObj.packages.length > 0) ? serviceObj.packages.map((packages) => packages) : null;
                                if (InHomeUtils.isNotNull(packagesObj) && packagesObj.length > 0) {
                                    packagesObj.map(function (pkg) {
                                        if (InHomeUtils.isNotNull(pkg)) {
                                            let productsObj = (InHomeUtils.isNotNull(pkg.products) && pkg.products.length > 0) ? pkg.products.map((products) => products) : null;
                                            if (InHomeUtils.isNotNull(productsObj) && productsObj.length > 0) {
                                                productsObj.map(function (product) {
                                                    if (InHomeUtils.isNotNull(product)) {
                                                        let couponOfferObj = (InHomeUtils.isNotNull(product.couponOffer) && product.couponOffer.length > 0) ? product.couponOffer.map((couponOffer) => couponOffer) : null;
                                                        if (InHomeUtils.isNotNull(couponOfferObj) && couponOfferObj.length > 0) {
                                                            couponOfferObj.map(function (coupon) {
                                                                if (InHomeUtils.isNotNull(coupon)) {
                                                                    if (InHomeUtils.isNotNull(coupon) && InHomeUtils.isNotEmpty(coupon?.BsOfferAttrValue) && (coupon?.BsOfferAttrValue?.toLowerCase().indexOf("visible") > -1 || coupon?.BsOfferAttrValue?.toLowerCase().indexOf("prepay") > -1 ) ) {
                                                                        isvisPreDiscountQualified = true;
                                                                        visPreCouponIsoc = coupon?.USOCIOSC
                                                                        
                                                                    }
                                                                }
                                                            });
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }
                    catch (ex) {
                        catchJSException('BuildProduct', visitId, 'updateCRMMRefresh', ex);
                    }
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCRMMRefresh', "refresh Promos - Success"));
                    if (isCompatibleVisPrePackageInCart && isvisPreDiscountQualified && !isMLPFlow) {
                        //For high data speed in cart+ crmm refresh success                        
                        let updateIntentResp = updateRefreshIntent(visitId, dispatch);
                        Promise.all([updateIntentResp]).then(function (values) {
                            if(appState && appState.flowType && appState.flowType === 'MV'){
                              fetchDataMTM(dispatch, visitId, 'MV', null, 'add'); 
                            }
                            else if(isFCPflow){
                            fetchDataMTM(dispatch, visitId, 'NC', null, 'add');    
                            }else{
                                isTvInCart ? fetchData2Y(dispatch, visitId,'NC') :  fetchDataMTM(dispatch, visitId, 'NC', null, 'add') 
                            }
                            visPreValidationInfo.visPreValidationSucess = true;
                            visPreValidationInfo.isDiscountEligible = true;
                            visPreValidationInfo.isDiscountApplied = true;
                            dispatch({type: 'COUPONISOC', value: visPreCouponIsoc})
                            dispatch({ type: 'COUPONSUCCESS', value: true })
                            dispatch({ type: 'VISPREBACKENDCALLSTART', value: false });
                            dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreValidationInfo });
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            resolve(response);

                            // VCGBQA-1466 - changes
                            tempSCData.pageName = isDoFlow ? "do accord" : "byob"
                            tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem success";
                            tempVzdlSCData.detail = "special offer code redeem success";
                            updateSCcustomEvent("vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                            updateVzdlSCCustomEvent("vzcRedeemLoad", "pageViewOmni", "detail,notification", false, "", false, "Promo code applied");              
                        });
                    }
                    else {
                        if(appState && appState.flowType && appState.flowType === 'MV'){
                          fetchDataMTM(dispatch, visitId, 'MV', null, 'add'); 
                        }
                        else if(isFCPflow){
                        fetchDataMTM(dispatch, visitId, 'NC', null, 'add');    
                        }else{
                            isTvInCart ? fetchData2Y(dispatch, visitId,'NC') :  fetchDataMTM(dispatch, visitId, 'NC', null, 'add') 
                        }
                        if (isMLPFlow) {
                            // For mlp Flow Highest  Data Speed  Product is added by default
                            visPreValidationInfo.visPreValidationSucess = true;
                        }
                        else if(!isCompatibleVisPrePackageInCart && isvisPreDiscountQualified ){
                            visPreValidationInfo.visPreValidationSucess = true;
                            visPreValidationInfo.isDiscountEligible = false;
                            visPreValidationInfo.isDiscountApplied = true;
                            dispatch({ type: 'COUPONSUCCESS', value: true })
                            visPreValidationInfo.visPreValidationErrorType = "noCompatibleVisPrePackageInCart";
                        }
                        else if (isCompatibleVisPrePackageInCart && !isvisPreDiscountQualified) {
                            //data speed+ crmm refresh fails
                            visPreValidationInfo.visPreValidationFailure = true;
                            visPreValidationInfo.isDiscountEligible = false;
                            visPreValidationInfo.isDiscountApplied = false;
                            visPreValidationInfo.visPreValidationErrorType = "INVALID";
                        }
                        else if (!isCompatibleVisPrePackageInCart && !isvisPreDiscountQualified) {
                            // For incompactible product and crmm doesnt return any promotion
                            visPreValidationInfo.visPreValidationSucess = true;
                            dispatch({ type: 'COUPONSUCCESS', value: true })
                        }
                        dispatch({ type: 'VISPREBACKENDCALLSTART', value: false });
                        dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreValidationInfo });
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        resolve(false);
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCRMMRefresh', "refresh Promos - Fail", PAGEACTIVITY.UA));
                    dispatch({ type: 'VISPREBACKENDCALLSTART', value: false });
                    visPreValidationInfo.visPreValidationFailure = true;
                    visPreValidationInfo.visPreValidationErrorType = "INVALID";
                    dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreValidationInfo });
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    resolve(false);
                }

                //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                // resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:updateCRMMRefresh,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCRMMRefresh', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}
export const applyCRMMRefresh = (visitId, visitorId, buildProductState, lqState, appState, firstBill, dispatch) => {
    try {
        let crmmRefreshResp = updateCRMMRefresh(lqState.mlpFFCouponInfo.ffCoupon, lqState.mlpFFCouponInfo.leadListID, visitId, dispatch, true, buildProductState);
        Promise.all([crmmRefreshResp]).then(function (values) {
            autoAddMaxQualifiedSpeedProduct(buildProductState, lqState, appState, firstBill, dispatch);
        });
    }
    catch (ex) {
        catchJSException('buildProduct', visitId, 'applyCRMMRefresh', ex);
    }
}

export const getCRMMRefresh = (visitId, buildProductState, dispatch, isRetryCRMMRefresh = false) => {
    console.log("getCRMM1")
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getCRMMRefresh', "Inside getCRMMRefresh"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding promotions", isLoaderImg: "loader" }
        });
        let vzcDiscountQualified = false;
        let vzcCouponIsoc ="";
        let triggerUpdateIntent = false;
        let isCompatibleVZPackageInCart = false;
        let isTvServiceInCart = (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct)) ? true : false;
        let internetTargetId = "";
        let voiceTargetId = "";
        if (InHomeUtils.isNotNull(buildProductState) && ((InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct)) || ((InHomeUtils.isNotNull(buildProductState.voice) && InHomeUtils.isNotNull(buildProductState.voice.selectedProduct))))) {
            isCompatibleVZPackageInCart = true;
            if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct)) {
                internetTargetId = buildProductState.internet.selectedProduct.id;
                if (InHomeUtils.isNotNull(internetTargetId) && InHomeUtils.isNotEmpty(internetTargetId) && internetTargetId.length == 1 && InHomeUtils.isNotNull(internetTargetId[0])) {
                    if (InHomeUtils.isNotNull(internetTargetId[0].prodId) && InHomeUtils.isNotEmpty(internetTargetId[0].prodId)) {
                        internetTargetId = internetTargetId[0].prodId;
                    }
                }
            }
            if (InHomeUtils.isNotNull(buildProductState.voice.selectedProduct))
                voiceTargetId = buildProductState.voice.selectedProduct.id;
        }
        let vzcCouponInfo = {
            vzcValidationSuccess: false,
            isDiscountEligible: false,
            isDiscountApplied: false,
            vzcValidationFailure: false
        }
        let url = apiUrl().refreshPromotionsUrl;
        return new Promise((resolve, reject) => {
            api(url, 'GET', '').then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.service) && response.service.length > 0) {
                    // CRMM refresh
                    try {
                        response.service.map(function (serviceObj) {
                            if (InHomeUtils.isNotNull(serviceObj)) {
                                let packagesObj = (InHomeUtils.isNotNull(serviceObj.packages) && serviceObj.packages.length > 0) ? serviceObj.packages.map((packages) => packages) : null;
                                if (InHomeUtils.isNotNull(packagesObj) && packagesObj.length > 0) {
                                    packagesObj.map(function (pkg) {
                                        if (InHomeUtils.isNotNull(pkg)) {
                                            let productsObj = (InHomeUtils.isNotNull(pkg.products) && pkg.products.length > 0) ? pkg.products.map((products) => products) : null;
                                            if (InHomeUtils.isNotNull(productsObj) && productsObj.length > 0) {
                                                productsObj.map(function (product) {
                                                    if (InHomeUtils.isNotNull(product)) {
                                                        let couponOfferObj = (InHomeUtils.isNotNull(product.couponOffer) && product.couponOffer.length > 0) ? product.couponOffer.map((couponOffer) => couponOffer) : null;
                                                        if (InHomeUtils.isNotNull(couponOfferObj) && couponOfferObj.length > 0) {
                                                            couponOfferObj.map(function (coupon) {
                                                                if (InHomeUtils.isNotNull(coupon) && InHomeUtils.isNotNull(coupon?.BsOfferAttrValue) && (InHomeUtils.isNotEmpty(coupon?.BsOfferAttrValue) && (coupon?.BsOfferAttrValue?.toLowerCase().indexOf("connections") > -1 || coupon?.BsOfferAttrValue?.toLowerCase().indexOf("deals") > -1) || InHomeUtils.isNotEmpty(coupon?.OfferText) && coupon?.OfferText?.toLowerCase().indexOf("affinity") > -1 || InHomeUtils.isNotEmpty(coupon?.OfferText) && coupon?.OfferText?.toLowerCase().indexOf("employee") > -1 ) && InHomeUtils.isNotNull(coupon?.Target) && InHomeUtils.isNotEmpty(coupon?.Target) && (coupon?.Target.indexOf(internetTargetId) > -1 || coupon.Target.indexOf(voiceTargetId) > -1)) {
                                                                    vzcDiscountQualified = true;
                                                                    vzcCouponIsoc = coupon?.USOCIOSC
                                                                }
                                                                else if (InHomeUtils.isNotNull(coupon) && InHomeUtils.isNotNull(coupon?.BsOfferAttrValue) && InHomeUtils.isNotEmpty(coupon?.BsOfferAttrValue) && (coupon?.BsOfferAttrValue?.toLowerCase().indexOf("$5") > -1 || coupon?.BsOfferAttrValue?.toLowerCase().indexOf("$10") > -1 || coupon?.BsOfferAttrValue?.toLowerCase().indexOf("FCP_EMPFLOW_DATA_DISCOUNT") > -1) && (InHomeUtils.isNotEmpty(coupon?.OfferText) && coupon?.OfferText?.toLowerCase().indexOf("connection") > -1 || InHomeUtils.isNotEmpty(coupon?.OfferText) && coupon?.OfferText?.toLowerCase().indexOf("affinity") > -1 || InHomeUtils.isNotEmpty(coupon?.OfferText) && coupon?.OfferText?.toLowerCase().indexOf("employee") > -1 || InHomeUtils.isNotEmpty(coupon?.OfferText) && coupon?.OfferText?.toLowerCase().indexOf("deals") > -1)&& InHomeUtils.isNotNull(coupon?.Target) && InHomeUtils.isNotEmpty(coupon?.Target) && (coupon?.Target.indexOf(internetTargetId) > -1 || coupon?.Target.indexOf(voiceTargetId) > -1)) {
                                                                    vzcDiscountQualified = true;
                                                                    vzcCouponIsoc = coupon?.USOCIOSC
                                                                }
                                                                else if (InHomeUtils.isNotNull(coupon) && InHomeUtils.isNotNull(coupon?.BsOfferAttrValue) && InHomeUtils.isNotEmpty(coupon?.BsOfferAttrValue) && (coupon?.BsOfferAttrValue?.toLowerCase().indexOf("FCP_EMPFLOW_DATA_DISCOUNT") > -1 ) && InHomeUtils.isNotEmpty(coupon?.OfferText) && coupon?.OfferText?.toLowerCase().indexOf("employee") > -1 && InHomeUtils.isNotNull(coupon?.Target) && InHomeUtils.isNotEmpty(coupon?.Target) && (coupon?.Target.indexOf(internetTargetId) > -1 || coupon?.Target.indexOf(voiceTargetId) > -1) ) {
                                                                    vzcDiscountQualified = true;
                                                                    vzcCouponIsoc = coupon?.USOCIOSC
                                                                }
                                                            });
                                                        }
                                                    }
                                                });
                                            }

                                        }
                                    });
                                }
                            }
                        });
                    }
                    catch (ex) {
                        catchJSException('BuildProduct', visitId, 'updateCRMMRefresh', ex);
                    }

                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'getCRMMRefresh', "update Cart - Success"));

                    if (isCompatibleVZPackageInCart && vzcDiscountQualified) {
                        console.log("getCRMM2")
                        // For Internet / Voice Service  in cart and CRMM refresh Success
                        triggerUpdateIntent = true;
                        let updateIntentResp = updateRefreshIntent(visitId, dispatch);
                        Promise.all([updateIntentResp]).then(function (values) {
                            vzcCouponInfo.vzcValidationSuccess = true;
                            vzcCouponInfo.isDiscountEligible = true;
                            vzcCouponInfo.isDiscountApplied = true;
                            buildProductState.vzcCouponInfo.isDiscountEligible = true;
                            buildProductState.vzcCouponInfo.isDiscountApplied = true;
                            dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
                            dispatch({ type: 'COUPONSUCCESS', value: true })
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            dispatch({ type: 'VZCCOUPONVALIDATIONSTART', value: false });
                            dispatch({type: 'COUPONISOC', value: vzcCouponIsoc})
                            resolve(response);
                        });
                        // refresh Data plans details to reflect DAW discounts
                        fetchDataMTM(dispatch, visitId);
                    }
                    else {
                        if (isCompatibleVZPackageInCart && !vzcDiscountQualified) {
                            // For Internet/Voice Service  in cart and CRMM refresh fails
                            vzcCouponInfo.isDiscountEligible = false;
                            vzcCouponInfo.isDiscountApplied = false;
                            vzcCouponInfo.vzcValidationFailure = true;                           
                        }
                        else if (!isCompatibleVZPackageInCart && !vzcDiscountQualified && isTvServiceInCart) {
                            // Only TV Service alone in cart and CRMM refresh doesnt returns any Promotions
                            console.log("getCRMM3")
                            vzcCouponInfo.vzcValidationSuccess = true;
                            vzcCouponInfo.isDiscountEligible = true;
                            buildProductState.vzcCouponInfo.isDiscountEligible = true;
                            dispatch({ type: 'COUPONSUCCESS', value: true })
                        }
                        dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        dispatch({ type: 'VZCCOUPONVALIDATIONSTART', value: false });
                        resolve(false);
                    }
                }
                else if (!isRetryCRMMRefresh) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getCRMMRefresh', "getCRMMRefresh - Reattempt", PAGEACTIVITY.UA));
                    getCRMMRefresh(visitId, buildProductState, dispatch, true);
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getCRMMRefresh', "getCRMMRefresh - FAIL", PAGEACTIVITY.UA));
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    dispatch({ type: 'VZCCOUPONVALIDATIONSTART', value: false });
                    vzcCouponInfo.vzcValidationFailure = true;
                    dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
                    resolve(false);
                }
                // if (!isCompatibleVZPackageInCart && !triggerUpdateIntent)
                // resolve(false);
            }).catch(error => {
                let errorMsg = `MethodName:getCRMMRefresh,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: 'VZCCOUPONVALIDATIONSTART', value: false });
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getCRMMRefresh', ex);
    }
}

const getRefreshIntentRequest = (key, value, action) => {
    let request = {
        key: key,
        value: value,
        action: action
    }
    return JSON.stringify(request)
}
export const updateRefreshIntent = (visitId, dispatch, isMnh = '', buildProduct = '', action = 'add') => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateRefreshIntent', "Inside updateRefreshIntent"));
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let value = (action ==="add"? "OFFER": buildProduct.couponInfo.couponisoc);
        let request = getRefreshIntentRequest("REFRESHCART", value, action);
        return new Promise((resolve, reject) => {

            api(url, 'POST', request).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateRefreshIntent', "update Cart - Success"));
                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail,
                            cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                        }
                    });
                    if(buildProduct && buildProduct!= ''){
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
                    }
                    if(isMnh === 'Y'){
                        if(!(InHomeUtils.isNotEmpty(response.data.flowType) && response.data.flowType && response.data.flowType === "Employee")){
                            getNameMnhDetailsBuildProduct(dispatch, buildProduct);
                            dispatch({ type: "SET_MNH_BANNER_STATUS", value: "UPDATE" });
                        }
                        else{
                            tempVzdlSCData.events = "event56,event10";
                            updateVzdlSCCustomEvent("buildFiosInit", "sendData", "events");
                        }
                    }
                    else if(isMnh === 'maxAttempt'){
                        mnhNotSuccessful(dispatch, buildProduct, true);
                    }
                    resolve(response);
                }
                else { //error while updating cart
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateRefreshIntent', "UPDATEREFRESHINTENT - FAIL", PAGEACTIVITY.UA));
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    resolve(false);
                }
            }).catch(error => {
                let errorMsg = `MethodName:updateRefreshIntent,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(false);
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateRefreshIntent', ex);
    }
}
const getPromocodeRemoveRequest = (value) => {
    let request = {
        status: value
    }
    return JSON.stringify(request)
}
export const updatePromocodeRemove = (action , visitId, dispatch ,buildProductState,targetid ) => {
    try {
        let url = apiUrl().removePromoCode;
        let request = getPromocodeRemoveRequest(action)
        return new Promise((resolve, reject) => {
            dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: action === "add"?"Adding promotions":"Removing promotions", isLoaderImg: "loader" }
        })
            api(url, 'POST', request).then((response) => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response?.service)) {
                   
                    validateInputcoupon({ [targetid]: '' }, dispatch);
                    updateRefreshIntent(visitId, dispatch, null, buildProductState , action)
                    couponRemoved(false, dispatch)
                    couponSuccess(false, dispatch)
                }
            }).catch((error) => {
                dispatch({
                    type: 'LOADER_ACTIVE',
                    value: { isLoaderActive: false, isLoaderText: action === "add"?"Adding promotions": "Removing promotions", isLoaderImg: "loader" }
                })
                let errorMsg = `MethodName:updatePromocodeRemove,errorMessage:${error.message}`;
                reject(error)
            })
        })
    } catch (ex) {
        catchJSException('BuildProduct', visitId, 'updatePromocodeRemove', ex);
    }
}
export const updateSaveTheSaleIntent = (visitId, dispatch, isMnh = '', buildProduct = '', product, flowType, isFcpFlow, notification="") => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSaveTheSaleIntent', "Inside updateSaveTheSaleIntent"));
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let request = getRefreshIntentRequest("REFRESHCART", "SAVETHESALEOFFER", "add");
        return new Promise((resolve, reject) => {
            api(url, 'POST', request).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSaveTheSaleIntent', "update Cart - Success"));
                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail,
                            cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                        }
                    }); 
                    dispatch({ type: "OFFER_APPLIED", value: true});
                    if(notification && notification!=""){
                         updateMessageValue(notification)
                    }
                    if(!buildProduct?.isSmartCartFlow)
                    addToCartVzdlSCEvent(visitId, product, product?.prodType, response, false, true, null, flowType, isFcpFlow, 'AddtoCart', "scAdd", product?.prodType)

                    if(buildProduct && buildProduct!= ''){
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
                    }
                    if(isMnh === 'Y'){
                        getNameMnhDetailsBuildProduct(dispatch, buildProduct);
                        dispatch({ type: "SET_MNH_BANNER_STATUS", value: "UPDATE" });
                    }
                    else if(isMnh === 'maxAttempt'){
                        mnhNotSuccessful(dispatch, buildProduct, true);
                    }
                    
                    resolve(response);
                }
                else { //error while updating cart
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateSaveTheSaleIntent', "UPDATESAVETHESALEINTENT - FAIL", PAGEACTIVITY.UA));
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    resolve(false);
                }
            }).catch(error => {
                let errorMsg = `MethodName:updateSaveTheSaleIntent,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(false);
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateSaveTheSaleIntent', ex);
    }
}

export const proceedToCheckoutForRAF = (visitId, lqState, buildProductState, cart, dispatch, isEnablePopup = true) => {
    // added to check  whether valid RAF package is added in cart
    let proceedToCheckoutForRAF = false;
    let selectedInternet = null;
    if (InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.isRAFEnabled) && lqState.runtimeKey.isRAFEnabled === "Y") {
        selectedInternet = getSelectedInternet(cart.cartResponse, visitId);
        if (InHomeUtils.isNotNull(buildProductState.couponInfo) && InHomeUtils.isNotNull(buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(buildProductState.couponInfo.coupon) && buildProductState.couponInfo.referfriendvalidationsucess) {
            if (InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow && InHomeUtils.isNotNull(selectedInternet) && selectedInternet.length > 0 && InHomeUtils.isNotNull(selectedInternet[0].speedCode) && InHomeUtils.isNotEmpty(selectedInternet[0].speedCode) && selectedInternet[0].speedCode == '941') {
                proceedToCheckoutForRAF = true;
            }
            else if (InHomeUtils.isNotNull(lqState.isFCPflow) && !lqState.isFCPflow && ((InHomeUtils.isNotNull(cart) && InHomeUtils.isNotNull(cart.cartOrderDetail) && InHomeUtils.isNotNull(cart.cartOrderDetail.bundle) && cart.cartOrderDetail.bundle)
                || (InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct.speedCode) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct.speedCode)
                    && buildProductState.internet.selectedProduct.speedCode === '941')
                || (InHomeUtils.isNotNull(selectedInternet) && selectedInternet.length > 0 && InHomeUtils.isNotNull(selectedInternet[0].speedCode) && InHomeUtils.isNotEmpty(selectedInternet[0].speedCode) && selectedInternet[0].speedCode == '941'))) {
                proceedToCheckoutForRAF = true;
            }
            else {
                proceedToCheckoutForRAF = false;
                if (isEnablePopup) {
                    modalAction.openModalWindow('COUPON', dispatch);
                    dispatch({ type: 'RAFPACKAGE_CHECKOUT_VALIDATION', value: true });
                }
            }
        }
        else {
            if (!isEnablePopup) {
                proceedToCheckoutForRAF = false;
            }
            else {
                proceedToCheckoutForRAF = true;
            }
        }

    }
    else
        proceedToCheckoutForRAF = true;

    return proceedToCheckoutForRAF;
}
export const proceedToCheckoutForFF = (visitId, lqState, buildProductState, cart, dispatch) => {
    // added to check  whether valid FF package is added in cart     
    let proceedToCheckoutForFF = false;
    let selectedInternet = null;
    let qualifiedSpeedProducts = [];
    if (buildProductState.internet.m2mPlans.length !== 0) {
        qualifiedSpeedProducts = buildProductState.internet.m2mPlans;
    }
    let maxSpeedProductSpeedCode = getMaxQualifiedSpeedProduct(qualifiedSpeedProducts);
    if (InHomeUtils.isNotNull(buildProductState.ffCouponInfo)) {

        selectedInternet = getSelectedInternet(cart.cartResponse, visitId);
        if (InHomeUtils.isNotNull(buildProductState.ffCouponInfo) && InHomeUtils.isNotNull(buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(buildProductState.ffCouponInfo.ffCoupon) && buildProductState.ffCouponInfo.ffValidationSucess) {
            if (InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow && InHomeUtils.isNotNull(selectedInternet) && selectedInternet.length > 0 && InHomeUtils.isNotNull(selectedInternet[0].speedCode) && InHomeUtils.isNotEmpty(selectedInternet[0].speedCode) && selectedInternet[0].speedCode == maxSpeedProductSpeedCode) {
                proceedToCheckoutForFF = true;
            }
            else if (InHomeUtils.isNotNull(lqState.isFCPflow) && !lqState.isFCPflow && ((InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct.speedCode) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct.speedCode)
                && buildProductState.internet.selectedProduct.speedCode === maxSpeedProductSpeedCode) || (InHomeUtils.isNotNull(selectedInternet) && selectedInternet.length > 0 && InHomeUtils.isNotNull(selectedInternet[0].speedCode) && InHomeUtils.isNotEmpty(selectedInternet[0].speedCode) && selectedInternet[0].speedCode == maxSpeedProductSpeedCode))) {
                proceedToCheckoutForFF = true;
            }
            if (!proceedToCheckoutForFF && InHomeUtils.isNotNull(buildProductState.ffCouponInfo.profileDataSpeed) && InHomeUtils.isNotEmpty(buildProductState.ffCouponInfo.profileDataSpeed) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct.speedCode) && InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct.speedCode)) {
                if (buildProductState.ffCouponInfo.profileDataSpeed == buildProductState.internet.selectedProduct.downSpeed.replace("M", "")) {
                    proceedToCheckoutForFF = true;
                }
                else if (buildProductState.internet.selectedProduct.speedCode === maxSpeedProductSpeedCode) {
                    proceedToCheckoutForFF = true;
                }
                else if (buildProductState?.internet?.selectedProduct?.speedCode === '941') {
                    proceedToCheckoutForFF = true;
                }
            }
            if (!proceedToCheckoutForFF) {
                modalAction.openModalWindow('COUPON', dispatch);
                dispatch({ type: 'FFPACKAGE_CHECKOUT_VALIDATION', value: true });
            }

        }
    }
    return proceedToCheckoutForFF;
}
export const proceedToCheckoutForVZC = (buildProductState, lqState, dispatch) => {
    let proceedToCheckoutForVZC = false;
    if (InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.isVZConnectionEnabled) && lqState.runtimeKey.isVZConnectionEnabled === "Y") {
        if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(buildProductState.vzcCouponInfo.vzcValidationSuccess) && buildProductState.vzcCouponInfo.vzcValidationSuccess) {
            if (InHomeUtils.isNotNull(buildProductState) && ((InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct)) || ((InHomeUtils.isNotNull(buildProductState.voice) && InHomeUtils.isNotNull(buildProductState.voice.selectedProduct))))) {
                proceedToCheckoutForVZC = true;
            }
            if (!proceedToCheckoutForVZC) {
                modalAction.openModalWindow('COUPON', dispatch);
                dispatch({ type: 'VZCPACKAGE_CHECKOUT_VALIDATION', value: true });
            }
        }
    }
    return proceedToCheckoutForVZC;
}

export const getMaxQualifiedSpeedProduct = (qualifiedSpeedProducts) => {
    let maxSpeedCode = "";
    let maxSpeedQual = "";
    let speedPrds = [];
    qualifiedSpeedProducts.map(obj => {
        if (obj.downSpeed !== undefined && obj.downSpeed !== null)
            speedPrds.push(obj.downSpeed.replace("M", ""));
    });
    speedPrds.sort(function (a, b) { return b - a });
    maxSpeedQual = speedPrds[0] + "M";
    let product = qualifiedSpeedProducts
        .filter(internetSpeedPlan => internetSpeedPlan.downSpeed === maxSpeedQual);

    if (InHomeUtils.isNotNull(product) && product.length > 0) {
        maxSpeedCode = product[0].speedCode;
    }
    // qualifiedSpeedProducts.map(obj => { speedPrds.push(obj.speedCode) });
    //speedPrds.sort(function (a, b) { return b - a });
    //maxSpeedCode = speedPrds[0];
    return maxSpeedCode;
};
export const autoAddMaxQualifiedSpeedProduct = (buildProductState, lqState, appState, firstBill, dispatch) => {
    let speedPrds = [];
    speedPrds = buildProductState.internet.m2mPlans;
    if (speedPrds.length > 0) {
        let maxSpeedCode = getMaxQualifiedSpeedProduct(speedPrds);
        let product = speedPrds.filter(internetSpeedPlan => internetSpeedPlan.speedCode === maxSpeedCode);
        product = product.length && product[0] || null;
        const tn = buildProductState.requestTN;
        let addonProduct = {
            productInCart: [],
            isRemoved: [],
            prodType: [],
            isMLPFlow: true
        }
        if (product) {
            let selectedProd = product;
            if (selectedProd.prodType === "FTTPD" && InHomeUtils.isNotNull(selectedProd.equipmentOffers) && selectedProd.equipmentOffers.length > 0) {
                let addonEquipTypes = selectedProd.equipmentOffers.filter(e => e.indexOf('Data') > -1).map(p => { return p.split(':')[1] });
                addonEquipTypes.forEach(e => {
                    addEquipment(e, addonProduct, false, buildProductState);
                })
            }

            updateCart(
                appState.visitId
                , lqState
                , product
                , 'INTERNET'
                , false
                , dispatch
                , tn
                , firstBill
                , addonProduct
                , "", "", false, false, null
                , buildProductState, false
                , appState.flowType, false, true);
            fetchRouter(dispatch, appState.visitId, appState.flowType, 0, false, lqState, tn, buildProductState);

        }
    }
};

export const updateCartChatOffer = (visitId, equipments, promodetails, dispatch,buildProduct) => {
    let isMnHAuthenticated = ""
    if(buildProduct?.internet?.mnhSignupIndicator !== "" && buildProduct?.internet?.mnhSignupIndicator !== null && buildProduct?.internet?.mnhSignupIndicator !== undefined){
    isMnHAuthenticated = buildProduct?.internet?.mnhSignupIndicator
   }
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "Inside updateCartChatOffer"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding Promotions", isLoaderImg: "loader" }
        });
        let url = apiUrl().productOffersUrl;
        let productpromo = '';
        let specialOfferpromo = '';
        let contractPromo = '';

        // let bsOfferId = 'OF10038167';
        //let bsPromoId = 'PR10006366';
        //PR10006365-OF10038167|PR10006366-OF10038167 
        if (promodetails === "PR10006366-OF10038167")
            promodetails = "PR10006365-OF10038167|PR10006366-OF10038167";
        let promoArray = promodetails.split("|");
        //promoArray.forEach(PromoItem => { 
        //let bsOfferId = PromoItem.split("-")[0];
        //let bsPromoId = PromoItem.split("-")[1];

        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "productOffersUrl - Success"));
                response.data.service.forEach(s => {
                    if (s.type === "Promo") {
                        s.packages.forEach(pack => {
                            pack.products.forEach(prod => {
                                prod.specialOffer.forEach(spoffer => {
                                    promoArray.forEach(PromoItem => {
                                        let bsPromoId = PromoItem.split("-")[0];
                                        let bsOfferId = PromoItem.split("-")[1];
                                        if (spoffer.bsPromoId === bsPromoId && spoffer.bsOfferId === bsOfferId) {
                                            specialOfferpromo = spoffer;
                                            productpromo = prod;
                                            contractPromo = pack.contract;
                                        }
                                    })
                                })
                            })
                        })
                    }
                })
                dispatch({
                    type: 'LOADER_ACTIVE',
                    value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
                });
                //based on response we will find the promoidofferid Find the details 
                if (InHomeUtils.isNotEmpty(productpromo)) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "update Cart - Starts"));
                    let url = apiUrl().updateCartAcc + '/' + visitId;
                    //(product, contract,specialOffer)
                    api(url, 'POST', getRequestChatoffer(productpromo, specialOfferpromo, contractPromo,isMnHAuthenticated)).then(response => {
                        if (response.meta.code === 200) {
                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "update Cart - Success"));
                            if (specialOfferpromo.BsOfferAttr === "EQUIPMENT") {
                                //based on response we will find the promoidofferid Find the details 
                                let product = equipments.filter(p => p.id === specialOfferpromo.Target);
                                dispatch({ type: 'RECORDING_SELECTEDPROD', value: product[0] });
                            }
                            dispatch({
                                type: "UPDATE_CART",
                                value: {
                                    cartResponse: response.data.cartTierPricing,
                                    cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                                    cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                                    cartOrderDetail: response.data.orderDetail,
                                    cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                                }
                            });
                        }
                        else {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartChatOffer', "UPDATECARTCHATOFFER - FAIL", PAGEACTIVITY.UA));
                        }
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    })
                        .catch(error => {
                            let errorMsg = `MethodName:updateCartChatOffer-cartUpdate,errorMessage:${error.message}`;
                            //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        });
                }

            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:updateCartChatOffer-products,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        //})
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartChatOffer', ex);
    }
}

export const updateCartSpecialOffer = (visitId, specialOfferpromo, contract, dispatch, offertype, isChecked, isDoFlow, stadiaMLPFlow = false, buildProductState = null, lqState = null, prodType = null, flowType = null, fromSelect = false) => {
    let isMnHAuthenticated = ""
    let isNetflixInSelectedProd = buildProductState?.perks?.selectedProduct?.findIndex((perk) => perk?.prodId === "R3559") > -1 ? true : false;
    function isNetmaxInOffer(response,subSectionType,promoId) {
        const promoProducts = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName?.toLowerCase() ===  "promotions"))?.subSections?.subSection?.find(s => s?.sectionType === subSectionType)?.promos;
        return Array.isArray(promoProducts) ? promoProducts?.some(p => p?.promoId === promoId) : false;
      }
    if(buildProductState?.internet?.mnhSignupIndicator !== "" && buildProductState?.internet?.mnhSignupIndicator !== null && buildProductState?.internet?.mnhSignupIndicator !== undefined){
        isMnHAuthenticated = buildProductState?.internet?.mnhSignupIndicator
      }
    try {
        if(!fromSelect)
            scClickEventProduct(specialOfferpromo, offertype);
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartSpecialOffer', "Inside updateCartSpecialOffer"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding Promotions", isLoaderImg: "loader" }
        });
        let blacFOffers2022 = false
        blacFOffers2022 = specialOfferpromo?.OfferText?.toLowerCase().indexOf('amazon') > -1;
        if (InHomeUtils.isNotEmpty(specialOfferpromo) && !isChecked) {
            let url = apiUrl().updateCartAcc + '/' + visitId;
            let eventAction = "";
            let eventValue = "";
            //(product, contract,specialOffer)
            if (!stadiaMLPFlow && specialOfferpromo && specialOfferpromo.OfferText) {
                updateSCTags("Select - " + specialOfferpromo.OfferText)
            }
            if (!lqState.cartFirstAddition) {
                eventValue = "scOpen,scAdd"
            }
            else {
                eventValue = isChecked ? "scRemove" : "scAdd"
            }
            eventAction = isChecked ? "RemovefromCart" : "AddtoCart";
            // let eventAction = "";
            // eventAction = isChecked ? "RemovefromCart" : "AddtoCart";
            api(url, 'POST', getRequestSpecialoffer(specialOfferpromo, contract, isChecked, offertype,isMnHAuthenticated, buildProductState)).then(response => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartSpecialOffer', "update Cart - Success"));
                    if (offertype === Service.splOffer) {
                        if (specialOfferpromo.offerFor.toUpperCase() === Service.data) {
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: specialOfferpromo });
                        }
                        else if (specialOfferpromo.offerFor.toUpperCase() === Service.video) {
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID_TV', value: specialOfferpromo });
                        }
                        dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: specialOfferpromo });
                    }
                    else if (offertype === Service.flashOffer || blacFOffers2022) {
                         dispatch({ type: 'FLASHOFFER_SELECTEDPRODID', value: isChecked ? null : specialOfferpromo });
                    }

                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail,
                            cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                        }
                    });
                    dispatch({ type: 'CART_SAVE_ON_UPDATE', value: true });

                    if(!(isNetmaxInOffer(response,"Offers","R4047") || isNetmaxInOffer(response,"SpecialOffers","R4047") || isNetmaxInOffer(response,"SpecialOffers","R4049")|| isNetmaxInOffer(response,"SpecialOffers","R4142") || isNetmaxInOffer(response,"Offers","R4142") || isNetmaxInOffer(response,"SpecialOffers","R4140")) && isNetflixInSelectedProd && buildProductState?.perks?.netMaxOfferToggle ){
                        setTimeout(() => {
                            updatePerkSelection({ prodId: 'R3559', add: true, dispatch, visitId, offerToggle: false, buildProductState });
                        }, 2000);
                    }

                    if (flowType === "SUPP") {
                        let suppProfileCartStatus = store && store.getState && store.getState()?.supp && store.getState()?.supp?.suppProfileCartStatus;
                        let searchTerm = specialOfferpromo?.id;
                       
                        suppProfileCartStatus['offer'] = getProductStatus(searchTerm, isChecked, 'offer') //productStatus;
                        
                        dispatch({
                            type: "UPDATE_PROFILE_CART_STATUS",
                            value: suppProfileCartStatus
                        });
                    }
                    if (flowType === "SUPP") {
                        let updatedSuppProfileCartStatus = store && store.getState && store.getState().supp && store.getState().supp.suppProfileCartStatus;
                        let suppCartupdateStatus = false;
                        if (JSON.stringify(updatedSuppProfileCartStatus).indexOf("ADDED") > -1 || JSON.stringify(updatedSuppProfileCartStatus).indexOf("REMOVED") > -1) {
                            suppCartupdateStatus = true;
                        }
                        dispatch({
                            type: "UPDATE_CART_SUPP",
                            value: suppCartupdateStatus
                        });
                    }
                    let leadListPromiseData = fetchDataMTM(dispatch, visitId,'NC'); 
                    let isLeadList = false;
                    Promise.all([leadListPromiseData]).then(function (values) {
                        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
                        isLeadList = values?.[0]?.leadListAddress;
                        if(isLeadList && eventAction == "AddtoCart" && specialOfferpromo?.id =="R4010"){
                            updateCart(visitId, lqState, buildProductState?.internet.selectedProduct, "INTERNET", isChecked, dispatch, "",null, null,contract, "DATA",false,false,null,buildProductState, null,flowType)
                        }
                        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    });

                    let cartProducts = getCartProducts(response.data.cartTierPricing, visitId)
                    fetchOfferInCart(visitId, cartProducts, dispatch, contract, isDoFlow, response, false, false, lqState, flowType, !blacFOffers2022, specialOfferpromo);
                    let offersInCart = [];
                    if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.rewardoffers)) {
                            offersInCart = cartProducts.CartSubProduct.SpecialOffers.rewardoffers.slice();
                        }
                    }
                    let splOfferProdType = typeof specialOfferpromo?.offerFor === "string" && specialOfferpromo?.offerFor !== ""
                        ? specialOfferpromo?.offerFor?.toUpperCase() : prodType;
                        // update banner message only when black friday, cyber monday and holiday offers netflix isnt selected. if netflix is selected, then update banner happens after perk selection
                        if(specialOfferpromo?.id !=="R4142" && specialOfferpromo?.id !=="R4047") {
                            updateSweetnerMsg(specialOfferpromo, offertype, false, processOfferSection(offersInCart), lqState, buildProductState, visitId, dispatch, splOfferProdType);
                        }
                    if (!stadiaMLPFlow) {
                        addToCartSCEvent(visitId, specialOfferpromo, offertype, response, isDoFlow, !isChecked, null, flowType, lqState.isFCPflow, null, eventAction)
                        addToCartVzdlSCEvent(visitId, specialOfferpromo, offertype, response, isDoFlow, !isChecked, null, flowType, lqState.isFCPflow, eventAction, eventValue)
                    }
                    if (prodType === Service.internet) {
                        fetchTVMTM(dispatch, visitId, lqState.selectedAdr.zip, lqState.selectedState.tarCode, buildProductState.masterpackageview, false, null, flowType)
                    }

                    // Netmax content updates as per api response.
                    if(response?.data?.cartTierPricing) {
                        const promoSection = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(p => p?.sectionName === CartServices.Promotions);
                        const offers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === 'Offers' || sec?.sectionType === 'SpecialOffers');
                        let netflixPromoEligible = false;
                        let netflixPerkEligible = false;
                        offers?.promos?.forEach(promo => {
                            /* Triggering for Marker and Discount isocs from update cart to handle api responses either case
                            */
                            if((promo?.promoId === "R4048" || promo?.promoId === 'R4047' || promo?.promoId === 'R4142' || promo?.promoId === 'R4143') && !isNetflixInSelectedProd ){
                                netflixPerkEligible = true;
                            } 
                            if(promo?.offerAttrValue === 'NETMAX_PERK_DISCOUNT' || promo?.offerAttrValue === 'NETMAX_PERK_MARKER') {
                                netflixPromoEligible = true;
                            }
                        });
                        if (netflixPerkEligible) {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            /* ITT-695487 setting timeout to delay this updatecart so that this to be the latest.
                            */
                            setTimeout(() => {
                                updatePerkSelection({ prodId: 'R3559', add: false, dispatch: dispatch,  visitId: visitId, offerToggle: true, buildProductState,specialOfferpromo,offertype,lqState,splOfferProdType });
                            }, 1000);
                        }
                        dispatch({ type: 'NETMAX_PROMO_PRESENT', value: netflixPromoEligible });
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartSpecialOffer', "UPDATECARTSPECIALOFFER - FAIL", PAGEACTIVITY.UA));
                }
                if (buildProductState?.isMNEnabled || buildProductState?.mnFromApi) {
                    /* CETC-145933 Perks shouldn't auto expand for classic customers*/
                    if(buildProductState?.internet?.m2mPlans?.[0]?.productKeyword?.includes('MM4')) {
                        setTimeout(() => {
                        dispatch({ type: "TOGGLE_PERKS_ACCOR", value: true });
                        }, 700);
                    }
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
                .catch(error => {
                    let errorMsg = `MethodName:updateCartSpecialOffer-cartUpdate,errorMessage:${error.message}`;
                    //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                });
        }
        else {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
        //})
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartSpecialOffer', ex);
    }
}

const getCouponMultiuseRequest = () => {
    let request = {
        key: "REFRESHCART",
        value: "COUPON",
        action: "add"
    }
    return JSON.stringify(request)
}

export const updateCouponMultiuse = (visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId, servicesQualified) => {
    try {
        /* dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding to cart", isLoaderImg: "loader" }
        }); */
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCouponMultiuse', "Inside updateCouponMultiuse"));
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let request = getCouponMultiuseRequest();
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCouponMultiuse', "update Cart - Success"));
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
                let servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) ? response.data.orderDetail.servicesOrdered : '';
                let addlInfo = {
                    zip: zip,
                    state: '',
                    tarCode: tarCode,
                    masterpackageview: masterpackageview,
                    selectedProductId: selectedProdId,
                    couponFlowType: '',
                    EquipmentState: null,
                    isAlaCarte: false,
                    servicesQualified: servicesQualified
                };
                doPrefetch('', dispatch, visitId, addlInfo, contract, selectedCoreServices, true, '', '', '', false, servicesInCart);
                //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else { //error while updating cart
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCouponMultiuse', "UPDATECOUPONMULTIUSE - FAIL", PAGEACTIVITY.UA));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateCouponMultiuse,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCouponMultiuse', ex);
    }
}

//"UpdatePromationFromChatNC('DNRD-9594-9431')" 
export const updateCartChatOfferCoupon = (visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId, promodetails, servicesQualified) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOfferCoupon', "Inside updateCartChatOfferCoupon"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding Promotions", isLoaderImg: "loader" }
        });
        let url = apiUrl().refreshPromotionsUrl
        api(url, 'POST', getRequestMultiUseoffer(promodetails)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.service) && response.service.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOfferCoupon', "refres Promos - Success"));
                updateCouponMultiuse(visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId, servicesQualified);
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartChatOfferCoupon', "refresh Promos - Fail", PAGEACTIVITY.UA));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateCartChatOfferCoupon,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartChatOfferCoupon', ex);
    }
}

export const updateContract = (visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId, servicesQualified, flowType) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateContract', "Inside updateContract"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding to cart", isLoaderImg: "loader" }
        });
        dispatch({
            type: 'SET_CART_DIRTY',
            value: true
        });

        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let request = getContractRequest(contract);
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateContract', "update cart - success"));
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
                let cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                let servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) ? response.data.orderDetail.servicesOrdered : '';
                // let eventAction = isChecked ? "RemovefromCart" : "AddtoCart";
                getSpecialOffers(visitId, contract, dispatch, '', '', null, cartProducts, false);
                fetchOfferInCart(visitId, cartProducts, dispatch, contract);
                let addlInfo = {
                    zip: zip,
                    state: '',
                    tarCode: tarCode,
                    masterpackageview: masterpackageview,
                    selectedProductId: selectedProdId,
                    couponFlowType: '',
                    EquipmentState: null,
                    isAlaCarte: false,
                    servicesQualified: servicesQualified
                };
                if (flowType === 'MV') {
                    addlInfo.flowType = flowType;
                }
                if (flowType === 'NC') {
                    isNC = true;
                    addlInfo.flowType = flowType;
                }

                doPrefetch('', dispatch, visitId, addlInfo, contract, selectedCoreServices, true, '', '', '', true, servicesInCart);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else { //error while updating cart
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateContract', "UPDATECONTRACT - Fail", PAGEACTIVITY.UA));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateContract,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateContract', ex);
    }
}

export const removeUnSelectedManualOffers = (offers, searchParam, offerType, currentOffer) => {
    //Removes all special choice offers and returns other offers
    //searchParam: if any special choice offer attribute value passed in this argument, with return that offer along with non special choice offers
    //OfferType : Data/Video
    //OfferTypes.allManualOFfers : List of all Special Choice Offers
    // typeof offer === 'string' is true for upsell overlay
    let offerFilter = OfferTypes.allManualOFfers[offerType] ? searchParam ? OfferTypes.allManualOFfers[offerType].replace(searchParam + '|', '') : OfferTypes.allManualOFfers[offerType] : '';
    offerFilter = offerFilter.endsWith('|') ? offerFilter.substring(0, offerFilter.lastIndexOf('|')) : offerFilter;
    if (offerFilter) {
        let exclusionFilter = OfferTypes.ExclusionOFfers;
        if (currentOffer) {
            if (currentOffer !== searchParam && !offerFilter.includes(currentOffer)) {
                offerFilter += '|' + currentOffer //removing current offer from final result if current offers is not available in offerFilter
            }
            if (currentOffer === OfferTypes.MarvelAvenger + '_' + OfferTypes.SpecialDiscount && InHomeUtils.isNotNull(offerFilter)) {
                offerFilter = offerFilter.replace("HULUSVOD_12MO_VZREWARD|", '');
                offerFilter = offerFilter.replace("HULUSVOD_6MO_VZREWARD|", '');
            }
            if (exclusionFilter && Object.keys(exclusionFilter).length > 0 && exclusionFilter[currentOffer]) {
                offers = removeExcludedOffers(offers, offerType, currentOffer); //remove non special offers that are not linked to the selected choice offer
            }
        }
        let offerArray = offerFilter.split('|');
        if (offers && offers.length) {
            offers = offers.filter(offer => (typeof offer === 'object' && offer.offerFor && offer.offerFor.toUpperCase() === offerType
                && ((offer.BsOfferAttr && offer.BsOfferAttrValue && !offerArray.includes(offer.BsOfferAttrValue + '_' + offer.BsOfferAttr)) || (offer.offerAttr && offer.offerAttrValue && !offerArray.includes(offer.offerAttrValue + '_' + offer.offerAttr))))
                || (typeof offer === 'string' && offer.toUpperCase().includes(offerType) && !offerArray.some(filter => offer.includes(filter))));
        }
    }
    return offers;
}

export const removeFlashOffers = (offers, offerType) => {
    if (offerType) {
        let removeFilter = OfferTypes.allFlashOffers[offerType];
        if (InHomeUtils.isNotNull(removeFilter)) {
            removeFilter = removeFilter.endsWith(',') ? removeFilter.substring(0, removeFilter.lastIndexOf(',')) : removeFilter;
            if (InHomeUtils.isNotNull(removeFilter)) {
                let offerArray = removeFilter.split(',');
                if (offers && offers.length) {
                    offers = offers.filter(offer => (typeof offer === 'object' && offer.offerFor && offer.offerFor.toUpperCase() === offerType
                        && ((offer.BsOfferAttr && offer.BsOfferAttrValue && !offerArray.includes(offer.BsOfferAttr + '|' + offer.BsOfferAttrValue)) || (offer.offerAttr && offer.offerAttrValue && !offerArray.includes(offer.offerAttr + '|' + offer.offerAttrValue)))));
                }
            }
        }

    }
    return offers;
}

export const getFlashOffers = (offers, offerType) => {
    if (offerType) {
        let removeFilter = OfferTypes.allFlashOffers[offerType];
        if (InHomeUtils.isNotNull(removeFilter)) {
            removeFilter = removeFilter.endsWith(',') ? removeFilter.substring(0, removeFilter.lastIndexOf(',')) : removeFilter;
            if (InHomeUtils.isNotNull(removeFilter)) {
                let offerArray = removeFilter.split(',');
                if (offers && offers.length) {
                    offers = offers.filter(offer => (typeof offer === 'object' && offer.offerFor && offer.offerFor.toUpperCase() === offerType
                        && ((offer.BsOfferAttr && offer.BsOfferAttrValue && offerArray.includes(offer.BsOfferAttr + '|' + offer.BsOfferAttrValue)) || (offer.offerAttr && offer.offerAttrValue && offerArray.includes(offer.offerAttr + '|' + offer.offerAttrValue)))));
                }
            }
        }

    }
    return offers;
}

export const removeExcludedOffers = (offers, offerType, currentOffer) => {
    //to remove non spl choice offers that have exclusion with special offers. for eg: Stream TV cannot be added with Google Stadia.
    //OfferTypes.ExclusionOFfers: Exclusion Offer List
    let exclusionFilter = OfferTypes.ExclusionOFfers;
    if (offers && offers.length && (exclusionFilter && Object.keys(exclusionFilter).length > 0)) {
        let exclusionArray = "";
        if (exclusionFilter[currentOffer]) {
            exclusionArray = exclusionFilter[currentOffer];
        }
        //exclusionArray : Offers to be removed from return array
        exclusionArray = exclusionArray.endsWith('|') ? exclusionArray.substring(0, exclusionArray.lastIndexOf('|')).split('|') : exclusionArray.split('|');
        if (exclusionArray && exclusionArray.length > 0) {
            offers = offers.filter(offer => (typeof offer === 'object' &&
                ((offer.BsOfferAttr && offer.BsOfferAttrValue && !exclusionArray.includes(offer.BsOfferAttrValue + '_' + offer.BsOfferAttr)) || (offer.offerAttr && offer.offerAttrValue && !exclusionArray.includes(offer.offerAttrValue + '_' + offer.offerAttr))))
                || (typeof offer === 'string' && !exclusionArray.some(filter => offer.includes(filter))));
        }
    }
    return offers;
}
var offerFilter = '';
export const getOffersFilter = (offer, offerType, index, upsellHulu) => {
    //Returns only the Special Choice Offers
    //OfferType : Data/Video
    //OfferTypes.allManualOFfers : List of all Special Choice Offers
    //OfferTypes.UniqueSpecialOffers : Offer applied to all plans but acts as a choice offer for specific plans. e.g: disney for 200M with amazon
    if (InHomeUtils.isNotNull(upsellHulu) && upsellHulu === "Y") {
        includeDisneyAsSpecialOffer = false;
    }
    if(isJointDeviceOffer){
        includeDisneyAsSpecialOffer = true;
    }
    if (!index) {
        offerFilter = includeDisneyAsSpecialOffer ? OfferTypes.allManualOFfers[offerType] + OfferTypes.Disney + '-' + OfferTypes.SpecialDiscount : OfferTypes.allManualOFfers[offerType];
    }
    if (InHomeUtils.isNotNull(offer) && InHomeUtils.isNotNull(offer.BsOfferAttrValue) && (offer.BsOfferAttrValue === OfferTypes.Hulu || offer.BsOfferAttrValue === OfferTypes.Hulu6Mo)) {
        ignoreUniqueSplOffer = true;
    }
    if (InHomeUtils.isNotNull(offer) && InHomeUtils.isNotNull(offer.BsOfferAttrValue) && offer.BsOfferAttrValue === OfferTypes.MarvelAvenger && InHomeUtils.isNotNull(offerFilter)) {
        offerFilter = offerFilter.replace(OfferTypes.Hulu6 + '_' + OfferTypes.Reward + '|', '');
        offerFilter = offerFilter.replace(OfferTypes.Hulu6Mo + '_' + OfferTypes.Reward + '|', '');
    }
    const uniqueOffers = !ignoreUniqueSplOffer ? OfferTypes.UniqueSpecialOffers : '';
    if (offerFilter && offer && offerType !== '' && ((offer.offerFor && offer.offerFor.toUpperCase() === offerType) || (typeof offer === 'string' && offer.toUpperCase().indexOf(offerType) > -1)) || offerType === 'all') {
        if (typeof offer === 'object') {
            if (uniqueOffers && uniqueOffers[(offer.BsOfferAttr && offer.BsOfferAttrValue && offer.BsOfferAttrValue + '_' + offer.BsOfferAttr) || (offer.offerAttr && offer.offerAttrValue && offer.offerAttrValue + '_' + offer.offerAttr)]) {
                offerFilter += uniqueOffers[(offer.BsOfferAttr && offer.BsOfferAttrValue && offer.BsOfferAttrValue + '_' + offer.BsOfferAttr) || (offer.offerAttr && offer.offerAttrValue && offer.offerAttrValue + '_' + offer.offerAttr)];
            }
            //return offerFilter.includes((offer.BsOfferAttr && offer.BsOfferAttrValue && offer.BsOfferAttrValue + '_' + offer.BsOfferAttr) || (offer.offerAttr && offer.offerAttrValue && offer.offerAttrValue + '_' + offer.offerAttr));

            let offerArray = [];
            if(offerFilter){
                offerArray = offerFilter.split('|');
            }
            return (offerArray.includes(offer.BsOfferAttrValue + '_' + offer.BsOfferAttr) || offerArray.includes(offer.offerAttrValue + '_' + offer.offerAttr))
        }
        else if (typeof offer === 'string') {
            //For Upsell Overlay
            //offer: PR10007436~OF10041237:SPCLDISCOUNT|GOOGLESTADIA_3MO|Data
            if (InHomeUtils.isNotNull(offer) && offer.indexOf(OfferTypes.MarvelAvenger) > -1 && InHomeUtils.isNotNull(offerFilter)) {
                offerFilter = offerFilter.replace(OfferTypes.Hulu6 + '_' + OfferTypes.Reward + '|', '');
                offerFilter = offerFilter.replace(OfferTypes.Hulu6Mo + '_' + OfferTypes.Reward + '|', '');
            }
            if (uniqueOffers && uniqueOffers[offer.split('|')[3]]) {
                offerFilter += uniqueOffers[offer.split('|')[3]];
            }
            if (offerFilter !== undefined) {
                offerFilter = offerFilter.endsWith('|') ? offerFilter.substring(0, offerFilter.lastIndexOf('|')) : offerFilter
                let offerArray = offerFilter.split('|');
                return offerArray.some(filter => offer.includes(filter));
            }
        }
    }
    return false;
}

export const setSpecialOffers = (visitId, contract, dispatch, flowType, isDoFlow, flashOffer = null, cartProducts = null, isFromUpdateCart = false, cartResponse = null, lqState = null, suppState = null, selectedProdType = null, buildProductState = null, splOffers = null) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'setSpecialOffers', "Inside setSpecialOffers"));
        const perfChangesEnabled = lqState?.runtimeKey?.EnableDispatchPerfChanges === 'Y';
        const dispatchActions = [];
        let splOffersData = {};
        if(contract === 'MTM') {
            if(InHomeUtils.isNull(flashOffer)) splOffersData = { offersMTM: splOffers}
            if(InHomeUtils.isNotNull(flashOffer)) splOffersData = { flashoffersMTM: splOffers}
        } else if(contract === '2YR') {
            if(InHomeUtils.isNull(flashOffer)) splOffersData = { offer2YR: splOffers}
            if(InHomeUtils.isNotNull(flashOffer)) splOffersData = { flashoffer2YR: splOffers}
        }

        if (flowType == "SUPP" && InHomeUtils.isNotNull(suppState) && InHomeUtils.isNotNull(suppState.vzOrder) && InHomeUtils.isNotNull(suppState.vzOrder.hasMarvel) && suppState.vzOrder.hasMarvel == "Y") {
            hasMarvelProfile = true;
        }
        if (!isDoFlow) {
                
            if (InHomeUtils.isNotNull(splOffersData.offersMTM) || InHomeUtils.isNotNull(splOffersData.offer2YR)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'setSpecialOffers', "Special Offers Found"));
                processOfferSection(splOffersData)
               
                if (lqState && lqState.showMarvel) {
                    showMarvel = true;
                }
                if (lqState && !lqState.isFCPflow) {
                    let data;
                    if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                        data = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.speedCode) && e.speedCode === 945);
                    }

                    let promotions = contract === 'MTM' ? splOffersData?.offersMTM || [] : splOffersData?.offer2YR || [];

                    let isDisney = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'DISNEYPLUS_12MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'DISNEYPLUS_12MO')));
                    if (data && data.length > 0 && isDisney && isDisney.length > 0) {
                        includeDisneyAsSpecialOffer = true;
                    }
                    else {
                        includeDisneyAsSpecialOffer = false;
                    }

                    if (contract !== 'MTM' && isDisney) {
                        ignoreUniqueSplOffer = true;
                    }
                    else {
                        ignoreUniqueSplOffer = false;
                    }
                }
                else if (lqState && lqState.isFCPflow) {
                    let data;
                    if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                        data = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.speedCode) && e.speedCode === 944);
                    }
                    let promotions = splOffersData?.offersMTM;
                    let isDisney = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'DISNEYPLUS_12MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'DISNEYPLUS_12MO')));
                    let isHulufor200M = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'HULUSVOD_6MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'HULUSVOD_6MO')));
                    if (data && data.length > 0 && isDisney && isDisney.length > 0 && !showMarvel && isHulufor200M && isHulufor200M.length === 0) {
                        includeDisneyAsSpecialOffer = true;
                    }
                    else {
                        includeDisneyAsSpecialOffer = false;
                    }

                }
                
                if(splOffersData?.offersMTM?.length > 0) { 
                    if(perfChangesEnabled) {
                        dispatchActions.push({ type: 'SET_SPL_PROMO_OFFERS_LIST', value: splOffersData?.offersMTM });
                    } else {
                        dispatch({ type: 'SET_SPL_PROMO_OFFERS_LIST', value: splOffersData?.offersMTM });
                    }
                }

                let specialDataMTMOffers = InHomeUtils.isNotNull(splOffersData.offersMTM) ? splOffersData.offersMTM.filter((offer, index) => getOffersFilter(offer, Service.data, index)) : null;
                let specialData2YROffers = InHomeUtils.isNotNull(splOffersData.offer2YR) ? splOffersData.offer2YR.filter((offer, index) => getOffersFilter(offer, Service.data, index)) : null
                let dataOfferCount = specialDataMTMOffers.filter(offer => (offer.offerFor.toUpperCase() === Service.data)).length;
              
                let specialTVMTMOffers = InHomeUtils.isNotNull(splOffersData.offersMTM) ? splOffersData.offersMTM.filter((offer, index) => getOffersFilter(offer, Service.video, index)) : null
                let specialTV2YROffers = InHomeUtils.isNotNull(splOffersData.offer2YR) ? splOffersData.offer2YR.filter(offer => getOffersFilter(offer, Service.video)) : null
                let tvOfferCount = specialTVMTMOffers.filter(offer => (offer.offerFor.toUpperCase() === Service.video)).length;

                let classicMTMOffers = null;
                if (specialTVMTMOffers && specialTVMTMOffers) {
                    classicMTMOffers = [...specialDataMTMOffers, ...specialTVMTMOffers].filter(o => o);
                }
                else {
                    classicMTMOffers = specialDataMTMOffers || specialTVMTMOffers;
                }
                let classic2YROffers = null;
                if (specialData2YROffers && specialTV2YROffers) {
                    classic2YROffers = [...specialData2YROffers, ...specialTV2YROffers].filter(o => o);
                }
                else {
                    classic2YROffers = specialData2YROffers || specialTV2YROffers;
                    if(classic2YROffers === null)
                    {
                        classic2YROffers = [];
                    }
                }

                if(perfChangesEnabled) {
                    dispatchActions.push({ type: 'FETCH_SPLOFFER', value: { offersMTM: classicMTMOffers, offer2YR: classic2YROffers, isDataOffer: dataOfferCount > 1, isTVOffer: tvOfferCount > 1, dataOffersMTM: specialDataMTMOffers, tvOffersMTM: specialTVMTMOffers }});
                } else {
                    dispatch({ type: 'FETCH_SPLOFFER', value: { offersMTM: classicMTMOffers, offer2YR: classic2YROffers, isDataOffer: dataOfferCount > 1, isTVOffer: tvOfferCount > 1, dataOffersMTM: specialDataMTMOffers, tvOffersMTM: specialTVMTMOffers }})
                }

                let filteredMTM = null;
                let filtered2YR = null;
                if (InHomeUtils.isNotNull(splOffersData.offersMTM)) {
                    filteredMTM = InHomeUtils.isNotNull(specialDataMTMOffers) ? splOffersData.offersMTM.filter(function (e) {
                        return this.indexOf(e) < 0;
                    }, specialDataMTMOffers) : splOffersData.offersMTM;
                }
                if (InHomeUtils.isNotNull(splOffersData.offer2YR)) {
                    filtered2YR = InHomeUtils.isNotNull(specialData2YROffers) ? splOffersData.offer2YR.filter(function (e) {
                        return this.indexOf(e) < 0;
                    }, specialData2YROffers) : splOffersData.offer2YR;
                }

                if(perfChangesEnabled) {
                    dispatchActions.push({ type: 'FETCH_CONTRACTOFFER', value: { offersMTM: filteredMTM, offer2YR: filtered2YR } });
                } else {
                    dispatch({ type: 'FETCH_CONTRACTOFFER', value: { offersMTM: filteredMTM, offer2YR: filtered2YR } })
                }
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'setSpecialOffers', "SPECIALOFFERS " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                if(perfChangesEnabled) {
                    dispatchActions.push({ type: 'FETCH_SPLOFFER', value: null });
                    dispatchActions.push({ type: 'FETCH_CONTRACTOFFER', value: { offersMTM: null, offer2YR: null, isDataOffer: false } });
                } else {
                    dispatch({ type: 'FETCH_SPLOFFER', value: null })
                    dispatch({ type: 'FETCH_CONTRACTOFFER', value: { offersMTM: null, offer2YR: null, isDataOffer: false } })
                }
            }

            if (InHomeUtils.isNotNull(splOffersData.flashoffersMTM) || InHomeUtils.isNotNull(splOffersData.flashoffer2YR)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'getSpecialOffers', "Flash Offers Found"));
                splOffersData["isFlashOffer"] = true;
                if(perfChangesEnabled) {
                    dispatchActions.push({ type: 'FETCH_FLASHOFFER', value: processOfferSection(splOffersData) });
                } else { 
                    dispatch({ type: 'FETCH_FLASHOFFER', value: processOfferSection(splOffersData) })
                }
                if (InHomeUtils.isNotNull(flashOffer) && InHomeUtils.isNotEmpty(splOffersData.flashOffer) && flashOffer.offerAttr === response.data.flashOffer) {
                    let latestOffer = null;
                    
                    if (InHomeUtils.isNotNull(latestOffer) && latestOffer.length > 0) {
                        latestOffer = latestOffer[0];
                        updateCartSpecialOffer(visitId, latestOffer, contract, dispatch, Service.flashOffer, false, isDoFlow, false, buildProductState, lqState, selectedProdType, flowType);
                    }
                    else if (isFromUpdateCart) {
                        fetchOfferInCart(visitId, cartProducts, dispatch, contract, isDoFlow, null, isFromUpdateCart);
                    }
                }
                else if (isFromUpdateCart) {
                    fetchOfferInCart(visitId, cartProducts, dispatch, contract, isDoFlow, null, isFromUpdateCart);
                }
                if (isDoFlow) {
                    if(perfChangesEnabled) {
                        dispatchActions.push({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
                    } else { 
                        dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
                    }
                }
            }
            else {
                let showStadia = lqState && lqState.showStadia;
                showMarvel = (lqState && lqState.showMarvel) || hasMarvelProfile;
                isFromUpdateCart ? fetchOfferInCart(visitId, cartProducts, dispatch, contract, isDoFlow, cartResponse, isFromUpdateCart, showStadia, lqState, flowType) : {};
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'setSpecialOffers', "FLASHOFFERS " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                if(perfChangesEnabled) {
                    dispatchActions.push({ type: 'FETCH_FLASHOFFER', value: null });
                } else { 
                    dispatch({ type: 'FETCH_FLASHOFFER', value: null })
                }

                let offersInCart = [];
                if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                    if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.rewardoffers)) {
                        offersInCart = cartProducts.CartSubProduct.SpecialOffers.rewardoffers.slice();
                    }
                }
                
                if (InHomeUtils.isNotNull(selectedProdType) && selectedProdType.toUpperCase() === "INTERNET") {
                    let isleadSpecialOfferInCart = false;
                    if (InHomeUtils.isNotNull(offersInCart)) {
                        offersInCart.forEach(offer => {
                            if (InHomeUtils.isNotNull(offer.offerAttrValue) && (offer.offerAttrValue === "AMAZON_ECHODOT_BLINK" || offer.offerAttrValue === "AMAZON_ECHOSPEAKER_RING" || offer.offerAttrValue === "FIOS200" || offer.offerAttrValue === "FIOS100" || offer.offerAttrValue == "DISNEYPLUS_12MO")) {
                                isleadSpecialOfferInCart = true;
                            }
                        });
                    }
                    
                    if (isleadSpecialOfferInCart) {
                        if(perfChangesEnabled) {
                            dispatchActions.push({ type: 'TOGGLE_DATA_SPLOFFER_ACCOR', value: 'isleadSpecialOfferInCart' });
                        } else { 
                            dispatch({ type: 'TOGGLE_DATA_SPLOFFER_ACCOR', value: 'isleadSpecialOfferInCart' });
                        }
                    }
                    else{
                        try {
                            var vintageOfferInCart =  InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions.filter(o => o.offerAttrValue === "SPR_VIN_PH_BO_DMA")) ? cartProducts.CartSubProduct.Promotions.promotions.filter(o => o.offerAttrValue === "SPR_VIN_PH_BO_DMA") : null;

                            if(vintageOfferInCart && vintageOfferInCart.length > 0){
                                if(perfChangesEnabled) {
                                    dispatchActions.push({ type: "TOGGLE_DATA_SPLOFFER_ACCOR", value: '' });
                                } else { 
                                    dispatch({ type: "TOGGLE_DATA_SPLOFFER_ACCOR", value: '' });   
                                }
                            }
                        }
                        catch (ex) {
                            catchJSException(PAGEACTIVITY.PAGE.BYOB, visitId, 'GetSpecialOffers', ex);
                        }
                    }
                }
                else if (InHomeUtils.isNotNull(offersInCart) && offersInCart.length > 0 && isDoFlow) {
                    if(perfChangesEnabled) {
                        dispatchActions.push({ type: 'TOGGLE_DATA_SPLOFFER_ACCOR', value: 'DOFlow' });
                    } else { 
                        dispatch({ type: 'TOGGLE_DATA_SPLOFFER_ACCOR', value: 'DOFlow' });
                    }
                }
                else if (isDoFlow) {
                    if(perfChangesEnabled) {
                        dispatchActions.push({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
                    } else { 
                        dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
                    }
                }
            }
        }
        else if (isDoFlow) {
            if(perfChangesEnabled) {
                dispatchActions.push({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
            } else { 
                dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
            }
        }
        performance.mark("After SPECIALOFFER_END")
        return dispatchActions;
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getSpecialOffers', ex);
    }
}

export const getSpecialOffers = (visitId, contract, dispatch, flowType, isDoFlow, flashOffer = null, cartProducts = null, isFromUpdateCart = false, cartResponse = null, lqState = null, suppState = null, selectedProdType = null, buildProductState = null) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getSpecialOffers', "Inside getSpecialOffers"));
        //if (InHomeUtils.isNotNull(flashOffer)) {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Fetching Promotions", isLoaderImg: "loader" }
        });
        //}
        if (flowType == "SUPP" && InHomeUtils.isNotNull(suppState) && InHomeUtils.isNotNull(suppState.vzOrder) && InHomeUtils.isNotNull(suppState.vzOrder.hasMarvel) && suppState.vzOrder.hasMarvel == "Y") {
            hasMarvelProfile = true;
        }
        let url = apiUrl().getProduct + '/sploffers';
        api(url, 'POST', getRequest(visitId, contract, "", flowType)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {
                
                if (InHomeUtils.isNotNull(response.data.offersMTM) || InHomeUtils.isNotNull(response.data.offer2YR)) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'getSpecialOffers', "Special Offers Found"));
                    processOfferSection(response.data)
                    // if(flowType !=='MV' && !smartCartFlow  && flowType !== 'SUPP'){
                    //     response.data.offersMTM =  InHomeUtils.isNotNull(response.data.offersMTM) ? response.data.offersMTM.filter(e => ((e.BsOfferAttrValue && e.BsOfferAttrValue != OfferTypes.MarvelAvenger) || (e.BsOfferAttrValue && e.BsOfferAttrValue != OfferTypes.MarvelAvenger))) : response.data.offersMTM;
                    //     response.data.offer2YR = InHomeUtils.isNotNull(response.data.offer2YR) ? response.data.offer2YR.filter(e => ((e.BsOfferAttrValue && e.BsOfferAttrValue != OfferTypes.MarvelAvenger) || (e.BsOfferAttrValue && e.BsOfferAttrValue != OfferTypes.MarvelAvenger))) : response.data.offer2YR;
                    //    }
                    if (lqState && lqState.showMarvel) {
                        showMarvel = true;
                    }
                    if (lqState && !lqState.isFCPflow) {
                        let data;
                        if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                            data = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.speedCode) && e.speedCode === 945);
                        }

                        let promotions = contract === 'MTM' ? response.data.offersMTM : response.data.offer2YR;

                        let isDisney = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'DISNEYPLUS_12MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'DISNEYPLUS_12MO')));
                        if (data && data.length > 0 && isDisney && isDisney.length > 0) {
                            includeDisneyAsSpecialOffer = true;
                        }
                        else {
                            includeDisneyAsSpecialOffer = false;
                        }

                        if (contract !== 'MTM' && isDisney) {
                            ignoreUniqueSplOffer = true;
                        }
                        else {
                            ignoreUniqueSplOffer = false;
                        }
                    }
                    else if (lqState && lqState.isFCPflow) {
                        let data;
                        if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                            data = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.speedCode) && e.speedCode === 944);
                        }
                        let promotions = response.data.offersMTM;
                        let isDisney = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'DISNEYPLUS_12MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'DISNEYPLUS_12MO')));
                        let isHulufor200M = promotions.filter(e => ((e.offerAttrValue && e.offerAttrValue === 'HULUSVOD_6MO') || (e.BsOfferAttrValue && e.BsOfferAttrValue === 'HULUSVOD_6MO')));
                        if (data && data.length > 0 && isDisney && isDisney.length > 0 && !showMarvel && isHulufor200M && isHulufor200M.length === 0) {
                            includeDisneyAsSpecialOffer = true;
                        }
                        else {
                            includeDisneyAsSpecialOffer = false;
                        }

                    }
                    
                    if(response?.data?.offersMTM?.length > 0) {
                        dispatch({ type: 'SET_SPL_PROMO_OFFERS_LIST', value: response?.data?.offersMTM });
                      }

                    let specialDataMTMOffers = InHomeUtils.isNotNull(response.data.offersMTM) ? response.data.offersMTM.filter((offer, index) => getOffersFilter(offer, Service.data, index)) : null;
                    let specialData2YROffers = InHomeUtils.isNotNull(response.data.offer2YR) ? response.data.offer2YR.filter((offer, index) => getOffersFilter(offer, Service.data, index)) : null
                    let dataOfferCount = specialDataMTMOffers.filter(offer => (offer.offerFor.toUpperCase() === Service.data)).length;
                  
                    let specialTVMTMOffers = InHomeUtils.isNotNull(response.data.offersMTM) ? response.data.offersMTM.filter((offer, index) => getOffersFilter(offer, Service.video, index)) : null
                    let specialTV2YROffers = InHomeUtils.isNotNull(response.data.offer2YR) ? response.data.offer2YR.filter(offer => getOffersFilter(offer, Service.video)) : null
                    let tvOfferCount = specialTVMTMOffers.filter(offer => (offer.offerFor.toUpperCase() === Service.video)).length;

                    let classicMTMOffers = null;
                    if (specialTVMTMOffers && specialTVMTMOffers) {
                        classicMTMOffers = [...specialDataMTMOffers, ...specialTVMTMOffers].filter(o => o);
                    }
                    else {
                        classicMTMOffers = specialDataMTMOffers || specialTVMTMOffers;
                    }
                    let classic2YROffers = null;
                    if (specialData2YROffers && specialTV2YROffers) {
                        classic2YROffers = [...specialData2YROffers, ...specialTV2YROffers].filter(o => o);
                    }
                    else {
                        classic2YROffers = specialData2YROffers || specialTV2YROffers;
                        if(classic2YROffers === null)
                        {
                            classic2YROffers = [];
                        }
                    }

                    dispatch({ type: 'FETCH_SPLOFFER', value: { offersMTM: classicMTMOffers, offer2YR: classic2YROffers, isDataOffer: dataOfferCount > 1, isTVOffer: tvOfferCount > 1, dataOffersMTM: specialDataMTMOffers, tvOffersMTM: specialTVMTMOffers } })
                    let filteredMTM = null;
                    let filtered2YR = null;
                    if (InHomeUtils.isNotNull(response.data.offersMTM)) {
                        filteredMTM = InHomeUtils.isNotNull(specialDataMTMOffers) ? response.data.offersMTM.filter(function (e) {
                            return this.indexOf(e) < 0;
                        }, specialDataMTMOffers) : response.data.offersMTM;
                    }
                    if (InHomeUtils.isNotNull(response.data.offer2YR)) {
                        filtered2YR = InHomeUtils.isNotNull(specialData2YROffers) ? response.data.offer2YR.filter(function (e) {
                            return this.indexOf(e) < 0;
                        }, specialData2YROffers) : response.data.offer2YR;
                    }
                    dispatch({ type: 'FETCH_CONTRACTOFFER', value: { offersMTM: filteredMTM, offer2YR: filtered2YR } })

                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getSpecialOffers', "SPECIALOFFERS " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                    dispatch({ type: 'FETCH_SPLOFFER', value: null })
                    dispatch({ type: 'FETCH_CONTRACTOFFER', value: { offersMTM: null, offer2YR: null, isDataOffer: false } })
                }

                if (InHomeUtils.isNotNull(response.data.flashoffersMTM) || InHomeUtils.isNotNull(response.data.flashoffer2YR)) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'getSpecialOffers', "Flash Offers Found"));
                    response.data["isFlashOffer"] = true;
                    dispatch({ type: 'FETCH_FLASHOFFER', value: processOfferSection(response.data) })
                    if (InHomeUtils.isNotNull(flashOffer) && InHomeUtils.isNotEmpty(response.data.flashOffer) && flashOffer.offerAttr === response.data.flashOffer) {
                        let latestOffer = null;
                        // if(InHomeUtils.isNotNull(response.data.flashoffer2YR) && (contract === 'TWOYEAR' || contract === '2YR')) {
                        //     latestOffer  = response.data.flashoffer2YR.filter(o => o.BsOfferAttrValue === flashOffer.offerAttrValue && o.id !== flashOffer.id);
                        // }
                        // else if(InHomeUtils.isNotNull(response.data.flashoffersMTM) && (contract === 'MTM')) {
                        //     latestOffer  = response.data.flashoffersMTM.filter(o => o.BsOfferAttrValue === flashOffer.offerAttrValue && o.id !== flashOffer.id);
                        // }
                        if (InHomeUtils.isNotNull(latestOffer) && latestOffer.length > 0) {
                            latestOffer = latestOffer[0];
                            updateCartSpecialOffer(visitId, latestOffer, contract, dispatch, Service.flashOffer, false, isDoFlow, false, buildProductState, lqState, selectedProdType, flowType);
                        }
                        else if (isFromUpdateCart) {
                            fetchOfferInCart(visitId, cartProducts, dispatch, contract, isDoFlow, null, isFromUpdateCart);
                        }
                    }
                    else if (isFromUpdateCart) {
                        fetchOfferInCart(visitId, cartProducts, dispatch, contract, isDoFlow, null, isFromUpdateCart);
                    }
                    if (isDoFlow) {
                        dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
                    }
                }
                else {
                    let showStadia = lqState && lqState.showStadia;
                    showMarvel = (lqState && lqState.showMarvel) || hasMarvelProfile;
                    isFromUpdateCart ? fetchOfferInCart(visitId, cartProducts, dispatch, contract, isDoFlow, cartResponse, isFromUpdateCart, showStadia, lqState, flowType) : {};
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getSpecialOffers', "FLASHOFFERS " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                    dispatch({ type: 'FETCH_FLASHOFFER', value: null })

                    let offersInCart = [];
                    if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.rewardoffers)) {
                            offersInCart = cartProducts.CartSubProduct.SpecialOffers.rewardoffers.slice();
                        }
                    }
                    
                    if (InHomeUtils.isNotNull(selectedProdType) && selectedProdType.toUpperCase() === "INTERNET") {
                        let isleadSpecialOfferInCart = false;
                        if (InHomeUtils.isNotNull(offersInCart)) {
                            offersInCart.forEach(offer => {
                                if (InHomeUtils.isNotNull(offer.offerAttrValue) && (offer.offerAttrValue === "AMAZON_ECHODOT_BLINK" || offer.offerAttrValue === "AMAZON_ECHOSPEAKER_RING" || offer.offerAttrValue === "FIOS200" || offer.offerAttrValue === "FIOS100" || offer.offerAttrValue == "DISNEYPLUS_12MO")) {
                                    isleadSpecialOfferInCart = true;
                                }
                            });
                        }
                        
                        if (isleadSpecialOfferInCart) {
                            dispatch({ type: 'TOGGLE_DATA_SPLOFFER_ACCOR', value: 'isleadSpecialOfferInCart' });
                        }
                        else{
                            try {
                                var vintageOfferInCart =  InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Promotions.promotions.filter(o => o.offerAttrValue === "SPR_VIN_PH_BO_DMA")) ? cartProducts.CartSubProduct.Promotions.promotions.filter(o => o.offerAttrValue === "SPR_VIN_PH_BO_DMA") : null;

                                if(vintageOfferInCart && vintageOfferInCart.length > 0){
                                    dispatch({ type: "TOGGLE_DATA_SPLOFFER_ACCOR", value: '' });   
                                }
                            }
                            catch (ex) {
                                catchJSException(PAGEACTIVITY.PAGE.BYOB, visitId, 'GetSpecialOffers', ex);
                            }
                        }
                    }
                    else if (InHomeUtils.isNotNull(offersInCart) && offersInCart.length > 0 && isDoFlow) {
                        dispatch({ type: 'TOGGLE_DATA_SPLOFFER_ACCOR', value: 'DOFlow' });
                    }
                    else if (isDoFlow) {
                        dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
                    }
                }
            }
            else if (isDoFlow) {
                dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                isFromUpdateCart ? fetchOfferInCart(visitId, cartProducts, dispatch, contract) : {};
                let errorMsg = `MethodName:getSpecialOffers,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getSpecialOffers', ex);
    }
}

export const fetchStreamingServices = (visitId, dispatch, flowType, couponFlowType) => {
    try {
        let isfcpFlow = InHomeUtils.isFcpFlow();
        let isFCPUEO = InHomeUtils.isFcpUEO();
        if ((!isfcpFlow && InHomeUtils.isNotEmpty(couponFlowType) && (couponFlowType !== "Employee" && couponFlowType !== "Retiree")) || (InHomeUtils.isNull(couponFlowType)) || (isFCPUEO && isfcpFlow && InHomeUtils.isNotEmpty(couponFlowType) && couponFlowType === "Employee")) {
            let url = apiUrl().getProduct + '/equipments';
            if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
                url = url + '?isMnFlow=Y';
            }
            api(url, 'POST', getRequest(visitId, Contract.monthToMonth, "OTT", flowType)).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {
                    dispatch({ type: 'FETCH_STREAMSERV', value: response.data.products.filter(p => p.prodType === "OTTBASIC" && (p.prodTypeValue.indexOf("YOUTUBE") >= 0) || (p.prodTypeValue.indexOf("SLING_REFERAL") >= 0)) })
                    let streamDev = response.data.products.filter(p => p.prodType === "OTTEQUIPNRC");
                    if (InHomeUtils.isNotNull(streamDev) && streamDev.length > 0) {
                        dispatch({ type: 'FETCH_STREAMDEV', value: response.data.products.filter(p => p.prodType === "OTTEQUIPNRC") })
                    }
                    if (InHomeUtils.isNotNull(response.data.products.filter(p => p.prodType === "OTTBASIC" && p.prodTypeValue.indexOf("YOUTUBE") >= 0)) && response.data.products.filter(p => p.prodType === "OTTBASIC" && p.prodTypeValue.indexOf("YOUTUBE") >= 0).length > 0) {
                        dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { OTT: true } });
                    }
                }
            })
                .catch(error => {
                    let errorMsg = `MethodName:fetchStreamingServices,errorMessage:${error.message}`;
                    //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    //  dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                });
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchStreamingServices', ex);
    }
}


export const updateSweetnerMsg = (products, serviceType, isChecked, offersInCart, lqState, buildProduct, visitId, dispatch, prodType) => {

    try {
        let SweetnerTxt = "";
        let splPromo = [];
        let splOffers = []
        let equipPromo = [];
        let previousPromos = [];
        let allCurrentOffers = [];
        let displayOffers = [];
        let sweetnerContent = {
            currentMsg: '',
            prevMsg: '',
            prevPromos: {
                INTERNET: null,
                TV: null
            },
            isDisplay: true
        };
        if (lqState && lqState.showMarvel) {
            showMarvel = true;
        }
        let splOfferInCart = "";
        let splOfferChoices = [];
        if (offersInCart && offersInCart.length) {
            if (serviceType === Service.internet || prodType === Service.internet) {
                splOfferInCart = offersInCart.filter(offer => getOffersFilter(offer, Service.data))[0];
            }
            else if (serviceType === Service.tv || prodType === Service.tv) {
                splOfferInCart = offersInCart.filter(offer => getOffersFilter(offer, Service.video))[0];
            }
            else if (serviceType === Service.splOffer && products?.offerFor?.toUpperCase() === Service.data) {
                splOfferInCart = offersInCart?.filter(offer => getOffersFilter(offer, Service.data));
            }
            else if (serviceType === Service.splOffer && products?.offerFor?.toUpperCase() === Service.tv) {
                splOfferInCart = offersInCart?.filter(offer => getOffersFilter(offer, Service.video))?.[0];
            }
        }
        if (serviceType === Service.internet || serviceType === Service.tv) {
            if (InHomeUtils.isNotNull(products.specialOffers) || InHomeUtils.isNotNull(products.equipmentOffers)) {
                if (InHomeUtils.isNotNull(products.specialOffers) && products.specialOffers.length > 0) {
                    splOffers = [...products.specialOffers];
                    //if(lqState && lqState.showStadia) {
                    if (serviceType === Service.internet || prodType === Service.internet) {
                        if (lqState && lqState.showStadia) {
                            //Remove reference to $100 card in stadia flow
                            splOffers = removeUnSelectedManualOffers(splOffers, OfferTypes.GoogleStadia + '_' + OfferTypes.Reward, Service.data, OfferTypes.GoogleStadia + '_' + OfferTypes.Reward);
                        }
                        if ((lqState && lqState.showMarvel) || hasMarvelProfile) {
                            splOffers = removeUnSelectedManualOffers(splOffers, OfferTypes.MarvelAvenger + '_' + OfferTypes.SpecialDiscount, Service.data, OfferTypes.MarvelAvenger + '_' + OfferTypes.SpecialDiscount);
                        }
                        // if((lqState && !lqState.showMarvel)|| !hasMarvelProfile){
                        //     splOffers = removeUnSelectedManualOffers(splOffers, Service.data, OfferTypes.Hulu);

                        // }
                        // if(isNC && (lqState && !lqState.showMarvel)){
                        //      splOffers = removeUnSelectedManualOffers(splOffers, OfferTypes.Hulu + '_' + OfferTypes.Reward, Service.data, OfferTypes.Hulu + '_' + OfferTypes.Reward);

                        // }

                        //Filter offers with manual choice and finally keep only the manually added offer
                        splOfferChoices = splOffers.filter((offer, index) => getOffersFilter(offer, Service.data, index))
                    }
                    else if (serviceType === Service.tv || prodType === Service.tv) {
                        splOffers = splOffers.filter(offer => offer.offerFor.toUpperCase() === Service.video);
                        //Filter offers with manual choice and finally keep only the manually added offer
                        splOfferChoices = splOffers.filter((offer, index) => getOffersFilter(offer, Service.video, index))
                    }
                    if (splOfferChoices.length > 1) {
                        // commented ITT-697269
                        let splOffers_check = splOffers.filter(x =>x.id == "R4139");
                        if(!splOffers_check){
                            splOffers = splOffers.filter(x => !splOfferChoices.includes(x));
                        }
                        
                        
                        
                        if (splOfferInCart) {
                            splOffers.unshift(splOfferChoices.filter(offer => splOfferInCart.offerAttrValue === offer.BsOfferAttrValue && splOfferInCart.offerFor.toUpperCase() === offer.offerFor.toUpperCase())[0]);
                        }
                    }

                    splOffers.forEach(offer => {
                        if (InHomeUtils.isNotEmpty(offer.offerFor) && InHomeUtils.isNotEmpty(offer.OfferText)) {
                            let promoOfferId = '';
                            let promoOfferText = '';
                            if (InHomeUtils.isNotNull(buildProduct.plansPromoFragments)) {
                                promoOfferId = offer.bsPromoId + '~' + offer.bsOfferId;
                            }
                            if (InHomeUtils.isNotEmpty(promoOfferId) && InHomeUtils.isNotNull(buildProduct.plansPromoFragments[promoOfferId]) && InHomeUtils.isNotEmpty(buildProduct.plansPromoFragments[promoOfferId].promo)) {
                                promoOfferText = buildProduct.plansPromoFragments[promoOfferId].promo;
                            } else if (InHomeUtils.isNotEmpty(offer.OfferText)) {
                                promoOfferText = offer.OfferText;
                            }

                            if ((serviceType === Service.internet && offer.offerFor.toUpperCase() === Service.data) || (serviceType === Service.tv && offer.offerFor.toUpperCase() === Service.video)) {
                                splPromo.push(promoOfferText);
                            }
                        }
                    });

                }
                if (InHomeUtils.isNotNull(products.equipmentOffers) && products.equipmentOffers.length > 0) {
                    products.equipmentOffers.forEach(offerId => {
                        if (offerId.indexOf(":") > -1) {
                            let promoApplicable = offerId.split(":")[0];
                            let promoOffer = offerId.split("|")[0];
                            if (InHomeUtils.isNotNull(buildProduct.plansPromoFragments[promoOffer]) && InHomeUtils.isNotNull(buildProduct.plansPromoFragments[promoOffer].promo)) {
                                if (serviceType === Service.internet && promoApplicable.toUpperCase().indexOf(Service.data) > -1) {
                                    equipPromo.push(buildProduct.plansPromoFragments[promoOffer].promo);
                                }
                                else if (serviceType === Service.tv && promoApplicable.toUpperCase().indexOf(Service.video) > -1) {
                                    equipPromo.push(buildProduct.plansPromoFragments[promoOffer].promo);
                                }
                            }
                        }
                    });
                    equipPromo = equipPromo.filter(o => o !== undefined && o !== null);
                }
                //Below code added to filter out verizon stream tv while stadia offer is there in blue ribbon
                if (splPromo.indexOf("Stadia Premiere Edition") > -1 && splPromo.indexOf("Verizon Stream TV") > -1) {
                    splPromo = splPromo.filter(e => e !== 'Verizon Stream TV');
                    allCurrentOffers = [... new Set([...splPromo, ...equipPromo])];
                }
                else if (lqState.showMarvel || hasMarvelProfile) {
                    if (splPromo.indexOf(offerText.marvelAvenger) > -1 && splPromo.indexOf(offerText.hulu12) > -1) {
                        splPromo = splPromo.filter(e => e !== offerText.hulu12);
                        allCurrentOffers = [... new Set([...splPromo, ...equipPromo])];
                    }
                    else {
                        allCurrentOffers = [... new Set([...splPromo, ...equipPromo])];
                    }
                }
                // else if(!lqState.showMarvel || !hasMarvelProfile){
                //     if(splPromo.indexOf(offerText.marvelAvenger)>-1 && splPromo.indexOf(offerText.hulu12)>-1){
                //         splPromo = splPromo.filter(e => e !== offerText.marvelAvenger);
                //         allCurrentOffers = [... new Set([...splPromo, ...equipPromo])];
                //     }
                // }
                else {
                    allCurrentOffers = [... new Set([...splPromo, ...equipPromo])];
                }
            }
            allCurrentOffers = allCurrentOffers.filter(o => offersInCart?.some(c => o?.includes(c?.OfferText) || c?.OfferText?.includes(o)));
            previousPromos = InHomeUtils.isNotNull(buildProduct.SweetnerMsg.prevPromos) && InHomeUtils.isNotNull(buildProduct.SweetnerMsg.prevPromos[serviceType]) ? buildProduct.SweetnerMsg.prevPromos[serviceType] : [];

           if (allCurrentOffers.length > 0 || previousPromos.length > 0) {
                if (previousPromos.length === 0 && allCurrentOffers.length > 0) {
                    displayOffers = allCurrentOffers.map(offer => { return `<strong>${offer}</strong>` });
                    SweetnerTxt = `${formatDisplayOffers(displayOffers)} has been added to your cart.`;  
                                
                    sweetnerContent.prevPromos[serviceType] = allCurrentOffers;
                   
                   
                }
                else if (previousPromos.length > 0) {
                    let addedOffers = allCurrentOffers.filter(x => !previousPromos.includes(x));
                    let removedOffers = previousPromos.filter(x => !allCurrentOffers.includes(x));
                    let unchangedOffers = allCurrentOffers.filter(x => previousPromos.includes(x));

                    if ((isChecked && previousPromos.length > 0) || allCurrentOffers.length === 0) {
                        SweetnerTxt = `${formatDisplayOffers(previousPromos)} have been removed from your shopping cart.`;
                        sweetnerContent.prevPromos[serviceType] = [];
                    }
                    else if (addedOffers.length === 0 && removedOffers.length > 0) {
                        SweetnerTxt = `${formatDisplayOffers(removedOffers)} have been removed from your shopping cart.`;
                        sweetnerContent.prevPromos[serviceType] = unchangedOffers && unchangedOffers.length ? unchangedOffers : [];
                    }
                    else if (addedOffers.length > 0) {
                        displayOffers = addedOffers.map(offer => { return `<strong>${offer}</strong>` });
                        SweetnerTxt = `${formatDisplayOffers(displayOffers)} has been added to your cart. ${removedOffers.length > 0 ? `(${formatDisplayOffers(removedOffers)} has been removed)` : ``}`;
                        sweetnerContent.prevPromos[serviceType] = unchangedOffers && unchangedOffers.length ? [...addedOffers, ...unchangedOffers] : addedOffers;
                    }
                }
                sweetnerContent.currentMsg = SweetnerTxt;
                sweetnerContent.isDisplay = true;
                SweetnerMsg(sweetnerContent, dispatch);
                // setTimeout(() => {
                //     sweetnerContent.isDisplay = false;
                //     SweetnerMsg(sweetnerContent, dispatch);
                // }, 7000);
                // sweetnerContent.isDisplay = false;
                // setTimeout(() => SweetnerMsg(sweetnerContent, dispatch), 7000);
            }
        }
        else if (serviceType === Service.splOffer) {
            if (splOfferInCart) {

                splOffers = prodType === Service.internet || prodType === Service.data ? buildProduct.internet.selectedProduct.specialOffers : prodType === Service.tv || prodType === Service.video ? buildProduct.tv.selectedProduct.specialOffers : [];
                let splOfferFor = prodType === Service.internet || prodType === Service.data ? Service.internet : prodType === Service.tv || prodType === Service.video ? Service.tv : "";
                //Filter offers with manual choice and finally keep only the manually added offer
                splOfferChoices = splOffers.filter(offer => getOffersFilter(offer, 'all',1))

                previousPromos = (InHomeUtils.isNotNull(buildProduct.SweetnerMsg.prevPromos) && InHomeUtils.isNotNull(buildProduct.SweetnerMsg.prevPromos[splOfferFor])) ? [...buildProduct.SweetnerMsg.prevPromos[splOfferFor]] : [];
                if (splOfferChoices.length > 1) {
                    let remainingsplOffers = splOfferChoices.filter(x => x.BsOfferAttrValue !== splOfferInCart.offerAttrValue);
                   // let cartsplOffer = splOfferChoices.filter(x => x.BsOfferAttrValue === splOfferInCart.offerAttrValue)[0];
                    // to show more than one offer in banner for cyber monday and black friday
                     let cyberMonArray = buildProduct?.internet?.m2mPlans?.filter(item => item?.id === "R3583" || item?.id === "R3582");
                     let isCyberMonday = cyberMonArray?.[0].specialOffers?.findIndex(item => ["R4139"].includes(item?.id))> -1 ? true : false;

                    let cartsplOffer = splOfferChoices?.filter(obj1=> splOfferInCart?.some(obj2 => obj1?.BsOfferAttrValue === obj2?.offerAttrValue));
                    cartsplOffer = cartsplOffer?.filter(obj1=> !previousPromos?.some(obj2 => obj1?.OfferText === obj2));
                    let previousSplOffer = remainingsplOffers?.filter(x => previousPromos?.includes(x?.OfferText));
                    // this code is only to handle scenarios in cyber monday offer
                    if(isCyberMonday) {
                        let xbox  = [];
                        xbox = previousPromos?.filter(obj1 => splOfferInCart?.some(obj2 => obj1 === obj2?.promoText && obj2?.promoId === "R4139"));
                    if(xbox?.length>0){
                        previousSplOffer = previousSplOffer?.filter(i => !xbox?.includes(i?.OfferText) && (i?.id == "R4140" || i?.id == "R4142"));;
                        previousPromos = previousPromos?.filter(obj1 => previousSplOffer?.some(obj2 => obj2?.OfferText !== obj1 && (obj2?.id == "R4140" || obj2?.id == "R4142")));
                    }
                    }
                    let cartOfferId = '';
                    let cartOfferText = [];
                    let prevOfferId = '';
                    let prevOfferText = [];
                    if (cartsplOffer) {
                    cartsplOffer?.forEach(offer => {
                       if (InHomeUtils.isNotNull(buildProduct?.plansPromoFragments)) {
                            cartOfferId = offer?.bsPromoId + '~' + offer?.bsOfferId;
                        }
                        if (InHomeUtils.isNotEmpty(cartOfferId) && InHomeUtils.isNotNull(buildProduct?.plansPromoFragments[cartOfferId]) && InHomeUtils.isNotEmpty(buildProduct.plansPromoFragments[cartOfferId]?.promo)) {
                            cartOfferText?.push(buildProduct?.plansPromoFragments[cartOfferId]?.promo);
                        } else if (InHomeUtils.isNotEmpty(offer?.OfferText)) {
                            cartOfferText?.push(offer?.OfferText);
                        }
                    })
                }

                    if (previousSplOffer) {
                        previousSplOffer?.forEach( item => {

                        if (InHomeUtils.isNotNull(buildProduct?.plansPromoFragments)) {
                            cartOfferId = cartsplOffer?.bsPromoId + '~' + cartsplOffer?.bsOfferId;
                            prevOfferId = item?.bsPromoId + '~' + item?.bsOfferId;
                        }
                        if (InHomeUtils.isNotEmpty(cartOfferId) && InHomeUtils.isNotNull(buildProduct?.plansPromoFragments[cartOfferId]) && InHomeUtils.isNotEmpty(buildProduct?.plansPromoFragments[cartOfferId]?.promo)) {
                            cartOfferText?.push(buildProduct?.plansPromoFragments[cartOfferId]?.promo);
                        } else if (InHomeUtils.isNotEmpty(cartsplOffer?.OfferText)) {
                            cartOfferText?.push(cartsplOffer?.OfferText);
                        }
                        if (InHomeUtils.isNotEmpty(prevOfferId) && InHomeUtils.isNotNull(buildProduct?.plansPromoFragments[prevOfferId]) && InHomeUtils.isNotEmpty(buildProduct?.plansPromoFragments[prevOfferId]?.promo)) {
                            prevOfferText?.push(buildProduct?.plansPromoFragments[prevOfferId]?.promo);
                        } else if (InHomeUtils.isNotEmpty(item?.OfferText)) {
                            prevOfferText?.push(item?.OfferText);
                        }
                    })

                    }
                    cartOfferText?.forEach(offerText => {
                        if (offerText!= '' && !previousPromos?.includes(offerText)) {
                            previousPromos?.push(offerText);
                        } 
                        else {
                                previousPromos = previousPromos?.map(offer => {
                                    return (offer === prevOfferText) ?
                                        offerText : offer;
                                });    
                            }
                    })
                    //let prevPromos = {...buildProduct.SweetnerMsg.prevPromos, [prodType] : previousPromos}
                    sweetnerContent = { ...buildProduct.SweetnerMsg, prevPromos: { ...buildProduct.SweetnerMsg.prevPromos, [splOfferFor]: previousPromos } }
                    let displaySPOfferMessage = `<strong>${formatDisplayOffers(cartOfferText)}</strong>`;
                    let suffix = '';
                    let prefix = '';
                    if(cartOfferText?.length == 1) {
                        suffix = ' has been added to your cart.';
                    } else if (cartOfferText?.length > 1) {
                        suffix = ' have been added to your cart.';
                    }
                    if(prevOfferText?.length == 1) {
                        prefix = ' has been removed.'
                    } else if (prevOfferText?.length > 1) {
                        prefix = ' have been removed.'
                    }
                    let SweetnerSPOfferMessage = `${displaySPOfferMessage}`+suffix+`${prevOfferText?.length>0 ? " <strong>" + formatDisplayOffers(prevOfferText) + "</strong>"+ prefix : ""}`;
                   
                    sweetnerContent.currentMsg = SweetnerSPOfferMessage;
                    sweetnerContent.isDisplay = true;
                    SweetnerMsg(sweetnerContent, dispatch);
                    
                }
            }
        }
        setTimeout(() => {

            if(sweetnerContent.currentMsg.includes("Amazon Fire HD 8 Plus tablet")){
                
                sweetnerContent.isDisplay = true;
            }else{
                sweetnerContent.isDisplay = false;
            }  
            SweetnerMsg(sweetnerContent, dispatch);
        }, 7000);
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'tile_updateSweetnerMsg', ex);
    }
}

export const formatDisplayOffers = (offers) => {
    let displayText = '';
    let lastOffer = '';
    if (InHomeUtils.isNull(offers) || offers.length === 0)
        return displayText;
    if (offers.length <= 2) {
        displayText = offers.join(' and ');
    }
    else if (offers.length > 2) {
        lastOffer = offers.pop();
        displayText = offers.join(', ');
        displayText += ' and ' + lastOffer;
    }
    return displayText;
}
export const suppressinter = (isSupInter, dispatch) => {

    dispatch({ type: 'MNH_SUPPRESSINTERSTITIAL', value: isSupInter });
}
export const suppressinterinvoke = (isSupInvoke, dispatch) => {

    dispatch({ type: 'MNH_SUPPRESSINVOKE', value: isSupInvoke });
}
export const upsellbanner = (isupsellbanner, dispatch) => {

    dispatch({ type: 'MNH_UPSELL_BANNER', value: isupsellbanner });
}

export const addEquipment = (discount, addonProduct, isChecked, buildProduct) => {
    let freeProduct = [];
    switch (discount) {
        case EquipmentDiscounts.router:
        case Service.router:
        case EquipmentDiscounts.routerEmp:
        case EquipmentDiscounts.whw:
            if (InHomeUtils.isNotNull(buildProduct.router.equipments)) {
                if (buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.indexOf('|Display:ACQ:1G_500MAtNonGigAddr|') > -1).length > 0) {
                    freeProduct = buildProduct.router.equipments.filter(p => (p.prodType === 'ROUTERBILLER' || p.prodType === 'ACCESSPOINTBILLER') && (p.keyword !== null && p.keyword.indexOf('|Display:ACQ:1G_500MAtNonGigAddr|') > -1) && p.originalPrice !== '0.00')[0];
                    // dispatch({ type: 'ADDON_PRODUCTS', value: freeProduct.prodType });
                }
                else {
                    if (buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.indexOf('|CHR|') > -1).length > 0) {
                        freeProduct = buildProduct.router.equipments.filter(p => (p.prodType === 'ROUTERBILLER' || p.prodType === 'ACCESSPOINTBILLER') && (p.keyword !== null && p.keyword.indexOf('|BHRX|') > -1) && p.originalPrice !== '0.00')[0];
                        // dispatch({ type: 'ADDON_PRODUCTS', value: freeProduct.prodType });
                    }
                    else if (buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.indexOf('|CHR|') === -1 && p.originalPrice !== '0.00').length > 0) {
                        freeProduct = buildProduct.router.equipments.filter(p => (p.prodType === 'ROUTERBILLER' || p.prodType === 'ACCESSPOINTBILLER') && (p.keyword === null || p.keyword !== null && p.keyword.indexOf('|BHRX|') === -1) && p.originalPrice !== '0.00' && p.displayPrice.indexOf("$0") > -1)[0];
                        //dispatch({ type: 'ADDON_PRODUCTS', value: freeProduct.prodType });
                    }
                }

                if (freeProduct && (InHomeUtils.isNull(buildProduct.router.selectedProduct) || (InHomeUtils.isNotNull(buildProduct.router.selectedProduct) && buildProduct.router.selectedProduct.id !== freeProduct.id))) {
                    addonProduct.productInCart.push(freeProduct);
                    addonProduct.prodType.push(Service.router);
                    addonProduct.isRemoved.push(isChecked);
                    //dispatch({ type: 'ADDON_PRODUCTS', value: freeProduct.prodType });
                }
            }
            break;
        case EquipmentDiscounts.vRoom:
        case EquipmentDiscounts.vRoomEmp:
            if (InHomeUtils.isNotNull(buildProduct.vRoom.equipments)) {
                freeProduct = buildProduct.vRoom.equipments.filter(p => p.unitCount === '1')[0];
                if (freeProduct && (InHomeUtils.isNull(buildProduct.vRoom.selectedProduct))) {
                    addonProduct.productInCart.push(freeProduct);
                    addonProduct.prodType.push(Service.vRoom);
                    addonProduct.isRemoved.push(isChecked);
                }
            }
            break;
        case EquipmentDiscounts.recording:
        case EquipmentDiscounts.recordingEmp:
            if (InHomeUtils.isNotNull(buildProduct.recording.equipments)) {
                freeProduct = buildProduct.recording.equipments.filter(p => p.prodTypeValue === 'HD-DVR')[0];
                if (freeProduct && (InHomeUtils.isNull(buildProduct.recording.selectedProduct) || (InHomeUtils.isNotNull(buildProduct.recording.selectedProduct) && buildProduct.recording.selectedProduct.id !== freeProduct.id))) {
                    addonProduct.productInCart.push(freeProduct);
                    addonProduct.prodType.push(Service.recording);
                    addonProduct.isRemoved.push(isChecked);
                }
            }
            break;
        case EquipmentDiscounts.recordingEmpMM2:
            if (InHomeUtils.isNotNull(buildProduct.recording.equipments)) {
                freeProduct = buildProduct.recording.equipments.filter(p => p.prodTypeValue === 'EM-DVR')[0];
                if (freeProduct && (InHomeUtils.isNull(buildProduct.recording.selectedProduct) || (InHomeUtils.isNotNull(buildProduct.recording.selectedProduct) && buildProduct.recording.selectedProduct.id !== freeProduct.id))) {
                    if (addonProduct.productInCart && addonProduct.productInCart.findIndex(x => x.id == freeProduct.id) == -1) {
                        addonProduct.productInCart.push(freeProduct);
                        addonProduct.prodType.push(Service.recording);
                        addonProduct.isRemoved.push(isChecked);
                    }
                }
            }
            break;
        default: break;
    }
}

export const updateCart = (visitId, lqState, product, prodType, isChecked, dispatch, voiceTn, firstBill,
    addonProduct, contract, selectedCoreServices, isLocalTVInCart = false,
    isDCTinCart = false, upsellInfo, buildProductState,
    equipmentState = null, flowType, cloudAccStatus, isMaxSpeedApplied = false , defaultProductadded = false, triggeredFromCta = false, selectPopularPlans = false) => {
    
        
    try {  
        let splOffers = {};
        if(prodType === Service.internet) {
            splOffers = product?.specialOffers;
        }
        let isStreamline =  lqState?.streamlineLQ  || false;
        const SuppressDuplicateCalls = lqState?.runtimeKey?.SuppressDuplicateCalls ? lqState.runtimeKey.SuppressDuplicateCalls: '';
        if(product.name && product.name.toLowerCase().indexOf("gigabit") > -1 && !(upsellInfo && upsellInfo.isUpsell)){
            isTagGspeed = true;
            if(product.planPerks){
            dispatch({type : 'MM3INTERNETSUBPROD',value : product.planPerks});
            }
        }
        if(prodType == "ROUTER"){
            isTagGspeed = false;
        }
        if (flowType === "SUPP" && isChecked === true && (prodType === Service.internet || prodType === Service.tv || prodType === Service.voice)) {
            return;
        }
        if (prodType === 'CUSTOMTV' && isChecked === false) {
            dispatch({ type: 'UPDATE_RECOMMENDED_TV', value: '' });
        }
        if (prodType === "CUSTOMROUTER" && product.prodType !== "CUSTOMROUTER") {
            prodType = "ROUTER";
        }
        let bfEnable = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.isbfpromo
        let bfSelectedProd = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.flashoffer && store.getState().buildProduct.flashoffer.selectedProduct
        if(prodType === "FTTPD" || prodType === "INTERNET") {
            dispatch({ type: 'BF_PROMOS', value: null});
        }else {
            if(bfEnable && !InHomeUtils.isNotNull(bfSelectedProd)){
                dispatch({ type: 'FLASHOFFER_SELECTEDPRODID', value: null});
            }else{
                dispatch({ type: 'FLASHOFFER_SELECTEDPRODID', value: bfSelectedProd ? bfSelectedProd : 'no value'});
            }
        }
        
        let cartProducts = "";


        let Mergescevent  = (InHomeUtils.isNotNull(lqState) && lqState.runtimeKey && lqState.runtimeKey.Mergescevent  && lqState.runtimeKey.Mergescevent  === "Y") ? "Y" : "N";
        vcloud = (InHomeUtils.isNotNull(lqState) && lqState.runtimeKey && lqState.runtimeKey.vcloud && lqState.runtimeKey.vcloud === "Y") ? "Y" : "N";
        let enableFdvStandalone = (InHomeUtils.isNotNull(lqState) && lqState.runtimeKey && lqState.runtimeKey.enableFdvStandalone && lqState.runtimeKey.enableFdvStandalone === "Y") ? "Y" : "N";
        let changeprodtype = (product.prodType === "OTTBASIC" && product.prodTypeValue === Service.slingtv) ? "OTTBASIC" : "";
        let vcpestbQty = '';
        let isFCPflow = false;
        let addlInfo = {
            isDoFlow: lqState && InHomeUtils.isNotNull(lqState.doFlowDetails) ? lqState.doFlowDetails.isDoFlow : false,
            zip: lqState && InHomeUtils.isNotNull(lqState.selectedState) ? lqState.selectedState.zip : null,
            tarCode: lqState && lqState.tarCode,
            state: lqState && lqState.selectedState && lqState.selectedState.state,
            couponFlowType: lqState && lqState.couponFlowType,
            EquipmentState: equipmentState,
            masterpackageview: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.masterpackageview) ? buildProductState.tv.masterpackageview : [],
            selectedProductId: '',
            isFCPflow: lqState && lqState.isFCPflow,
            isAlaCarte: product.isAlaCarte,
            flowType: flowType,
            servicesQualified: lqState && InHomeUtils.isNotNull(lqState.servicesQualified) ? lqState.servicesQualified : null,
            regionId: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveSearchVhoParams) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveSearchVhoParams.regionId) ? buildProductState.tv.fiosFiveSearchVhoParams.regionId : ''
        }
        isFCPflow = lqState && lqState.isFCPflow ? lqState.isFCPflow: false;
        if (InHomeUtils.isNull(upsellInfo)) {
            upsellInfo = { isUpsell: false }
        }

        let isSubSectionsValid = false;
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCart', "Inside updateCart"));
        if (upsellInfo.isUpsell) {
            modalAction.closeModalWindow("UPSELL", dispatch);
        }
        const nrTimeData = getNRCurrentTime('BuildProducts:UpdateCart', dispatch);
        window.nrTimeState = nrTimeData;

        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart", isLoaderImg: "loader" } });
        dispatch({ type: 'SET_CART_DIRTY', value: true });


        if (prodType === Service.winBack || product.id === 'CUST') {
            if (!isChecked) {
                if (!upsellInfo.isUpsell) {
                    scClickEventProduct(product, prodType);
                }
                if (product.id === Service.winBackNo) {
                    tempSCData.pageName = addlInfo.isDoFlow ? "do accord" : "byob";
                    tempSCData.detailPageName = (addlInfo.isDoFlow ? "do accord" : "byob") + "| phone| add your existing phone number";
                    tempVzdlSCData.detail = "add your phone number";
                    if (flowType == "MV") {
                        tempSCData.customerCategory = "^Moves^";
                        tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                        updateSCcustomEvent("cartAddServiceMoves", "ddAddToCartEvent", "detailPageName,pageName,contentChannel")
                    }
                    else {
                        updateSCcustomEvent("cartAddService", "ddAddToCartEvent", "detailPageName,pageName");
                        updateVzdlSCCustomEvent("winBackPage", "pageViewOmni", "detail");
                    }
                }
            }
            dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });
            // if (prodType === 'TV' && isChecked) {
            //     dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: null });
            // }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
        else {
            if (!isChecked && product.prodTypeValue !== "CUSTOMER_PROVIDED_ROUTER") {
                if (!upsellInfo.isUpsell && triggeredFromCta === false && selectPopularPlans === false) {
                    if(prodType === Service.recording){
                        setTimeout(() => {
                            updateDetailValue('Add your recording service');
                            scClickEventProduct(product, prodType, isChecked);
                        }, 2000);
                    }
                    else{
                        scClickEventProduct(product, prodType, isChecked);
                    }
                }
                if (prodType === Service.router) {
                    customRouterCheck(true, dispatch);
                }
            }else if(isChecked && product.prodTypeValue !== "CUSTOMER_PROVIDED_ROUTER"){
                scClickEventProduct(product, prodType, isChecked);

            }

            let url = "";
            let eventAction = "";
            let eventValue = "";
            let request = "";
            let utdClearCart = false;
            let clearTVsubprods = false;
            let clearStreamServ = false;
            if ((prodType === Service.internet || prodType === Service.tv || prodType === Service.voice) && isChecked && product.prodType !== Service.streamServ) {
                if (enableFdvStandalone === 'N' && selectedCoreServices === 'FIOS_VOICE') {
                    selectedCoreServices = '';
                }
                else if ((InHomeUtils.isNotNull(buildProductState) && (InHomeUtils.isNotNull(buildProductState.tv)) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && buildProductState.tv.selectedProduct.prodTypeValue === 'ULTIMATETESTDRIVE' && prodType !== Service.tv && selectedCoreServices.indexOf(Service.video) > -1 && (selectedCoreServices.split(",").length === 2 || (selectedCoreServices.split(",").length === 3 && prodType === 'TV')))) {
                    selectedCoreServices = '';
                    utdClearCart = true;
                }
                else if (enableFdvStandalone === 'N' && (selectedCoreServices.split(",").length === 2 && selectedCoreServices.indexOf(Service.voice) > -1 && prodType !== Service.voice)) {
                    selectedCoreServices = '';
                }
                else if (prodType === Service.tv) {
                    clearTVsubprods = true;
                }
                if (prodType === Service.internet && isChecked && InHomeUtils.isNotNull(buildProductState) && (InHomeUtils.isNotNull(buildProductState.tv)) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && buildProductState.tv.selectedProduct.prodType === Service.streamServ) {
                    clearStreamServ = true;
                }
                url = apiUrl().clearCart + '/' + visitId;
                request = getClearCartRequest(prodType, selectedCoreServices);
            }
            else {
                url = apiUrl().updateCartAcc + '/' + visitId;
                let reqcontract = (contract === ContractConstants.twoYear) ? ContractConstants.twoYearInWords : ContractConstants.monthToMonth;

                let coreService = false;
                if (prodType === Service.internet || prodType === Service.tv || prodType === Service.customTV || prodType === Service.voice) {
                    coreService = true;
                }
                if (!coreService) {
                    reqcontract = ContractConstants.monthToMonth;
                }
                request = (prodType === 'TECHSURE') ? getStdRequest(reqcontract, product, 'VAS', isChecked, selectedCoreServices, voiceTn, flowType,buildProductState) : product.bundleId ?
                    getBundleRequest(reqcontract, product, prodType, isChecked, voiceTn, selectedCoreServices, isLocalTVInCart, isFCPflow, flowType, lqState, buildProductState) : getStdRequest(reqcontract, product, prodType, isChecked, selectedCoreServices, voiceTn, flowType, buildProductState)
                
            }

            if (lqState && !lqState.cartFirstAddition)
                eventValue = "scOpen,scAdd"
            else
                eventValue = isChecked ? "scRemove" : "scAdd"
            eventAction = isChecked ? "RemovefromCart" : "AddtoCart";
            const dispatchActions = [];
            let isRouterAPIInvoked = false;
            return new Promise((resolve, reject) => {
                api(url, 'POST', request).then(response => {
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                        const perfChangesEnabled = lqState?.runtimeKey?.EnableDispatchPerfChanges === 'Y';
                        const splOfferPerfChangesEnabled = lqState?.runtimeKey?.EnableSplOfferPerfChanges === 'Y';
                        const chatRequestIdleEnabled = lqState?.runtimeKey?.EnableChatRequestIdle === 'Y';
                        const SuppressPopularPlanCalls = lqState?.runtimeKey?.SuppressPopularPlanCalls === 'Y';
                        const isPopularPlanPage = SuppressPopularPlanCalls && window?.location?.href?.includes('inhome/popularPlans?isPerf=y');
                        if (perfChangesEnabled) {
                            dispatchActions.push({ type: CheckOut.productChangedResetDueDate, value: "" });
                        } else {
                            dispatch({ type: CheckOut.productChangedResetDueDate, value: "" });
                        }

                        if (perfChangesEnabled && isStreamline && prodType === Service.internet) {
                            fetchRouter(dispatch, visitId, flowType, 0, false, lqState, voiceTn, buildProductState, null, true);
                            isRouterAPIInvoked = true;
                        }
                        if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && response.data.cartTierPricing.tierContent.length > 0) {
                            let slogtext = !isChecked ? "ADDED" : "REMOVED";
                            const servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.servicesOrdered) ? response.data.orderDetail.servicesOrdered : '';
                            if(splOfferPerfChangesEnabled) {
                                triggerSpecialOffers(response.data.cartTierPricing, servicesInCart);
                            }
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', prodType + "-" + slogtext + "|CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));

                            try {
                                if (InHomeUtils.isNotEmpty(response.data.vcpestbQty)) {
                                    vcpestbQty = response.data.vcpestbQty;
                                }
                                if (InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections) && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0])
                                    && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections)
                                    && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection)
                                    && response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.length > 0) {
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, PAGEACTIVITY.UA));
                                    isSubSectionsValid = true;
                                }
                            }
                            catch (ex) {
                                catchJSException(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'updateCart', ex);
                            }
                        }
                        else {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART TIER CONTENT EMPTY", PAGEACTIVITY.UA));
                        }
                        
                        dispatch({
                            type: "UPDATE_CART",
                            value: {
                                cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                                cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                                cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                                cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail,
                                cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty,
                                chatRequestIdleEnabled: chatRequestIdleEnabled
                            }
                        });
                        performance.mark("After UPDATE_CART");

                        /* Disney perk promo changes -- planned during Oct 7th, 2024 to Nov 6th, 2024
                          For disney perk promo changes
                        */
                       if(prodType === Service.internet || prodType === Service.tv) {
                            const promoSection = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(p => p?.sectionName === CartServices.Promotions);
                            const offers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === 'Offers' || sec?.sectionType === 'SpecialOffers');
                            let disneyPromoEligible = false;
                            let netmaxEligible = false;
                            offers?.promos?.forEach(promo => {
                                if(promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_TRACKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_MARKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT') {
                                    disneyPromoEligible = true;
                                }
                                if(promo?.offerAttrValue ==='NETMAX_PERK_DISCOUNT' || promo?.offerAttrValue ==='NETMAX_PERK_MARKER'){
                                    netmaxEligible  = true;  
                                }
                            });
                            if (perfChangesEnabled) {
                                dispatchActions.push({
                                  type: "UPDATE_PROMO_PRESENT",
                                  value: {
                                    disneyPromoEligible: disneyPromoEligible,
                                    netmaxEligible: netmaxEligible,
                                  },
                                });
                              } else {
                                dispatch({ type: "DISNEY_PROMO_PRESENT", value: disneyPromoEligible });
                                dispatch({ type: "NETMAX_PROMO_PRESENT", value: netmaxEligible });
                              }
                            // Checks special offers in cart and removes selected special offer if update cart does not have the special offer
                            const specialOffers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === CartServices.specialoffer);
                            const hasCartOffer = specialOffers?.promos?.some(promo =>
                                (promo?.id && (buildProductState?.sploffer?.selectedProduct?.id === promo?.id || buildProductState?.sploffer?.selectedProduct?.promoId !== promo?.id))
                                || (promo?.promoId && (buildProductState?.sploffer?.selectedProduct?.id === promo?.promoId || buildProductState?.sploffer?.selectedProduct?.promoId === promo?.promoId))
                            );
                            if(!['R3584', 'R3582', 'R3583']?.includes(product?.id) && prodType === Service.internet){
                                if(perfChangesEnabled) { 
                                    dispatchActions.push({ type: 'SPLOFFER_SELECTEDPRODID', value: null });
                                } else { 
                                    dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: null });
                                }
                            }
                            if (!hasCartOffer) {
                                if (prodType === Service.internet) {
                                    if(perfChangesEnabled)
                                        {
                                            dispatchActions.push({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: null });
                                        } else {
                                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: null });
                                        }
                                } else if (prodType === Service.tv) {
                                    dispatch({ type: 'SPLOFFER_SELECTEDPRODID_TV', value: null });
                                }
                                if(perfChangesEnabled)
                                {
                                    dispatchActions.push({ type: 'SPLOFFER_SELECTEDPRODID', value: null });
                                } else {
                                    dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: null });
                                }
                            }
                        }

                        if (InHomeUtils.isNotNull(response.data.atvQual) && response.data?.atvQual == true) {
                            if(perfChangesEnabled)
                                {
                                    dispatchActions.push({type : 'ANDROID_TV_STB',value : true});
                                } else {
                                    dispatch({type : 'ANDROID_TV_STB',value : true})
                                }
                        }
                        else{
                            if(perfChangesEnabled)
                                {
                                    dispatchActions.push({type : 'ANDROID_TV_STB',value : false});
                                } else {
                                    dispatch({type : 'ANDROID_TV_STB',value : false})
                                }
                        }
                        if(prodType === Service.internet && product)
                        {
                            /* To set system enabled netmax flag to false if user switches data to non-gig
                                and remove netmax perk if it's already selected
                                R3584 - max 500
                                R3582 - 2 gig
                                R3583 - 1 gig
                            */
                            if(!['R3584', 'R3582', 'R3583']?.includes(product?.id) && buildProductState?.perks?.netMaxOfferToggle) {
                                if(buildProductState?.perks?.selectedProduct?.find(prod => prod?.prodId === 'R3559')) {
                                    updatePerkSelection({ prodId: 'R3559', add: true, dispatch, visitId, offerToggle: false, buildProductState });
                                }
                            }
                            if(InHomeUtils.isNull(product.planPerks))
                            {
                                if(perfChangesEnabled)
                                    {
                                        dispatchActions.push({type : 'FETCH_DATASUBPROD',value : null});
                                    } else {
                                        dispatch({type : 'FETCH_DATASUBPROD',value : null})
                                    }
                            }
                        }
                        if((prodType === Service.internet || prodType === Service.data) && product && product.planPerks && !upsellInfo.isUpsell)
                        {
                            if((!isStreamline && !isPopularPlanPage) || SuppressDuplicateCalls.indexOf('router') === -1) fetchRouter(dispatch, visitId, flowType);
                            if(perfChangesEnabled)
                                {
                                    dispatchActions.push({type : 'FETCH_DATASUBPROD',value : product.planPerks});
                                    dispatchActions.push({ type: "MM3_SELECTEDPROD", value: null });
                                } else {
                                    dispatch({type : 'FETCH_DATASUBPROD',value : product.planPerks})
                                    dispatch({ type: "MM3_SELECTEDPROD", value: null })
                                }
                        }
                        else if(prodType  === "MM3")
                        {
                            dispatch({type:"MM3_SELECTEDPROD",value : product})
                        }
                        if (flowType === "SUPP") {
                            let suppProfileCartStatus = store && store.getState && store.getState().supp && store.getState().supp.suppProfileCartStatus;
                            let searchTerm = (prodType === Service.internet && product?.speedCode) ? `"speedCode":${product?.speedCode}` : (product?.id || product?.prodId);
                            if (prodType === 'TECHSURE' || prodType === Service.channel) {
                                suppProfileCartStatus[prodType + '_' + searchTerm] = getProductStatus(searchTerm, isChecked, prodType) //productStatus;
                            } else {
                                suppProfileCartStatus[prodType] = getProductStatus(searchTerm, isChecked, prodType) //productStatus;
                            } // }
                            dispatch({
                                type: "UPDATE_PROFILE_CART_STATUS",
                                value: suppProfileCartStatus
                            });
                        }
                        if(perfChangesEnabled) {
                            dispatchActions.push({
                                type: CheckLQ.cartFirstAddition,
                                value: true
                            });
                        } else {
                            dispatch({
                                type: CheckLQ.cartFirstAddition,
                                value: true
                            });
                        }
                        DispatchSelectedCoreService(response.data.orderDetail, dispatch)
                        cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }) //No need to wait loader for backend work process prefetch call so close loader here...
                        if (perfChangesEnabled) {
                            dispatch(batchActions(dispatchActions));
                        }
                        let servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.servicesOrdered) ? response.data.orderDetail.servicesOrdered : '';
                        isLocalTVInCart = (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") ? true : false;
                        if (upsellInfo.isUpsell) {
                            dispatch({ type: BuildProduct.upsellCTA, value: { isUpsellAddedToCart: true, isUpsellDenied: false } });
                            let contract = response.data.orderDetail.contract === 'MTM' ? response.data.orderDetail.contract : '2YR';
                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCart', "updating Contract for SC - " + contract));
                            updatecontractforSC(contract, response.data.orderDetail.bundle, dispatch, addlInfo.couponFlowType)
                            
                            if (!upsellInfo.isUpsellAddonProduct && upsellInfo.redirectToCheckout) {
                                dispatch({ type: BuildProduct.checkoutBtnSelection, value: true });
                            }
                            else if (upsellInfo.isUpsellAddonProduct && upsellInfo.redirectToCheckout) {
                                if (upsellInfo.upsellAddonProduct && upsellInfo.upsellAddonProduct.name && upsellInfo.upsellAddonProduct.name.indexOf("Whole-Home Wi-Fi") > -1) {
                                    dispatch({ type: BuildProduct.checkoutBtnSelection, value: true });
                                }
                                else if (upsellInfo.upsellAddonProduct && upsellInfo.upsellAddonProduct.length>0 && upsellInfo.upsellAddonProduct[0].name && upsellInfo.upsellAddonProduct[0].name.indexOf("Whole-Home Wi-Fi") > -1){
                                    dispatch({ type: BuildProduct.checkoutBtnSelection, value: true });
                                }
                            }
                            if (!upsellInfo.isUpsellAddonProduct) {
                                doPrefetch("UPSELL", dispatch, visitId, addlInfo, contract, selectedCoreServices, false, isLocalTVInCart, '', '', false, servicesInCart, buildProductState);
                                let additionalInfo = { flowType: '', isUpsell: upsellInfo.isUpsell, couponFlowType: addlInfo.couponFlowType, orderType: flowType, vcpestbQty: vcpestbQty };
                                PreselectCartProducts(cartProducts, dispatch, visitId, additionalInfo, null, buildProductState, lqState, upsellInfo.cart, addlInfo.servicesQualified);
                            }
                            let dataPerkProduct = cartProducts && cartProducts.DataProduct && cartProducts.DataProduct.dataProd && cartProducts.DataProduct.dataProd.filter(prod => prod.prodTypeVal === 'STREAMING' || prod.prodTypeVal === 'GAMING' || prod.prodTypeVal === 'COMPLETE' );
                            if ( InHomeUtils.isNotNull(dataPerkProduct) && dataPerkProduct !== undefined && dataPerkProduct) {                            
                                setDataPerksForSCFlows(response.data.cartTierPricing,buildProductState,flowType, visitId, dispatch)
                                }                                             
                            if (upsellInfo.isUpsellAddonProduct) {
                                upsellInfo.isUpsellAddonProduct = false;
                            }
                        }
                        
                        if(upsellInfo.isUpsell && upsellInfo.upsellProducts.length > 0){
                            let productsSO = upsellInfo.upsellProducts.filter(prod => prod.prodType === 'FTTPD');
                            productsSO.map(prods => {
                                processOfferSection(prods)
                            })
                        }
                        if (perfChangesEnabled) {
                            dispatch({
                              type: "CART_UPDATE",
                              value: {
                                isCartUpdated: true,
                                isCartSaveOnUpdate: true,
                              },
                            });
                          } else {
                            dispatch({ type: "ISCARTUPDATED", value: true });
                            dispatch({ type: "CART_SAVE_ON_UPDATE", value: true });
                          }
                        if (flowType === "SUPP") {
                            let updatedSuppProfileCartStatus = store && store.getState && store.getState().supp && store.getState().supp.suppProfileCartStatus;
                            let suppCartupdateStatus = false;
                            if (JSON.stringify(updatedSuppProfileCartStatus).indexOf("ADDED") > -1 || JSON.stringify(updatedSuppProfileCartStatus).indexOf("REMOVED") > -1) {
                                suppCartupdateStatus = true;
                            }
                            dispatch({
                                type: "UPDATE_CART_SUPP",
                                value: suppCartupdateStatus
                            });
                        }

                        //var cartJson = require('./../containers/cart/sampleCartJson.json'); 
                        if (isSubSectionsValid && prodType === Service.channel) {
                            let premiumChannels = [];
                            let channel = response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.filter(p => p.sectionType === Service.channel);
                            if (InHomeUtils.isNotNull(channel) && channel.length > 0 && InHomeUtils.isNotNull(channel[0]) && InHomeUtils.isNotNull(channel[0].products)) {
                                premiumChannels = channel[0].products.filter(p => !p.prodType.includes('INTLPREMIUM'));
                            }
                            dispatch({ type: prodType + '_SELECTEDPROD', value: premiumChannels.length > 0 ? premiumChannels : null });
                        }
                        else if (isSubSectionsValid && prodType === Service.intrnlChnl) {
                            let internationalChannels = [];
                            let intrnlchannel = response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.filter(p => p.sectionType === Service.internationalPackageCart);
                            if (InHomeUtils.isNotNull(intrnlchannel) && intrnlchannel.length > 0 && InHomeUtils.isNotNull(intrnlchannel[0]) && InHomeUtils.isNotNull(intrnlchannel[0].products)) {
                                internationalChannels = intrnlchannel[0].products.filter(p => p.prodType.includes('INTLPREMIUM'));

                            }
                            dispatch({ type: prodType + '_SELECTEDPROD', value: internationalChannels.length > 0 ? internationalChannels : null });
                        }
                        else if (prodType === Service.vRoom || prodType === Service.dummyvRoom || prodType === Service.ceAppsParity || prodType === Service.ceAppsBundle) {
                            let vRoom = null;
                            let dummyvRoom = null;
                            let ceApps = null;
                            let equipmentSection = response.data.cartTierPricing.tierContent[0].sections.section.filter(s => s.sectionName && s.sectionName.toUpperCase().includes('EQUIP'));
                            let tvConnProds = equipmentSection && equipmentSection.length ? equipmentSection[0].subSections.subSection.filter(p => p.sectionType === Service.setupbox) : [];
                            if (InHomeUtils.isNotNull(tvConnProds) && tvConnProds.length > 0 && tvConnProds[0] && tvConnProds[0].products && tvConnProds[0].products.length) {
                                vRoom = tvConnProds[0].products.filter(p => p.prodType === Service.vRoom);
                                ceApps = tvConnProds[0].products.filter(p => p.prodType === Service.ceAppsParity || p.prodType === Service.ceAppsBundle);
                                dummyvRoom = tvConnProds[0].products.filter(p => p.prodType === Service.dummyvRoom);
                                vRoom = vRoom && vRoom.length ? vRoom[0] : null;
                                ceApps = ceApps && ceApps.length ? ceApps[0] : null;
                                dummyvRoom = dummyvRoom && dummyvRoom.length ? dummyvRoom[0] : null;
                                if ((prodType === Service.ceAppsParity || prodType === Service.ceAppsBundle) && ceApps && product) {
                                    if (product.fromTVConnections) {
                                        ceApps['fromTVConnections'] = true;
                                    }
                                    else if (product.fromCEApps) {
                                        ceApps['fromCEApps'] = true;
                                    }
                                }
                                if (prodType === Service.vRoom || vRoom.unitCount !== buildProductState.vRoom.unitCount) {
                                    if (buildProductState.showConnectedApps) {
                                        dispatch({ type: Service.vRoom + '_SELECTEDPROD_CEAPPS', value: { vRoom, ceApps, dummyvRoom } });
                                    }
                                    else {
                                        dispatch({ type: Service.vRoom + '_SELECTEDPROD', value: vRoom });
                                    }
                                }

                                let isFiosOrMundoTv = ceApps;
                                // if(!buildProductState.ceApps.isAccordionOpen && (buildProductState.ceApps.selectedProduct === null || buildProductState.ceApps.selectedProduct === '') && (buildProductState?.tv?.selectedProduct?.id !== "R3377" && buildProductState?.tv?.selectedProduct?.id !== "R3375")){
                                //     isFiosOrMundoTv = null;
                                // }
                                
                               
                                dispatch({ type: Service.ceAppsParity + '_SELECTEDPROD', value: { vRoom, ceApps: isFiosOrMundoTv, dummyvRoom } });
                                
                                
                                dispatch({ type: Service.dummyvRoom + '_SELECTEDPROD', value: { vRoom, ceApps: isFiosOrMundoTv, dummyvRoom } });
                                 

                                // Saving Default CeApps data for default selection when TV option is changed
                                // if(ceApps !== null && ceApps.prodId === 'R0529') {
                                //     dispatch({ type: 'DEFAULT_CEAPPS_RESPONSE', value: { ceApps }});
                                // }
                                if (prodType === Service.vRoom || prodType === Service.dummyvRoom || prodType === Service.ceAppsParity || prodType === Service.ceAppsBundle)
                                    fetchRecording(dispatch, visitId, addlInfo.couponFlowType, flowType);
                            }
                            else {
                                if (buildProductState.showConnectedApps) {
                                    dispatch({ type: Service.vRoom + '_SELECTEDPROD_CEAPPS', value: { vRoom, ceApps, dummyvRoom } });
                                }
                                else {
                                    dispatch({ type: Service.vRoom + '_SELECTEDPROD', value: null });
                                }
                                dispatch({ type: Service.ceAppsParity + '_SELECTEDPROD', value: { vRoom, ceApps, dummyvRoom } });
                                
                                dispatch({ type: Service.dummyvRoom + '_SELECTEDPROD', value: { vRoom, ceApps, dummyvRoom } });
                                
                            }
                            if (buildProductState.showConnectedApps && prodType === Service.vRoom) {
                                // setTVConnectionsView(buildProductState.tvConnections, isChecked, visitId, dispatch, {vRoom, ceApps, dummyvRoom}, buildProductState);
                                setTVConnectionsView(buildProductState.tvConnections, isChecked, visitId, dispatch, { vRoom, ceApps, dummyvRoom }, buildProductState, true);
                                setCEAppsView(null, buildProductState.ceApps, visitId, dispatch, { vRoom, ceApps, dummyvRoom });
                                if (product && (product.id || product.prodId) && product.unitCount && parseInt(product.unitCount) === 1) {
                                    let dummyvRoomProd = buildProductState.tvConnections && buildProductState.tvConnections.equipments && buildProductState.tvConnections.equipments.length ? buildProductState.tvConnections.equipments.filter(p => p.id === product.id || p.id === product.prodId) : null;
                                    if (dummyvRoomProd && dummyvRoomProd.length) {
                                        dummyvRoomProd = { ...dummyvRoomProd[0] };
                                        dummyvRoomProd['fromvRoom'] = true;
                                        updateCart(visitId, lqState, dummyvRoomProd, Service.dummyvRoom, false, dispatch, voiceTn, firstBill, null, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState,flowType)
                                    }
                                }
                            }
                            // const vRoomCount = prodObject && prodObject.vRoom && prodObject.vRoom.unitCount ? parseInt(prodObject.vRoom.unitCount) : 0;
                            // if(buildProductState.internet.selectedProduct && !prodObject.ceApps){
                            //     dispatch({ type: 'SHOW_CONNECTED_APPS_VROOM_OVERLAY', value: vRoomCount > 1 });
                            //     }
                            if (prodType === Service.dummyvRoom && !product.fromvRoom) {
                                setCEAppsView(product, buildProductState.ceApps, visitId, dispatch, { vRoom, ceApps, dummyvRoom });
                            }

                            if ((prodType === Service.ceAppsParity || prodType === Service.ceAppsBundle) && product && product.fromTVConnections) {
                                if (prodType === Service.ceAppsBundle) {
                                    // setTVConnectionsView(buildProductState.tvConnections, isChecked, visitId, dispatch, {vRoom, ceApps, dummyvRoom}, buildProductState);
                                    setTVConnectionsView(buildProductState.tvConnections, isChecked, visitId, dispatch, { vRoom, ceApps, dummyvRoom }, buildProductState, false);
                                    setCEAppsView(null, buildProductState.ceApps, visitId, dispatch, { vRoom, ceApps, dummyvRoom });
                                }
                                setCEAppsConfirmOverlay(dispatch);
                            }
                        }
                        else if (isSubSectionsValid && (prodType === Service.techSure )) {
                            let vasProducts = [];
                            let vas = response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.filter(p => p.sectionType === Service.vasstandalone);
                            if (InHomeUtils.isNull(vas) || (InHomeUtils.isNotNull(vas) && vas.length === 0)) {
                                let oneTimeArray = response.data.cartTierPricing.tierContent[0].sections.section.filter(p => p.sectionName === "Onetimecharges");
                                if (oneTimeArray.length > 0) {
                                    vas = oneTimeArray[0].subSections.subSection.filter(p => p.sectionType === Service.vasstandalone);
                                }
                            }
                            if (InHomeUtils.isNotNull(vas) && vas.length > 0 && InHomeUtils.isNotNull(vas[0]) && InHomeUtils.isNotNull(vas[0].products)) {
                                vasProducts = vas[0].products;
                            }

                            if (vcloud === 'Y' && product.isVCloudProd && product.isVCloudProd === 'Yes') { // add vcloud === 'Y' condition while commiting
                                const vcloudProd = vasProducts.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes');
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: vcloudProd.length > 0 ? vcloudProd : null });

                            }
                            else {
                                const vasProd = vasProducts.filter(p => InHomeUtils.isNull(p.isVCloudProd));
                                dispatch({ type: prodType + '_SELECTEDPROD', value: vasProd.length > 0 ? vasProd : null });

                            }
                            if ( InHomeUtils.isNotNull(lqState) && lqState !== undefined && InHomeUtils.isNotNull(lqState.MFRTEligible) && lqState.MFRTEligible  && prodType === Service.techSure && product.name === "Home Device Advisor" && InHomeUtils.isNotNull(product.specialOffers)) {
                                product.specialOffers.map(spl => {
                                    if (InHomeUtils.isNotNull(spl) && InHomeUtils.isNotNull(spl.OfferText) && spl.OfferText.indexOf('Home Advisor Discount') > -1) {
                                        fetchVoiceMTM(dispatch, visitId, null, flowType);
                                    }
                                })
                            }

                        }

                        else {
                            if (addlInfo.isFCPflow && prodType === Service.tv && !isChecked) {
                                if (InHomeUtils.isNotNull(buildProductState) && (InHomeUtils.isNotNull(buildProductState.tv)) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && buildProductState.tv.selectedProduct.prodType !== product.prodType) {

                                    if (buildProductState.streamServ.selectedProduct && buildProductState.streamServ.selectedProduct.prodType === 'OTTBASIC' &&
                                        buildProductState.streamServ.selectedProduct.prodTypeValue === Service.slingtv && product.prodTypeValue === Service.slingtv) {
                                        clearStreamService(dispatch);
                                    }
                                    else {
                                        if (InHomeUtils.isNotEmpty(product.prodTypeValue) && product.prodType === "OTTBASIC"
                                            && product.prodTypeValue != Service.slingtv) {
                                            clearVideoSubProducts(dispatch, servicesInCart);
                                        }
                                    }
                                }
                            }
                            if (changeprodtype != "") {
                                        dispatch({ type: changeprodtype + '_SELECTEDPROD', value: isChecked ? null : product });
                            }
                            else {
                            //    selected product
                                if(prodType === 'AccessPoint'){
                                    if(product.length !== 0 || isChecked){
                                                dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });
                                    }
                                }else{
                                    dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });
                                }
                                if(product && product.planPerks && prodType === Service.internet)
                                {
                                    dispatch({type : 'FETCH_DATASUBPROD',value : product.planPerks})
                                }

                                if(buildProductState?.tv?.selectedProduct && buildProductState?.tvConnections?.selectedProduct && product && prodType === Service.tv)
                                {                                     
                                    const ceAppsChecked = false;
                                    if((product.id === "R3377" || product.id === "R3375"))
                                    {                                          
                                        updateCart(visitId, lqState, buildProductState.ceApps.equipments[1], buildProductState.ceApps.equipments[1].prodType, ceAppsChecked, dispatch, voiceTn, firstBill, null, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState,flowType);
                                    }
                                    else if(buildProductState.ceApps.selectedProduct)
                                    {
                                        const oldSelectedDevice = buildProductState.ceApps.selectedProduct.prodId === 'NOCEAPPS' ? buildProductState.ceApps.equipments[0] : buildProductState.ceApps.equipments[1];

                                        updateCart(visitId, lqState, oldSelectedDevice, oldSelectedDevice.prodType, true, dispatch, voiceTn, firstBill, null, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState,flowType);
                                    }
                                    else{
                                        let ceApps = buildProductState.ceApps;
                                        if(InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && (product.id !== 'R3377' && product.id !== 'R3375'))
                                        {
                                            ceApps = buildProductState.ceApps.selectedProduct ? Object.assign({}, buildProductState.ceApps, {
                                                selectedProduct: null,
                                                isSubAccordionOpen: true,
                                                subAccordionStatus: 'optional',
                                                isAccordionOpen: true
                                            }) : buildProductState.ceApps;
                                        }
                                        dispatch({ type: 'UPDATE_DESELECTEDPRODUCT', value: ceApps });                                    
                                    }                                    
                                }
                            }
                            if (flowType === "MV" && !buildProductState?.slingnotinprofile) {
                                let slinginProfile = false;
                                if (servicesInCart !== "") {
                                    slinginProfile = (InHomeUtils.isNotNull(cartProducts.StreamingService) && InHomeUtils.isNotNull(cartProducts.StreamingService.StreamingService) && cartProducts.StreamingService.StreamingService[0].prodType === "OTTBASIC" && cartProducts.StreamingService.StreamingService[0].prodTypeVal === Service.slingtv) ? true : false
                                }
                                if (slinginProfile) {
                                    dispatch({ type: cartProducts.StreamingService.StreamingService[0].prodType + '_SELECTEDPROD', value: cartProducts.StreamingService.StreamingService[0] });
                                    dispatch({ type: 'MOVES_SLINGONPROFILE', value: true });
                                    dispatch({ type: 'MOVES_SLINGNOTINPROFILE', value: false });
                                }
                                else {
                                    dispatch({ type: 'OTTBASIC_SELECTEDPROD', value: null });
                                    dispatch({ type: 'MOVES_SLINGONPROFILE', value: false });
                                    dispatch({ type: 'MOVES_SLINGNOTINPROFILE', value: true });
                                }
                            }
                        }

                        // if (product && product.speedCode && product.speedCode === '947') {
                        //     if (buildProductState?.tv?.selectedProduct?.prodType != "OTTBASIC") {
                        //         dispatch({ type: 'TV_SELECTEDPROD', value: null });
                        //     }

                        //     clearVideoSubProducts(dispatch, servicesInCart);
                        //     if (!clearTVsubprods)
                        //         dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService: '' } });
                        //     //Open Internet Plans by default for BYOB and DO
                        //     //If condition added to stop unnecessary closing of internet accordion
                        //     if(buildProductState?.internet?.isAccordionOpen == false){
                        //         dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: '' });
                        //     }
                        // }
                        if(prodType === Service.tv && (buildProductState?.isMNEnabled || buildProductState?.mnFromApi)){
                            //Auto Expansion of streaming device
                            if(InHomeUtils.isNotEmpty(buildProductState?.tv.selectedProduct) && InHomeUtils.isNotEmpty(buildProductState?.tvConnections?.selectedProduct) && InHomeUtils.isNull(buildProductState?.ceApps.selectedProduct) )
                                {
                                    dispatch({ type: 'TOGGLE_CEAPPS_ACCOR', value: true });
                                }
                        }
                        let cartResponse = InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing;
                        if(!splOfferPerfChangesEnabled) {
                            triggerSpecialOffers(cartResponse, servicesInCart);
                        }
                        if (showMarvel && InHomeUtils.isNotNull(prodType) && prodType.toUpperCase() === "INTERNET") {
                            //Open Internet Plans by default for Marvel flow
                            dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'MarvelFlow' });
                        }

                        if (prodType === Service.internet) {
                            if (isChecked) {
                                clearDataSubProducts(dispatch, servicesInCart);
                                clearStreamService(dispatch);
                            }
                        }
                        else if (prodType === Service.tv) {
                            if (isChecked) {
                                if (InHomeUtils.isNotEmpty(product.prodTypeValue) && product.prodType === "OTTBASIC"
                                    && product.prodTypeValue != Service.slingtv) {
                                    clearVideoSubProducts(dispatch, servicesInCart);
                                }
                                if (InHomeUtils.isNotEmpty(product.prodTypeValue) && product.prodType === "OTTBASIC"
                                    && product.prodTypeValue === Service.slingtv) {
                                    clearStreamService(dispatch);
                                }
                            }
                            dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: null });
                            if (InHomeUtils.isNotNull(response.data.cartTierPricing)) {
                                let selectedInternet = getSelectedInternet(response.data.cartTierPricing, visitId)
                                if (InHomeUtils.isNotNull(selectedInternet) && selectedInternet.length > 0) {
                                    dispatch({ type: Service.internet + '_SELECTEDPRODID', value: selectedInternet });
                                    if(product && product.planPerks && prodType === Service.internet)
                                    {
                                        dispatch({type : 'FETCH_DATASUBPROD',value : product.planPerks})
                                    }
    
                                }

                                let selectedChannels = getSelectedChannels(response.data.cartTierPricing, visitId)
                                let selectedIntrChannels = getSelectedIntrnlChannels(response.data.cartTierPricing, visitId);
                                dispatch({ type: 'CHANNEL_SELECTEDPROD_ON_TVCHANGE', value: selectedChannels });
                                dispatch({ type: 'INTERNATIONALCHANNEL_SELECTEDPROD_ON_TVCHANGE', value: selectedIntrChannels });
                            }
                        }
                        else if (prodType === Service.voice && isChecked) {
                            clearVoiceSubProducts(dispatch);
                        }

                        let equipmentSection = response.data.cartTierPricing.tierContent[0].sections.section.filter(s => s.sectionName === Service.equipment);
                        let rouProds = equipmentSection && equipmentSection?.length > 0 ? equipmentSection[0].subSections.subSection.filter(p => p.sectionType === 'AccessPoint' || p.sectionType === 'ROUTER') : [];
                        if (!rouProds || (rouProds && rouProds.length === 0)) {
                            let equipmentSection = response.data.cartTierPricing.tierContent[0].sections.section.filter(s => s.sectionName === CartServices.oneTimeCharges);
                            let rouProds = equipmentSection && equipmentSection.length ? equipmentSection[0].subSections.subSection.filter(p => p.sectionType === "ROUTERBUY" || p.sectionType === "AccessPoint" || p.sectionType === "APBUY") : [];
                            if (!rouProds || (rouProds && rouProds.length === 0)) {
                                dispatch({ type: 'ROUTER_SELECTEDPROD', value: null });
                                if(product && product.planPerks && prodType === Service.internet)
                                {
                                    dispatch({type : 'FETCH_DATASUBPROD',value : product.planPerks})
                                }

                            }
                        }

                        if (prodType === Service.recording) {
                            fetchVRoom(dispatch, visitId, "", "", flowType, 0, false, true);
                        }
                        if (prodType === Service.voice && product.name === "Fios Home Phone") {
                            fetchTechSure(dispatch, visitId, flowType, lqState, "", buildProductState)
                        }
                        if (utdClearCart || clearStreamServ || clearTVsubprods) {
                            dispatch({ type: 'TV_SELECTEDPROD', value: null });
                            clearVideoSubProducts(dispatch, servicesInCart);
                            if (!clearTVsubprods)
                                dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService: '' } });
                            //Open Internet Plans by default for BYOB and DO
                            dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: '' });
                        }
                        if (servicesInCart === '') {
                            dispatch({ type: 'FIOS_VOICE_SELECTEDPROD', value: null });
                            dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService: '' } });
                            clearVoiceSubProducts(dispatch);
                        }
                        if (InHomeUtils.isNotNull(firstBill) && !firstBill.socInvoked && response.data.cartTierPricing != null && !isChecked) {
                            fetchPostSoc(dispatch, visitId);
                            socInvoked(true, dispatch);
                            // fetchGetSoc(dispatch, visitId,true);
                        }

                        //ADDON Products
                  /*     if(prodType === Service.mm3)
                        {
                            let vas = '';
                            //dispatch({type : 'LOADER_ACTIVE',value : true});
                            setTimeout(() => {
                                fetchRouter(dispatch, visitId, flowType);
                                fetchTechSure(dispatch, visitId, flowType);
                                let vasProducts = [];
                               /* let routerselectedprod = [];
                                routerselectedprod = response.data.cartTierPricing?.tierContent[0]?.sections?.section[0]?.subSections?.subSection.filter(p => p.sectionType === Service.router);
                                if (InHomeUtils.isNotNull(routerselectedprod) && routerselectedprod.length > 0 && InHomeUtils.isNotNull(routerselectedprod[0]) && InHomeUtils.isNotNull(routerselectedprod[0].products)) {
                                    routerselectedprod = routerselectedprod[0].products;
                                    dispatch({type : 'ROUTER_SELECTEDPROD',value : routerselectedprod})
                                }
                                
                                vas = response.data.cartTierPricing?.tierContent[0]?.sections?.section[0]?.subSections?.subSection.filter(p => p.sectionType === Service.vasstandalone);
                                if (InHomeUtils.isNotNull(vas) && vas.length > 0 && InHomeUtils.isNotNull(vas[0]) && InHomeUtils.isNotNull(vas[0].products)) {
                                    vasProducts = vas[0].products;
                                }
                                const cloudProd = vasProducts.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes' && vcloud === 'Y');
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: cloudProd.length > 0 ? cloudProd : null });
                                    
                            }, 3000) 
                            //dispatch({type : 'LOADER_ACTIVE', value : false } );
                        }
                      /*  if (product && product.defaultProduct && product.planPerks && product.planPerks.length > 0 && isChecked === false) {
                            
                            let default_add_product = product.planPerks.find(e => e.id === product.defaultProduct);
                            if(default_add_product)
                            {
                                updateCart(visitId,lqState,default_add_product,Service.mm3,false,dispatch,voiceTn,firstBill,addonProduct,contract,selectedCoreServices,isLocalTVInCart,isDCTinCart,upsellInfo,buildProductState,equipmentState,flowType)
                            }
                        } 
                        if (product && product.defaultProduct && product.planPerks && product.planPerks.length > 0 && isChecked === true) {
                            
                            let default_add_product = product.planPerks.find(e => e.id === product.defaultProduct);
                            if(default_add_product)
                            {
                                updateCart(visitId,lqState,default_add_product,Service.mm3,true,dispatch,voiceTn,firstBill,addonProduct,contract,selectedCoreServices,isLocalTVInCart,isDCTinCart,upsellInfo,buildProductState,equipmentState,flowType)
                            }
                        } 
                         */
                        let upsell1GWHW = (lqState && lqState.runtimeKey && lqState.runtimeKey.upsell1Gig && lqState.runtimeKey.upsell1Gig === "Y" && upsellInfo.isUpsell && product.downSpeed === "1024M") ? true : false;
                        if (!isMaxSpeedApplied && InHomeUtils.isNotNull(addonProduct) && InHomeUtils.isNotNull(addonProduct.productInCart) && addonProduct.productInCart.length > 0) {
                            let addonProd = addonProduct.productInCart.shift();
                            let addonProdType = addonProduct.prodType.shift();
                            let addonProdMode = addonProduct.isRemoved.shift();
                            addonProducts = addonProd.prodType;
                            if(addonProdType !== "BBUSHIPMENT") {
                                //https://onejira.verizon.com/browse/ITT-699061 - Regarding TV Recording section is not adding automatically
                                //&& addonProduct.productInCart.length>0
                                updateCart(visitId, lqState, addonProd, addonProdType, addonProdMode, dispatch, voiceTn, firstBill, addonProduct, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState,flowType);
                            }
                            prodType === Service.vRoom ? dispatch({ type: 'TOGGLE_TV_RECORDING_ACCOR', value: null }) : {};
                        }
                        else if (prodType === Service.battery && InHomeUtils.isNotNull(addonProduct) && InHomeUtils.isNotNull(addonProduct.productInCart) && addonProduct.productInCart.length > 0) {
                            dispatch({ type: 'BBUSHIPMENT_SELECTEDPROD', value: null });
                        }
                        if ((upsell1GWHW || isMaxSpeedApplied) && !isPopularPlanPage){
                            fetchRouter(dispatch, visitId, flowType, 0, false, lqState, voiceTn, buildProductState);
                        }
                        if (prodType === Service.dct || prodType === Service.tv || prodType === Service.vRoom) {
                            if (InHomeUtils.isNotNull(buildProductState) && (InHomeUtils.isNotNull(buildProductState.vRoom)) && InHomeUtils.isNotNull(buildProductState.vRoom.selectedProduct) && buildProductState.vRoom.selectedProduct.id === "NOVROOM") {
                                dispatch({ type: 'TOGGLE_TV_SETTOPBOX_ACCOR', value: null })
                            }
                            setTimeout(() => {
                            dispatch({ type: 'UPDATE_VROOM', value: { product, isChecked } });
                            }, 3000)
                        }
                        if (isSubSectionsValid && (prodType === Service.internet)) {
                            let vasProducts = [];
                            let vas = response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.filter(p => p.sectionType === Service.vasstandalone);
                            if (InHomeUtils.isNotNull(vas) && vas.length > 0 && InHomeUtils.isNotNull(vas[0]) && InHomeUtils.isNotNull(vas[0].products)) {
                                vasProducts = vas[0].products;
                            }
                            const cloudProd = vasProducts.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes' && vcloud === 'Y');
                            dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: cloudProd.length > 0 ? cloudProd : null });
                        }
                        let timerval = 500;
                        if (prodType === Service.internet && product.speedCode === "941") {
                            timerval = 3000;
                        }
                        else if (prodType === Service.internet) {
                            timerval = 1500;
                        }
                        setTimeout(() => {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            upsellInfo.isUpsell ? dispatch({ type: 'COLLAPSE_ALL_ACCORDION' }) : {};
                        }, timerval);
                        //Sitecatalist Logging
                        // if(product && product.speedCode && product.speedCode == "941"){
                        //     onegigvzdlObj = {visitId:visitId , product:product,prodType:prodType,response:response, isDoFlow:addlInfo.isDoFlow,isprdevent:true,upsellInfo:upsellInfo,flowType:flowType,isfcpflow:addlInfo.isFCPflow,
                        //         cloudAccStatus:cloudAccStatus,eventAction:eventAction, eventValue:eventValue,addonProducts:addonProducts}
                        // }

                        if (!isChecked) {
                            //let istimeoutReq = false;
                            
                            addToCartSCEvent(visitId, product, prodType, response, addlInfo.isDoFlow, true, upsellInfo, flowType, addlInfo.isFCPflow, cloudAccStatus);
                            
                            //CETC-142148 - Omnibug - Fix to trigger 1G products on second call.
                            if(selectPopularPlans === false){
                                if (product.speedCode === "941" || product.speedCode === "947"){
                                    if (prodType === Service.mm3 || prodType === Service.internet){
                                        addToCartVzdlSCEvent(visitId, product, prodType, response, addlInfo.isDoFlow, true, upsellInfo, flowType, addlInfo.isFCPflow, eventAction, eventValue, addonProducts, isTagGspeed, Mergescevent, defaultProductadded)
                                    } 
                                }
                                else {
                                    addToCartVzdlSCEvent(visitId, product, prodType, response, addlInfo.isDoFlow, true, upsellInfo, flowType, addlInfo.isFCPflow, eventAction, eventValue, addonProducts, isTagGspeed, Mergescevent, defaultProductadded) 

                                }
                            }
                            if (prodType === Service.voice) {
                                // updateSCTags("check my number");
                                tempSCData.pageName = addlInfo.isDoFlow ? "do accord" : "byob";
                                if (flowType == "MV") {
                                    tempSCData.customerCategory = "^Moves^";
                                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                                    updateSCcustomEvent("winBackLoad", "ddAddToCartEvent", "pageName,contentChannel");
                                }
                                else {
                                    updateSCcustomEvent("winBackLoad", "ddAddToCartEvent", "pageName");
                                }
                                setTimeout(() => {
                                    tempVzdlSCData.detail = "Add you phone Number";
                                    updateVzdlSCCustomEvent("winBackLoad", "pageViewOmni", "detail");
                                }, 1500);
                            }
                        }
                        else {
                            addToCartSCEvent(visitId, product, prodType, response, addlInfo.isDoFlow, false, upsellInfo, flowType, addlInfo.isFCPflow, cloudAccStatus);
                            addToCartVzdlSCEvent(visitId, product, prodType, response, addlInfo.isDoFlow, true, upsellInfo, flowType, addlInfo.isFCPflow, eventAction, eventValue, addonProducts, isTagGspeed, Mergescevent,defaultProductadded)
                        }
                        if(prodType === Service.mm3 || prodType === Service.internet)
                        {
                            if((InHomeUtils.isNotNull(lqState) && lqState.runtimeKey && lqState.runtimeKey.enableSaveTheSale && lqState.runtimeKey.enableSaveTheSale === "Y") && flowType==='NC')
                            {
                              saveTheSaleFromDataAEM(visitId, dispatch); 
                            }
                            
                            let vas = '';
                            //dispatch({type : 'LOADER_ACTIVE',value : true});
                            setTimeout(() => {
                                if((!isStreamline && !isPopularPlanPage) || SuppressDuplicateCalls.indexOf('router') === -1) fetchRouter(dispatch, visitId, flowType);
                                fetchTechSure(dispatch, visitId, flowType);
                                let vasProducts = [];
                               // let additionalInfo = { flowType: '', isUpsell:upsellInfo.isUpsell , couponFlowType: addlInfo.couponFlowType, orderType: flowType, vcpestbQty: '' };
                                //let part = cartProducts;
                                let router  = cartProducts?.CartSubProduct?.Equipment?.equipment.filter(a=>a.prodType === "ROUTERBILLER" || a.prodType === 'ACCESSPOINTBILLER')
                               // PreselectCartProducts(cartProducts, dispatch, visitId, additionalInfo, null, buildProductState, lqState, upsellInfo.cart, addlInfo.servicesQualified);
                               if(InHomeUtils.isNotNull(router) && router.length > 0){
                                dispatch({type:'ROUTER_SELECTEDPROD',value:router[0]});
                                dispatch({ type: "TOGGLE_INTERNET_ROUTER_ACCOR", value: true });
                                //To stop jumping and unnecessary opening of accordions 
                               //dispatch({type:'MM3_ROUTER_OPENACCOR',value:true});
                               if(buildProductState?.isMNEnabled || buildProductState?.mnFromApi)
                                {
                                    dispatch({ type: "TOGGLE_INTERNET_ROUTER_ACCOR", value: "" });
                                    const buildProductSplOffer = store?.getState()?.buildProduct?.sploffer;
                                    const internetSplOffers = buildProductSplOffer?.data?.offerplansMTM;
                                    const productSplOffers = product?.specialOffers?.filter(o => o?.offerType === "Manual");
                                    if ((!Array.isArray(productSplOffers) || productSplOffers?.length === 0) || (Array.isArray(productSplOffers) && productSplOffers?.length > 0 && buildProductState?.sploffer?.data?.selectedProduct)) {
                                        if ((!Array.isArray(internetSplOffers) || internetSplOffers?.length === 0) || (internetSplOffers?.length > 0 && buildProductState?.sploffer?.data?.selectedProduct)) {
                                            /* CETC-145933 Perks shouldn't auto expand for classic customers */
                                            if(buildProductState?.internet?.m2mPlans?.[0]?.productKeyword?.includes('MM4')) {
                                                dispatch({type : 'TOGGLE_PERKS_ACCOR',value : true})
                                            }
                                        }
                                    }
                                }
 
                               }
                               if(prodType === Service.mm3)
                               {
                             // dispatch({type:'MM3_ROUTER_OPENACCOR',value:true});                              
                               }
                               if(defaultProductadded)
                               {
                               // dispatch({type:'MM3_ROUTER_OPENACCOR',value:true});   
                               //To stop jumping and unnecessary opening of accordions                                                        
                                //dispatch({type : 'TOGGLE_DATASUB_ACCOR',value : true})
                                
                               }
                                vas = response.data.cartTierPricing?.tierContent[0]?.sections?.section[0]?.subSections?.subSection.filter(p => p.sectionType === Service.vasstandalone);
                                if (InHomeUtils.isNotNull(vas) && vas.length > 0 && InHomeUtils.isNotNull(vas[0]) && InHomeUtils.isNotNull(vas[0].products)) {
                                    vasProducts = vas[0].products;
                                }
                                const cloudProd = vasProducts.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes' && vcloud === 'Y');
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: cloudProd.length > 0 ? cloudProd : null });
                                
                            }, 1000) 
                            //dispatch({type : 'LOADER_ACTIVE', value : false } );
                        }
                
                //   if (product && product.defaultProduct && product.planPerks && product.planPerks.length > 0 && isChecked === false) {
                            
                //             let default_add_product = product.planPerks.find(e => e.id === product.defaultProduct);
                //             if(default_add_product)
                //             {
                //                 updateCart(visitId,lqState,default_add_product,Service.mm3,false,dispatch,voiceTn,firstBill,addonProduct,contract,selectedCoreServices,isLocalTVInCart,isDCTinCart,upsellInfo,buildProductState,equipmentState,flowType,cloudAccStatus,isMaxSpeedApplied,true)
                //             }
                //         } 
                //         if (product && product.defaultProduct && product.planPerks && product.planPerks.length > 0 && isChecked === true) {
                            
                //             let default_add_product = product.planPerks.find(e => e.id === product.defaultProduct);
                //             if(default_add_product)
                //             {
                //                 updateCart(visitId,lqState,default_add_product,Service.mm3,true,dispatch,voiceTn,firstBill,addonProduct,contract,selectedCoreServices,isLocalTVInCart,isDCTinCart,upsellInfo,buildProductState,equipmentState,flowType,cloudAccStatus,isMaxSpeedApplied,true)
                //             }
                //         } 
                        // clearing voice products on selecting 2Gig
                        if((InHomeUtils.isNotNull(lqState) && lqState.runtimeKey && lqState.runtimeKey.AllowVoiceWithMultiGIG && lqState.runtimeKey.AllowVoiceWithMultiGIG !== "Y") && product && product.speedCode == "947" && isChecked === false && buildProductState.voice?.selectedProduct){
                            dispatch({ type: 'FIOS_VOICE_SELECTEDPROD', value: null });
                            clearVoiceSubProducts(dispatch);
                        }

                        let bfOffers  = product && product.specialOffers && product.specialOffers.filter((offer)=>{if(offer.BsOfferAttr. indexOf("ACQBLACKFRIDAY2022")){return offer}}).length > 0 ? true : false
                        if(product && product.prodType === "FTTPD" && bfOffers && !isChecked){
                            setTimeout(()=>{
                                dispatch({ type: 'BF_ACCOR_EXPANSION', value: null});
                                // if ((prodType === Service.mm3 || prodType === Service.internet) && cartProducts?.CartSubProduct?.Equipment?.equipment?.filter(a => a?.prodType === "ROUTERBILLER")?.length > 0) {
                                //     dispatch({ type: "TOGGLE_INTERNET_ROUTER_ACCOR", value: true });
                                // }
                            },1500)
                        }

                        if (upsellInfo.isUpsell) {
                            dispatch({type : 'SET_UPSELL_TAG_LIMIT_FLAG', value : true})
                            setTimeout(() => {
                                let internetAccEle = document.querySelector('#toggle_internet_accor');
                                if (InHomeUtils.isNotNull(internetAccEle)) {
                                    internetAccEle.click();
                                    let internetPlanAccEle = document.querySelector('#toggle_internet_plan_accor');
                                    if ( InHomeUtils.isNotNull(internetPlanAccEle)) {
                                        internetPlanAccEle?.click();
                                        let specialOfferAccEle = document.querySelector('#toggle_data_splOffer_accor');
                                        let perksAccEle = document.querySelector('#toggle_internet_perks_accor');
                                        if ( InHomeUtils.isNotNull(specialOfferAccEle)) {
                                            specialOfferAccEle?.click();
                                        } else if (InHomeUtils.isNotNull(perksAccEle)) {
                                            perksAccEle?.click();
                                        }
                                    }
                                }
                                setTimeout(() => {
                                    dispatch({type : 'SET_UPSELL_TAG_LIMIT_FLAG', value : false})
                                }, 500);
                            }, 5000);
                        }
                        // If tv plan is selected and recording service is not in the cart
                        if (prodType === Service.tv && buildProductState?.recording?.selectedProduct) {
                            const cartRecordingIndex = response?.data?.cartTierPricing?.tierContent[0]?.sections?.section?.find(p => p?.sectionName === Service.equipment)?.subSections?.subSection?.findIndex(p => p?.sectionType === Service.recording);
                            if (cartRecordingIndex === -1 || (!cartRecordingIndex && cartRecordingIndex !== 0)) {
                                dispatch({ type: "RECORDING_SELECTEDPROD", value: null });
                            }
                        }
                    }
                    else { //error while updating cart
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCart', "updateCart - Failed"));
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }
                    
                    checkProductsForLBO(buildProductState, prodType, addlInfo, visitId, dispatch, product);

                    resolve(true);

                    function triggerSpecialOffers(cartResponse, servicesInCart) {
                        if (prodType === Service.internet || prodType === Service.tv || prodType === Service.customTV || prodType === Service.voice || prodType === Service.mm3) {
                            let cartProducts = null;
                            try {
                                cartProducts = getCartProducts(cartResponse, visitId)
                            } catch (e) {
                                console.error(e);
                            }
                            performance.mark("SpecialOffers triggered");
                            const isStreamlineTvVoice =  window?.location?.href?.includes('inhome/streamlinetvvoice');
                            if(prodType === Service.internet && SuppressDuplicateCalls.indexOf('specialoffers') > -1 && isStreamline) {
                                const dispatchActionsList = setSpecialOffers(visitId, contract, dispatch, addlInfo.flowType, addlInfo.isDoFlow, buildProductState.flashoffer.selectedProduct, cartProducts, true, cartResponse, lqState, '', prodType, buildProductState, splOffers);
                                dispatchActions.push(...dispatchActionsList)
                            } else if(!isStreamlineTvVoice){
                                getSpecialOffers(visitId, contract, dispatch, addlInfo.flowType, addlInfo.isDoFlow, buildProductState.flashoffer.selectedProduct, cartProducts, true, cartResponse, lqState, '', prodType, buildProductState);
                            }
                            //fetchOfferInCart(visitId, cartProducts, dispatch);
                            var selectedprodid = product.id;
                            if (!isChecked && InHomeUtils.isNotEmpty(product.prodTypeValue) && product.prodTypeValue === "ULTIMATETESTDRIVE" && InHomeUtils.isNotNull(buildProductState) && (InHomeUtils.isNotNull(buildProductState.tv)) && InHomeUtils.isNotNull(buildProductState.tv.ultimateTvUsoc)) {
                                selectedprodid = buildProductState.tv.ultimateTvUsoc;
                            }

                            addlInfo.selectedProductId = selectedprodid;
                            if (!upsellInfo.isUpsell) {
                                performance.mark('Triggered Do prefetch')
                                doPrefetch(prodType + "_SELECTED", dispatch, visitId, addlInfo, contract, selectedCoreServices, false, isLocalTVInCart, isDCTinCart, '', isChecked, servicesInCart, buildProductState, null, null, lqState, voiceTn, isRouterAPIInvoked );
                            }
                            let offersInCart = [];
                            if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                                if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.rewardoffers)) {
                                    offersInCart = cartProducts.CartSubProduct.SpecialOffers.rewardoffers.slice();
                                }
                            }
                            let Netmaxoffer = product?.specialOffers.find(item => item.id === "R4261") || {};
                            let netmaxmarkerpromotion = cartProducts?.CartSubProduct?.Promotions?.promotions?.some(item => item?.promoId === "R4262");
                            let netmaxperkpromotion = cartProducts?.CartSubProduct?.Promotions?.promotions?.some(item => item?.promoId === "R4261");
                            if (Netmaxoffer.id && netmaxmarkerpromotion && !netmaxperkpromotion) {
                                Netmaxoffer.promoText = "Netflix & Max (With Ads) Perk for 12 months, on us";
                                offersInCart.push(Netmaxoffer);
                            }
                            updateSweetnerMsg(product, prodType, isChecked, processOfferSection(offersInCart), lqState, buildProductState, visitId, dispatch);
                            if ((prodType.toUpperCase() === "INTERNET" || prodType.toUpperCase() === "FIOS_VOICE")) {
                                updateVZCCouponNotification(prodType, isChecked, cartProducts, buildProductState, visitId, dispatch);
                            }
                            if (InHomeUtils.isNotNull(buildProductState.vzcCouponInfo) && InHomeUtils.isNotEmpty(buildProductState.vzcCouponInfo) && buildProductState.vzcCouponInfo.vzcValidationSuccess && buildProductState.vzcCouponInfo.isDiscountEligible && buildProductState.vzcCouponInfo.isDiscountApplied) {

                                if (InHomeUtils.isNull(response.data.orderDetail.servicesOrdered)) {
                                    let vzcCouponInfo = {
                                        vzcValidationSuccess: true,
                                        isDiscountEligible: true,
                                        isDiscountApplied: false
                                    };
                                    dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
                                }
                            }
                        }
                    }
                })
                    .catch(error => {
                        let errorMsg = `MethodName:updateCart,errorMessage:${error.message}`;
                        // //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                        logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    });
            });
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCart', ex);
    }
}

export const clearPerkFromPP = (visitId)=>{
    const getClearCartRequest = () => {
        let request = {
            serviceType: 'DATA',
            productType: 'All'
        }
        return JSON.stringify(request)
    }
    let clearCartUrl = apiUrl().clearCart + '/' + visitId;
    let request = getClearCartRequest();
      return new Promise((resolve, reject) => {
        api(clearCartUrl, 'POST', request).then(response => {
            resolve(true)
        })})
}

// const setTVConnectionsView = (tvConnections, isChecked, visitId, dispatch, prodObject, buildProductState) => {
const setTVConnectionsView = (tvConnections, isChecked, visitId, dispatch, prodObject, buildProductState, showOverlay) => {
    try {
        let displayTVConnectionsProducts = [];
        // let tvConnections = buildProductState.tvConnections;
        let internet = buildProductState.internet.selectedProduct !== null;
        const vRoomCount = prodObject && prodObject.vRoom && prodObject.vRoom.unitCount ? parseInt(prodObject.vRoom.unitCount) : 0;
        if (!isChecked && vRoomCount && tvConnections && tvConnections.equipments && tvConnections.equipments.length) {
            displayTVConnectionsProducts = tvConnections.equipments.filter(p => p && p.unitCount && parseInt(p.unitCount) <= vRoomCount && parseInt(p.unitCount) >= vRoomCount - 2);
        }
        dispatch({ type: 'UPDATE_TVCONNECTIONS', value: displayTVConnectionsProducts });
        if (showOverlay && !prodObject.ceApps)
            // dispatch({ type: 'SHOW_CONNECTED_APPS_VROOM_OVERLAY', value: vRoomCount > 1 && internet });
            dispatch({ type: 'SHOW_CONNECTED_APPS_VROOM_OVERLAY', value: false });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setTVConnectionsView', ex);
    }
}

const setCEAppsView = async (tvConnections, ceApps, visitId, dispatch, prodObject) => {
    try {
        let displayCEAppProducts = [];
        let displayAccorCEAppProducts = [];
        const tvConnectionsCount = prodObject && prodObject.dummyvRoom && prodObject.dummyvRoom.unitCount ? parseInt(prodObject.dummyvRoom.unitCount) : 0;
        let selectedvRoomProd = [];
        if (prodObject && prodObject.vRoom) {
            selectedvRoomProd.push(prodObject.vRoom);
        }
        // else{
        //     selectedvRoomProd = vRoom && vRoom.selectedProduct && (vRoom.selectedProduct.prodId || vRoom.selectedProduct.id) && vRoom.equipments && vRoom.equipments.filter(p => p && (p.id === vRoom.selectedProduct.prodId || p.id === vRoom.selectedProduct.id));
        // }
        const vRoomCount = selectedvRoomProd && selectedvRoomProd.length && selectedvRoomProd[0].unitCount ? parseInt(selectedvRoomProd[0].unitCount) : 0;
        if (vRoomCount && ceApps && ceApps.equipments && ceApps.equipments.length) {
            if (vRoomCount === 1 || tvConnectionsCount && tvConnectionsCount === vRoomCount) {
                displayCEAppProducts = [];
                let cloneCEApps = JSON.parse(JSON.stringify(ceApps.equipments));
                let bundleCEApps = cloneCEApps.filter(p => p.prodType === Service.ceAppsBundle);
                if (bundleCEApps && bundleCEApps.length) {
                    bundleCEApps = bundleCEApps[0];
                    let noCEApps = {
                        ...bundleCEApps,
                        id: 'NOCEAPPS',
                        name: 'I don\'t want to use a streaming device.',
                        accordionTitle: 'I don\'t want to use a streaming device.',
                        originalPrice: '0',
                        displayPrice: '$0.0'
                    };
                    //const vRoomprice =  selectedvRoomProd[0].price ? parseInt(selectedvRoomProd[0].price.replace('$','')) : 0;
                    //const stbPrice = tvConnections && tvConnections.displayPrice ? parseInt(tvConnections.displayPrice.replace('$','')) : 0;
                    const ceBundlePrice = bundleCEApps.displayPrice ? parseInt(bundleCEApps.displayPrice.replace('$', '')) : 0;
                    //const dynamicPrice = stbPrice + ceBundlePrice - vRoomprice;
                    const dynamicPrice = ceBundlePrice;
                    let displayPrice = dynamicPrice ? dynamicPrice < 0 ? `$${dynamicPrice * -1} less/mo` : `$${dynamicPrice} more/mo` : 'same price';
                    bundleCEApps["displayPrice"] = displayPrice;
                    bundleCEApps["unitCount"] = '1';
                    bundleCEApps["description"] = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to ${vRoomCount > 3 ? '4' : '2'} devices at once</li><li>Device authorization not required</li></ul>`;
                    displayAccorCEAppProducts.push(bundleCEApps);
                    displayAccorCEAppProducts.push(noCEApps);
                }
            }
            else if (tvConnectionsCount > 0 && tvConnectionsCount < vRoomCount) {
                const diff = vRoomCount - tvConnectionsCount;
                let qualifiedParityProduct = diff === 1 || diff === 2 ? diff : 0
                let cloneCEApps = JSON.parse(JSON.stringify(ceApps.equipments));
                cloneCEApps = cloneCEApps.filter(p => p.prodType === Service.ceAppsBundle || (qualifiedParityProduct && p.prodType === Service.ceAppsParity));
                displayCEAppProducts = cloneCEApps.map(p => {
                    if (p.prodType === Service.ceAppsParity) {
                        p.name = `${diff} ${p.name}${diff > 1 && (!p.name.toUpperCase().includes('DEVICES') && !p.name.toUpperCase().includes('(S)')) ? 's' : ''}`;
                        p.unitCount = diff.toString();
                        p['description'] = `<ul><li>Watch on ${diff} of your streaming devices only</li><li>Device Authorization required</li><li> 2 Authorizations allowed per month per device</li></ul>`
                    }
                    else if (p.prodType === Service.ceAppsBundle) {
                        const vRoomprice = selectedvRoomProd && selectedvRoomProd.length && selectedvRoomProd[0].price ? parseInt(selectedvRoomProd[0].price.replace('$', '')) : 0;
                        const stbPrice = tvConnections && tvConnections.displayPrice ? parseInt(tvConnections.displayPrice.replace('$', '')) : 0;
                        const ceBundlePrice = p.displayPrice ? parseInt(p.displayPrice.replace('$', '')) : 0;
                        const dynamicPrice = stbPrice + ceBundlePrice - vRoomprice;
                        let displayPrice = dynamicPrice ? dynamicPrice < 0 ? `$${dynamicPrice * -1} less/mo` : `$${dynamicPrice} more/mo` : 'same price';
                        p.displayPrice = displayPrice;
                        p.unitCount = '1';
                        p['description'] = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to ${vRoomCount > 3 ? '4' : '2'} devices at once</li><li>Device authorization not required</li></ul>`;
                    }
                    return p;
                })
            }
        }
        dispatch({ type: 'UPDATE_CEAPPS', value: displayCEAppProducts });
        dispatch({ type: 'UPDATE_ACCOR_CEAPPS', value: displayAccorCEAppProducts });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setCEAppsView', ex);
    }
}

const setCEAppsConfirmOverlay = (dispatch) => {
    dispatch({ type: 'SHOW_CONNECTED_APPS_CEAPPS_OVERLAY', value: true });
}

const checkProductsForLBO = (buildProduct, LastAddedProdType, additionalInfo, visitId, dispatch, product) => {
    let isOTTProduct = InHomeUtils.isNotNull(additionalInfo) && additionalInfo.flowType === "SUPP" && InHomeUtils.isNotNull(product) && InHomeUtils.isNotNull(product.prodType) && (product.prodType === "OTTBASIC");
    if (LastAddedProdType === Service.data && (InHomeUtils.isNull(buildProduct.router.equipments) || buildProduct.router.equipments.length === 0)) {
        fetchRouter(dispatch, visitId, additionalInfo.orderType, 0, true)
    } else if (!isOTTProduct && LastAddedProdType === Service.tv && (InHomeUtils.isNull(buildProduct.vRoom.equipments) || buildProduct.vRoom.equipments.length === 0)) {
        fetchVRoom(dispatch, visitId, '', '', additionalInfo.orderType, 0, true);
    } else if (!isOTTProduct && LastAddedProdType === Service.vRoom && (InHomeUtils.isNull(buildProduct.recording.equipments) || buildProduct.recording.equipments.length === 0)) {
        fetchRecording(dispatch, visitId, additionalInfo.couponFlowType, additionalInfo.orderType, 0, true)
    } else if (!isOTTProduct && LastAddedProdType === Service.tv && (InHomeUtils.isNull(buildProduct.recording.equipments) || buildProduct.recording.equipments.length === 0)) {
        fetchRecording(dispatch, visitId, additionalInfo.couponFlowType, additionalInfo.orderType, 0, true)
    }
}

const updateInCartVidoeSubProducts = (buildProduct, typeofProduct, visitId) => {
    try {
        const { vRoom, recording } = buildProduct;
        var videoSubProdcut = {
            product: "",
            prodType: ""
        }
        switch (typeofProduct) {
            case "VROOM":
                vRoom.equipments.some(function (sBox) {
                    if (sBox.displayPrice.indexOf("$0.00") > -1) {
                        videoSubProdcut.Product = sBox;
                        videoSubProdcut.prodType = sBox.prodType;
                    }
                });
                break;
            case "RECORDING":
                recording.equipments.some(function (rec) {
                    if (rec.displayPrice.indexOf("$0.00") > -1) {
                        videoSubProdcut.Product = rec;
                        videoSubProdcut.prodType = rec.prodType;
                        //return videoSubProdcut;
                    }
                });
                break;
            default: videoSubProdcut;
                break;
        }
    } catch (ex) {
        catchJSException('action_BuildProduct', visitId, 'updateInCartVidoeSubProducts', ex);
    }
    return videoSubProdcut;
}
const clearDataSubProducts = (dispatch, selectedCoreServices) => {
    dispatch({ type: 'TECHSURE_SELECTEDPROD', value: null });
    dispatch({type : "MM3_SELECTEDPROD",value :null});
    dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: null });
    if (selectedCoreServices === '') {
        dispatch({ type: 'ROUTER_SELECTEDPROD', value: null });
    }

    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet" });
}

const clearVideoSubProducts = (dispatch, selectedCoreServices) => {
    dispatch({ type: 'DCT_SELECTEDPROD', value: null });
    dispatch({ type: 'VROOM_SELECTEDPROD', value: null });
    dispatch({ type: 'RECORDING_SELECTEDPROD', value: null });
    dispatch({ type: 'CHANNEL_SELECTEDPROD', value: null });
    dispatch({ type: 'INTERNATIONALCHANNEL_SELECTEDPROD', value: null });
    if (selectedCoreServices === '') {
        dispatch({ type: 'ROUTER_SELECTEDPROD', value: null });
    }
    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "tv" });
}

const clearVoiceSubProducts = (dispatch) => {
    dispatch({ type: 'INTERNATIONALCHANNELPLAN_SELECTEDPROD', value: null });
    dispatch({ type: 'INTLPLAN_SELECTEDPROD', value: null });
    dispatch({ type: 'WINBACK_SELECTEDPROD', value: null });
    dispatch({ type: 'LISTING_SELECTEDPROD', value: null });
    dispatch({ type: 'BATTERY_SELECTEDPROD', value: null });
    dispatch({ type: 'BBUSHIPMENT_SELECTEDPROD', value: null });

    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice" });
}
export const ForceWinbackStatus = (dispatch) => {
    dispatch({ type: 'WINBACK_SELECTEDPROD', value: 'added' });
}

export const clearPreviousSelection = (dispatch) => {
    dispatch({ type: Service.tv + '_SELECTEDPROD', value: null });
}

const clearStreamService = (dispatch) => {
    dispatch({ type: 'OTTBASIC_SELECTEDPROD', value: null });
    dispatch({ type: 'OTTEQUIPNRC_SELECTEDPROD', value: null });
    dispatch({ type: 'STREAMDEVCNT_SELECTEDPROD', value: null });

    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "stream" });
}

export const toggleMessage = (dispatch) => {
    dispatch({ type: 'TOGGLE_MESSAGE', value: "" });
}

export const toggleBatteryMessage = (dispatch) => {
    dispatch({ type: BuildProduct.toggleBatteryMsg, value: "" });
}

export const toggleDctMessage = (dispatch) => {
    dispatch({ type: BuildProduct.toggleDctMsg, value: "" });
}
export const toggleTVMoreOption = (dispatch) => {
    dispatch({ type: BuildProduct.toggleTVMoreOpt, value: "" });
}
export const toggleRouterMoreOption = (dispatch) => {
    dispatch({ type: BuildProduct.toggleRouterMoreOpt, value: "" });
}
export const SweetnerMsg = (SweetnerMessage, dispatch, isMnhMsg= false) => {
    if(!isMnhMsg){
        dispatch({ type: 'SET_MNH_STATUS', value: '' });
    }
    dispatch({
        type: BuildProduct.SweetnerMsg,
        value: SweetnerMessage
    });
}
export const bannerContent = (dispatch) => {
    let value =
    {
        headerText: "No one delivers entertainment to your home like Fios.", footerText: "The best deserves the best. Save $10 off your Verizon Wireless bill and your Verizon Fios bill - a total savings of $20 per month",
        bodyText: "Sign up for a qualifying Fios Triple Play bundle with a 2-year agreement and get one year of Netflix premium plan on us. Already have Netflix? We'll cover the cost for one year.",
        imgUrl: "desk-ordering-page-hero-netflix.jpg"
    }
    dispatch({ type: 'BANNER_UPDATED', value: value });
}

export const resetTNStatus = (dispatch) => {
    dispatch({ type: 'UPDATE_WB_PH1', value: '' })
    dispatch({ type: 'UPDATE_WB_PH2', value: '' })
    dispatch({ type: 'UPDATE_WB_PH3', value: '' })
    dispatch({ type: 'UPDATE_PORTEDTN', value: '' })
    dispatch({ type: 'UPDATE_TNPORTABILITY', value: false })
}

export const tnPortableCheck = async (tn, dispatch, visitId, isDoFlow) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'tnPortableCheck', "Inside tnPortableCheck"));
        let url = apiUrl().checkportability + '/checkportability';
        let request = JSON.stringify({ "tn": tn, "lineNo": 1 })
        let isTNPortable = false;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        return api(url, 'POST', request).then(response => {
            // response={
            //     "meta": {
            //         "code": 200.01,
            //         "description": "Portability Completed successfully .",
            //         "timestamp": "Fri Nov 16 11:09:42 UTC 2018"
            //     },
            //     "data": {
            //         "isPortable": "Y",
            //         "isCharged": "true"
            //     }
            // }
            dispatch({ type: 'UPDATE_PORTEDTN', value: tn })
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'tnPortableCheck', "tnPortableCheck - Success"));
                let val = isDoFlow ? "do accord" : "byob";
                tempSCData.pageName = val;
                if (response.data.isPortable === "Y") {
                    isTNPortable = true;
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'tnPortableCheck', "tn - PORTABLE", PAGEACTIVITY.UA));
                    tempSCData.detailPageName = val + "| phone| winback| current phone number eligible";
                    tempVzdlSCData.detail = "phone winback current phone number eligible";
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'tnPortableCheck', "tn - NONPORTABLE", PAGEACTIVITY.UA));
                    tempSCData.detailPageName = val + "| phone| winback| current phone number ineligible";
                    tempVzdlSCData.detail = "phone winback current phone number ineligible";
                }
                updateSCcustomEvent("winBackPage", "ddAddToCartEvent", "detailPageName,pageName");
                tempVzdlSCData.events = "prodView";
                updateVzdlSCCustomEvent("winBackPage", "pageViewOmni", "detail,events");
                dispatch({ type: 'UPDATE_TNPORTABILITY', value: (response.data.isPortable === "Y" ? true : false) });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'tnPortableCheck', "tnPortableCheck - FAIL", PAGEACTIVITY.UA));
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return isTNPortable;
        }).catch(error => {
            let errorMsg = `MethodName:tnPortableCheck,errorMessage:${error.message}`;
            // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return false;
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'tnPortableCheck', ex);
        return false;

    }
};

export const updateTn = (type, value, dispatch) => {
    dispatch({ type: 'UPDATE_WB_' + type, value: value });
    dispatch({ type: 'UPDATE_PORTEDTN', value: '' })
    dispatch({ type: 'UPDATE_TNPORTABILITY', value: false })
}

export const fetchPostSoc = (dispatch, visitId, showLoader = false, isVZDLCall = false, postSoc = '') => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPostSoc', "Inside fetchPostSoc"));
        if (showLoader) {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Estimating your first month bill", isLoaderImg: "loader" } });
        }
        let jsonstr = JSON.stringify({ flowtype: 'BAU' });
        let url = apiUrl().fbePostSoc;
        api(url, 'POST', jsonstr).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPostSoc', "fetchPostSoc - Success"));
                dispatch({ type: 'POST_SOC', value: response.meta.description });
                if (showLoader || isVZDLCall)
                    fetchGetSoc(dispatch, visitId, isVZDLCall);
            }
            else {
                postSoc == 'postSoc' && modalAction.openModalWindow("SOC", dispatch);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPostSoc', "fetchPostSoc - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchPostSoc,errorMessage:API Response error`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchPostSoc,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        //setTimeout(() => dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }), 30000);
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchPostSoc', ex);
    }
};

export const fetchGetSoc = (dispatch, visitId, isVZDLCall = false, isRetry = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchGetSoc', "Inside fetchGetSoc"));
        let url = apiUrl().fbeGetSoc;
        let reAttempt = !isRetry ? true : false;
        let cartPromos =  store.getState()?.cart?.cartData[0]?.Promotions?.promotions?.filter((obj)=>{
            obj?.promoText?.includes("ARPA Broadband Discount up to $10")
        })
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchGetSoc', "fetchGetSoc - Success"));
                reAttempt = false;
                dispatch({
                    type: 'GET_SOC',
                    value: response.data
                });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                if (!isVZDLCall) {
                    modalAction.openModalWindow("SOC", dispatch);
                }
            } else if(reAttempt || cartPromos.length>1){
                fetchGetSoc(dispatch, visitId, false, true)
            }
            else {
                modalAction.openModalWindow("SOC", dispatch);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchGetSoc', "fetchGetSoc - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchGetSoc,errorMessage:API Response error,statusCode:${response.meta.code},data=null`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                //errorAction("LBO", "BuildProduct", error.message, "applogs", visitId, dispatch, true, "FirstBillEstimate");
                let errorMsg = `MethodName:fetchGetSoc,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //  vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchGetSoc', ex);
    }
};

export const checkAndFetchMon = async (dispatch, visitId, lqState) => {
    const stateFromLq = lqState.selectedState && lqState.selectedState.state || '';
    if (!stateFromLq) {
        const eligible = lqState.servicesQualified && (lqState.servicesQualified.isDataQualified || lqState.servicesQualified.isVideoQualified || lqState.servicesQualified.isVoiceQualified);
        if (eligible) {
            await getMon(dispatch, visitId, stateFromLq);
        } else {
            InHomeUtils.clearMemory();
            InHomeUtils.redirectToHomePage();
        }
    } else {
        await getMon(dispatch, visitId, stateFromLq);
    }

}
export const getMon = async (dispatch, visitId, stateFromLq, isRetry = false) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "Inside getMon", PAGEACTIVITY.UA));
        // let url = apiUrl().getMon;
        // if (InHomeUtils.isNotEmpty(stateFromLq)){
        //     url += "?serviceState=" + stateFromLq
        // }

        const url = stateFromLq ? apiUrl().getMon + "?serviceState=" + stateFromLq : apiUrl().getMon;

        return api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - Success", PAGEACTIVITY.UA));
                dispatch({ type: BuildProduct.monNo, value: response.data.mon });
                monInvoked(true, dispatch)
            }
            else if (!isRetry) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - " + PAGEACTIVITY.MSG.notAvailable + "ReAttempt", PAGEACTIVITY.UA));
                getMon(dispatch, visitId, stateFromLq, true);
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response?.meta) && InHomeUtils.getIndexOf(response?.meta?.code, '400') && InHomeUtils.getIndexOf(response?.meta?.description?.toLowerCase(), 'state not found')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - 400 State not found", PAGEACTIVITY.UA));
                errorAction("MON-400", "BuildProduct", 'MON generation failed', "applogs", visitId, dispatch, true, "StateNotFound");
            } else if (response && response.meta && response.meta.code && parseInt(response.meta.code) < 504) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - " + response.meta.code, PAGEACTIVITY.UA));
            }// clearing timeInterval on 5xx except 504.

            if (response && response.response && response.response.status < 504) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - " + response.meta.code, PAGEACTIVITY.UA));
            }
            return true;
            // else {
            //     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
            //     errorAction("LBO", "BuildProduct", 'MON generation failed', "applogs", visitId, dispatch, true, "MONGENFailed");
            // }
        })
            .catch(error => {
                let errorMsg = `MethodName:getMon,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', errorMsg, PAGEACTIVITY.UA));
                errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
                return true;
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getMon', ex);
    }
}

export const socInvoked = (status, dispatch) => {
    dispatch({ type: BuildProduct.socInvoked, value: status })
};

export const monInvoked = (status, dispatch) => {
    dispatch({ type: BuildProduct.monInvoked, value: status })
};

export const setResumedMON = (status, dispatch) => {
    dispatch({ type: BuildProduct.monNo, value: status })
};

export const customRouterCheck = (status, dispatch) => {
    dispatch({ type: BuildProduct.cutomeRouterCheck, value: status })
};

export const updateCheckoutBtnStatus = (val, dispatch) => {
    dispatch({ type: BuildProduct.updateCheckoutBtnStatus, value: val })
}

export const couponErr = (status, dispatch) => {
    dispatch({ type: "COUPONVALIDATIONERROR", value: status })
};
export const couponSuccess = (status, dispatch) => {
    dispatch({ type: "COUPONSUCCESS", value: status })
}
export const couponRemoved = (status, dispatch) => {
    dispatch({ type: "COUPONREMOVED", value: status })
}
export const couponIsoc = (status, dispatch) => {
    dispatch({ type: "COUPONISOC", value: status })
}
export const validateInputcoupon = (action, dispatch) => {
    dispatch({ type: "COUPONVALIDATION", value: action });
}

export const updateGPONINOTContract = (action, dispatch) => {
    dispatch({ type: "UPDATE_GPONIONT_CONTRACT", value: action });
}
export const updateVideoContract = (action, dispatch) => {
    dispatch({ type: "UPDATE_VIDEO_CONTRACT", value: action });
}
export const updateContractStatus = (action, dispatch) => {
    dispatch({ type: "UPDATE_CONTRACT_STATUS", value: action });
}

export const processViewDetails = (usoc, modalId, serviceType, viewDetailObj, dispatch) => {
    let prodViewDetail = viewDetailObj[serviceType][usoc];
    if (prodViewDetail && prodViewDetail.longdesc) {
        let displayText = prodViewDetail.longdesc.replace(/u003C/g, '<')
            .replace(/u003E/g, '>')
            .replace(/\\\'/g, "'")
        modalAction.openModalWindow(modalId, dispatch);
        dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: displayText });
    }
}

export const saveTheSaleFromDataAEM = (visitId, dispatch) => {
    try {     
           
        const saveIsocOffers = ['R3883', 'R3884','R3885'];
        let url = `${apiUrl().viewDetailAEM}${'data.json'}`;
        if (store && store.getState && store.getState().buildProduct && store.getState().buildProduct.saveTheSale) {           
                
            const selectedInternetService = store.getState().buildProduct?.internet?.selectedProduct?.specialOffers?.filter(save => saveIsocOffers.includes(save.id));
            let usoc = selectedInternetService?.length > 0 ? selectedInternetService[0]?.id :'';
            if(usoc){
                const saveSalsObj={'savetheSaleoffer':selectedInternetService[0]}; 
                const savetheSale = Object.assign({}, store.getState().buildProduct.saveTheSale, {...saveSalsObj});
                dispatch({type:"UPDATE_SAVETHESALE_OFFER", value:savetheSale})       
            }                 
            
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'viewDetails', ex);
    }
}

export const viewDetailsFromAEM = (modalId, prodType, visitId, dispatch, QAM_Type = "") => {
    console.log(modalId, 'Get Modal ID');
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" }
        });
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "Inside viewDetails"));
        let serviceType = 'DAT';
        let usoc = modalId;
        if ((modalId.indexOf('DETAIL') > -1) || (modalId.indexOf('SPLOFFER') > -1) || (modalId.indexOf('FLASHOFFER') > -1)) {
            usoc = modalId.split('_')[1];
            if (QAM_Type === 'QAM' && ((usoc === 'N0017') || (usoc === 'N0018') || (usoc === 'N0020'))) {
                usoc = `${usoc}_QAM`
            }
        }
        if (InHomeUtils.isNotNull(usoc) && usoc === 'R0276') {
            const isNYDMASpeed = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqQualdetails && store.getState().loopQual.lqQualdetails.getAdditionalInfo && store.getState().loopQual.lqQualdetails.getAdditionalInfo.isNYDMA;
            const speedCode = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.selectedProduct && store.getState().buildProduct.internet.selectedProduct.speedCode;

            if (isNYDMASpeed && speedCode === '940') {
                usoc = usoc + '_500';
            }
        }
        // if(prodType === Service.voice) {
        //     const isNYDMA = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqQualdetails && store.getState().loopQual.lqQualdetails.getAdditionalInfo && store.getState().loopQual.lqQualdetails.getAdditionalInfo.isNYDMA;
        //     usoc = isNYDMA ? usoc+'0' : usoc;
        // }
        switch (prodType) {
            case Service.internet:
            case Service.router:
            case Service.customRouter:
            case Service.techSure:
            case Service.streamServ:
                serviceType = 'DAT';
                break;

            case Service.tv:
            case Service.customTV:
            case Service.vRoom:
            case Service.recording:
            case Service.channel:
            case Service.intrnlChnl:
                serviceType = 'VID';
                break;

            case Service.voice:
            case Service.intlPlans:
            case Service.listing:
            case Service.battery:
            case Service.batteryshipment:
                serviceType = 'FDV';
                break;
            default:
                serviceType = 'DAT';
                break;
        }
        let url = `${apiUrl().viewDetailAEM}${serviceType === 'DAT' ? 'data' : serviceType === 'VID' ? 'tv' : 'voice'}.json`;
        if (store && store.getState && store.getState().buildProduct && store.getState().buildProduct.viewDetails) {
            if ((serviceType === 'DAT' && store.getState().buildProduct.viewDetails.DAT) || (serviceType === 'VID' && store.getState().buildProduct.viewDetails.VID) || (serviceType === 'FDV' && store.getState().buildProduct.viewDetails.FDV)) {
                processViewDetails(usoc, modalId, serviceType, store.getState().buildProduct.viewDetails, dispatch)
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                api(url, 'GET', '', 'text/plain').then(response => {
                    if (typeof response === 'string' && response) {
                        console.log(response, 'response getting');
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetailsFromAEM', "viewDetailsFromAEM - Success"));
                        let jsonString = response
                            .replace(/^\s+|\s+$/g, "")
                            .replace(/\s+/g, " ")
                            .replace(/\\n/g, "\\n")
                            .replace(/\'/g, "\\\\'")
                            .replace(/\/\//g, "\\\/\\/")
                            .replace(/\\r/g, "\\r")
                            .replace(/\\t/g, "\\t")
                            .replace(/\\b/g, "\\b")
                            .replace(/\\f/g, "\\f")
                            .replace(/\</g, 'u003C')
                            .replace(/\>/g, 'u003E');
                        //let uint8array = new TextEncoder("utf-8").encode(jsonString);
                        //let resstring = new TextDecoder("utf-8").decode(uint8array);
                        //     console.log(JSON.parse(resstring));
                        response = JSON.parse(jsonString);
                        // console.log(response);
                        if (response && response.Products && response.Products.length) {
                            let parsedResponse = {};
                            response.Products.forEach(item => {
                                let viewdetailsidentifier = item.identifier ? item.identifier : '';
                                parsedResponse[viewdetailsidentifier] = { ...item };
                            });
                            let viewDetailObj = {};
                            viewDetailObj[serviceType] = parsedResponse;
                            dispatch({ type: 'VIEW_DETAILS_AEM_UPDATE', value: viewDetailObj });
                            processViewDetails(usoc, modalId, serviceType, viewDetailObj, dispatch)
                        }
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }
                    else {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetailsFromAEM', "viewDetailsFromAEM - Failed"));
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        viewDetailsExpApi(modalId, prodType, visitId, dispatch, QAM_Type = "");
                    }
                }).catch(error => {
                    let errorMsg = `MethodName:viewDetailsFromAEM,errorMessage:${error.message}`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                    errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
                    dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: '' });
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                });
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'viewDetails', ex);
    }
}

export const viewDetailsExpApi = (modalId, prodType, visitId, dispatch, QAM_Type = "") => {
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" }
        });
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "Inside viewDetails"));
        let url = apiUrl().viewDetail;
        let usoc = modalId;
        if ((modalId.indexOf('DETAIL') > -1) || (modalId.indexOf('SPLOFFER') > -1) || (modalId.indexOf('FLASHOFFER') > -1)) {
            usoc = modalId.split('_')[1];
            if (QAM_Type === 'QAM' && ((usoc === 'N0017') || (usoc === 'N0018') || (usoc === 'N0020'))) {
                usoc = `${usoc}_QAM`
            }
        }
        if (InHomeUtils.isNotNull(usoc) && usoc === 'R0276') {
            const isNYDMASpeed = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqQualdetails && store.getState().loopQual.lqQualdetails.getAdditionalInfo && store.getState().loopQual.lqQualdetails.getAdditionalInfo.isNYDMA;
            const speedCode = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.selectedProduct && store.getState().buildProduct.internet.selectedProduct.speedCode;

            if (isNYDMASpeed && speedCode === '940') {
                usoc = usoc + '_500';
            }
        }
        // if(prodType === Service.voice) {
        //     const isNYDMA = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqQualdetails && store.getState().loopQual.lqQualdetails.getAdditionalInfo && store.getState().loopQual.lqQualdetails.getAdditionalInfo.isNYDMA;
        //     usoc = isNYDMA ? usoc+'0' : usoc;
        // }
        switch (prodType) {
            case Service.internet:
            case Service.router:
            case Service.customRouter:
            case Service.techSure:
            case Service.streamServ:
                url += '/DAT/' + usoc;
                break;

            case Service.tv:
            case Service.customTV:
            case Service.vRoom:
            case Service.recording:
            case Service.channel:
            case Service.intrnlChnl:

                url += '/VID/' + usoc;
                break;

            case Service.voice:
            case Service.intlPlans:
            case Service.listing:
            case Service.battery:
            case Service.batteryshipment:
                url += '/FDV/' + usoc;
                break;
            default:
                url += '/DAT/' + usoc;
                break;
        }

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "viewDetails - Success"));
                modalAction.openModalWindow(modalId, dispatch);
                dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: response.data });
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "viewDetails - Failed"));
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }).catch(error => {
            let errorMsg = `MethodName:viewDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            //  vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
            dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: '' });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'viewDetails', ex);
    }
}
export const viewDetails = (modalId, prodType, visitId, dispatch) => {
    let QAM_Type = store.getState().loopQual?.runtimeKey?.QAM === 'Y' && store.getState().loopQual?.lqResponse ?.ontPonType !== 'BPON' ? 'QAM' : '';
    viewDetailsFromAEM(modalId, prodType, visitId, dispatch, QAM_Type);
    if (!(store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.viewdetailsaem && store.getState().loopQual.runtimeKey.viewdetailsaem.toUpperCase() === 'N')) {
        viewDetailsFromAEM(modalId, prodType, visitId, dispatch, QAM_Type);
    }
    else {
        viewDetailsExpApi(modalId, prodType, visitId, dispatch, QAM_Type);
    }
}


export const tellMeDetails = (prodType, visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'tellMeDetails', "Inside tellMeDetails"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        let url = apiUrl().viewDetail + '/DAT/';

        if (prodType.indexOf('HELP') > -1) {
            url += prodType.substring(4);
        } else {
            url += prodType;
        }

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'tellMeDetails', "tellMeDetails - Success"));
                modalAction.openModalWindow(prodType, dispatch);
                //dispatch({ type: 'UPDATE_TELLMECONTENT', value: response.data });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return response.data;
            } else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'tellMeDetails', "tellMeDetails - Failed"));
                //dispatch({ type: 'UPDATE_TELLMECONTENT', value: '' });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return "";
            }
        }).catch(error => {
            let errorMsg = `MethodName:tellMeDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
            //dispatch({ type: 'UPDATE_TELLMECONTENT', value: '' });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return "";
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'tellMeDetails', ex);
    }
}

export const seeFcpDetails = (prodType, visitId, dispatch, usocList) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'seeFcpDetails', "Inside seeFcpDetails"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        let url = apiUrl().seeFcpDetail + "/" + usocList;

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'seeFcpDetails', "seeFcpDetails - Success"));
                dispatch({ type: BuildProduct.fcpSeeDetails, value: response.data });
                modalAction.openModalWindow(prodType, dispatch);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return response.data;
            } else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'seeFcpDetails', "seeFcpDetails - Failed"));
                // dispatch({type: BuildProduct.fcpSeeDetails, value:response.data})
                // modalAction.openModalWindow(prodType, dispatch);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return "";
            }
        }).catch(error => {
            let errorMsg = `MethodName:seeFcpDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return "";
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'seeFcpDetails', ex);
    }
}

export const doPrefetch = (action, dispatch, visitId, stateInfo, contract, selectedCoreServices, isContractSwitched, isLocalTVInCart,
    isDCTinCart, isDoFlow, isChecked = false, serviceInCart = null, buildProductState = null, saveState = null, hoaFlowDetails = null, lqState = null, voicetn = "", isRouterAPIInvoked=false) => {

    prefetchAction.prefetch(action, dispatch, visitId, stateInfo, contract, selectedCoreServices, isContractSwitched, isLocalTVInCart,
        isDCTinCart, isDoFlow, isChecked, serviceInCart, buildProductState, saveState, hoaFlowDetails, lqState, voicetn, isRouterAPIInvoked);
}

export const setDCTEligibility = (dispatch, state) => {
    let eligible = false;
    // if (InHomeUtils.isNotEmpty(state) && state === "MD")
    //     eligible = true;
    dispatch({
        type: 'SET_DCT_ELIGIBLE',
        value: eligible
    });
}

export const fetchInternetSubProducts = (dispatch, visitId, orderType) => {
    //fetchRouter(dispatch, visitId);
    fetchTechSure(dispatch, visitId, orderType);
}

export const fetchTVSubProducts = (dispatch, visitId, couponFlowType = null, selectedProdId, orderType) => {
    //fetchRouter(dispatch, visitId);
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVSubProducts', "Inside fetchTVSubProducts"));
    fetchVRoom(dispatch, visitId, "", "", orderType);
    fetchRecording(dispatch, visitId, couponFlowType, orderType);
    fetchChannel(dispatch, visitId, selectedProdId, orderType);
    fetchIntrChannel(dispatch, visitId, selectedProdId, orderType);
    fetchDCT(dispatch, visitId, orderType);
    fetchCeapps(dispatch, visitId, selectedProdId, orderType);
}

export const fetchVoiceSubProducts = (dispatch, visitId, orderType) => {
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVoiceSubProducts', "Inside fetchVoiceSubProducts"));
    fetchIntlPlans(dispatch, visitId, orderType);
    fetchListing(dispatch, visitId, orderType);
    fetchWinbackProducts(dispatch, orderType);
    fetchBackup(dispatch, visitId, orderType);
}

export const updatecontractforSC = (contract, flag, dispatch, couponFlowType = null) => {
    let contractUpdated = {
        contract: contract,
        tileFlag: true,
        isEmpFlow: false
    }
    if (InHomeUtils.isNotEmpty(contract) && contract === "MTM") {
        contractUpdated.tileFlag = false;
        if (InHomeUtils.isNotNull(flag) && flag) {
            contractUpdated.tileFlag = true;
        }
    }
    if (InHomeUtils.isNotEmpty(couponFlowType) && (couponFlowType === "Employee" || couponFlowType === "Retiree")) {
        contractUpdated.isEmpFlow = true;
    }
    dispatch({ type: BuildProduct.contractInSmartCart, value: contractUpdated })
};

export const updateContractAccordionStatus = (dispatch, val) => {
    dispatch({ type: BuildProduct.updateContractAccordionStatus, value: val })
};

export const getofferDisclaimer = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getofferDisclaimer', "Inside getofferDisclaimer"));
        let getVzIdUrl = apiUrl().getDisclaimer;
        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                dispatch({ type: 'DISCLAIMER_CONTENT_FRAGMENTS', value: response });
            }
        })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getofferDisclaimer', ex);
    }
}

export const getofferDisclaimerFromAEM = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getofferDisclaimerFromAEM', "Inside getofferDisclaimerFromAEM"));
        let getVzIdUrl = apiUrl().getDisclaimerAEM;
        var host = window.location.host;
        if (host.indexOf("sit") > -1) {
            getVzIdUrl = apiUrl().getDisclaimer;
        }
        api(getVzIdUrl, 'GET', '').then(response => {
            if (response && response.items && response.items.length) {
                let parsedResponse = {};
                response.items.forEach(item => {
                    let discpromoidentifier = '';
                    if (InHomeUtils.isNotEmpty(item.promoid)) {
                        discpromoidentifier = (item.promoid ? item.promoid : '') + '~' + (item.offerid ? item.offerid : '');
                        parsedResponse[discpromoidentifier] = { ...item };
                    } else {
                        discpromoidentifier = (item.offerid ? item.offerid : '');
                        parsedResponse[discpromoidentifier] = { ...item };
                    }
                });
                dispatch({ type: 'DISCLAIMER_CONTENT_FRAGMENTS_FROM_AEM', value: parsedResponse });
            }
            else {
                getofferDisclaimer(dispatch, visitId);
            }
        })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getofferDisclaimer', ex);
    }
}

export const getProductsDisclaimer = (dispatch, visitId, isProductDisclaimerAEM) => {
    try {
        let getVzIdUrl = host.indexOf("preprod") > -1 ? apiUrl().getDisclaimerProducts : apiUrl().getDisclaimerProductsAEM;
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getProductsDisclaimer', "Inside getProductsDisclaimer"));
        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                if (response && response.items && response.items.length) {
                    let productDiscResponse = {};
                    response.items.forEach(item => {
                        let productdiscidentifier = (item.productid ? item.productid : '');
                        productDiscResponse[productdiscidentifier] = { ...item };
                    });
                    dispatch({ type: 'DISCLAIMER_PRODUCTS_FRAGMENTS', value: productDiscResponse });
                    checkoutAction.getScreeningInfo(dispatch, visitId, productDiscResponse)
                }
                else {
                    dispatch({ type: 'DISCLAIMER_PRODUCTS_FRAGMENTS', value: response });
                    checkoutAction.getScreeningInfo(dispatch, visitId, response)
                }
            }
        })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getProductsDisclaimer', ex);
    }
}
export const getCommonDisclaimer = (dispatch, visitId, isDirectAEM) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getCommonDisclaimer', "Inside getCommonDisclaimer"));
        let getVzIdUrl = host.indexOf("preprod") > -1 ? apiUrl().getDisclaimerCommon : apiUrl().getCommonAEM;

        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                dispatch({ type: 'DISCLAIMER_COMMON_FRAGMENTS', value: response });
            }
        })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getCommonDisclaimer', ex);
    }
}

export const getPlansPromo = async (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPlansPromo', "Inside getPlansPromo"));
        let getVzIdUrl = apiUrl().getPlansPromo;
        return api(getVzIdUrl, 'GET', '').then(async response => {
            if (InHomeUtils.isNotNull(response)) {
                dispatch({ type: 'PLANSPROMO_CONTENT_FRAGMENTS', value: response });
                dispatch({ type: 'FETCH_EMERGENCY_NOTIFICATION_STATES_CONFIG', value: response });
                return response;
            }
            else
                return null;
        })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                return null;
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getPlansPromo', ex);
        return null;
    }
}

export const getPlansPromoFromAEM = async (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPlansPromoFromAEM', "Inside getPlansPromoFromAEM"));
        let getPlansPromoUrl = apiUrl().getPlansPromoAEM;
        return api(getPlansPromoUrl, 'GET', '').then(async response => {
            if (response && response.items && response.items.length) {
                let parsedResponse = {};
                response.items.forEach(item => {
                    let planspromoidentifier = (item.promoid ? item.promoid : '') + '~' + (item.offerid ? item.offerid : '');
                    parsedResponse[planspromoidentifier] = { ...item };
                });
                dispatch({ type: 'PLANSPROMO_CONTENT_FRAGMENTS_FROM_AEM', value: parsedResponse });
                dispatch({ type: 'FETCH_EMERGENCY_NOTIFICATION_STATES_CONFIG', value: parsedResponse });
                return parsedResponse;
            }
            else
                return getPlansPromo(dispatch, visitId);
        })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                return null;
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getPlansPromo', ex);
        return null;
    }
}
export const setQueryParam = (dispatch, value) => {
    dispatch({type: 'SET_MIDNIGHT', value})
}

export const setShowCloudModal = (dispatch, value) => {
    dispatch({type: 'SET_CLOUD_STEP_DOWN', value})
}

export const setAPEnabled = (dispatch, value) => {
        dispatch({type : 'SET_APENABLED', value})
    }
export const setMnhToggle = (dispatch, value) => {
        dispatch({type : 'SET_MnhToggle', value})
}
export const setPPEnabled = (dispatch, value) => {
      dispatch({type : 'SET_PPENABLED', value})
  }


export const getProductsAEM = (dispatch, visitId) => {
    // ACT112-842 
 if(store.getState()?.loopQual && store.getState()?.loopQual?.runtimeKey  && store.getState()?.loopQual?.runtimeKey?.logsFlag?.toUpperCase() === 'N') {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getProductsAEM', "In get products"));
        const serviceTypes = [ 'tv', 'voice', 'data'];
        serviceTypes?.forEach(type => {
            let getVzIdUrl = apiUrl()?.getProductsAEM?.replace('<service>', type);
            api(getVzIdUrl, 'GET', '').then(response => {
                if (InHomeUtils.isNotNull(response)) {
                    const jsonString = response
                        .replace(/^\s+|\s+$/g, "")
                        .replace(/\s+/g, " ")
                        .replace(/\\n/g, "\\n")
                        .replace(/\'/g, "\\\\'")
                        .replace(/\/\//g, "\\\/\\/")
                        .replace(/\\r/g, "\\r")
                        .replace(/\\t/g, "\\t")
                        .replace(/\\b/g, "\\b")
                        .replace(/\\f/g, "\\f")
                        .replace(/\</g, 'u003C')
                        .replace(/\>/g, 'u003E')
                        .replace(/\\\\\\/g, '');
                    dispatch({ type: 'ALL_PRODUCTS_AEM_FRAGMENTS', value: { response: JSON.parse(jsonString), servType: type }});
                }
            })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getCommonDisclaimer', ex);
    }
 }
}

export const getPerksAEM = async (dispatch, visitId) => {
        // ACT112-842 logs  clean up
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPerksAEM', "Inside getPerksAEM"));
        let getPerksUrl = apiUrl()?.getPerksAEM;
        console.log(getPerksUrl,'getPerksUrl');
        api(getPerksUrl, 'GET', '').then(response => {
            console.log(response,'meta.code');
            console.log(response.data);
            if (InHomeUtils.isNotNull(response)) {
                const jsonString = response
                console.log("***perks",JSON.stringify(jsonString))
                dispatch({ type: 'ALL_PERKS_AEM_FRAGMENTS', value: { response: jsonString, servType: 'perks' }});
            }
        })
        .catch(error => {
            errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getPerksFromAEM', ex);
        return null;
    }
 
}

export const getPopularPlansAEM = async (dispatch, visitId) => {
  try {
      logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPopularPlansAEM', "Inside getPopularPlansAEM"));
      let getPopularPlansUrl = apiUrl()?.getPopularPlansAEM;
      api(getPopularPlansUrl, 'GET', '').then(response => {
          if (InHomeUtils.isNotNull(response)) {
              const jsonString = response
              dispatch({ type: 'PopuplarPlans_AEM', value: { response: jsonString, servType: 'popularPlans' }});
          }
      })
      .catch(error => {
          errorAction("ERROR", "buildProduct popularPlans", error.message, "applogs", visitId, dispatch, false, "");
      });
  }
  catch (ex) {
      catchJSException('BuildProduct', visitId, 'getPopularPlansAEM', ex);
      return null;
  }
}

export const updatePerkSelection = async(requestParams) => {
    const { product, prodId, visitId, add, flowType, dispatch, isMnHAuthenticated, fromUpsell, checkoutClick, offerToggle, fromPopularPlans, buildProductState,specialOfferpromo,offertype,lqState,splOfferProdType, isStreamline, skipTaggingCall} = requestParams;
    // const { data } = product;
    const payload = {
        "contract": "MTM",
        "productId": prodId ? prodId : product?.data?.id,
        "productType": "BYOPERK",
        "quantity": "1",
        "serviceType": "DATA",
        "status": add ? 'remove' : 'add',
        "orderType": "",
        "isMnHAuthenticated":isMnHAuthenticated
    };
    const perkProductId = prodId ? prodId : product?.data?.id;
    let isMethodCompleted = false;
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart"} })

    try {
      // logOtherInfo(detailsInfo('BuildProduct', visitId, 'perk selection', "In update perks"));                
      let perkUpdateUrl = apiUrl()?.updateCartAcc + '/' + visitId;
      await api(perkUpdateUrl, 'POST', JSON.stringify(payload)).then(response => {
          if (InHomeUtils.isNotNull(response)) {  
            //add cybermonday and black friday check
            let blackFridayandCyberMonArray = buildProductState?.internet?.m2mPlans?.filter(item => item?.id === "R3583" || item?.id === "R3582");
            let isBlackFridayOrCyberMonday = blackFridayandCyberMonArray?.[0]?.specialOffers?.findIndex(item => ["R4139","R4093"].includes(item?.id))> -1 ? true : false;
            if((specialOfferpromo?.id == "R4142" || specialOfferpromo?.id =="R4047") && isBlackFridayOrCyberMonday|| specialOfferpromo?.id == "R4261"){
                let cartProducts = getCartProducts(response?.data?.cartTierPricing, visitId)
                    let offersInCart = [];
                    if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts?.CartSubProduct)) {
                        if (InHomeUtils.isNotNull(cartProducts?.CartSubProduct?.SpecialOffers) && InHomeUtils.isNotNull(cartProducts?.CartSubProduct?.SpecialOffers?.rewardoffers)) {
                            offersInCart = cartProducts?.CartSubProduct?.SpecialOffers?.rewardoffers;
                        }
                    }
                updateSweetnerMsg(specialOfferpromo, offertype, false, processOfferSection(offersInCart), lqState, buildProductState, visitId, dispatch, splOfferProdType);
           }
            if(offerToggle !== null || undefined){
                dispatch({type : 'NETMAX_OFFER_TOGGLE', value : offerToggle});    
            }
            // if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)
            //     && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && response.data.cartTierPricing.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName ===  "Perks"))?.subSections?.subSection?.find(s => s?.sectionType === "Perks")?.products?.findIndex((perk)=>perk?.prodId ===  "R3559")>-1){

            // let netMaxPromoAvailable = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName ===  "Promotions"))?.subSections?.subSection?.find(s => s?.sectionType === "SpecialOffers")?.promos?.findIndex((promo)=>promo?.promoId ===  "R4047")>-1 ? true : false

            // let netMaxPromo = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName ===  "Promotions"))?.subSections?.subSection?.find(s => s?.sectionType === "SpecialOffers")?.promos?.find((promo)=>promo?.promoId ===  "R4047")
            
            // const processNetMaxOfferSection = (netMaxPromo) => {
            //   if (
            //     netMaxPromo?.USOCIOSC
            //   ) {
            //       netMaxPromo["id"] = netMaxPromo.USOCIOSC;
            //       netMaxPromo["prodType"] = "SPLOFFER";
            //       netMaxPromo["prodTypeVal"] = netMaxPromo["prodTypeValue"] = "";
            //       netMaxPromo["OfferText"] = netMaxPromo.OfferText;
            //   }
            //   return netMaxPromo;
            // };

            //         if (netMaxPromoAvailable) {
            //             if (netMaxproduct?.offerFor?.toUpperCase() === Service?.data) {
            //                 dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: processNetMaxOfferSection(netMaxPromo) });
            //             }}
            // }
            // const res = JSON.parse(JSON.stringify(response));
            if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)
                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && response.data.cartTierPricing.tierContent.length > 0) {
                const tierContent = response.data.cartTierPricing.tierContent[0];
                if(fromUpsell) {
                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail,
                            cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                        }
                    });
                }
                if(InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections) && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section) && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section.length > 0)) {
                    const perkRes = response.data.cartTierPricing.tierContent[0].sections.section.find(sec => sec.sectionName === 'Perks');
                    const perkName =  requestParams?.perkModalName ? 'perks - '+ requestParams?.perkModalName : product?.displayName ? 'perks - ' + product?.displayName : "perks"
                    if(perkRes && InHomeUtils.isNotNull(perkRes.subSections) && InHomeUtils.isNotNull(perkRes.subSections.subSection) && InHomeUtils.isNotNull(perkRes.subSections.subSection.length > 0)) {
                        const perkProds = perkRes.subSections.subSection.find(sub => sub.sectionType === 'Perks');
                        const prods = perkProds.products;
                        dispatch({ type: 'PERKS_SELECTEDPROD', value: prods});
                    } else {
                        dispatch({ type: 'PERKS_SELECTEDPROD', value: []});
                    }
                    if(!fromPopularPlans){
                        updateDetailValue(perkName)
                        let findNewProduct = product?.perkDetails?.filter((item) =>item?.id == perkProductId)?.[0];
                        if(product?.data && !skipTaggingCall){
                            //PRODDEF-41164
                            let perkLinkName = findNewProduct && findNewProduct.name ? findNewProduct.name :  product.data?.displayName ? product.data.displayName : "";
                            updateSCTags(`${ perkLinkName}-${!add}`);
                        }
                        setTimeout(() => {
                            const buildProduct = store && store.getState().buildProduct;
                            // Avoid page call while toggling on/off Youtube Premium in Perks overlay
                            // if(product,product?.perkDetails?.[0]?.productId !== "R3680"){
                            if(perkName === 'perks' && !requestParams?.perkModalName){
                                tempVzdlSCData.detail = 'perks'}
                            else{
                                tempVzdlSCData.detail = 'perks - ' + product?.data?.displayName;
                            } 
                            tempVzdlSCData.events = !add ? "scAdd" : "scRemove"; 
                            if(isStreamline === true){
                                tempVzdlSCData.name = 'Streamline Buildproducts - Internet & Perks'
                                updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,name,events", false, '', false, '', findNewProduct , '', '', buildProduct)
                            }
                            else{
                                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events", false, '', false, '', findNewProduct, '', '', buildProduct);
                            }
                            // }  
                        }, 2000);
                    }
                }
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
                if (perkProductId === "R3559" && !add) {
                    const netMaxSplOffer = buildProductState?.sploffer?.offerplansMTM?.find((o => o?.id === "R4047" || o?.id === "R4142"));
                    if (netMaxSplOffer) {
                        if (netMaxSplOffer?.offerFor?.toUpperCase() === Service.data) {
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: netMaxSplOffer });
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: netMaxSplOffer });
                        }
                        else if (netMaxSplOffer?.offerFor?.toUpperCase() === Service.video) {
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: netMaxSplOffer });
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID_TV', value: netMaxSplOffer });
                        } else {
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: netMaxSplOffer });
                        }
                    }
                }
                // if Home Device Support & Protection perks were added or removed from the cart update the buildProduct techsure state
                if (perkProductId === "R3731" || perkProductId === "R3784") {
                    const iwmProducts = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(sec => sec?.sectionName?.toLowerCase() === "service")?.subSections?.subSection?.find(sec => sec?.sectionType?.toUpperCase() === "VASSTANDALONE")?.products;
                    dispatch({ type: "TECHSURE_SELECTEDPROD", value: iwmProducts ? iwmProducts : null });
                }

                if (flowType === "SUPP") {
                    let updatedSuppProfileCartStatus = store && store.getState && store.getState().supp && store.getState().supp.suppProfileCartStatus;
                    
                    /* Below two line for identifing if first perk is updated - as suppProfileCartStatus will not update by this time */
                    let searchTerm = prodId ? prodId : product?.data?.id;               
                    const firstPerkStatus = getProductStatus(searchTerm, add, 'BYOPERK');

                    let suppCartupdateStatus = false;
                    if (JSON.stringify(updatedSuppProfileCartStatus).indexOf("ADDED") > -1 || JSON.stringify(updatedSuppProfileCartStatus).indexOf("REMOVED") > -1 || firstPerkStatus == 'ADDED' || firstPerkStatus == 'REMOVED') {
                        suppCartupdateStatus = true;
                    }
                    dispatch({
                        type: "UPDATE_CART_SUPP",
                        value: suppCartupdateStatus
                    });
                }
                isMethodCompleted = true;
            }

            if (flowType === "SUPP") {
                let suppProfileCartStatus = store && store.getState && store.getState()?.supp && store.getState()?.supp?.suppProfileCartStatus;
                let searchTerm = prodId ? prodId : product?.data?.id;
               
                suppProfileCartStatus['BYOPERK'] = getProductStatus(searchTerm, add, 'BYOPERK') //productStatus;
                
                dispatch({
                    type: "UPDATE_PROFILE_CART_STATUS",
                    value: suppProfileCartStatus
                });
            }
            // const perks = res?.data?.cartTierPricing?.tierContent?[0]?.sections;
            // dispatch({ type: 'PERKS_SELECTEDPROD', value: { response: JSON.parse(jsonString), servType: type }});
          }
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "Updating your cart"} })  
        if(isMethodCompleted && fromUpsell && fromUpsell === true && (checkoutClick && typeof checkoutClick === "function")){
            modalAction.closeModalWindow("UPSELL", dispatch);
            checkoutClick();
        }
      })
      .catch(error => {
          errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "Updating your cart"} })
      });
    }
    catch (ex) {
      catchJSException('BuildProduct', visitId, 'getCommonDisclaimer', ex);
    }
};

export const nsiNewRequest = (dispatch, visitId, addressID, state, firstName, lastName, eMailID, phonenumber) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'nsiNewRequest', "Inside nsiNewRequest"));
        let url = apiUrl().nsiNotify;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        api(url, 'POST', getNsiRequest(addressID, state, firstName, lastName, eMailID, phonenumber)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'nsiNewRequest', "nsiNotify - Success"));
                dispatch({
                    type: 'NSI_STATUS',
                    value: response.data
                });
                dispatch({
                    type: FutureNotification.validationsucess,
                    value: true
                });
            }
            else if (InHomeUtils.isNull(response) || (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500') || InHomeUtils.getIndexOf(response.meta.code, '400'))) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'nsiNewRequest', "nsiNotify - Failed"));
                dispatch({
                    type: 'NSI_FAILED',
                    value: true
                });
                if (InHomeUtils.isNull(response)) {
                    dispatch({
                        type: FutureNotification.validationfailure,
                        value: true
                    });
                }
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:nsiNewRequest,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'nsiNewRequest', ex);
    }
};

const getNsiRequest = (addressID, state, firstName, lastName, eMailID, phonenumber) => {
    let request = {
        addressId: addressID,
        programName: 'vzcom',
        inquiryType: 'request',
        nsiID: '',
        state: state,
        firstName: firstName,
        lastName: lastName,
        emailAddress: eMailID,
        contactPhone: phonenumber,
        notifyFios: '',
        notifyFiosTv: 'Y',
        siResponse: ''
    }
    return JSON.stringify(request);
}

export const getProductsFromPlans = (products, prodKey, contract, prodValue) => {
    if (InHomeUtils.isNotNull(contract) && InHomeUtils.isNotNull(products.m2mPlans)) {
        products = contract === 'MTM' ? products.m2mPlans : products.twoYearPlans;
    }
    if (InHomeUtils.isNotNull(products) && InHomeUtils.isNotNull(prodKey) && InHomeUtils.isNotNull(prodValue)) {
        switch (prodKey) {
            case 'id':
                for (let count = 0; count < products.length; count++) {
                    if (InHomeUtils.isNotNull(products[count].id) && products[count].id === prodValue) {
                        return products[count];
                    }
                }
                break;
            case 'prodTypeValue':
                for (let count = 0; count < products.length; count++) {
                    if (InHomeUtils.isNotNull(products[count].prodTypeValue) && products[count].prodTypeValue === prodValue) {
                        return products[count];
                    }
                }
                break;
            case 'name':
                for (let count = 0; count < products.length; count++) {
                    if (InHomeUtils.isNotNull(products[count].name) && products[count].name === prodValue) {
                        return products[count];
                    }
                }
                break;
            default:
                return null
        }
    }
    return null;
}

export const getCoreDataProductFromPlanPerks = (products, prodValue, visitId) => {
    try {
        if (InHomeUtils.isNotNull(products) && InHomeUtils.isNotNull(prodValue)) {
            for (let count = 0; count < products.length; count++) {
                for (let len = 0; len < products[count].planPerks.length; len++) {                    
                    if (InHomeUtils.isNotNull(products[count].id) && products[count].planPerks[len].id === prodValue) {
                        return products[count];
                    }
                }
            }
        }
        return null;
    }
    catch (err) {
        catchJSException('BuildProduct', visitId, 'getCoreDataProductFromPlanPerks', err);
    }
}


export const getFaqBuildProduct = (dispatch, visitId, pageName, faqaem, hoaFlag = "N") => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getFaqBuildProduct', "Inside getFaqBuildProduct"));
        let url = faqaem == "Y" ? apiUrl().getFaqAEM : (apiUrl().getFaq + '/' + pageName);
        let sorrtedResponse = [];
        api(url, 'GET', '').then(response => {
            if (faqaem == "Y") {
                if (InHomeUtils.isNotNull(response) && response.items && response.items.length) {
                    let parsedResponse = [];
                    response.items.forEach(item => {
                        if (hoaFlag === "Y" && item.pagetype == "vecordering") {
                            parsedResponse.push(item);
                        }
                        if (item.pagetype == "buildproduct" && hoaFlag !== "Y") {
                            parsedResponse.push(item);
                        }
                        // if(item.pagetype == "buildproduct"){
                        //     parsedResponse.push(item);
                        // }
                    });

                    if (hoaFlag === "Y") {

                        // for (let prodname = 0; prodname < parsedResponse.length; prodname++) {
                        //     if( parsedResponse[prodname].question.indexOf("Who do I reach") >-1){
                        //         sorrtedResponse.push(parsedResponse[prodname]);
                        //     }                                    
                        // }                 

                        parsedResponse.sort((x, y) => {
                            if (x.question.indexOf("Who do I reach out to answer my questions?") > -1) {
                                return -1;
                            } else if (x.question.indexOf("Who do I reach out to answer my questions?") > -1) {
                                return 0;
                            } else {
                                return 1;
                            }
                        })
                    }
                    // parsedResponse[0] = sorrtedResponse;
                    // parsedResponse.add(1,sorrtedResponse);
                    // parsedResponse.unshift(sorrtedResponse);
                    // parsedResponse.splice(index, 1, sorrtedResponse);
                    //parsedResponse = [...sorrtedResponse,...parsedResponse];
                    dispatch({ type: 'FAQ_BUILDPRODUCT_CONTENT', value: parsedResponse });
                }
            }
            else {
                if (InHomeUtils.isNotNull(response))
                    dispatch({ type: 'FAQ_BUILDPRODUCT_CONTENT', value: response });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:getFaqBuildProduct,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getFaqBuildProduct', ex);
    }
}

export const autoPayinCart = (status, dispatch) => {
    dispatch({ type: 'AUTOPAYINCART', value: status });
};
export const advantageOfferinCart = (status, dispatch) => {
    dispatch({ type: 'ADVANTAGEOFFERINCART', value: status });
};
export const fiosSetupFee = (action, dispatch) => {
    dispatch({ type: 'FIOSSETUPFEE', value: action });
};

export const removeNonSupportedProducts = (dispatch, visitId, request, nonProductIds, nonprods, removedProducts, flowType, buildProductState = null) => {
    let isMnHAuthenticated = ""
    if(buildProductState?.internet?.mnhSignupIndicator !== "" && buildProductState?.internet?.mnhSignupIndicator !== null && buildProductState?.internet?.mnhSignupIndicator !== undefined){
        isMnHAuthenticated = buildProductState?.internet?.mnhSignupIndicator
      }
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'removeNonSupportedProducts', "Inside removeNonSupportedProducts"));
        let url = apiUrl().updateCartAcc + '/' + visitId;

        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" } });

        api(url, 'POST', JSON.stringify(request)).then(response => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'removeNonSupportedProducts', "updateCart - Success"));
                dispatch({ type: 'UPDATE_UNSUPPORTED_PRODUCTS', value: updateNonProduct(removedProducts, nonprods, visitId) });
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                        cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
                dispatch({ type: 'ISCARTUPDATED', value: true });
                dispatch({ type: 'CART_SAVE_ON_UPDATE', value: true });
                if (flowType === "SUPP") {
                    dispatch({ type: 'UPDATE_CART_SUPP', value: true });
                }
                // Changes for  PR00032100  HBO Only
                if (InHomeUtils.isNotNull(removedProducts) && removedProducts.length > 0 && InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.hboUnSupportedNotificationInfo) && InHomeUtils.isNotNull(buildProductState.hboUnSupportedNotificationInfo.removeChannel) && InHomeUtils.isNotEmpty(buildProductState.hboUnSupportedNotificationInfo.removeChannel) && InHomeUtils.isNotNull(buildProductState.hboUnSupportedNotificationInfo.addChannel) && InHomeUtils.isNotEmpty(buildProductState.hboUnSupportedNotificationInfo.addChannel)) {
                    configureSwappedProductsForHBO(buildProductState, removedProducts, dispatch);
                }
                if (request.productType.indexOf('VROOM') > -1   && request.status.indexOf('remove') > -1  ) {
                    dispatch({ type: 'VROOM_SELECTEDPROD', value: null });
                }
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'removeNonSupportedProducts', "updateCart - Failed"));
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:removeNonSupportedProducts,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'removeNonSupportedProducts', ex);
    }
}
// Changes for  PR00032100  HBO Only
export const configureSwappedProductsForHBO = (buildProductState, removedProducts, dispatch) => {
    const removedHBOProducts = removedProducts.filter(p => p === buildProductState.hboUnSupportedNotificationInfo.removeChannel);
    if (InHomeUtils.isNotNull(removedHBOProducts) && removedHBOProducts.length > 0 && InHomeUtils.isNotNull(buildProductState.hboUnSupportedNotificationInfo) && InHomeUtils.isNotNull(buildProductState.hboUnSupportedNotificationInfo.addChannel) && InHomeUtils.isNotEmpty(buildProductState.hboUnSupportedNotificationInfo.addChannel)) {
        var channelAdd = buildProductState.hboUnSupportedNotificationInfo.addChannel;
        buildProductState.hboUnSupportedNotificationInfo.addChannel = '';
        buildProductState.hboUnSupportedNotificationInfo.removeChannel = '';
        buildProductState.hboUnSupportedNotificationInfo.showNotification = false;
        buildProductState.hboUnSupportedNotificationInfo.swapStatus = true;
        let hboUnSupportedNotificationInfo = {
            addChannel: '',
            removeChannel: '',
            showNotification: false,
            swapStatus: true
        }
        dispatch({ type: 'HBOUNSUPPORTED_NOTIFICATION', value: hboUnSupportedNotificationInfo });

        if (InHomeUtils.isNotNull(document.querySelector('#CHANNEL_SECTION')) && InHomeUtils.isNotNull(document.querySelector('#CHANNEL_SECTION').querySelector('#' + channelAdd)) && InHomeUtils.isNotNull(document.querySelector('#CHANNEL_SECTION').querySelector('#' + channelAdd).querySelector('.blocks_equipment-choices'))) {
            var selectedChannel = document.querySelector('#CHANNEL_SECTION').querySelector('#' + channelAdd).querySelector('.blocks_equipment-choices');
            if (InHomeUtils.isNotNull(selectedChannel)) {
                selectedChannel.click();
            }
        }
    }
}
export const fetchUpsellrecommendations = (dispatch, visitId, isDoFlow = false, lqState) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchUpsellrecommendations', "Inside fetchUpsellrecommendations"));
        let mnhupsell = false;
        dispatch({ type: BuildProduct.upsellCallStatus, value: true })
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "processing...", isLoaderImg: "loader" }
        });
        let url = apiUrl().getProduct + '/upsell/' + visitId;

        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchUpsellrecommendations', "fetchUpsellrecommendations - Success"));
                dispatch({ type: BuildProduct.saveUpsell, value: response.data })
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    modalAction.openModalWindow("UPSELL", dispatch);
                    let flow = isDoFlow ? "do accord" : "byob";
                    let speedCode = "";
                    response.data.products.map(prod => {
                        if (prod.display) {
                            switch (prod.prodType) {
                                case ProductType.INTERNET_PLAN:
                                    speedCode = prod.speedCode;
                                    break;
                                default: break;
                            }
                        }
                        return;
                    });
                    let mnhUpsellPrice = response.data.price.includes('$0.00') ? '0' : (response.data.price.includes('.00')) ? response.data.price.replace('.00', '') : response.data.price;

                    if (InHomeUtils.isNotNull(speedCode) && speedCode === "941" && InHomeUtils.isNotNull(lqState.vzwOffer) && lqState.vzwOffer.indexOf("VZWADVOFFERELIGIBLE:Y") > -1 && InHomeUtils.isNotNull(lqState.lqResponse) && InHomeUtils.isNotNull(lqState.lqResponse.wirelessPlanType)) {
                        if (lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && lqState.lqResponse.wirelessPlanType === 'UNLIMITED') {
                            tempSCData.detailPageName = `${flow}|upsell ovrly|upgrd to ${mnhUpsellPrice}-unlmtgig`;
                            tempVzdlSCData.detail = `upsell ovrly-upgrd to ${mnhUpsellPrice}-unlmtgig`;
                            updateSCcustomEvent("upsellInit", "ddPageViewUpdateEvent", "detailPageName");
                            updateVzdlSCCustomEvent("upsellInit", "pageViewOmni", "detail");
                        }
                        else if (lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && lqState.lqResponse.wirelessPlanType === 'METERED') {
                            tempSCData.detailPageName = `${flow}|upsell ovrly|upgrd to ${mnhUpsellPrice}-mtdgig`;
                            tempVzdlSCData.detail = `upsell ovrly-upgrd to ${mnhUpsellPrice}-mtdgig`;
                            updateSCcustomEvent("upsellInit", "ddPageViewUpdateEvent", "detailPageName");
                            updateVzdlSCCustomEvent("upsellInit", "pageViewOmni", "detail");
                        }
                        else if (lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && lqState.lqResponse.wirelessPlanType === 'UNLIMITED') {
                            tempSCData.detailPageName = `${flow}|upsell ovrly|upgrd to ${mnhUpsellPrice}-unlmtgig bns`;
                            tempVzdlSCData.detail = `upsell ovrly-upgrd to ${mnhUpsellPrice}-unlmtgig bns`;
                            updateSCcustomEvent("upsellInit", "ddPageViewUpdateEvent", "detailPageName");
                            updateVzdlSCCustomEvent("upsellInit", "pageViewOmni", "detail");
                        }
                        else if (lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && lqState.lqResponse.wirelessPlanType === 'METERED') {
                            tempSCData.detailPageName = `${flow}|upsell ovrly|upgrd to ${mnhUpsellPrice}-mtdgig bns`;
                            tempVzdlSCData.detail = `upsell ovrly-upgrd to ${mnhUpsellPrice}-mtdgig bns`;
                            updateSCcustomEvent("upsellInit", "ddPageViewUpdateEvent", "detailPageName");
                            updateVzdlSCCustomEvent("upsellInit", "pageViewOmni", "detail");
                        }
                    }
                    else {
                        let cartProd = parseInt(response.data.oncartkey.match(/\d+/), 10);
                        let upsellProd = "";
                        if (response.data.services = BuildProduct.UpsellService.tv) {
                            // upsellService = "tv plan"
                            if (cartProd === 7818) {
                                cartProd = "your fios tv";
                            }
                            else if (cartProd === 6456) {
                                cartProd = "more fios tv";
                            }
                        }

                        if (response.data.products.length > 0) {
                            if (response.data.oncartkey && response.data.oncartkey === 'FTTP_1000M_1000M') {
                                upsellProd = "protect home";
                            }
                            else {
                                if (InHomeUtils.isNotNull(window.targetupsell) && window.targetupsell === 'Y' && InHomeUtils.isNotNull(window.showupsell) && window.showupsell === 'Y') {
                                    if (response.data.oncartkey && (response.data.oncartkey === 'FTTP_1000M_1000M:Q9854' || response.data.oncartkey === 'FTTP_1000M_1000M:R0477')) {
                                        mnhupsell = true;
                                    }
                                }
                                else {
                                    let upsellObject = response.data.products.filter(product => product.display);
                                    if (InHomeUtils.isNotEmpty(upsellObject) && upsellObject.length > 0 && InHomeUtils.isNotEmpty(upsellObject[0].name)) {
                                        upsellProd = upsellObject[0]?.name?.toLowerCase();
                                    }
                                }
                            }
                        }
                        tempSCData.pageName = isDoFlow ? "do accord" : "byob";

                        if (mnhupsell) {
                            tempSCData.detailPageName = (isDoFlow ? "do accord upsell| " : "byob| upsell| ") + "switch to vzw unlimited";
                            // tempSCData.detailPageName = (isDoFlow ? "do accord upsell| " : "byob| upsell| ") + ""+upsellService+" - "+cartProd+ ""+response.data.services == BuildProduct.UpsellService.tv+"" ? "" : " mbps to " + upsellProd ; 
                            tempVzdlSCData.detail = "upsell switch to vzw unlimited";
                        }
                        else {
                            tempSCData.detailPageName = (isDoFlow ? "do accord upsell| " : "byob| upsell| ") + "internet plan - " + cartProd + " mbps to " + upsellProd;
                            // tempSCData.detailPageName = (isDoFlow ? "do accord upsell| " : "byob| upsell| ") + ""+upsellService+" - "+cartProd+ ""+response.data.services == BuildProduct.UpsellService.tv+"" ? "" : " mbps to " + upsellProd ; 
                            if(response.data.oncartkey && response.data.oncartkey === 'FTTP_1000M_1000M') {
                            tempVzdlSCData.detail = "Verizon Home Device Protection Model";}
                            else if(response.data.oncartkey && ['FTTP_100M_100M', 'FTTP_300M_300M', 'FTTP_500M_500M']?.includes(response.data.oncartkey)) {
                                tempVzdlSCData.detail = "upsell internet plan - 1 gig";
                            }
                            tempVzdlSCData.events="prodView";
                        }
                        //tempSCData.detailPageName = (isDoFlow ? "do accord upsell| " : "byob| upsell| ") + "internet plan - " + cartProd + " mbps to " + upsellProd;
                        // tempSCData.detailPageName = (isDoFlow ? "do accord upsell| " : "byob| upsell| ") + ""+upsellService+" - "+cartProd+ ""+response.data.services == BuildProduct.UpsellService.tv+"" ? "" : " mbps to " + upsellProd ; 
                        //tempVzdlSCData.detail = "upsell internet plan - " + cartProd + " mbps to " + upsellProd;
                        // tempVzdlSCData.detail = "upsell "+upsellService+" - "+cartProd+ ""+response.data.services == BuildProduct.UpsellService.tv+"" ? "" : " mbps to " + upsellProd ;
                        tempSCData.events = "event5,event15,event20,event46";
                        tempSCData.contentChannel = "/vz/residential/order/prospect accord/select";
                        updateSCcustomEvent("upsellInit", "ddPageViewUpdateEvent", "detailPageName,pageName,events,contentChannel");
                        updateVzdlSCCustomEvent("upsellInit", "pageViewOmni", "detail,events", false, mnhupsell ? "mnhupsell" : "");
                    }
                }
                else
                    dispatch({ type: BuildProduct.checkoutBtnSelection, value: true })
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchUpsellrecommendations', "fetchUpsellrecommendations - Failed"));
                dispatch({ type: BuildProduct.checkoutBtnSelection, value: true })
            }
            dispatch({ type: BuildProduct.upsellCallStatus, value: false })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchUpsellrecommendations,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: BuildProduct.checkoutBtnSelection, value: true });
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchUpsellrecommendations', ex);
    }
}

export const checkoutBtnSelection = (dispatch, value) => {
    dispatch({ type: BuildProduct.checkoutBtnSelection, value: value })
}

export const upSellCTA = (dispatch, value) => {
    dispatch({ type: BuildProduct.upsellCTA, value: value })
}

export const getServiceType = (prodType) => {
    let serviceType = '';
    if(InHomeUtils.isNotNull(prodType)){
    serviceType = prodType.indexOf('FTTP') >= 0 ? Service.internet : prodType.indexOf('ROUTER') >= 0 ? Service.router :
    prodType.indexOf('ACCESSPOINTNRCBILLER') >= 0 ? Service.router : prodType.indexOf('ACCESSPOINTBILLER') >= 0 ? Service.router :
        prodType.indexOf('PPP') >= 0 ? Service.techSure : prodType.indexOf('OTTBASIC') >= 0 ? Service.streamServ : prodType.indexOf('BASIC') >= 0 ? Service.tv :
            prodType.indexOf('FVPRIMARY') >= 0 ? Service.voice : prodType.indexOf('DUMMYVROOM') >= 0 ? Service.dummyvRoom : prodType.indexOf('VROOM') >= 0 ? Service.vRoom : prodType.indexOf('CEDEVICEAPPBNDL') >= 0 ? Service.ceAppsBundle : prodType.indexOf('CEDEVICEAPP') >= 0 ? Service.ceAppsParity :
                prodType.indexOf('VFEATURE') >= 0 ? Service.recording : (prodType.indexOf('FVNONPUB') >= 0 || prodType.indexOf('FVLISTMAIN') >= 0) ? Service.listing :
                    prodType.indexOf('SLABATTERYSHIPMENT') >= 0 || prodType.indexOf('DCELLTRAYSHIPMENT') >= 0 ? Service.batteryshipment :
                        prodType.indexOf('BATTERY') >= 0 || prodType.indexOf('DCELL') >= 0 ? Service.battery : prodType.indexOf('INTLPREMIUM') >= 0 ? Service.intrnlChnl : prodType.indexOf('PREMIUM') >= 0 ? Service.channel :
                            prodType.indexOf('FVINTLPLAN') >= 0 ? Service.intlPlans : prodType.indexOf('WINBACK') >= 0 ? Service.winBack : prodType.indexOf('VCPESTB') >= 0 ? Service.dct :
                                prodType.indexOf('SPLOFFER') >= 0 ? Service.splOffer : prodType.indexOf('FLASHOFFER') >= 0 ? Service.flashOffer : prodType.indexOf('OTTEQUIPNRC') >= 0 ? Service.streamDev : prodType.indexOf('STREAMDEVCNT') >= 0 ? Service.streamDevCount : prodType.indexOf('BYOPERK') >= 0 ? Service.perks : '';
    }

    return serviceType;
}

export const getFcpEligibility = (visitId) => {
    let url = apiUrl().getProduct + '/getFcpEligibility';
    return new Promise((resolve, reject) => {
        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response))
                resolve(response);
            else {
                resolve(false);
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:getFcpEligibility,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "getFcpEligibility", errorMsg, getErrorLogUrl, "applogs", visitId);
                resolve(false);
            });
    })
}
export const updateRequestTNForFDV = (visitId, tn, dispatch, fireAndForget = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateRequestTNForFDV', "Inside updateRequestTNForFDV", PAGEACTIVITY.UA));
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let request = setTNRequestForFDV(tn);
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && !fireAndForget) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateRequestTNForFDV', "update Cart - Success", PAGEACTIVITY.UA));
                dispatch({ type: Save.isTNUpdatedForResumeSmartCart, value: true });
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing) && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && InHomeUtils.isNotNull(response.data.orderDetail)) {
                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail,
                            cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                        }
                    });
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateRequestTNForFDV', "updateRequestTNForFDV - Order Detail null", PAGEACTIVITY.UA));
                }
            }
            else {
                if (fireAndForget) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateRequestTNForFDV - FireAndForget', "update Cart - " + PAGEACTIVITY.MSG.available, PAGEACTIVITY.UA));
                } else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateRequestTNForFDV', "update Cart - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                }
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateRequestTNForFDV,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateRequestTNForFDV', ex);
    }
}

const setTNRequestForFDV = (tnValue) => {
    let request = {
        key: "UPDATETN",
        value: tnValue,
        action: "add"
    }
    return JSON.stringify(request)
}

export const updateFiosFiveCartReqObj = (request, product) => {
    if (product.fiosFiveSelectedChannels && product.fiosFiveSelectedChannels.length > 0) {
        let allPackageIds = {
            "PACKA": undefined,
            "PACKB": undefined
        };
        request.productId = request.productId + ":add," + product.fiosFiveSelectedChannels.map((el) => el.id + ":add").join(',');
        product.fiosFiveSelectedChannels.forEach((channel) => {
            request.productType += ",BASIC_FF";
            if (channel.packageType && !allPackageIds[channel.packageType]) {
                allPackageIds[channel.packageType] = channel.packageId;
            }

        });
        //update request for package info
        /* on hold
        let packageId = allPackageIds.PACKA || allPackageIds.PACKB;
        if (packageId) {
            request.productId = request.productId + "," + packageId + ":add";
            request.productType += ",BASIC_FF";
        }
        */
        delete product.fiosFiveSelectedChannels;
    }
}

export const updateIntlPackageCartReqObj = (request, product) => {
    if (product && product.internationalPackages && product.internationalPackages.length) {
        let count = product.internationalPackages.split(',').length;
        request.productId = product.internationalPackages;
        for (let i = 0; i <= count - 2; i++) {
            request.productType += ",INTLPREMIUM";
        }
        request.serviceType = Service.video;
        delete product.internationalPackages;
    }
}

function getPopularffChannel(dispatch, zipCode = '', channelsList, selectedChannels = [],) {
    try {
        let request = {
            "category": "All",
            "acctID": "",
            "SelectChannelList": selectedChannels,
            "lastChannel": "",
            "sessionId": "",
            "zipCode": zipCode
        }
        let url = apiUrl().getProduct + '/popularffchannel';
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.RESULT)) {
                channelsList = channelsList.map((ele) => {
                    if (ele.channelCategory && ele.channelCategory.length) {
                        const index = ele.channelCategory.indexOf('popular');
                        if (index !== -1) {
                            ele.channelCategory.splice(index, 1);
                        }
                    }
                    return ele;
                });
                dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNELS', value: channelsList }); // clearing popular channels
                // console.log('channelsList without popular::', channelsList);
                if (channelsList && channelsList.length) {
                    channelsList = channelsList.map((ele) => {
                        if (ele.id && response.RESULT.indexOf(ele.id) != -1) {
                            if (ele.channelCategory) {
                                ele.channelCategory.indexOf('popular') == -1 ? ele.channelCategory.push('popular') : ele.channelCategory;
                            }
                        }
                        return ele;
                    });

                    dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNELS', value: channelsList }); // updating channels with popular
                    //  console.log('channelsList with popular::', channelsList);
                }
            } else {
                // console.log(" getPopularffChannel", response);
            }
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log("getPopularffChannel: ", error);
            })
    } catch (ex) {
        //console.log("getPopularffChannel: ", ex);
    }
}

export const fetchPopularffChannels = (dispatch, zipCode, channelsList, selectedChannels) => {
    getPopularffChannel(dispatch, zipCode, channelsList, selectedChannels);
}

export const fetchFiosFiveBasicChannels = (dispatch, zipCode, regionId, state) => {
    try {
        let url = apiUrl().getProduct + '/basicffchannel?zipCode=' + zipCode + '&regionId=' + (regionId || '') + '&state=' + state;
        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')
                && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.basicChannels)) {
                let channelIsocs = {};
                let channelData = response.data.basicChannels.map((el) => {
                    el.id && (channelIsocs[el.id] = el.id);
                    let category = InHomeUtils.isNotNull(el.category) ? el.category.map((cat) => cat?.toLowerCase()) : '';
                    let channelTitle = el.name;
                    if (channelTitle.indexOf('(GF)') !== -1) {
                        channelTitle = channelTitle.replace(/\(GF\)/, '').trim();
                    }
                    if (/\(Q\d{4}\)/.test(channelTitle)) {
                        channelTitle = channelTitle.replace(/\(Q\d{4}\)/, '').trim();
                    }

                    return { 'id': el.id, 'name': channelTitle, 'logo': el.id + ".png", 'channelCategory': category, 'packageId': el.packageId, 'packageType': el.packageType };
                });
                dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNELS', value: channelData });
                dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNEL_ISOCS', value: channelIsocs });

                if (channelData && channelData.length) {
                    getPopularffChannel(dispatch, zipCode, channelData);
                }
                let recommendedChannelData = response?.data?.fiosFiveChannels;
                if (Array.isArray(recommendedChannelData) && recommendedChannelData?.length > 0) {
                    let recommendedChannelIsocs = recommendedChannelData?.map(f => f?.fios5channelIosc);
                    if (recommendedChannelIsocs?.length > 5) {
                        recommendedChannelIsocs = recommendedChannelIsocs?.slice(0, 5);
                    }
                    dispatch({ type: 'SET_FIOSFIVE_RECOMMENDED_CHANNELS', value: recommendedChannelData });
                    dispatch({ type: 'SET_FIOSFIVE_RECOMMENDED_CHANNEL_ISOCS', value: recommendedChannelIsocs });
                }
                // console.log("channelData::", channelData);
                // console.log('===FF Basic Channels=== ', response.data.basicChannels);
            } else {
                // console.log("FF basic channel fetch response error ", response);
            }
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log("FF basic channel fetch error: ", error);
            })
    } catch (ex) {
        //console.log("FF basic channel fetch exception: ", ex);
    }
}

export const setFiosFiveSelectedChannels = (selectedChannels, dispatch) => {
    // console.log("FF: setting channels ", selectedChannels);
    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: selectedChannels });
}

export const setFiosFiveEventType = (isNewChannelsSet, dispatch) => {
    dispatch({ type: 'SET_FIOSFIVE_EVENT_TYPE', value: isNewChannelsSet })
}

//==Begin FF search implementation

export const fetchRegionId = (dispatch, zip, city, visitId, visitorId) => {

    //temp
    let vhoParams = {};
    if (window.location.host.indexOf('localhost') !== -1) {
        vhoParams = {
            regionId: "91905",
            lfa: "PHILADELPHIACITY",
            lfaName: "PHILADELPHIA CITY",
            vhoName: "PHILADELPHIA PA"
        };
    }
    try {
        let url = apiUrl().channelLineupVhoUrl;
        //temp - regionid only on NTE1 for now

        let requestObj = {
            visitid: visitId,
            visitorid: visitorId,
            zip: zip,
            appid: "consumer",
            tarcode: ""
        };
        api(url, 'POST', JSON.stringify(requestObj)).then(response => {
            if (response && response.vhoregionlist && response.vhoregionlist.length) {
                let { vhoregionlist } = response;
                // city = city.toUpperCase();
                // let regionIdCityMatchArr = [];

                //Temp Fix added by Santhosh to avoid city check
                // regionIdCityMatchArr = vhoregionlist;
                ////////////regionIdCityMatchArr = vhoregionlist.filter((el) => {
                ////////////    /* hold          
                ////////////    let elCity = el.vhoname.substr(0, el.vhoname.lastIndexOf(' '));
                ////////////    return elCity === city;
                ////////////    */
                ////////////   return (el.lfaname.indexOf(city) !== -1)
                ////////////});        
                vhoParams = {
                    regionId: InHomeUtils.isNotNull(vhoregionlist[0].regionid) ? vhoregionlist[0].regionid : "",
                    lfa: vhoregionlist[0].lfa,
                    lfaName: vhoregionlist[0].lfaname,
                    vhoName: vhoregionlist[0].vhoname
                };
            } else {
                // console.log('fetchRegionId response error ', response);
            }
            dispatch({
                type: 'SET_FIOSFIVE_SEARCH_VHO_PARAMS',
                value: vhoParams
            });
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log('fetchRegionId call error ', error);
            });

    } catch (ex) {
        //console.log('fetchRegionId exception ', ex);
    }
};


export const searchFiosFiveChannelProgramMercury = (dispatch, regionId, searchString) => {
    try {
        let url = 'https://mercuryha.verizon.com/MercuryServer/FiosFiveChannelSearch/F5Search/GetSuggestions?RegionId=' + regionId + '&SearchString=' + searchString;
        api(url, 'GET').then(response => {
            // console.log("FiosFive channel/program search response ", response);
            if (response && response.Status === 'OK' && response.autoSuggestResults) {
                dispatch({
                    type: 'SET_FIOSFIVE_SEARCH_SUGGESTIONS',
                    value: response.autoSuggestResults
                });
            }
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log("FiosFive channel/program search error", error)
            })
    } catch (ex) {
        //console.log("FiosFive channel/program search exception", ex);
    }

};

export const searchFiosFiveChannelProgram = (dispatch, searchString, lfa, visitId, visitorId) => {

    try {
        let requestObj = {
            appid: 'consumer',
            lfa: lfa,
            programchannelname: searchString.toLowerCase(),
            visitid: visitId,
            visitorid: visitorId
        };

        let url = apiUrl().channelProgramMasterUrl;
        api(url, 'POST', JSON.stringify(requestObj)).then(response => {
            if (response && response.chanelprogramlist) {
                dispatch({
                    type: 'SET_FIOSFIVE_SEARCH_SUGGESTIONS',
                    value: response.chanelprogramlist
                });
            } else {
                // console.log("FiosFive channel/program response error", response)
            }
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log("FiosFive channel/program search error", error)
            });
    } catch (ex) {
        //console.log("FiosFive channel/program search exception", ex);
    }
};

export const clearFiosFiveSearch = (dispatch) => {
    dispatch({ type: 'SET_FIOSFIVE_SEARCH_SUGGESTIONS', value: undefined });
};

export const getFiosFiveChannelMatch = (dispatch, selectedItem, visitId, visitorId, lfa, vhoName, fiosFiveBasicChannels, fiosFiveBasicChannelIsocs, searchString) => {

    try {
        let requestObj = {
            appid: 'consumer',
            channelid: selectedItem.channelid,
            elkchannelprogram: selectedItem.elkchannelname,
            lfa: lfa,
            name: selectedItem.name,
            programid: selectedItem.programid,
            type: selectedItem.type,
            vhoname: vhoName,
            visitid: visitId,
            visitorid: visitorId
        };

        let matchedChannelList = [];
        let url = apiUrl().channelProgramSearchUrl;
        api(url, 'POST', JSON.stringify(requestObj)).then(response => {
            // console.log("getFiosFiveChannelMatch response ", response);
            if (response && response.channellistwithpack && response.channellistwithpack.length && response.channellistwithpack[0].packagelist) {
                let packageList = response.channellistwithpack[0].packagelist;
                let packageIdsToSearch = processFiosFiveSearchPackageList(packageList, fiosFiveBasicChannelIsocs);
                if (packageIdsToSearch && packageIdsToSearch.length) {
                    // console.log('getFiosFiveChannelMatch found channels for FF search in package list -', packageIdsToSearch);
                    packageIdsToSearch.forEach((el) => {
                        let matchesFound = filterFiosFiveBasicChannels(el, fiosFiveBasicChannels);
                        if (matchesFound && matchesFound.length) {
                            matchedChannelList.push(matchesFound[0]);
                        }
                    })
                } else {
                    // console.log('getFiosFiveChannelMatch ', packageIdsToSearch, ' channels for FF search in package list -', packageList);
                }

            } else {
                // console.log('getFiosFiveChannelMatch package list not found in response -', response);
            }
            // console.log('getFiosFiveChannelMatch matchedChannelList is ', matchedChannelList);
            matchedChannelList.length && matchedChannelList.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1);
            dispatch({
                type: 'SET_FIOSFIVE_SEARCH_MATCHED_CHANNELS',
                value: matchedChannelList
            });
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log("getFiosFiveChannelMatch error");
            });
    } catch (ex) {
        //console.log("getFiosFiveChannelMatch exception");
    }

}

export const getFiosFiveChannelMatchForProgram = (dispatch, channelId, regionId, fiosFiveBasicChannels) => {
    try {
        let url = 'https://mercuryha.verizon.com/MercuryServer/FiosFiveChannelSearch/F5Search/GetChannels?RegionId=' + regionId + '&Id=' + channelId + '&Type=TVSeries';
        api(url, 'GET').then(response => {
            // console.log("getFiosFiveChannelMatchForProgram response ", response);
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log("getFiosFiveChannelMatchForProgram error");
            });
    } catch (ex) {
       // console.log("getFiosFiveChannelMatchForProgram exception");
    }
}

export const getFiosFiveChannelMatchForProgramMercury = (dispatch, channelId, regionId, fiosFiveBasicChannels) => {
    try {
        let url = 'https://mercuryha.verizon.com/MercuryServer/FiosFiveChannelSearch/F5Search/GetChannels?RegionId=' + regionId + '&Id=' + channelId + '&Type=TVSeries';
        api(url, 'GET').then(response => {
            // console.log("getFiosFiveChannelMatchForProgram response ", response);
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                //console.log("getFiosFiveChannelMatchForProgram error");
            });
    } catch (ex) {
        //console.log("getFiosFiveChannelMatchForProgram exception");
    }
}

const processFiosFiveSearchPackageList = (packageList, fiosFiveBasicChannelIsocs) => {

    let packageIdsToSearch = [];
    if (packageList) {
        if (packageList.indexOf('[') !== -1 && packageList.indexOf(']') !== -1) {
            packageList = packageList.replace(/\[/, '').replace(/\]/, '');
        }
        let packageListArr = packageList.split(',');

        packageListArr.forEach((el) => {
            let isoc = el.trim();
            fiosFiveBasicChannelIsocs[isoc] && packageIdsToSearch.push(isoc)
        });
    }

    return packageIdsToSearch;
};

const filterFiosFiveBasicChannels = (filterText, fiosFiveBasicChannels) => {
    let matchedChannelList = [];

    if (filterText) {
        filterText = filterText.toUpperCase();
        matchedChannelList = fiosFiveBasicChannels.filter((el) => {
            return (el.id.toUpperCase().indexOf(filterText) !== -1)
        });
    }
    return matchedChannelList;
};

export const setFiosFiveModalDetails = (modalType, selectedChannels, dispatch) => {
    dispatch({
        type: 'SET_FIOS_FIVE_MODAL_DETAILS',
        payload: {
            modalType: modalType,
            selectedChannels: selectedChannels
        }
    })
}

export const clearFiosFiveSearchMatchedChannels = (dispatch) => {
    dispatch({
        type: 'SET_FIOSFIVE_SEARCH_MATCHED_CHANNELS',
        value: undefined
    });
}

//==End FF search implementation
const getRequestPackageViewFiosFive = (visitId, visitorId, lfa, vhoname, packageid) => {
    let request = {
        visitid: visitId,
        visitorid: visitorId,
        lfa: lfa,
        vhoname: vhoname,
        packageid: packageid,
        appid: "consumer"
    };
    return JSON.stringify(request);
}

const sortAllChannels = (packageDetails) => {
    const groupedChannelData = {};
    let reviewChannelList = [];

    packageDetails.channesnameview.forEach(data => {
        reviewChannelList = [...reviewChannelList, ...data.channelist]
    });
    // Duplicate channelno.s removal
    reviewChannelList = reviewChannelList.reduce((acc, current) => {
        const x = acc.find(item => (item.channelno === current.channelno));
        if (!x) {
            return acc.concat([current]);
        } else {
            return acc;
        }
    }, []);
    reviewChannelList.sort(function (a, b) {
        if (a.channelname < b.channelname) { return -1; }
        if (a.channelname > b.channelname) { return 1; }
        return 0;
    });

    for (let i = 0; i < reviewChannelList.length; i++) {
        const firstLetter = reviewChannelList[i].channelname.charAt(0);
        if (groupedChannelData[firstLetter] === undefined) {
            groupedChannelData[firstLetter] = [];
        }
        groupedChannelData[firstLetter].push(reviewChannelList[i]);
    }
    return groupedChannelData;
}
export const getChannelPackageViewFiosFive = (visitId, visitorId, lfa, vhoname, packageid, dispatch) => {
    try {
        let url = apiUrl().channelLineupPackageView;
        api(url, "POST", getRequestPackageViewFiosFive(visitId, visitorId, lfa, vhoname, packageid))
            .then(response => {
                if (response && response.channesnameview && response.channesnameview.length) {
                    const groupedChannels = sortAllChannels(response);
                    dispatch({
                        type: "SET_PACKAGE_VIEW_FIOS_FIVE",
                        value: groupedChannels || {}
                    })
                }

            }).catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'getChannelPackageViewFiosFive', "Exception is: " + error.message || ''));
                let errorMsg = `MethodName:getChannelPackageViewFiosFive,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "FiosFiveChannelPackage", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'SET_PACKAGE_VIEW_FIOS_FIVE', value: {} });
            });
    } catch (ex) {
        catchJSException('BuildProduct', visitId, 'getChannelPackageViewFiosFive', ex);
        dispatch({ type: 'SET_PACKAGE_VIEW_FIOS_FIVE', value: {} });
    }
}

export const prefetchPlansForFailedCase = (dispatch, visitId, addlParam, plan) => {
    if (plan === 'data') {
        fetchDataMTM(dispatch, visitId, addlParam.flowType, addlParam.couponFlowType, null, addlParam.reAttemptCount);
    }
    else if (plan === 'video') {
        fetchTVMTM(dispatch, visitId, addlParam.zip, addlParam.tarCode, addlParam.channelLineUpTvPackages, addlParam.isDoflow, addlParam.couponFlowType, addlParam.flowType, addlParam.reAttemptCount, true);
    }
    else if (plan === 'voice') {
        fetchVoiceMTM(dispatch, visitId, addlParam.couponFlowType, addlParam.flowType, addlParam.reAttemptCount, true);
    }
    else if (plan === 'perks'){
        fetchPerksMTM(dispatch, visitId, addlParam.couponFlowType, addlParam.flowType, addlParam.reAttemptCount, true);
    }
}

export const getProductStatus = (searchTerm, isChecked, prodType) => {
    console.log(searchTerm, isChecked, prodType, 'getProductStatus');
    let suppProfileCart = store && store.getState && store.getState().profileCart && store.getState().profileCart.cartData;
    console.log(suppProfileCart, 'suppProfileCart');
    let productStatus = '';

    if (JSON.stringify(suppProfileCart).indexOf(searchTerm) < 0) {
        // not in profile
        if (prodType === 'TECHSURE' || prodType === Service.channel) {
            productStatus = !isChecked ? "ADDED" : "UNCHANGED"
        } else {
            productStatus = !isChecked ? "ADDED" : "REMOVED"
        }
    }
    if (JSON.stringify(suppProfileCart).indexOf(searchTerm) > -1) {
        // product already in profile cart
        productStatus = !isChecked ? "UNCHANGED" : "REMOVED"
    }
    console.log(productStatus, 'productStatus');
    return productStatus
}
export const errorMsgRemoveService = (status, dispatch) => {
    dispatch({ type: 'ERRORMSG_REMOVESERVICE', value: status });
};

export const resetBuildProductState = (dispatch) => {
    dispatch({ type: 'RESET_BUILD_PRODUCT_STATE', value: {} });
};

export const setProdNotificationDisplay = (dispatch, value) => {
    dispatch({ type: 'DISPLAY_PENDING_PRODUCTS', value: value });
};

export const setDoFlowOmnicartFirstAddition = (dispatch) => {
    dispatch({
        type: CheckLQ.cartFirstAddition,
        value: true
    });
}

export const updateFireAlarmDetails = (visitId, emergencyServiceObj, isECFlow = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFireAlarmDetails', "Inside updateFireAlarmDetails"));
        let request = {
            "notificationStatus": emergencyServiceObj?.selectedProduct.value == "yes" ? 'Y' : 'N',
            "notificationType": emergencyServiceObj?.selectedProduct.value == "yes" && emergencyServiceObj?.notificationMethod == "text" ? 'M' : emergencyServiceObj?.notificationMethod == "email" ? 'E' : emergencyServiceObj?.notificationMethod == "both" ? 'B' : '',
            "mtn": emergencyServiceObj?.selectedProduct.value == "yes" && ['text','both'].includes(emergencyServiceObj?.notificationMethod) ? emergencyServiceObj.mobile.value.replaceAll(".","") : '',
            "email": emergencyServiceObj?.selectedProduct.value == "yes" && ['email','both'].includes(emergencyServiceObj?.notificationMethod) ? emergencyServiceObj.email.value : ''
        }
        let url = apiUrl().updateFireAlarm;
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && response.data !== "" && response.data == "SUCCESS") {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFireAlarmDetails', "updateFireAlarmDetails is Success"));
                /*
                if(isECFlow){
                    sendDataEvent("emergency_services","event116");
                }
                else{
                    tempVzdlSCData.detail = "Emergency Services";
                    updateVzdlSCCustomEvent("emergencyServicesCheckout", "sendData", "detail,subflow");
                }*/
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateFireAlarmDetails', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFireAlarmDetails', "Exception is: " + error.message));
                let errorMsg = `MethodName:updateFireAlarmDetails,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateFireAlarmDetails', ex);
    }
}

export const updateIntlCallingPlan = async (visitId, dispatch, planCodeType) => {
    try {
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let request = getIntlCallingRequest(planCodeType);
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CART, 'CART Intent Error', PAGEACTIVITY.UA));
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:updateInstallation,errorMessage:${error.message}`;
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateInstallation', ex);
    }
}

const getIntlCallingRequest = (planCodeType) => {
    let request = {
        key: "pricingPlanCode",
        value: planCodeType,
        action: "add"
    }
    return JSON.stringify(request)
}
export const setIntlCallingProductForSCFlow = (cart, visitId, buildProductState, dispatch) => {
    try {
        let cartProducts = getCartProducts(cart, visitId);
        if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.VoiceProduct) && InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd) && cartProducts.VoiceProduct.voiceProd.length > 0 &&
            InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0]) && InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0].prodType) && cartProducts.VoiceProduct.voiceProd[0].prodType === 'FVPRIMARY' &&
            InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0].pricingPlanCode) && InHomeUtils.isNotEmpty(cartProducts.VoiceProduct.voiceProd[0].pricingPlanCode)) {
            let productInfo = buildProductState.intlCalling.intlCallingProducts.filter(p => p.pricingPlanCode === cartProducts.VoiceProduct.voiceProd[0].pricingPlanCode);
            if (InHomeUtils.isNotNull(productInfo) && productInfo.length > 0) {
                let intlCallingProduct = {
                    countryName: productInfo[0].countryName,
                    pricingPlanCode: productInfo[0].pricingPlanCode,
                    usageCap: productInfo[0].usageCap
                }
                dispatch({ type: 'INTERNATIONALCHANNELPLAN_SELECTEDPROD', value: intlCallingProduct });
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setIntlCallingProductForSCFlow', ex);
    }
}
export const setCEAppsForSC = (cart, buildProduct, dispatch, visitId, lqState) => {
    try {
        let cartProducts = getCartProducts(cart, visitId);
        let hasFiosConnectedTVProducts = false;
        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment) && InHomeUtils.isNotNull(buildProduct.tvConnections.equipments) && InHomeUtils.isNotEmpty(buildProduct.tvConnections.equipments)) {
            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Cart has Equipments"));
            cartProducts.CartSubProduct.Equipment.equipment.forEach(function (prod) {
                if ((prod.prodType === 'VROOM' || prod.prodType === 'DUMMYVROOM' || prod.prodType === 'CEDEVICEAPP' || prod.prodType === 'CEDEVICEAPPBNDL')) {
                    hasFiosConnectedTVProducts = true;
                }
            });
            if (hasFiosConnectedTVProducts) {
                let vRoom = null;
                let dummyvRoom = null;
                let ceApps = null;
                if (cartProducts.CartSubProduct.Equipment.equipment) {
                    vRoom = cartProducts.CartSubProduct.Equipment.equipment.filter(p => p.prodType === Service.vRoom);
                    ceApps = cartProducts.CartSubProduct.Equipment.equipment.filter(p => p.prodType === Service.ceAppsParity || p.prodType === Service.ceAppsBundle);
                    dummyvRoom = cartProducts.CartSubProduct.Equipment.equipment.filter(p => p.prodType === Service.dummyvRoom);
                    vRoom = vRoom && vRoom.length ? vRoom[0] : null;
                    ceApps = ceApps && ceApps.length ? ceApps[0] : null;
                    dummyvRoom = dummyvRoom && dummyvRoom.length ? dummyvRoom[0] : null;
                    dispatch({ type: Service.vRoom + '_SELECTEDPROD_CEAPPS', value: { vRoom, ceApps, dummyvRoom } });
                    dispatch({ type: Service.ceAppsParity + '_SELECTEDPROD', value: { vRoom, ceApps, dummyvRoom } });
                    dispatch({ type: Service.dummyvRoom + '_SELECTEDPROD', value: { vRoom, ceApps, dummyvRoom } });
                    // setTVConnectionsView(buildProduct.tvConnections, false, visitId, dispatch, { vRoom, ceApps, dummyvRoom }, buildProductState);
                    setTVConnectionsView(buildProduct.tvConnections, false, visitId, dispatch, { vRoom, ceApps, dummyvRoom }, buildProduct, false);
                    setCEAppsView(null, buildProduct.ceApps, visitId, dispatch, { vRoom, ceApps, dummyvRoom });
                    if (InHomeUtils.isNull(dummyvRoom) && InHomeUtils.isNotNull(vRoom) && (vRoom.id || vRoom.prodId) && vRoom.unitCount && parseInt(vRoom.unitCount) === 1) {
                        let dummyvRoomProd = buildProduct.tvConnections && buildProduct.tvConnections.equipments && buildProduct.tvConnections.equipments.length ? buildProduct.tvConnections.equipments.filter(p => p.id === vRoom.id || p.id === vRoom.prodId) : null;
                        if (dummyvRoomProd && dummyvRoomProd.length) {
                            dummyvRoomProd = { ...dummyvRoomProd[0] };
                            dummyvRoomProd['fromvRoom'] = true;
                            updateCart(
                                visitId
                                , lqState
                                , dummyvRoomProd
                                , 'DUMMYVROOM'
                                , false
                                , dispatch
                                , buildProduct.requestTN
                                , ""
                                , ""
                                , "MTM", "", false, false, null
                                , buildProduct
                                , null);
                        }
                    }
                }
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setCEAppsForSC', ex);
    }
}

export const setDataPerksForSCFlows = (cart, buildProductState, flowtype, visitId, dispatch) => {
    try {
        let internetProduct = null;
        let dataPerkProduct = null;
        let cartProducts = getCartProducts(cart, visitId);
        if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
            cartProducts.DataProduct.dataProd.forEach(function (prod) {
                if ((prod.prodTypeVal === 'STREAMING' || prod.prodTypeVal === 'GAMING' || prod.prodTypeVal === 'COMPLETE')) {
                    dataPerkProduct = prod;
                    let vas = '';
                            setTimeout(() => {
                                fetchFreeRouter(dispatch, visitId, flowtype,"","",buildProductState);
                                fetchTechSure(dispatch, visitId, flowtype);
                                let vasProducts = [];

                                vas = cart?.tierContent[0]?.sections?.section[0]?.subSections?.subSection.filter(p => p.sectionType === Service.vasstandalone);
                                if (InHomeUtils.isNotNull(vas) && vas.length > 0 && InHomeUtils.isNotNull(vas[0]) && InHomeUtils.isNotNull(vas[0].products)) {
                                    vasProducts = vas[0].products;
                                }
                                const cloudProd = vasProducts.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes' && vcloud === 'Y');
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: cloudProd.length > 0 ? cloudProd : null });

                            }, 3000) 
                }
            });            
        }     
        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.rewardoffers)) {
            cartProducts.CartSubProduct.SpecialOffers.rewardoffers.forEach(function (prod) {
                if (prod.offerAttr === 'ACQBLACKFRIDAY2022'){
                    dispatch({ type: 'FLASHOFFER_SELECTEDPRODID', value: prod });
                }                
            });
        }   
        if (InHomeUtils.isNotNull(dataPerkProduct)) {
            internetProduct = getCoreDataProductFromPlanPerks(buildProductState.internet.m2mPlans, dataPerkProduct.prodId, visitId);
            if (InHomeUtils.isNotNull(internetProduct)) {
                dispatch({ type: 'INTERNET_SELECTEDPROD', value: processOfferSection(internetProduct) });
                dispatch({ type: 'MM3INTERNETSUBPROD', value: internetProduct.planPerks });
                dispatch({ type: 'FETCH_DATASUBPROD', value: internetProduct.planPerks })
                dispatch({ type: "MM3_SELECTEDPROD", value: dataPerkProduct })
                dispatch({type : 'TOGGLE_DATASUB_ACCOR',value : true})
                 dispatch({type:'MM3_ROUTER_OPENACCOR',value:true})
                buildProductState.mm3internetsub.subAccordionStatus = "added"
                buildProductState.isDataPerksSetForSCFlow = true;
                dispatch({ type: "PERKS_FOR_SCFLOWS", value: true });
            }
        }

    }
    catch (err) {
        catchJSException('BuildProduct', visitId, 'setDataPerksForSCFlows', err);
    }
}
export const isSelectedData500Or400=(incomingSpeed,dispatch)=>{
    try{
       if(incomingSpeed.downSpeed==="500M" || incomingSpeed.downSpeed==="400M"){
           dispatch({type:"IS_SELECTED_DATA_500_OR_400",value:true})
       }else{
           dispatch({type:"IS_SELECTED_DATA_500_OR_400",value:false})
       }

    }catch(err){

    }
}

export const IONTOccupanyCheck = (dispatch)=>{
    let IONTCheck =  false
    let occupancyCheck =  false

    if(store.getState() && store.getState().loopQual){
        IONTCheck =  store.getState().loopQual.iONTEligible
        occupancyCheck =  store.getState().loopQual.lqResponse && store.getState().loopQual.lqResponse.occupancyType && store.getState().loopQual.lqResponse.occupancyType === 'SOC' ? true: false    
    }

    if(IONTCheck && occupancyCheck){
        dispatch({ type: "CHANGE_PLANDETAILS_STATUS", value: true })
        dispatch({ type: "UPDATE_ALL_M2MPLANS_EXPANDED", value: true })
    }
}

 export const getGigBadgeMessage = async (dispatch) => {
    try {
        let url = apiUrl().getProduct + '/fioszineone';
        api(url, 'GET').then((response) => {
            if(response){
                dispatch({
                    type: 'SET_GIG_BADGE_MESSAGE',
                    value: response
                })
            }
        })
        .catch(error => {
           // console.log("getGigBadgeMessage error ", error);
        })
    }
    catch (ex) {
       // console.log("getGigBadgeMessage exception", ex);
    }
}

export const triggerFiosReferralChangeAuth = (mon,email, mtn, lang, dispatch) => {
    const  getTransactionIdUrl = apiUrl().fiosReferralAdaptiveAuthentication;
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "Validating Mobile Number", isLoaderImg: "loader" }
    });
    const payload = { mon, mtn, email, lang  };
    api(getTransactionIdUrl, 'POST', payload).then((response) => {
        if(response.data.tokenGenerationResponse && response.data.tokenGenerationResponse.transactionID) {
            dispatch({ type: 'UPDATE_FIOS_REFERRAL_TRANSACTION_ID_GENERATION_RESPONSE', value: response.data.tokenGenerationResponse });
        }

    }).catch((error) => {
        console.log(error);
        // mnhNotSuccessful(dispatch, buildProduct);
        // let errorMsg = `MethodName:validateVzwMtn,errorMessage:${error.message}`;
        // logKafka("ERROR", "MTNQual", errorMsg, getErrorLogUrl, "applogs", visitId);
        //                 vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                  });

}

export const validateMtnBP = (mtn, visitId, addrID, dispatch, zipcode, buildProduct, modalWindow) => {
    try {
        let url = apiUrl().vzwOfferEligibility;
        let request = {
            "mtn": mtn,
            "addressId": addrID
        };
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Validating Eligibility", isLoaderImg: "loader" }
        });
        api(url, 'POST', JSON.stringify(request)).then(resp => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: ''} });
            if (InHomeUtils.isNotNull(resp) && InHomeUtils.isNotNull(resp.meta) && InHomeUtils.getIndexOf(resp.meta.code, '200') && InHomeUtils.isNotNull(resp.data) && InHomeUtils.isNotNull(resp.data.offerEligibilitydata)) {
                setVzwMtn(resp.data.offerEligibilitydata, mtn, dispatch);
                if((resp.data.offerEligibilitydata.validVzw && resp.data.offerEligibilitydata.validVzw.toUpperCase() === 'Y' && resp.data.offerEligibilitydata.accountOwnerManagerIndicator && resp.data.offerEligibilitydata.accountOwnerManagerIndicator.toUpperCase() === 'Y')){
                    const mnhData = { username: mtn, zipCode: zipcode };
                    let mnhUrl = apiUrl().ssoMHAuthiniticate;
                    dispatch({
                        type: 'LOADER_ACTIVE',
                        value: { isLoaderActive: true, isLoaderText: "Validating Mobile Number", isLoaderImg: "loader" }
                    });
                    api(mnhUrl, 'POST', JSON.stringify(mnhData)).then(response => {
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
                        if (response && response.data && response.data.isAuthenticated === 'Y') {
                            if(response.data.tokenGenerationResponse && response.data.tokenGenerationResponse.transactionID && response.data.tokenGenerationResponse.data.listOfDevices && response.data.tokenGenerationResponse.data.listOfDevices[0] && response.data.tokenGenerationResponse.data.listOfDevices[0].deviceID && response.data.tokenGenerationResponse.data.listOfDevices[0].deviceType) {
                                dispatch({ type: 'UPDATE_MNH_TOKEN_GENERATION_RESPONSE', value: response.data.tokenGenerationResponse });
                                if(response.data.tokenGenerationResponse.data.listOfDevices[0].deviceType === 'SMARTPHONE' || response.data.tokenGenerationResponse.data.listOfDevices[0].deviceType === 'TABLET'){
                                    if(mtn && mtn.length === 10){
                                        let mtnSmart = mtn.slice(0, 3) + "." + mtn.slice(3, 6) + "." + mtn.slice(6, 10);
                                        updateTNInfo(dispatch, "PH1", mtnSmart);
                                    }
                                    updateSubFlowValue(' | M+H', 'm+h');
                                    tempVzdlSCData.detail = "Mobile Authentication Notification Overlay";
                                    updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail");
                                    modalAction.openModalWindow('mnhPushNotificationOverlay', dispatch);
                                }
                                else if (response.data.tokenGenerationResponse.data.listOfDevices[0].deviceType === 'BASIC') {
                                    if(mtn && mtn.length === 10){
                                        let mtnBasic = mtn.slice(0, 3) + "." + mtn.slice(3, 6) + "." + mtn.slice(6, 10);
                                        updateTNInfo(dispatch, "PH1", mtnBasic);
                                    }
                                    updateSubFlowValue(' | M+H', 'm+h');
                                    tempVzdlSCData.detail = "Mobile Verification Code Overlay";
                                    updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail");
                                    modalAction.openModalWindow('mnhBasicPhoneOverlay', dispatch);
                                }
                                else{
                                    mnhNotSuccessful(dispatch, buildProduct);
                                }
                            }
                            else{
                                mnhNotSuccessful(dispatch, buildProduct);
                            }
                        }
                        else{
                            mnhNotSuccessful(dispatch, buildProduct);
                        }
                    }).catch(error => {
                        mnhNotSuccessful(dispatch, buildProduct);
                        let errorMsg = `MethodName:validateVzwMtn,errorMessage:${error.message}`;
                        logKafka("ERROR", "MTNQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                        vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                    });
                }
                else{
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    mnhNotSuccessful(dispatch, buildProduct);
                }
            } else {
                mnhNotSuccessful(dispatch, buildProduct);
            }
        }).catch(error => {
            mnhNotSuccessful(dispatch, buildProduct);
            let errorMsg = `MethodName:validateVzwMtn,errorMessage:${error.message}`;
            logKafka("ERROR", "MTNQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
        });
    } catch (ex) {
        mnhNotSuccessful(dispatch, buildProduct);
        catchJSException('loopQual', visitId, 'validateVzwMtn', ex);
    }
}

export const callVerificationAPI = (props)=>{
    if (!checkTokenValidity()) {
        genarateToken().then((resp) => {
        if (resp.status === 200) {
            return invokeCallVerification(props);
        }
        }).catch((error) => {
            logKafka('ERROR', 'callVerificationAPI', error, getErrorLogUrl, 'applogs');
        });
    } else {
        return invokeCallVerification(props);
    }
}

export const invokeCallVerification = (props)=>{
    try {
        const url = `${apiUrl().verification}?transactionID=${props.mnhTokenGenerationResponse.transactionID}`;
        return new Promise((resolve) => {
            api(url, 'GET', '').then(() => {
              resolve(true);
            })
            .catch((error) => {
              const errorMsg = `MethodName:callVerificationAPI,errorMessage:${error.message}`;
              logKafka('ERROR', 'callVerificationAPI_Failure', errorMsg, getErrorLogUrl, 'applogs');
              resolve(true);
            });
        });
    } catch (error) {
        catchJSException('LOOPQUAL2.0', 'callVerificationAPI', error);
    }
}

export const enableVerifyButton = (dispatch, input) => {
    dispatch({ type: 'ENABLE_MNH_VERIFY_BUTTON', value: input });
};

export const updateSaveTheSaleOffer = (saveObj, saveTheSaleObj, dispatch) => {
    const savetheSale = Object.assign({}, saveTheSaleObj, {...saveObj});
    dispatch({ type: 'UPDATE_SAVETHESALE_OFFER', value: savetheSale });
}

export const mnhNotSuccessful = (dispatch, buildProduct, maxAttemptCase = false)=>{
    dispatch({ type: 'SET_MNH_STATUS', value: 'N' });
    /*if(modalWindow && modalWindow.modalId){
        modalAction.closeModalWindow(modalWindow.modalId, dispatch)
    }*/
    let message = '';
    let titleMessage = ""
    if(!maxAttemptCase){
        message = 'Select the Fios plan or Mobile plan best suited for you';
        titleMessage = "Unfortunately you're not eligible for the Mobile + Home Discount.";
    }
    else{
        message = 'Please sign in to your mobile account below to confirm one time access to your account.';
        titleMessage = "We were not able to validate your mobile account verification request";
        updateSubFlowValue(' | M+H', 'm+h');
    }
    updateVzdlSCCustomEvent("buildFiosInit", "sendData", "notification", false, "", false, titleMessage);
    mnhSetBanner(dispatch, buildProduct, message, titleMessage);
    focusAnimation(0);
}

export const mnhSetBanner = (dispatch, buildProduct, message, TitleMessage)=>{
    let sweetnerMnhContent = {
        currentMsg: '',
        prevMsg: '',
        prevPromos: {
            INTERNET: null,
            TV: null
        },
        isDisplay: true
    };
    sweetnerMnhContent = { ...buildProduct.SweetnerMsg, prevPromos: { ...buildProduct.SweetnerMsg.prevPromos} }
    let displaySPOfferMessage = `<strong>${TitleMessage}</strong> <br/>`;
    let SweetnerSPOfferMessage = fiosReferral === "true" && TitleMessage.includes("Congratulations!") ? `<div style="font-size:2rem;line-height:2.2rem">${displaySPOfferMessage} ${message}</div>` : `${displaySPOfferMessage} ${message}`;
    sweetnerMnhContent.currentMsg = SweetnerSPOfferMessage;
    sweetnerMnhContent.isDisplay = true;
    SweetnerMsg(sweetnerMnhContent, dispatch, true);
    // sweetnerMnhContent.isDisplay = false;
    // setTimeout(() => SweetnerMsg(sweetnerMnhContent, dispatch), 7000);
}

export const getNameMnhDetailsBuildProduct = (dispatch, buildProduct, skipTagCall=false) => {
    fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
    try {
      const couponFlowType = store?.getState?.()?.loopQual?.couponFlowType;
      if (couponFlowType === "Employee" || couponFlowType === "Retiree") {
        return;
      } else if (buildProduct?.internet?.mnhSignupIndicator !== "Y") {
        return;
      }
      let isMovesFlowWithMNHCredit = false;
      let flowTypeVal = store && store?.getState && store?.getState().app && store?.getState()?.app?.flowType;
        let promotionsInCart = store?.getState()?.profileCart?.cartData[0]?.Promotions.promotions;
        promotionsInCart?.map(item => {
            if(item?.promoText?.toUpperCase?.()?.includes?.("HOME PERK CREDIT") && flowTypeVal == 'MV'){
                isMovesFlowWithMNHCredit = true;
            }
        });
      const isEmberFlow = buildProduct?.emberInfo?.isEmberFlow || store?.getState?.()?.loopQual?.runtimeKey?.isEmberFlow === "Y";
      const is2GigPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => item?.id === "R3582" || item?.name?.toUpperCase?.()?.includes?.("2 GIG")) > -1;
      const isGigabitPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => !is2GigPlan && item?.name?.toUpperCase?.()?.includes?.("GIGABIT CONNECTION")) > -1;
      const is1GigPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => item?.id === "R3583" || (!is2GigPlan && item?.name?.toUpperCase?.()?.includes?.("GIG"))) > -1;
      // const hasPerkCredit = buildProduct?.internet?.m2mPlans?.find?.(p => p?.specialOffers?.some?.(o => o?.OfferText?.toUpperCase?.()?.includes?.("HOME PERK CREDIT")));
      let tileMessage =  fiosReferral === "true" ? 'Congratulations!'  : 'Congratulations';
      let message = fiosReferral === "true" ? "You're getting a Mobile + Home Discount up to $15/mo." :"You're getting the Mobile + Home Discount.";
      
      if (isEmberFlow) {
        let plan = is2GigPlan ? "1 Gig or 2 Gig" : isGigabitPlan ? "Gigabit Connection" : is1GigPlan ? "1 Gig" : "500 Mbps";
        message += ` ${plan} customers also get a $10/mo credit on any eligible perk.`;
      }
      // CETC-147252 end function if mnhBannerStatus is "UPDATE" and SweetnerMsg already has ember perk credit message
      if (buildProduct?.mnhBannerStatus === "UPDATE" && isEmberFlow && buildProduct?.SweetnerMsg?.currentMsg?.includes?.(message)) {
        dispatch({ type: "SET_MNH_BANNER_STATUS", value: "" });
        return;
      }
      dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "Fetching Data", isLoaderImg: "loader" }
        });
      const url = apiUrl().ssoMHGetName;
      dispatch({ type: 'SET_MNH_STATUS', value: 'Y' });
      api(url, 'GET', '').then(response => {
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
      if(response && response.data && response.data.firstName ){
        let input = response.data.firstName;
        let final = input.charAt(0) + input?.toLowerCase()?.substring(1);
        dispatch({
            type: 'UPDATEMNHDETAILS',
            value: final
        });
        tileMessage = `${tileMessage}, ${final}!`;
      }
      if(!skipTagCall){
        tempVzdlSCData.events = "event56,event10";
        updateVzdlSCCustomEvent("buildFiosInit", "sendData", "notification,events", false, "", false, "Congratulations You're getting the Mobile + Home discount");
      }
      mnhSetBanner(dispatch, buildProduct, message, tileMessage);
      dispatch({ type: "SET_MNH_BANNER_STATUS", value: "" });
      }).catch((error) => {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
        mnhSetBanner(dispatch, buildProduct, message, tileMessage);
        dispatch({ type: "SET_MNH_BANNER_STATUS", value: "" });
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ,'','callGetNameMnhDetails_Failure', PAGEACTIVITY.MSG.callValidateAPIFailure, PAGEACTIVITY.UA));
        const errorMsg = `MethodName:callGetNameMnhDetails,errorMessage:${error.message}`;
        logKafka('ERROR', 'callGetNameMnhDetails_Failure', errorMsg, getErrorLogUrl, 'applogs');
      });
    } catch (error) {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
        mnhSetBanner(dispatch, buildProduct, message, tileMessage);
        dispatch({ type: "SET_MNH_BANNER_STATUS", value: "" });
        catchJSException('LOOPQUAL2.0', 'callGetNameMnhDetails', error);
    }
}




export const FCCLabelData = (dispatch,isocInfo)=>{
    try {
        const url = apiUrl().getFccLabel
        return new Promise((resolve) => {
            api(url, 'GET', '').then((response) => {
             let isocData=[]
             response.plans?.filter((item)=>{
                if(isocInfo?.includes(item.planCode)){
                    isocData.push(item)
                }}) 
              dispatch({ type: 'FCC_LABEL_INFO', value: isocData});
              resolve(true);
            })
            .catch((error) => {
              const errorMsg = `MethodName:FCCLabelData,errorMessage:${error.message}`;
              logKafka('ERROR', 'FCCLabelData_Failure', errorMsg, getErrorLogUrl, 'applogs');
              resolve(true);
            });
        });
    } catch (error) {
        catchJSException('FCCLabelData', 'FCCLabelData', error);
    }
}

export const GetMovesThrottle = (reskinHandler)=>{
    try {
        const url = apiUrl().getMovesThrottle;
        return new Promise((resolve) => {
            api(url, 'GET', '').then((response) => {
                window.sessionStorage.setItem('movesThrottle', 'true')
                let data = response?.data?.throttleList || ""; 
                data = data.split("|")
                if(data.indexOf("fios_mv")!=-1){
                    window.sessionStorage.setItem('Reskin', 'Enabled');
                    reskinHandler()
                }
              resolve(true);
            })
            .catch((error) => {
              const errorMsg = `MethodName:GetMovesThrottle,errorMessage:${error.message}`;
              logKafka('ERROR', 'GetMovesThrottle_Failure', errorMsg, getErrorLogUrl, 'applogs');
              resolve(true);
            });
        });
    } catch (error) {
        catchJSException('GetMovesThrottle', 'GetMovesThrottle', error);
    }
}

// export const GetCreditCheckThrottle = (creditCheckHandler)=>{
//     try {
//         const url = apiUrl().getMovesThrottle;
//         return new Promise((resolve) => {
//             api(url, 'GET', '').then((response) => {
//                 window.sessionStorage.setItem('creditCheckThrottle', 'true')
//                 let data = response?.data?.throttleList || ""; 
//                 data = data.split("|")
//                 if(data.indexOf("fios_cc")!=-1){
//                     window.sessionStorage.setItem('creditCheckV2', 'true')
//                     creditCheckHandler()
//                 }
//               resolve(true);
//             })
//             .catch((error) => {
//               const errorMsg = `MethodName:GetCreditCheckThrottle,errorMessage:${error.message}`;
//               logKafka('ERROR', 'GetCreditCheckThrottle_Failure', errorMsg, getErrorLogUrl, 'applogs');
//               resolve(true);
//             });
//         });
//     } catch (error) {
//         catchJSException('GetCreditCheckThrottle', 'GetCreditCheckThrottle', error);
//     }
// }
export const GetOrderSummaryThrottle = async(saveTheSaleObj,dispatch, appState) => {
    try {
        if( appState?.flowType !== 'MV' && appState?.flowType !== 'SUPP' ){
            dispatch({type:"ENABLE_STICKYPROGRESSBAR_THROTTLE", value: true}); 
        }
        const url = apiUrl().getMovesThrottle;
        return new Promise((resolve) => {
            api(url, 'GET', '').then(async (response) => {
                let data = response?.data?.throttleList || "";                
                data = data.split("|")
                if(appState?.flowType !== 'MV' && appState?.flowType !== 'SUPP' ){

                if(!window.sessionStorage.enableAutopayOptThrottle){
                    if(data.indexOf("fios_apbopt")!=-1){
                        
                        dispatch({type:"ENABLE_AUTOPAY_OPTTHROTTLE", value: true});                      
                        window.sessionStorage.setItem('enableAutopayOptThrottle', 'fios_apbopt')
                        
                    }
                    else if(data?.indexOf("fios_c_apbopt")!=-1){
                        window.sessionStorage.setItem('enableAutopayOptThrottle', 'fios_c_apbopt')
                        
                    }
                }
                else{
                    dispatch({type:"ENABLE_AUTOPAY_OPTTHROTTLE", value: window.sessionStorage.enableAutopayOptThrottle === 'fios_apbopt' ? true : false}); 
                } 
                // if(!window.sessionStorage.enableAuotpayThrottle){
                //     if(data.indexOf("fios_apb")!=-1){
                        
                //         dispatch({type:"ENABLE_AUTOPAY_THROTTLE", value: true});                      
                //         window.sessionStorage.setItem('enableAuotpayThrottle', 'fios_apb')
                        
                //     }
                //     else if(data?.indexOf("fios_c_apb")!=-1){
                //         window.sessionStorage.setItem('enableAuotpayThrottle', 'fios_c_apb')
                        
                //     }
                // }
                // else{
                //     dispatch({type:"ENABLE_AUTOPAY_THROTTLE", value: window.sessionStorage.enableAuotpayThrottle === 'fios_apb' ? true : false}); 
                // }                

                // if(!window.sessionStorage.stickyprogressbar){
                //     if(data.indexOf("fios_spb")!=-1){                        
                //         dispatch({type:"ENABLE_STICKYPROGRESSBAR_THROTTLE", value: true});                        
                //         window.sessionStorage.setItem('stickyprogressbar', 'fios_spb')
                //         updateSandboxIdValue('fios_spb')
                //     }
                //     else if(data?.indexOf("fios_c_spb")!=-1){
                //         updateSandboxIdValue('fios_c_spb')
                //         window.sessionStorage.setItem('stickyprogressbar', 'fios_c_spb')
                //     }
                // }
                // else{
                //     dispatch({type:"ENABLE_STICKYPROGRESSBAR_THROTTLE", value: window.sessionStorage.stickyprogressbar === 'fios_spb' ? true : false});

                //     updateSandboxIdValue(window.sessionStorage.stickyprogressbar);
                // }
                


                if(!window.sessionStorage.saveSaleOffer){
                    if(data.indexOf("SS_POPUP")!=-1){
                        const saveSalsObj={'stsThrottleFlag':true}; 
                        const savetheSale = Object.assign({}, saveTheSaleObj, {...saveSalsObj});
                        dispatch({type:"UPDATE_SAVETHESALE_OFFER", value:savetheSale})
                        
                        window.sessionStorage.setItem('saveSaleOffer', 'SS_POPUP_AAL')
                        updateSandboxIdValue('SS_POPUP_AAL')
                    }
                    else if(data?.indexOf("SS_C_POPUP")!=-1){
                        updateSandboxIdValue('SS_C_POPUP_AAL')
                        window.sessionStorage.setItem('saveSaleOffer', 'SS_C_POPUP_AAL')
                    }
                }
                else{
                    updateSandboxIdValue(window.sessionStorage.saveSaleOffer);
                    if(window.sessionStorage.saveSaleOffer && window.sessionStorage.saveSaleOffer === 'SS_POPUP_AAL'){
                        const saveSalsObj={'stsThrottleFlag':true}; 
                        const savetheSale = Object.assign({}, saveTheSaleObj, {...saveSalsObj});
                        dispatch({type:"UPDATE_SAVETHESALE_OFFER", value:savetheSale})
                    }
                }
            }
            if( appState?.flowType === 'MV' ){                              
                if (!window.sessionStorage.movesstickyheaderfooter) {
                    if (data.indexOf("fios_mshf") != -1) { 
                        // Making this condition as true temporarily, as we are not getting stickyheader throttle from nsathrottlelist api 
                        dispatch({ type: "ENABLE_MOVES_STICKYHEADER_THROTTLE", value: true });
                        window.sessionStorage.setItem('movesstickyheaderfooter', 'fios_mshf')
                        updateSandboxIdValue('fios_mshf')
                    }
                    else if (data?.indexOf("fios_c_mshf") != -1) {
                        window.sessionStorage.setItem('movesstickyheaderfooter', 'fios_c_mshf')
                        updateSandboxIdValue('fios_c_mshf')
                    }
                    else if(data?.indexOf("fios_c_mshf") == -1 && data.indexOf("fios_mshf") == -1 ){

                        dispatch({ type: "ENABLE_MOVES_STICKYHEADER_THROTTLE", value: true });
                        window.sessionStorage.setItem('movesstickyheaderfooter', 'fios_mshf')
                        updateSandboxIdValue('fios_mshf')
                    }
                }
                else {
                    dispatch({type:"ENABLE_MOVES_STICKYHEADER_THROTTLE", value: window.sessionStorage.movesstickyheaderfooter === 'fios_mshf'}); 
                    updateSandboxIdValue(window.sessionStorage.movesstickyheaderfooter);
                }
                
                if (!window.sessionStorage.enableMovePerksOverlay) {
                    if (data.indexOf("fios_musp") != -1) { 
                        // Making this condition as true temporarily, as we are not getting stickyheader throttle from nsathrottlelist api 
                        dispatch({ type: "ENABLE_MOVES_UPSELL_PERKSOVERLAY", value: true });
                        window.sessionStorage.setItem('enableMovePerksOverlay', 'fios_musp')
                        updateSandboxIdValue('fios_musp')
                    }
                    else if (data?.indexOf("fios_c_musp") != -1) {
                        window.sessionStorage.setItem('enableMovePerksOverlay', 'fios_c_musp')
                        updateSandboxIdValue('fios_c_musp')
                    }
                    else if(data?.indexOf("fios_c_mshf") == -1 && data.indexOf("fios_mshf") == -1 ){

                        dispatch({ type: "ENABLE_MOVES_UPSELL_PERKSOVERLAY", value: true });
                        window.sessionStorage.setItem('enableMovePerksOverlay', 'fios_musp')
                        updateSandboxIdValue('fios_musp')
                    }
                }
                else {
                    dispatch({type:"ENABLE_MOVES_UPSELL_PERKSOVERLAY", value: window.sessionStorage.enableMovePerksOverlay === 'fios_musp'}); 
                    updateSandboxIdValue(window.sessionStorage.movesstickyheaderfooter);
                }   

                
                

            }
                
             await resolve(true);
            })
            .catch((error) => {
              const errorMsg = `MethodName:GetMovesThrottle,errorMessage:${error.message}`;
              logKafka('ERROR', 'GetMovesThrottle_Failure', errorMsg, getErrorLogUrl, 'applogs');
              resolve(true);
            });
        });
    } catch (error) {
        catchJSException('GetMovesThrottle', 'GetMovesThrottle', error);
    }
}

export const mnhfiosFetch = (dispatch)=>{
    const url = apiUrl().fiosMnhFetch;
    let domainURL = window.location.origin + "/inhome/buildproducts";
    try{
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: 'Checking Details.' } });
        api(url, 'GET', '').then((response) => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')){
                window.location.href = domainURL + "?lq2=y&fiosmnh=y";
            }
            else{
                window.location.href = domainURL + "?lq2=y&fiosmnh=n";
            }
        })
        .catch((error) => {
            const errorMsg = `MethodName:mnhfiosFetch,errorMessage:${error.message}`;
            logKafka('ERROR', 'FIOSMNH_Failure', errorMsg, getErrorLogUrl, 'applogs');
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
            window.location.href = domainURL + "?lq2=y&fiosmnh=n";

        });

    } catch (error) {
        catchJSException('fiosMNH', 'fiosMNH', error);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
        window.location.href = domainURL + "?lq2=y&fiosmnh=n";
        
    }
}

export const emberInfo = (visitId,dispatch) => {
  try {
    function findNestedObj(entireObj, keyToFind, valToFind) {
      let foundObj;
      JSON.stringify(entireObj, (_, nestedValue) => {
        if (nestedValue && nestedValue[keyToFind] === valToFind) {
          foundObj = nestedValue;
        }
        return nestedValue;
      });
      return foundObj;
    }
    if (
      store &&
      store.getState &&
      store.getState().buildProduct &&
      store.getState().buildProduct?.internet?.m2mPlans?.length > 0
    ) {
      let m2mPlans = store.getState().buildProduct?.internet?.m2mPlans;

      let isEmberMrkrInOffer = findNestedObj(
        m2mPlans,
        "BsOfferAttrValue",
        "MF4MRKF15"                                     
      );
      let isEmberDiscInOffer = findNestedObj(
        m2mPlans,
        "BsOfferAttrValue",
        "MF4DISCF15"
      );
        
        let isEmberFlowAEM =
          store &&
          store.getState() &&
          store.getState().loopQual &&
          store.getState().loopQual?.runtimeKey &&
          store.getState().loopQual?.runtimeKey?.isEmberFlow == "Y"
            ? true
            : true;

        let isEmberMrkrAEM =
          store &&
          store.getState() &&
          store.getState().loopQual &&
          store.getState().loopQual?.runtimeKey &&
          store.getState().loopQual?.runtimeKey?.isMF4MRKF15 == "Y"
            ? true
            : true;

      if (store?.getState()?.ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.length > 0) {
        let promotions = store.getState().ecProfileCart?.cartData?.[0]?.Promotions?.promotions;
        isEmberMrkrInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4MRKF15")
          ? true : isEmberMrkrInOffer;
        isEmberDiscInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4DISCF15")
          ? true : isEmberDiscInOffer;
      }

      if (store?.getState()?.profileCart?.cartData?.[0]?.Promotions?.promotions?.length > 0) {
        let promotions = store.getState().profileCart?.cartData?.[0]?.Promotions?.promotions;
        isEmberMrkrInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4MRKF15")
          ? true : isEmberMrkrInOffer;
        isEmberDiscInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4DISCF15")
          ? true : isEmberDiscInOffer;
      }

      let emberVal = {};
      if (isEmberMrkrInOffer !== undefined || isEmberMrkrAEM) {
        emberVal.isMF4MRKF15 = true;
      }

      if (isEmberDiscInOffer !== undefined) {
        emberVal.isMF4DISC15 = true;
      }

      if (isEmberFlowAEM || isEmberMrkrInOffer !== undefined || isEmberDiscInOffer !== undefined) {
        emberVal.isEmberFlow = true;
      }

        dispatch({ type: "SET_EMBER_INFO", value: emberVal });
    }
  } catch (ex) {
    catchJSException("BuildProduct", visitId, "emberInfo", ex);
  }
};
